
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aGARu", function(module, exports) {
class $2a191efd0d34b17f$export$51be62b46ee668fd {
    /**
   * The default implementation calls AstNode#accept on the specified node.
   * @param node
   */ visit(node) {
        return node.accept(this);
    }
    /**
   * The default implementation initializes the aggregate result to defaultResult(). Before visiting each child, it
   * calls shouldVisitNextChild; if the result is false no more children are visited and the current aggregate result is
   * returned. After visiting a child, the aggregate result is updated by calling aggregateResult with the previous
   * aggregate result and the result of visiting the child.
   */ visitChildren(node) {
        let result = this.defaultResult();
        const children = node.getChildren();
        for(let i = 0; i < children.length; i++){
            if (!this.shouldVisitNextChild(node, result)) break;
            const childResult = children[i].accept(this);
            result = this.aggregateResult(result, childResult);
        }
        return result;
    }
    /**
   * Aggregates the results of visiting multiple children of a node.
   *
   * The default implementation returns `nextResult`, meaning
   * {@link #visitChildren} will return the result of the last child visited
   * (or return the initial value if the node has no children).
   *
   * @param _aggregate The previous aggregate value. In the default
   * implementation, the aggregate value is initialized to
   * {@link #defaultResult}, which is passed as the `aggregate` argument
   * to this method after the first child node is visited.
   * @param nextResult The result of the immediately preceeding call to visit
   * a child node.
   *
   * @returns The updated aggregate result.
   */ aggregateResult(_aggregate, nextResult) {
        return nextResult;
    }
    /**
   * This method is called before visiting each child in
   * {@link #visitChildren}. When the method is first called\ `currentResult`
   * will be the initial value (in the default implementation, the initial value
   * is returned by a call to {@link #defaultResult}).
   *
   * The default implementation always returns `true`, indicating that
   * `visitChildren` should only return after all children are visited.
   * One reason to override this method is to provide a "short circuit"
   * evaluation option for situations where the result of visiting a single
   * child has the potential to determine the result of the visit operation as
   * a whole.
   *
   * @param _node The {@link AstNode} whose children are currently being
   * visited.
   * @param _currentResult The current aggregate result of the children visited
   * to the current point.
   *
   * @returns `true` to continue visiting children. Otherwise return
   * `false` to stop visiting children and immediately return the
   * current aggregate result from {@link #visitChildren}.
   */ shouldVisitNextChild(_node, _currentResult) {
        return true;
    }
}
module.exports["AbstractJastVisitor"] = $2a191efd0d34b17f$export$51be62b46ee668fd;

});

parcelRegister("aAFSf", function(module, exports) {

var $hTvki = parcelRequire("hTvki");


var $2XqLN = parcelRequire("2XqLN");


var $f9r94 = parcelRequire("f9r94");

var $jHyNg = parcelRequire("jHyNg");


var $9foTl = parcelRequire("9foTl");


var $3St4x = parcelRequire("3St4x");


var $9bonr = parcelRequire("9bonr");

class $c714a192910523d5$export$d0857f60ff1f385 {
    constructor(){
        this.errors = [];
        this.syntaxError = (_recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
            if (offendingSymbol === undefined) this.errors.push(new (0, $3St4x.JQLParseError)(msg));
            else this.errors.push(new (0, $9bonr.JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
        };
    }
}







class $fd187a062a004a6a$export$d3c14d7188b09387 {
    visit(_tree) {
        throw new Error('Unsupported operation visit(ParseTree)');
    }
    visitChildren(_node) {
        throw new Error('Unsupported operation visitChildren(RuleNode)');
    }
    visitErrorNode(_node) {
        throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
    }
    visitTerminal(_node) {
        throw new Error('Unsupported operation visitTerminal(TerminalNode)');
    }
    constructor(tokens){
        this.tokens = void 0;
        this.tokens = tokens;
    }
}
const $fd187a062a004a6a$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
        startToken.startIndex,
        (stopToken || startToken).stopIndex + 1
    ];
const $fd187a062a004a6a$export$264629d4cd3cad3f = (ctx)=>[
        ctx.start.startIndex,
        ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
    ];
const $fd187a062a004a6a$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$fd187a062a004a6a$export$85a4e6d858dbc6fb(node.payload));
const $fd187a062a004a6a$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');



var $awcA2 = parcelRequire("awcA2");




/**
 * Type predicate to assert an argument is not undefined.
 */ function $9c5ed597fed1d164$export$9a1adf421b69c6a(x) {
    return x !== undefined;
}











class $fbae2f0fab852b6a$export$617850cb96304515 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.visitJqlString = (ctx)=>{
            const text = this.tokens.getText(ctx);
            const position = (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx);
            let value;
            if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
            else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
            else // unquoted string
            value = text;
            return {
                text: text,
                value: value,
                position: position
            };
        };
    }
}


class $b26245b4e817fe38$export$46b5a1f6d962d533 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $fbae2f0fab852b6a$export$617850cb96304515)(this.tokens);
        this.visitJqlArgument = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $9foTl.internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $9foTl.internalCreators).argument(text, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
            }
        };
    }
}




class $d2dbf28672f03342$export$c6a85c4c3bf2317d extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $fbae2f0fab852b6a$export$617850cb96304515)(this.tokens);
        this.fieldPropertyVisitor = new $d2dbf28672f03342$var$FieldPropertyVisitor(this.tokens);
        this.visitJqlNumberField = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $9foTl.internalCreators).field(text, text, undefined, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
        this.visitJqlNonNumberField = (ctx)=>{
            const stringContext = ctx.jqlString();
            const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $9foTl.internalCreators).field(stringValue.value, stringValue.text, properties, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
            }
            const text = this.tokens.getText(ctx);
            return (0, $9foTl.internalCreators).field(text, text, properties, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $d2dbf28672f03342$var$FieldPropertyVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $b26245b4e817fe38$export$46b5a1f6d962d533)(this.tokens);
        this.propertyArgumentVisitor = new $d2dbf28672f03342$var$PropertyArgumentVisitor(this.tokens);
        this.visitJqlFieldProperty = (ctx)=>{
            const argumentContext = ctx.jqlArgument();
            const propertyArgumentContext = ctx.jqlPropertyArgument();
            const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
            return (0, $9foTl.internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $d2dbf28672f03342$var$PropertyArgumentVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $b26245b4e817fe38$export$46b5a1f6d962d533)(this.tokens);
        this.visitJqlPropertyArgument = (ctx)=>{
            return ctx.jqlArgument().accept(this.argumentVisitor);
        };
    }
}


class $c267d55591ca61d7$export$2774b71b99734811 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.searchSortVisitor = new $c267d55591ca61d7$var$SearchSortVisitor(this.tokens);
        this.visitJqlOrderBy = (ctx)=>{
            // If this rule returned due to an exception then the order by operator is incomplete so we should exit early,
            // e.g. 'order '.
            if (ctx.exception) return undefined;
            const operator = (0, $9foTl.internalCreators).orderByOperator((0, $fd187a062a004a6a$export$85a4e6d858dbc6fb)(ctx.ORDER().payload, ctx.BY().payload));
            const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return (0, $9foTl.internalCreators).orderBy(fields, operator, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $c267d55591ca61d7$var$SearchSortVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $d2dbf28672f03342$export$c6a85c4c3bf2317d)(this.tokens);
        this.visitJqlSearchSort = (ctx)=>{
            const fieldCtx = ctx.jqlField();
            // If the field rule is returned due to an exception then we should ignore this search search rule. This happens
            // when there are no fields following and order by clause, e.g. 'order by '
            if (fieldCtx.exception) return undefined;
            let direction;
            const desc = ctx.DESC();
            const asc = ctx.ASC();
            if (desc !== undefined) direction = (0, $9foTl.internalCreators).orderByDirection((0, $awcA2.ORDER_BY_DIRECTION_DESC), (0, $fd187a062a004a6a$export$85a4e6d858dbc6fb)(desc.payload));
            else if (asc !== undefined) direction = (0, $9foTl.internalCreators).orderByDirection((0, $awcA2.ORDER_BY_DIRECTION_ASC), (0, $fd187a062a004a6a$export$85a4e6d858dbc6fb)(asc.payload));
            return (0, $9foTl.internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}



var $chZN7 = parcelRequire("chZN7");













var $bztru = parcelRequire("bztru");











class $e2a9a737e8127d30$export$a55432f0884633e4 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.visitJqlNumber = (ctx)=>{
            const text = this.tokens.getText(ctx);
            return (0, $9foTl.internalCreators).valueOperand(text, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}



class $87aabac83748a70c$export$ef8ae1aa15d9c9af extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $fbae2f0fab852b6a$export$617850cb96304515)(this.tokens);
        this.numberVisitor = new (0, $e2a9a737e8127d30$export$a55432f0884633e4)(this.tokens);
        this.functionNameVisitor = new $87aabac83748a70c$var$FunctionNameVisitor(this.tokens);
        this.argumentListVisitor = new $87aabac83748a70c$var$ArgumentListVisitor(this.tokens);
        this.visitJqlOperand = (ctx)=>{
            const operandContext = [
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlList(),
                ctx.jqlFunction()
            ].find((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return operandContext?.accept(this);
        };
        this.visitJqlEmpty = (ctx)=>{
            // ANTLR will optimistically create a jqlEmpty node in some situations where user input doesn't match the EMPTY
            // token, e.g. when using value operands in IS clauses ("field is value"), where EMPTY is the only valid operand.
            if (ctx.exception) return undefined;
            return (0, $9foTl.internalCreators).keywordOperand((0, $bztru.OPERAND_EMPTY), (0, $fd187a062a004a6a$export$85a4e6d858dbc6fb)(ctx.EMPTY().payload));
        };
        this.visitJqlValue = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $9foTl.internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
            }
            const numberContext = ctx.jqlNumber();
            if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
        };
        this.visitJqlList = (ctx)=>{
            const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return (0, $9foTl.internalCreators).listOperand(values, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
        this.visitJqlFunction = (ctx)=>{
            const argumentListContext = ctx.jqlArgumentList();
            return (0, $9foTl.internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $87aabac83748a70c$var$FunctionNameVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.stringVisitor = new (0, $fbae2f0fab852b6a$export$617850cb96304515)(this.tokens);
        this.visitJqlFunctionName = (ctx)=>{
            const stringContext = ctx.jqlString();
            if (stringContext !== undefined) {
                const stringValue = stringContext.accept(this.stringVisitor);
                return (0, $9foTl.internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
            } else {
                const text = this.tokens.getText(ctx);
                return (0, $9foTl.internalCreators).functionString(text, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
            }
        };
    }
}
class $87aabac83748a70c$var$ArgumentListVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.argumentVisitor = new (0, $b26245b4e817fe38$export$46b5a1f6d962d533)(this.tokens);
        this.visitJqlArgumentList = (ctx)=>{
            return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
        };
    }
}






var $jNj2z = parcelRequire("jNj2z");


class $930ddd557be618a7$export$e56f89ba95b51d2a extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    visitJqlEqualsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $jNj2z.isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
        return (0, $9foTl.internalCreators).operator(text, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlLikeOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $jNj2z.isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
        return (0, $9foTl.internalCreators).operator(text, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlComparisonOperator(ctx) {
        const text = this.tokens.getText(ctx);
        if (!(0, $jNj2z.isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
        return (0, $9foTl.internalCreators).operator(text, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fd187a062a004a6a$export$7c2714a5250b9239)(text);
        if (!(0, $jNj2z.isInOperator)(value)) // This can happen if an incomplete operator is used, e.g. `status not open`.
        return undefined;
        return (0, $9foTl.internalCreators).operator(value, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlIsOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fd187a062a004a6a$export$7c2714a5250b9239)(text);
        if (!(0, $jNj2z.isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
        return (0, $9foTl.internalCreators).operator(value, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlWasOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fd187a062a004a6a$export$7c2714a5250b9239)(text);
        if (!(0, $jNj2z.isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
        return (0, $9foTl.internalCreators).operator(value, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlWasInOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fd187a062a004a6a$export$7c2714a5250b9239)(text);
        if (!(0, $jNj2z.isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
        return (0, $9foTl.internalCreators).operator(value, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    visitJqlChangedOperator(ctx) {
        const text = this.tokens.getText(ctx);
        const value = (0, $fd187a062a004a6a$export$7c2714a5250b9239)(text);
        if (!(0, $jNj2z.isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
        return (0, $9foTl.internalCreators).operator(value, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
    }
    constructor(...args){
        super(...args);
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const { sourceInterval: sourceInterval } = node;
            const text = this.tokens.getText(sourceInterval);
            if (text) {
                const value = (0, $fd187a062a004a6a$export$7c2714a5250b9239)(text);
                const { a: startIndex, b: stopIndex } = sourceInterval;
                const startToken = this.tokens.get(startIndex);
                const stopToken = this.tokens.get(stopIndex);
                const position = (0, $fd187a062a004a6a$export$85a4e6d858dbc6fb)(startToken, stopToken);
                if ((0, $jNj2z.isOperator)(value)) return (0, $9foTl.internalCreators).operator(value, text, position);
            }
            return undefined;
        };
    }
}





const $3697fa5c762ebd6c$export$3d56e2ae1b4bbbf9 = 'after';
const $3697fa5c762ebd6c$export$f0a816341603bb63 = 'before';
const $3697fa5c762ebd6c$export$cdc81c84f768d513 = 'by';
const $3697fa5c762ebd6c$export$8a5280c65e704c3d = 'during';
const $3697fa5c762ebd6c$export$71f882dcac65f97a = 'from';
const $3697fa5c762ebd6c$export$5685a35c6b0a7ee8 = 'on';
const $3697fa5c762ebd6c$export$5a83c4789e531a = 'to';
const $3697fa5c762ebd6c$export$e200440af9f1d9f = [
    $3697fa5c762ebd6c$export$3d56e2ae1b4bbbf9,
    $3697fa5c762ebd6c$export$f0a816341603bb63,
    $3697fa5c762ebd6c$export$cdc81c84f768d513,
    $3697fa5c762ebd6c$export$8a5280c65e704c3d,
    $3697fa5c762ebd6c$export$71f882dcac65f97a,
    $3697fa5c762ebd6c$export$5685a35c6b0a7ee8,
    $3697fa5c762ebd6c$export$5a83c4789e531a
];


const $2b3fc7656d053fa7$export$188978ad94919403 = (operator)=>(0, $3697fa5c762ebd6c$export$e200440af9f1d9f).includes(operator);





class $ae29f81e1850476f$export$33bb52a35c693109 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.predicateOperatorVisitor = new $ae29f81e1850476f$var$PredicateOperatorVisitor(this.tokens);
        this.predicateOperandVisitor = new $ae29f81e1850476f$var$PredicateOperandVisitor(this.tokens);
        this.visitJqlWasPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx);
            return (0, $9foTl.internalCreators).predicate(operator, operand, position);
        };
        this.visitJqlChangedPredicate = (ctx)=>{
            const operator = this.getOperatorForContexts([
                ctx.jqlDatePredicateOperator(),
                ctx.jqlDateRangePredicateOperator(),
                ctx.jqlUserPredicateOperator(),
                ctx.jqlValuePredicateOperator()
            ]);
            const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
            const position = (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx);
            return (0, $9foTl.internalCreators).predicate(operator, operand, position);
        };
        this.getOperatorForContexts = (contexts)=>{
            const operatorContext = contexts.find((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
            else throw new Error('Undefined predicate operator context');
        };
    }
}
class $ae29f81e1850476f$var$PredicateOperatorVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.visitJqlDatePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlDateRangePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlUserPredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.visitJqlValuePredicateOperator = (ctx)=>{
            return this.getPredicateOperator(ctx);
        };
        this.getPredicateOperator = (ctx)=>{
            const text = this.tokens.getText(ctx);
            // Replace consecutive whitespace chars with single space
            const value = text.toLowerCase().replace(/\s+/g, ' ');
            if (!(0, $2b3fc7656d053fa7$export$188978ad94919403)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
            return (0, $9foTl.internalCreators).predicateOperator(value, text, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}
class $ae29f81e1850476f$var$PredicateOperandVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $87aabac83748a70c$export$ef8ae1aa15d9c9af)(this.tokens);
        this.visitJqlPredicateOperand = (ctx)=>{
            return ctx.jqlOperand().accept(this.operandVisitor);
        };
    }
}


class $f8dd793299edde69$export$14576ae5bd1874a9 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.fieldVisitor = new (0, $d2dbf28672f03342$export$c6a85c4c3bf2317d)(this.tokens);
        this.terminalClauseRhsVisitor = new $f8dd793299edde69$var$TerminalClauseRhsVisitor(this.tokens);
        this.visitJqlTerminalClause = (ctx)=>{
            const field = ctx.jqlField().accept(this.fieldVisitor);
            const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
            const position = (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx);
            return (0, $9foTl.internalCreators).terminalClause(field, operator, operand, predicates, position);
        };
    }
}
class $f8dd793299edde69$var$TerminalClauseRhsVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.operatorVisitor = new (0, $930ddd557be618a7$export$e56f89ba95b51d2a)(this.tokens);
        this.terminalClauseOperandVisitor = new $f8dd793299edde69$var$TerminalClauseOperandVisitor(this.tokens);
        this.predicateVisitor = new (0, $ae29f81e1850476f$export$33bb52a35c693109)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlLikeClause = (ctx)=>{
            const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlComparisonClause = (ctx)=>{
            const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlInClause = (ctx)=>{
            const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlIsClause = (ctx)=>{
            const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            return {
                operator: operator,
                operand: operand,
                predicates: []
            };
        };
        this.visitJqlWasClause = (ctx)=>{
            const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlWasInClause = (ctx)=>{
            const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
            const operand = ctx.accept(this.terminalClauseOperandVisitor);
            const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return {
                operator: operator,
                operand: operand,
                predicates: predicates
            };
        };
        this.visitJqlChangedClause = (ctx)=>{
            const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
            const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return {
                operator: operator,
                operand: undefined,
                predicates: predicates
            };
        };
        // Recover from clause type ambiguities, e.g. "issuetype was " (which can be a WAS or WAS IN clause)
        this.visitChildren = (node)=>{
            const operator = node.accept(this.operatorVisitor);
            return {
                operator: operator,
                operand: undefined,
                predicates: []
            };
        };
    }
}
class $f8dd793299edde69$var$TerminalClauseOperandVisitor extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.operandVisitor = new (0, $87aabac83748a70c$export$ef8ae1aa15d9c9af)(this.tokens);
        this.visitJqlEqualsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlLikeClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlComparisonClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlIsClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty()
            ]);
        };
        this.visitJqlWasClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlEmpty(),
                ctx.jqlValue(),
                ctx.jqlFunction()
            ]);
        };
        this.visitJqlWasInClause = (ctx)=>{
            return this.getOperandForContexts([
                ctx.jqlList(),
                ctx.jqlFunction()
            ]);
        };
        this.getOperandForContexts = (contexts)=>{
            const operandContext = contexts.find((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            return operandContext?.accept(this.operandVisitor);
        };
    }
}


class $151e0cdf80cbf0e7$export$c573472f1d20e15d extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.terminalClauseVisitor = new (0, $f8dd793299edde69$export$14576ae5bd1874a9)(this.tokens);
        this.visitJqlWhere = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
        this.visitJqlOrClause = (ctx)=>{
            const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            if (clauses.length > 1) {
                const operator = (0, $9foTl.internalCreators).compoundOperator((0, $chZN7.COMPOUND_OPERATOR_OR), (0, $fd187a062a004a6a$export$30d51184879cbaa8)(ctx.OR()));
                return (0, $9foTl.internalCreators).compoundClause(operator, clauses, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlAndClause = (ctx)=>{
            const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, $9c5ed597fed1d164$export$9a1adf421b69c6a));
            if (clauses.length > 1) {
                const operator = (0, $9foTl.internalCreators).compoundOperator((0, $chZN7.COMPOUND_OPERATOR_AND), (0, $fd187a062a004a6a$export$30d51184879cbaa8)(ctx.AND()));
                return (0, $9foTl.internalCreators).compoundClause(operator, clauses, (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
            }
            return clauses.length === 0 ? undefined : clauses[0];
        };
        this.visitJqlNotClause = (ctx)=>{
            const notClauseContext = ctx.jqlNotClause();
            const subClauseContext = ctx.jqlSubClause();
            const terminalClauseContext = ctx.jqlTerminalClause();
            let clause;
            if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
            else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
            else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
            // Our token can be either NOT or !
            let notToken = ctx.NOT();
            notToken = notToken === undefined ? ctx.BANG() : notToken;
            if (notToken && clause) return (0, $9foTl.internalCreators).notClause(clause, (0, $9foTl.internalCreators).notClauseOperator((0, $fd187a062a004a6a$export$85a4e6d858dbc6fb)(notToken.payload)), (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
            return clause;
        };
        this.visitJqlSubClause = (ctx)=>{
            return this.visitJqlOrClause(ctx.jqlOrClause());
        };
    }
}


class $08957ff9b6ed141c$export$418003b930734805 extends (0, $fd187a062a004a6a$export$d3c14d7188b09387) {
    constructor(...args){
        super(...args);
        this.whereVisitor = new (0, $151e0cdf80cbf0e7$export$c573472f1d20e15d)(this.tokens);
        this.orderByVisitor = new (0, $c267d55591ca61d7$export$2774b71b99734811)(this.tokens);
        this.visitJqlQuery = (ctx)=>{
            const whereContext = ctx.jqlWhere();
            const orderByContext = ctx.jqlOrderBy();
            return (0, $9foTl.internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, $fd187a062a004a6a$export$264629d4cd3cad3f)(ctx));
        };
    }
}


class $cd13f8f14bfa73a1$export$99cae18a5a6ba8cf {
    setErrorHandler(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    }
    setErrorListeners(errorListeners) {
        this.errorListeners = this.errorListeners.concat(errorListeners);
        return this;
    }
    build(value) {
        const tokens = this.getTokens(value);
        const parser = this.getParser(tokens);
        const astErrorListener = new (0, $c714a192910523d5$export$d0857f60ff1f385)();
        parser.removeErrorListeners();
        parser.addErrorListener(astErrorListener);
        this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
        if (this.errorHandler) {
            parser.errorHandler = this.errorHandler;
            this.errorHandler.reset(parser);
        }
        const visitor = new (0, $08957ff9b6ed141c$export$418003b930734805)(tokens);
        try {
            const parseTree = parser.jqlQuery();
            const query = parseTree.accept(visitor);
            return (0, $9foTl.default).jast(query, value, astErrorListener.errors);
        } catch (error) {
            return (0, $9foTl.default).jast(undefined, value, [
                new (0, $3St4x.JQLParseError)(error.message, error)
            ]);
        }
    }
    constructor(){
        this.errorListeners = [];
        this.errorHandler = undefined;
        this.getTokens = (0, $2XqLN.default)((value)=>{
            const chars = (0, $hTvki.CharStreams).fromString(value);
            const lexer = new (0, $f9r94.JQLLexer)(chars);
            return new (0, $hTvki.CommonTokenStream)(lexer);
        });
        this.getParser = (0, $2XqLN.default)((tokens)=>new (0, $jHyNg.JQLParser)(tokens));
    }
}
module.exports["JastBuilder"] = $cd13f8f14bfa73a1$export$99cae18a5a6ba8cf;

});

parcelRegister("hTvki", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d06fdf7cc4c2ca54$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d06fdf7cc4c2ca54$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d06fdf7cc4c2ca54$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("bzv2G")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("1dznN")), module.exports);

// export * from "./ANTLRFileStream";
$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("88hdm")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("g5y6J")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("gvaIw")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("3DQZ5")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("892DV")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("8O5Sc")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("1mRlg")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("dasyL")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("aucRF")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("bO1lR")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("lwiXx")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("goW0A")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("30Gp3")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("7qAGk")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("2M3s9")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("1GSEa")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("9payv")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("eK8do")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("hEcm0")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("e4hZr")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("1XGWL")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("lgiUf")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("dF72r")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("dCLTv")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("6gTKJ")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("ed0cM")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("7EUlr")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("fPBfc")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("lINPT")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("jzLQT")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("lEpws")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("cVMBX")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("kNx2J")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("9D4O5")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("6biZ5")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("lxPhv")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("lWDte")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("4ctYY")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("edOCj")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("7C4OZ")), module.exports);

// export * from "./UnbufferedCharStream";
// export * from "./UnbufferedTokenStream";
$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("jcv78")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("auHu3")), module.exports);

$d06fdf7cc4c2ca54$var$__exportStar((parcelRequire("7pR22")), module.exports); //# sourceMappingURL=index.js.map

});

parcelRegister("bzv2G", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=ANTLRErrorListener.js.map

});

parcelRegister("1dznN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=ANTLRErrorStrategy.js.map

});

parcelRegister("88hdm", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ // ConvertTo-TS run at 2016-10-04T11:26:49.0828748-07:00
var $5ebc6c831a588622$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ANTLRInputStream = void 0;

var $9ir1r = parcelRequire("9ir1r");


var $4w9vi = parcelRequire("4w9vi");


var $eK8do = parcelRequire("eK8do");

const $5ebc6c831a588622$var$READ_BUFFER_SIZE = 1024;
const $5ebc6c831a588622$var$INITIAL_BUFFER_SIZE = 1024;
/**
 * Vacuum all input from a {@link Reader}/{@link InputStream} and then treat it
 * like a `char[]` buffer. Can also pass in a {@link String} or
 * `char[]` to use.
 *
 * If you need encoding, pass in stream/reader with correct encoding.
 *
 * @deprecated as of 4.7, please use `CharStreams` interface.
 */ class $5ebc6c831a588622$var$ANTLRInputStream {
    /** Reset the stream so that it's in the same state it was
     *  when the object was created *except* the data array is not
     *  touched.
     */ reset() {
        this.p = 0;
    }
    consume() {
        if (this.p >= this.n) {
            $9ir1r(this.LA(1) === $eK8do.IntStream.EOF);
            throw new Error("cannot consume EOF");
        }
        //System.out.println("prev p="+p+", c="+(char)data[p]);
        if (this.p < this.n) this.p++;
    }
    LA(i) {
        if (i === 0) return 0; // undefined
        if (i < 0) {
            i++; // e.g., translate LA(-1) to use offset i=0; then data[p+0-1]
            if (this.p + i - 1 < 0) return $eK8do.IntStream.EOF; // invalid; no char before first char
        }
        if (this.p + i - 1 >= this.n) //System.out.println("char LA("+i+")=EOF; p="+p);
        return $eK8do.IntStream.EOF;
        //System.out.println("char LA("+i+")="+(char)data[p+i-1]+"; p="+p);
        //System.out.println("LA("+i+"); p="+p+" n="+n+" data.length="+data.length);
        return this.data.charCodeAt(this.p + i - 1);
    }
    LT(i) {
        return this.LA(i);
    }
    /** Return the current input symbol index 0..n where n indicates the
     *  last symbol has been read.  The index is the index of char to
     *  be returned from LA(1).
     */ get index() {
        return this.p;
    }
    get size() {
        return this.n;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    /** consume() ahead until p==index; can't just set p=index as we must
     *  update line and charPositionInLine. If we seek backwards, just set p
     */ seek(index) {
        if (index <= this.p) {
            this.p = index; // just jump; don't update stream state (line, ...)
            return;
        }
        // seek forward, consume until p hits index or n (whichever comes first)
        index = Math.min(index, this.n);
        while(this.p < index)this.consume();
    }
    getText(interval) {
        let start = interval.a;
        let stop = interval.b;
        if (stop >= this.n) stop = this.n - 1;
        let count = stop - start + 1;
        if (start >= this.n) return "";
        // System.err.println("data: "+Arrays.toString(data)+", n="+n+
        // 				   ", start="+start+
        // 				   ", stop="+stop);
        return this.data.substr(start, count);
    }
    get sourceName() {
        if (!this.name) return $eK8do.IntStream.UNKNOWN_SOURCE_NAME;
        return this.name;
    }
    toString() {
        return this.data;
    }
    /** Copy data in string to a local char array */ constructor(input){
        /** 0..n-1 index into string of next char */ this.p = 0;
        this.data = input;
        this.n = input.length;
    }
}
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "consume", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "LA", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "index", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "size", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "mark", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "release", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "seek", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "getText", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "sourceName", null);
$5ebc6c831a588622$var$__decorate([
    $4w9vi.Override
], $5ebc6c831a588622$var$ANTLRInputStream.prototype, "toString", null);
module.exports.ANTLRInputStream = $5ebc6c831a588622$var$ANTLRInputStream; //# sourceMappingURL=ANTLRInputStream.js.map

});

parcelRegister("4w9vi", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
function $34a185d04f37bd99$var$NotNull(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.NotNull = $34a185d04f37bd99$var$NotNull;
function $34a185d04f37bd99$var$Nullable(target, propertyKey, propertyDescriptor) {
// intentionally empty
}
module.exports.Nullable = $34a185d04f37bd99$var$Nullable;
function $34a185d04f37bd99$var$Override(target, propertyKey, propertyDescriptor) {
// do something with 'target' ...
}
module.exports.Override = $34a185d04f37bd99$var$Override;
function $34a185d04f37bd99$var$SuppressWarnings(options) {
    return (target, propertyKey, descriptor)=>{
    // intentionally empty
    };
}
module.exports.SuppressWarnings = $34a185d04f37bd99$var$SuppressWarnings; //# sourceMappingURL=Decorators.js.map

});

parcelRegister("eK8do", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntStream = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.6934376-07:00
var $abbbbbe0505aa838$var$IntStream;
(function(IntStream) {
    /**
     * The value returned by {@link #LA LA()} when the end of the stream is
     * reached.
     */ IntStream.EOF = -1;
    /**
     * The value returned by {@link #getSourceName} when the actual name of the
     * underlying source is not known.
     */ IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
})($abbbbbe0505aa838$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {})); //# sourceMappingURL=IntStream.js.map

});

parcelRegister("g5y6J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bb67920bd0887ea6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BailErrorStrategy = void 0;

var $goW0A = parcelRequire("goW0A");


var $1GSEa = parcelRequire("1GSEa");


var $4w9vi = parcelRequire("4w9vi");


var $im4Ak = parcelRequire("im4Ak");

/**
 * This implementation of {@link ANTLRErrorStrategy} responds to syntax errors
 * by immediately canceling the parse operation with a
 * {@link ParseCancellationException}. The implementation ensures that the
 * {@link ParserRuleContext#exception} field is set for all parse tree nodes
 * that were not completed prior to encountering the error.
 *
 * This error strategy is useful in the following scenarios.
 *
 * * **Two-stage parsing:** This error strategy allows the first
 *   stage of two-stage parsing to immediately terminate if an error is
 *   encountered, and immediately fall back to the second stage. In addition to
 *   avoiding wasted work by attempting to recover from errors here, the empty
 *   implementation of {@link BailErrorStrategy#sync} improves the performance of
 *   the first stage.
 * * **Silent validation:** When syntax errors are not being
 *   reported or logged, and the parse result is simply ignored if errors occur,
 *   the {@link BailErrorStrategy} avoids wasting work on recovering from errors
 *   when the result will be ignored either way.
 *
 * ```
 * myparser.errorHandler = new BailErrorStrategy();
 * ```
 *
 * @see Parser.errorHandler
 */ class $bb67920bd0887ea6$var$BailErrorStrategy extends $goW0A.DefaultErrorStrategy {
    /** Instead of recovering from exception `e`, re-throw it wrapped
     *  in a {@link ParseCancellationException} so it is not caught by the
     *  rule function catches.  Use {@link Exception#getCause()} to get the
     *  original {@link RecognitionException}.
     */ recover(recognizer, e) {
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $im4Ak.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover inline; if the parser
     *  successfully recovers, it won't throw an exception.
     */ recoverInline(recognizer) {
        let e = new $1GSEa.InputMismatchException(recognizer);
        for(let context = recognizer.context; context; context = context.parent)context.exception = e;
        throw new $im4Ak.ParseCancellationException(e);
    }
    /** Make sure we don't attempt to recover from problems in subrules. */ sync(recognizer) {
    // intentionally empty
    }
}
$bb67920bd0887ea6$var$__decorate([
    $4w9vi.Override
], $bb67920bd0887ea6$var$BailErrorStrategy.prototype, "recover", null);
$bb67920bd0887ea6$var$__decorate([
    $4w9vi.Override
], $bb67920bd0887ea6$var$BailErrorStrategy.prototype, "recoverInline", null);
$bb67920bd0887ea6$var$__decorate([
    $4w9vi.Override
], $bb67920bd0887ea6$var$BailErrorStrategy.prototype, "sync", null);
module.exports.BailErrorStrategy = $bb67920bd0887ea6$var$BailErrorStrategy; //# sourceMappingURL=BailErrorStrategy.js.map

});

parcelRegister("goW0A", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bf0be282b5a85462$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bf0be282b5a85462$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorStrategy = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $2M3s9 = parcelRequire("2M3s9");


var $1GSEa = parcelRequire("1GSEa");


var $g8cb0 = parcelRequire("g8cb0");


var $dF72r = parcelRequire("dF72r");


var $ca31u = parcelRequire("ca31u");


var $lxPhv = parcelRequire("lxPhv");


var $4w9vi = parcelRequire("4w9vi");

/**
 * This is the default implementation of {@link ANTLRErrorStrategy} used for
 * error reporting and recovery in ANTLR parsers.
 */ class $bf0be282b5a85462$var$DefaultErrorStrategy {
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition} to
     * ensure that the handler is not in error recovery mode.
     */ reset(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * This method is called to enter error recovery mode when a recognition
     * exception is reported.
     *
     * @param recognizer the parser instance
     */ beginErrorCondition(recognizer) {
        this.errorRecoveryMode = true;
    }
    /**
     * {@inheritDoc}
     */ inErrorRecoveryMode(recognizer) {
        return this.errorRecoveryMode;
    }
    /**
     * This method is called to leave error recovery mode after recovering from
     * a recognition exception.
     *
     * @param recognizer
     */ endErrorCondition(recognizer) {
        this.errorRecoveryMode = false;
        this.lastErrorStates = undefined;
        this.lastErrorIndex = -1;
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation simply calls {@link #endErrorCondition}.
     */ reportMatch(recognizer) {
        this.endErrorCondition(recognizer);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation returns immediately if the handler is already
     * in error recovery mode. Otherwise, it calls {@link #beginErrorCondition}
     * and dispatches the reporting task based on the runtime type of `e`
     * according to the following table.
     *
     * * {@link NoViableAltException}: Dispatches the call to
     *   {@link #reportNoViableAlternative}
     * * {@link InputMismatchException}: Dispatches the call to
     *   {@link #reportInputMismatch}
     * * {@link FailedPredicateException}: Dispatches the call to
     *   {@link #reportFailedPredicate}
     * * All other types: calls {@link Parser#notifyErrorListeners} to report
     *   the exception
     */ reportError(recognizer, e) {
        // if we've already reported an error and have not matched a token
        // yet successfully, don't report any errors.
        if (this.inErrorRecoveryMode(recognizer)) //			System.err.print("[SPURIOUS] ");
        return; // don't report spurious errors
        this.beginErrorCondition(recognizer);
        if (e instanceof $dF72r.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
        else if (e instanceof $1GSEa.InputMismatchException) this.reportInputMismatch(recognizer, e);
        else if (e instanceof $2M3s9.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
        else {
            console.error(`unknown recognition error type: ${e}`);
            this.notifyErrorListeners(recognizer, e.toString(), e);
        }
    }
    notifyErrorListeners(recognizer, message, e) {
        let offendingToken = e.getOffendingToken(recognizer);
        if (offendingToken === undefined) // Pass null to notifyErrorListeners so it in turn calls the error listeners with undefined as the offending
        // token. If we passed undefined, it would instead call the listeners with currentToken from the parser.
        offendingToken = null;
        recognizer.notifyErrorListeners(message, offendingToken, e);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation resynchronizes the parser by consuming tokens
     * until we find one in the resynchronization set--loosely the set of tokens
     * that can follow the current rule.
     */ recover(recognizer, e) {
        //		System.out.println("recover in "+recognizer.getRuleInvocationStack()+
        //						   " index="+recognizer.inputStream.index+
        //						   ", lastErrorIndex="+
        //						   lastErrorIndex+
        //						   ", states="+lastErrorStates);
        if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) // uh oh, another error at same token index and previously-visited
        // state in ATN; must be a case where LT(1) is in the recovery
        // token set so nothing got consumed. Consume a single token
        // at least to prevent an infinite loop; this is a failsafe.
        //			System.err.println("seen error condition before index="+
        //							   lastErrorIndex+", states="+lastErrorStates);
        //			System.err.println("FAILSAFE consumes "+recognizer.getTokenNames()[recognizer.inputStream.LA(1)]);
        recognizer.consume();
        this.lastErrorIndex = recognizer.inputStream.index;
        if (!this.lastErrorStates) this.lastErrorStates = new $g8cb0.IntervalSet();
        this.lastErrorStates.add(recognizer.state);
        let followSet = this.getErrorRecoverySet(recognizer);
        this.consumeUntil(recognizer, followSet);
    }
    /**
     * The default implementation of {@link ANTLRErrorStrategy#sync} makes sure
     * that the current lookahead symbol is consistent with what were expecting
     * at this point in the ATN. You can call this anytime but ANTLR only
     * generates code to check before subrules/loops and each iteration.
     *
     * Implements Jim Idle's magic sync mechanism in closures and optional
     * subrules. E.g.,
     *
     * ```antlr
     * a : sync ( stuff sync )* ;
     * sync : {consume to what can follow sync} ;
     * ```
     *
     * At the start of a sub rule upon error, {@link #sync} performs single
     * token deletion, if possible. If it can't do that, it bails on the current
     * rule and uses the default error recovery, which consumes until the
     * resynchronization set of the current rule.
     *
     * If the sub rule is optional (`(...)?`, `(...)*`, or block
     * with an empty alternative), then the expected set includes what follows
     * the subrule.
     *
     * During loop iteration, it consumes until it sees a token that can start a
     * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
     * stay in the loop as long as possible.
     *
     * **ORIGINS**
     *
     * Previous versions of ANTLR did a poor job of their recovery within loops.
     * A single mismatch token or missing token would force the parser to bail
     * out of the entire rules surrounding the loop. So, for rule
     *
     * ```antlr
     * classDef : 'class' ID '{' member* '}'
     * ```
     *
     * input with an extra token between members would force the parser to
     * consume until it found the next class definition rather than the next
     * member definition of the current class.
     *
     * This functionality cost a little bit of effort because the parser has to
     * compare token set at the start of the loop and at each iteration. If for
     * some reason speed is suffering for you, you can turn off this
     * functionality by simply overriding this method as a blank { }.
     */ sync(recognizer) {
        let s = recognizer.interpreter.atn.states[recognizer.state];
        //		System.err.println("sync @ "+s.stateNumber+"="+s.getClass().getSimpleName());
        // If already recovering, don't try to sync
        if (this.inErrorRecoveryMode(recognizer)) return;
        let tokens = recognizer.inputStream;
        let la = tokens.LA(1);
        // try cheaper subset first; might get lucky. seems to shave a wee bit off
        let nextTokens = recognizer.atn.nextTokens(s);
        if (nextTokens.contains(la)) {
            // We are sure the token matches
            this.nextTokensContext = undefined;
            this.nextTokensState = $ltT8J.ATNState.INVALID_STATE_NUMBER;
            return;
        }
        if (nextTokens.contains($lxPhv.Token.EPSILON)) {
            if (this.nextTokensContext === undefined) {
                // It's possible the next token won't match; information tracked
                // by sync is restricted for performance.
                this.nextTokensContext = recognizer.context;
                this.nextTokensState = recognizer.state;
            }
            return;
        }
        switch(s.stateType){
            case $jW0J3.ATNStateType.BLOCK_START:
            case $jW0J3.ATNStateType.STAR_BLOCK_START:
            case $jW0J3.ATNStateType.PLUS_BLOCK_START:
            case $jW0J3.ATNStateType.STAR_LOOP_ENTRY:
                // report error and recover if possible
                if (this.singleTokenDeletion(recognizer)) return;
                throw new $1GSEa.InputMismatchException(recognizer);
            case $jW0J3.ATNStateType.PLUS_LOOP_BACK:
            case $jW0J3.ATNStateType.STAR_LOOP_BACK:
                //			System.err.println("at loop back: "+s.getClass().getSimpleName());
                this.reportUnwantedToken(recognizer);
                let expecting = recognizer.getExpectedTokens();
                let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                break;
            default:
                break;
        }
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link NoViableAltException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportNoViableAlternative(recognizer, e) {
        let tokens = recognizer.inputStream;
        let input;
        if (tokens) {
            if (e.startToken.type === $lxPhv.Token.EOF) input = "<EOF>";
            else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
        } else input = "<unknown input>";
        let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is an
     * {@link InputMismatchException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportInputMismatch(recognizer, e) {
        let expected = e.expectedTokens;
        let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
        let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This is called by {@link #reportError} when the exception is a
     * {@link FailedPredicateException}.
     *
     * @see #reportError
     *
     * @param recognizer the parser instance
     * @param e the recognition exception
     */ reportFailedPredicate(recognizer, e) {
        let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
        let msg = "rule " + ruleName + " " + e.message;
        this.notifyErrorListeners(recognizer, msg, e);
    }
    /**
     * This method is called to report a syntax error which requires the removal
     * of a token from the input stream. At the time this method is called, the
     * erroneous symbol is current `LT(1)` symbol and has not yet been
     * removed from the input stream. When this method returns,
     * `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenDeletion} identifies
     * single-token deletion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportUnwantedToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let tokenName = this.getTokenErrorDisplay(t);
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * This method is called to report a syntax error which requires the
     * insertion of a missing token into the input stream. At the time this
     * method is called, the missing token has not yet been inserted. When this
     * method returns, `recognizer` is in error recovery mode.
     *
     * This method is called when {@link #singleTokenInsertion} identifies
     * single-token insertion as a viable recovery strategy for a mismatched
     * input error.
     *
     * The default implementation simply returns if the handler is already in
     * error recovery mode. Otherwise, it calls {@link #beginErrorCondition} to
     * enter error recovery mode, followed by calling
     * {@link Parser#notifyErrorListeners}.
     *
     * @param recognizer the parser instance
     */ reportMissingToken(recognizer) {
        if (this.inErrorRecoveryMode(recognizer)) return;
        this.beginErrorCondition(recognizer);
        let t = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
        recognizer.notifyErrorListeners(msg, t, undefined);
    }
    /**
     * {@inheritDoc}
     *
     * The default implementation attempts to recover from the mismatched input
     * by using single token insertion and deletion as described below. If the
     * recovery attempt fails, this method
     * {@link InputMismatchException}.
     *
     * **EXTRA TOKEN** (single token deletion)
     *
     * `LA(1)` is not what we are looking for. If `LA(2)` has the
     * right token, however, then assume `LA(1)` is some extra spurious
     * token and delete it. Then consume and return the next token (which was
     * the `LA(2)` token) as the successful result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenDeletion}.
     *
     * **MISSING TOKEN** (single token insertion)
     *
     * If current token (at `LA(1)`) is consistent with what could come
     * after the expected `LA(1)` token, then assume the token is missing
     * and use the parser's {@link TokenFactory} to create it on the fly. The
     * "insertion" is performed by returning the created token as the successful
     * result of the match operation.
     *
     * This recovery strategy is implemented by {@link #singleTokenInsertion}.
     *
     * **EXAMPLE**
     *
     * For example, Input `i=(3;` is clearly missing the `')'`. When
     * the parser returns from the nested call to `expr`, it will have
     * call chain:
     *
     * ```
     * stat → expr → atom
     * ```
     *
     * and it will be trying to match the `')'` at this point in the
     * derivation:
     *
     * ```
     * => ID '=' '(' INT ')' ('+' atom)* ';'
     *                    ^
     * ```
     *
     * The attempt to match `')'` will fail when it sees `';'` and
     * call {@link #recoverInline}. To recover, it sees that `LA(1)==';'`
     * is in the set of tokens that can follow the `')'` token reference
     * in rule `atom`. It can assume that you forgot the `')'`.
     */ recoverInline(recognizer) {
        // SINGLE TOKEN DELETION
        let matchedSymbol = this.singleTokenDeletion(recognizer);
        if (matchedSymbol) {
            // we have deleted the extra token.
            // now, move past ttype token as if all were ok
            recognizer.consume();
            return matchedSymbol;
        }
        // SINGLE TOKEN INSERTION
        if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
        // even that didn't work; must throw the exception
        if (this.nextTokensContext === undefined) throw new $1GSEa.InputMismatchException(recognizer);
        else throw new $1GSEa.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
    }
    /**
     * This method implements the single-token insertion inline error recovery
     * strategy. It is called by {@link #recoverInline} if the single-token
     * deletion strategy fails to recover from the mismatched input. If this
     * method returns `true`, `recognizer` will be in error recovery
     * mode.
     *
     * This method determines whether or not single-token insertion is viable by
     * checking if the `LA(1)` input symbol could be successfully matched
     * if it were instead the `LA(2)` symbol. If this method returns
     * `true`, the caller is responsible for creating and inserting a
     * token with the correct type to produce this behavior.
     *
     * @param recognizer the parser instance
     * @returns `true` if single-token insertion is a viable recovery
     * strategy for the current mismatched input, otherwise `false`
     */ singleTokenInsertion(recognizer) {
        let currentSymbolType = recognizer.inputStream.LA(1);
        // if current token is consistent with what could come after current
        // ATN state, then we know we're missing a token; error recovery
        // is free to conjure up and insert the missing token
        let currentState = recognizer.interpreter.atn.states[recognizer.state];
        let next = currentState.transition(0).target;
        let atn = recognizer.interpreter.atn;
        let expectingAtLL2 = atn.nextTokens(next, $ca31u.PredictionContext.fromRuleContext(atn, recognizer.context));
        //		console.warn("LT(2) set="+expectingAtLL2.toString(recognizer.getTokenNames()));
        if (expectingAtLL2.contains(currentSymbolType)) {
            this.reportMissingToken(recognizer);
            return true;
        }
        return false;
    }
    /**
     * This method implements the single-token deletion inline error recovery
     * strategy. It is called by {@link #recoverInline} to attempt to recover
     * from mismatched input. If this method returns `undefined`, the parser and error
     * handler state will not have changed. If this method returns non-`undefined`,
     * `recognizer` will *not* be in error recovery mode since the
     * returned token was a successful match.
     *
     * If the single-token deletion is successful, this method calls
     * {@link #reportUnwantedToken} to report the error, followed by
     * {@link Parser#consume} to actually "delete" the extraneous token. Then,
     * before returning {@link #reportMatch} is called to signal a successful
     * match.
     *
     * @param recognizer the parser instance
     * @returns the successfully matched {@link Token} instance if single-token
     * deletion successfully recovers from the mismatched input, otherwise
     * `undefined`
     */ singleTokenDeletion(recognizer) {
        let nextTokenType = recognizer.inputStream.LA(2);
        let expecting = this.getExpectedTokens(recognizer);
        if (expecting.contains(nextTokenType)) {
            this.reportUnwantedToken(recognizer);
            /*
            System.err.println("recoverFromMismatchedToken deleting "+
                               ((TokenStream)recognizer.inputStream).LT(1)+
                               " since "+((TokenStream)recognizer.inputStream).LT(2)+
                               " is what we want");
            */ recognizer.consume(); // simply delete extra token
            // we want to return the token we're actually matching
            let matchedSymbol = recognizer.currentToken;
            this.reportMatch(recognizer); // we know current token is correct
            return matchedSymbol;
        }
        return undefined;
    }
    /** Conjure up a missing token during error recovery.
     *
     *  The recognizer attempts to recover from single missing
     *  symbols. But, actions might refer to that missing symbol.
     *  For example, x=ID {f($x);}. The action clearly assumes
     *  that there has been an identifier matched previously and that
     *  $x points at that token. If that token is missing, but
     *  the next token in the stream is what we want we assume that
     *  this token is missing and we keep going. Because we
     *  have to return some token to replace the missing token,
     *  we have to conjure one up. This method gives the user control
     *  over the tokens returned for missing tokens. Mostly,
     *  you will want to create something special for identifier
     *  tokens. For literals such as '{' and ',', the default
     *  action in the parser or tree parser works. It simply creates
     *  a CommonToken of the appropriate type. The text will be the token.
     *  If you change what tokens must be created by the lexer,
     *  override this method to create the appropriate tokens.
     */ getMissingSymbol(recognizer) {
        let currentSymbol = recognizer.currentToken;
        let expecting = this.getExpectedTokens(recognizer);
        let expectedTokenType = $lxPhv.Token.INVALID_TYPE;
        if (!expecting.isNil) // get any element
        expectedTokenType = expecting.minElement;
        let tokenText;
        if (expectedTokenType === $lxPhv.Token.EOF) tokenText = "<missing EOF>";
        else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
        let current = currentSymbol;
        let lookback = recognizer.inputStream.tryLT(-1);
        if (current.type === $lxPhv.Token.EOF && lookback != null) current = lookback;
        return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
    }
    constructToken(tokenSource, expectedTokenType, tokenText, current) {
        let factory = tokenSource.tokenFactory;
        let x = current.tokenSource;
        let stream = x ? x.inputStream : undefined;
        return factory.create({
            source: tokenSource,
            stream: stream
        }, expectedTokenType, tokenText, $lxPhv.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
    }
    getExpectedTokens(recognizer) {
        return recognizer.getExpectedTokens();
    }
    /** How should a token be displayed in an error message? The default
     *  is to display just the text, but during development you might
     *  want to have a lot of information spit out.  Override in that case
     *  to use t.toString() (which, for CommonToken, dumps everything about
     *  the token). This is better than forcing you to override a method in
     *  your token objects because you don't have to go modify your lexer
     *  so that it creates a new Java type.
     */ getTokenErrorDisplay(t) {
        if (!t) return "<no token>";
        let s = this.getSymbolText(t);
        if (!s) {
            if (this.getSymbolType(t) === $lxPhv.Token.EOF) s = "<EOF>";
            else s = `<${this.getSymbolType(t)}>`;
        }
        return this.escapeWSAndQuote(s);
    }
    getSymbolText(symbol) {
        return symbol.text;
    }
    getSymbolType(symbol) {
        return symbol.type;
    }
    escapeWSAndQuote(s) {
        //		if ( s==null ) return s;
        s = s.replace("\n", "\\n");
        s = s.replace("\r", "\\r");
        s = s.replace("\t", "\\t");
        return "'" + s + "'";
    }
    /*  Compute the error recovery set for the current rule.  During
     *  rule invocation, the parser pushes the set of tokens that can
     *  follow that rule reference on the stack; this amounts to
     *  computing FIRST of what follows the rule reference in the
     *  enclosing rule. See LinearApproximator.FIRST().
     *  This local follow set only includes tokens
     *  from within the rule; i.e., the FIRST computation done by
     *  ANTLR stops at the end of a rule.
     *
     *  EXAMPLE
     *
     *  When you find a "no viable alt exception", the input is not
     *  consistent with any of the alternatives for rule r.  The best
     *  thing to do is to consume tokens until you see something that
     *  can legally follow a call to r *or* any rule that called r.
     *  You don't want the exact set of viable next tokens because the
     *  input might just be missing a token--you might consume the
     *  rest of the input looking for one of the missing tokens.
     *
     *  Consider grammar:
     *
     *  a : '[' b ']'
     *    | '(' b ')'
     *    ;
     *  b : c '^' INT ;
     *  c : ID
     *    | INT
     *    ;
     *
     *  At each rule invocation, the set of tokens that could follow
     *  that rule is pushed on a stack.  Here are the various
     *  context-sensitive follow sets:
     *
     *  FOLLOW(b1_in_a) = FIRST(']') = ']'
     *  FOLLOW(b2_in_a) = FIRST(')') = ')'
     *  FOLLOW(c_in_b) = FIRST('^') = '^'
     *
     *  Upon erroneous input "[]", the call chain is
     *
     *  a -> b -> c
     *
     *  and, hence, the follow context stack is:
     *
     *  depth     follow set       start of rule execution
     *    0         <EOF>                    a (from main())
     *    1          ']'                     b
     *    2          '^'                     c
     *
     *  Notice that ')' is not included, because b would have to have
     *  been called from a different context in rule a for ')' to be
     *  included.
     *
     *  For error recovery, we cannot consider FOLLOW(c)
     *  (context-sensitive or otherwise).  We need the combined set of
     *  all context-sensitive FOLLOW sets--the set of all tokens that
     *  could follow any reference in the call chain.  We need to
     *  resync to one of those tokens.  Note that FOLLOW(c)='^' and if
     *  we resync'd to that token, we'd consume until EOF.  We need to
     *  sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
     *  In this case, for input "[]", LA(1) is ']' and in the set, so we would
     *  not consume anything. After printing an error, rule c would
     *  return normally.  Rule b would not find the required '^' though.
     *  At this point, it gets a mismatched token error and
     *  exception (since LA(1) is not in the viable following token
     *  set).  The rule exception handler tries to recover, but finds
     *  the same recovery set and doesn't consume anything.  Rule b
     *  exits normally returning to rule a.  Now it finds the ']' (and
     *  with the successful match exits errorRecovery mode).
     *
     *  So, you can see that the parser walks up the call chain looking
     *  for the token that was a member of the recovery set.
     *
     *  Errors are not generated in errorRecovery mode.
     *
     *  ANTLR's error recovery mechanism is based upon original ideas:
     *
     *  "Algorithms + Data Structures = Programs" by Niklaus Wirth
     *
     *  and
     *
     *  "A note on error recovery in recursive descent parsers":
     *  http://portal.acm.org/citation.cfm?id=947902.947905
     *
     *  Later, Josef Grosch had some good ideas:
     *
     *  "Efficient and Comfortable Error Recovery in Recursive Descent
     *  Parsers":
     *  ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
     *
     *  Like Grosch I implement context-sensitive FOLLOW sets that are combined
     *  at run-time upon error to avoid overhead during parsing.
     */ getErrorRecoverySet(recognizer) {
        let atn = recognizer.interpreter.atn;
        let ctx = recognizer.context;
        let recoverSet = new $g8cb0.IntervalSet();
        while(ctx && ctx.invokingState >= 0){
            // compute what follows who invoked us
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            let follow = atn.nextTokens(rt.followState);
            recoverSet.addAll(follow);
            ctx = ctx._parent;
        }
        recoverSet.remove($lxPhv.Token.EPSILON);
        //		System.out.println("recover set "+recoverSet.toString(recognizer.getTokenNames()));
        return recoverSet;
    }
    /** Consume tokens until one matches the given token set. */ consumeUntil(recognizer, set) {
        //		System.err.println("consumeUntil("+set.toString(recognizer.getTokenNames())+")");
        let ttype = recognizer.inputStream.LA(1);
        while(ttype !== $lxPhv.Token.EOF && !set.contains(ttype)){
            //System.out.println("consume during recover LA(1)="+getTokenNames()[input.LA(1)]);
            //			recognizer.inputStream.consume();
            recognizer.consume();
            ttype = recognizer.inputStream.LA(1);
        }
    }
    constructor(){
        /**
         * Indicates whether the error strategy is currently "recovering from an
         * error". This is used to suppress reporting multiple error messages while
         * attempting to recover from a detected syntax error.
         *
         * @see #inErrorRecoveryMode
         */ this.errorRecoveryMode = false;
        /** The index into the input stream where the last error occurred.
         * 	This is used to prevent infinite loops where an error is found
         *  but no token is consumed during recovery...another error is found,
         *  ad nauseum.  This is a failsafe mechanism to guarantee that at least
         *  one token/tree node is consumed for two errors.
         */ this.lastErrorIndex = -1;
        /**
         * @see #nextTokensContext
         */ this.nextTokensState = $ltT8J.ATNState.INVALID_STATE_NUMBER;
    }
}
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reset", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportMatch", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportError", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "recover", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "sync", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull),
    $bf0be282b5a85462$var$__param(1, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull),
    $bf0be282b5a85462$var$__param(1, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull),
    $bf0be282b5a85462$var$__param(1, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.Override
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "recoverInline", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.NotNull,
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.NotNull,
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.NotNull,
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
$bf0be282b5a85462$var$__decorate([
    $4w9vi.NotNull,
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
$bf0be282b5a85462$var$__decorate([
    $bf0be282b5a85462$var$__param(0, $4w9vi.NotNull),
    $bf0be282b5a85462$var$__param(1, $4w9vi.NotNull)
], $bf0be282b5a85462$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
module.exports.DefaultErrorStrategy = $bf0be282b5a85462$var$DefaultErrorStrategy; //# sourceMappingURL=DefaultErrorStrategy.js.map

});

parcelRegister("ltT8J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fa37140cc6629a63$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNState = void 0;

var $4w9vi = parcelRequire("4w9vi");

const $fa37140cc6629a63$var$INITIAL_NUM_TRANSITIONS = 4;
/**
 * The following images show the relation of states and
 * {@link ATNState#transitions} for various grammar constructs.
 *
 * * Solid edges marked with an &#0949; indicate a required
 *   {@link EpsilonTransition}.
 *
 * * Dashed edges indicate locations where any transition derived from
 *   {@link Transition} might appear.
 *
 * * Dashed nodes are place holders for either a sequence of linked
 *   {@link BasicState} states or the inclusion of a block representing a nested
 *   construct in one of the forms below.
 *
 * * Nodes showing multiple outgoing alternatives with a `...` support
 *   any number of alternatives (one or more). Nodes without the `...` only
 *   support the exact number of alternatives shown in the diagram.
 *
 * <h2>Basic Blocks</h2>
 *
 * <h3>Rule</h3>
 *
 * <embed src="images/Rule.svg" type="image/svg+xml"/>
 *
 * <h3>Block of 1 or more alternatives</h3>
 *
 * <embed src="images/Block.svg" type="image/svg+xml"/>
 *
 * <h2>Greedy Loops</h2>
 *
 * <h3>Greedy Closure: `(...)*`</h3>
 *
 * <embed src="images/ClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Positive Closure: `(...)+`</h3>
 *
 * <embed src="images/PositiveClosureGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Greedy Optional: `(...)?`</h3>
 *
 * <embed src="images/OptionalGreedy.svg" type="image/svg+xml"/>
 *
 * <h2>Non-Greedy Loops</h2>
 *
 * <h3>Non-Greedy Closure: `(...)*?`</h3>
 *
 * <embed src="images/ClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Positive Closure: `(...)+?`</h3>
 *
 * <embed src="images/PositiveClosureNonGreedy.svg" type="image/svg+xml"/>
 *
 * <h3>Non-Greedy Optional: `(...)??`</h3>
 *
 * <embed src="images/OptionalNonGreedy.svg" type="image/svg+xml"/>
 */ class $fa37140cc6629a63$var$ATNState {
    /**
     * Gets the state number.
     *
     * @returns the state number
     */ getStateNumber() {
        return this.stateNumber;
    }
    /**
     * For all states except {@link RuleStopState}, this returns the state
     * number. Returns -1 for stop states.
     *
     * @returns -1 for {@link RuleStopState}, otherwise the state number
     */ get nonStopStateNumber() {
        return this.getStateNumber();
    }
    hashCode() {
        return this.stateNumber;
    }
    equals(o) {
        // are these states same object?
        if (o instanceof $fa37140cc6629a63$var$ATNState) return this.stateNumber === o.stateNumber;
        return false;
    }
    get isNonGreedyExitState() {
        return false;
    }
    toString() {
        return String(this.stateNumber);
    }
    getTransitions() {
        return this.transitions.slice(0);
    }
    get numberOfTransitions() {
        return this.transitions.length;
    }
    addTransition(e, index) {
        if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
        else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
            this.epsilonOnlyTransitions = false;
            throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
        }
        this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
    }
    transition(i) {
        return this.transitions[i];
    }
    setTransition(i, e) {
        this.transitions[i] = e;
    }
    removeTransition(index) {
        return this.transitions.splice(index, 1)[0];
    }
    get onlyHasEpsilonTransitions() {
        return this.epsilonOnlyTransitions;
    }
    setRuleIndex(ruleIndex) {
        this.ruleIndex = ruleIndex;
    }
    get isOptimized() {
        return this.optimizedTransitions !== this.transitions;
    }
    get numberOfOptimizedTransitions() {
        return this.optimizedTransitions.length;
    }
    getOptimizedTransition(i) {
        return this.optimizedTransitions[i];
    }
    addOptimizedTransition(e) {
        if (!this.isOptimized) this.optimizedTransitions = new Array();
        this.optimizedTransitions.push(e);
    }
    setOptimizedTransition(i, e) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions[i] = e;
    }
    removeOptimizedTransition(i) {
        if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
        this.optimizedTransitions.splice(i, 1);
    }
    constructor(){
        this.stateNumber = $fa37140cc6629a63$var$ATNState.INVALID_STATE_NUMBER;
        this.ruleIndex = 0; // at runtime, we don't have Rule objects
        this.epsilonOnlyTransitions = false;
        /** Track the transitions emanating from this ATN state. */ this.transitions = [];
        this.optimizedTransitions = this.transitions;
    }
}
$fa37140cc6629a63$var$__decorate([
    $4w9vi.Override
], $fa37140cc6629a63$var$ATNState.prototype, "hashCode", null);
$fa37140cc6629a63$var$__decorate([
    $4w9vi.Override
], $fa37140cc6629a63$var$ATNState.prototype, "equals", null);
$fa37140cc6629a63$var$__decorate([
    $4w9vi.Override
], $fa37140cc6629a63$var$ATNState.prototype, "toString", null);
module.exports.ATNState = $fa37140cc6629a63$var$ATNState;
(function(ATNState) {
    ATNState.INVALID_STATE_NUMBER = -1;
})($fa37140cc6629a63$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {})); //# sourceMappingURL=ATNState.js.map

});

parcelRegister("jW0J3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNStateType = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:27.4734328-07:00
var $e833ff2f995d8865$var$ATNStateType;
(function(ATNStateType) {
    ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
    ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
    ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
    ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
    ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
    ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
    ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
    ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
    ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
    ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
    ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
    ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
    ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
})($e833ff2f995d8865$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {})); //# sourceMappingURL=ATNStateType.js.map

});

parcelRegister("2M3s9", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $2052be2b0b7f6e13$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $2052be2b0b7f6e13$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedPredicateException = void 0;

var $jzLQT = parcelRequire("jzLQT");


var $4w9vi = parcelRequire("4w9vi");


var $1qA0P = parcelRequire("1qA0P");

/** A semantic predicate failed during validation.  Validation of predicates
 *  occurs when normally parsing the alternative just like matching a token.
 *  Disambiguating predicate evaluation occurs when we test a predicate during
 *  prediction.
 */ let $2052be2b0b7f6e13$var$FailedPredicateException = class FailedPredicateException extends $jzLQT.RecognitionException {
    get ruleIndex() {
        return this._ruleIndex;
    }
    get predicateIndex() {
        return this._predicateIndex;
    }
    get predicate() {
        return this._predicate;
    }
    static formatMessage(predicate, message) {
        if (message) return message;
        return `failed predicate: {${predicate}}?`;
    }
    constructor(recognizer, predicate, message){
        super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
        let s = recognizer.interpreter.atn.states[recognizer.state];
        let trans = s.transition(0);
        if (trans instanceof $1qA0P.PredicateTransition) {
            this._ruleIndex = trans.ruleIndex;
            this._predicateIndex = trans.predIndex;
        } else {
            this._ruleIndex = 0;
            this._predicateIndex = 0;
        }
        this._predicate = predicate;
        super.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$2052be2b0b7f6e13$var$__decorate([
    $4w9vi.NotNull
], $2052be2b0b7f6e13$var$FailedPredicateException, "formatMessage", null);
$2052be2b0b7f6e13$var$FailedPredicateException = $2052be2b0b7f6e13$var$__decorate([
    $2052be2b0b7f6e13$var$__param(0, $4w9vi.NotNull)
], $2052be2b0b7f6e13$var$FailedPredicateException);
module.exports.FailedPredicateException = $2052be2b0b7f6e13$var$FailedPredicateException; //# sourceMappingURL=FailedPredicateException.js.map

});

parcelRegister("jzLQT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecognitionException = void 0;
/** The root of the ANTLR exception hierarchy. In general, ANTLR tracks just
 *  3 kinds of errors: prediction errors, failed predicate errors, and
 *  mismatched input errors. In each case, the parser knows where it is
 *  in the input, where it is in the ATN, the rule invocation stack,
 *  and what kind of problem occurred.
 */ class $e40667a29c3e11ba$var$RecognitionException extends Error {
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     *
     * If the state number is not known, this method returns -1.
     */ get offendingState() {
        return this._offendingState;
    }
    setOffendingState(offendingState) {
        this._offendingState = offendingState;
    }
    /**
     * Gets the set of input symbols which could potentially follow the
     * previously matched symbol at the time this exception was thrown.
     *
     * If the set of expected tokens is not known and could not be computed,
     * this method returns `undefined`.
     *
     * @returns The set of token types that could potentially follow the current
     * state in the ATN, or `undefined` if the information is not available.
     */ get expectedTokens() {
        if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
        return undefined;
    }
    /**
     * Gets the {@link RuleContext} at the time this exception was thrown.
     *
     * If the context is not available, this method returns `undefined`.
     *
     * @returns The {@link RuleContext} at the time this exception was thrown.
     * If the context is not available, this method returns `undefined`.
     */ get context() {
        return this.ctx;
    }
    /**
     * Gets the input stream which is the symbol source for the recognizer where
     * this exception was thrown.
     *
     * If the input stream is not available, this method returns `undefined`.
     *
     * @returns The input stream which is the symbol source for the recognizer
     * where this exception was thrown, or `undefined` if the stream is not
     * available.
     */ get inputStream() {
        return this.input;
    }
    getOffendingToken(recognizer) {
        if (recognizer && recognizer !== this._recognizer) return undefined;
        return this.offendingToken;
    }
    setOffendingToken(recognizer, offendingToken) {
        if (recognizer === this._recognizer) this.offendingToken = offendingToken;
    }
    /**
     * Gets the {@link Recognizer} where this exception occurred.
     *
     * If the recognizer is not available, this method returns `undefined`.
     *
     * @returns The recognizer where this exception occurred, or `undefined` if
     * the recognizer is not available.
     */ get recognizer() {
        return this._recognizer;
    }
    constructor(recognizer, input, ctx, message){
        super(message);
        this._offendingState = -1;
        this._recognizer = recognizer;
        this.input = input;
        this.ctx = ctx;
        if (recognizer) this._offendingState = recognizer.state;
    }
}
module.exports.RecognitionException = $e40667a29c3e11ba$var$RecognitionException; //# sourceMappingURL=RecognitionException.js.map

});

parcelRegister("1qA0P", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $10a4276f9031121a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $10a4276f9031121a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredicateTransition = void 0;

var $4Lzcj = parcelRequire("4Lzcj");


var $4w9vi = parcelRequire("4w9vi");


var $cAJ3R = parcelRequire("cAJ3R");

/** TODO: this is old comment:
 *  A tree of semantic predicates from the grammar AST if label==SEMPRED.
 *  In the ATN, labels will always be exactly one predicate, but the DFA
 *  may have to combine a bunch of them as it collects predicates from
 *  multiple ATN configurations into a single DFA state.
 */ let $10a4276f9031121a$var$PredicateTransition = class PredicateTransition extends $4Lzcj.AbstractPredicateTransition {
    get serializationType() {
        return 4 /* PREDICATE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $cAJ3R.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
    }
    toString() {
        return "pred_" + this.ruleIndex + ":" + this.predIndex;
    }
    constructor(target, ruleIndex, predIndex, isCtxDependent){
        super(target);
        this.ruleIndex = ruleIndex;
        this.predIndex = predIndex;
        this.isCtxDependent = isCtxDependent;
    }
};
$10a4276f9031121a$var$__decorate([
    $4w9vi.Override
], $10a4276f9031121a$var$PredicateTransition.prototype, "serializationType", null);
$10a4276f9031121a$var$__decorate([
    $4w9vi.Override
], $10a4276f9031121a$var$PredicateTransition.prototype, "isEpsilon", null);
$10a4276f9031121a$var$__decorate([
    $4w9vi.Override
], $10a4276f9031121a$var$PredicateTransition.prototype, "matches", null);
$10a4276f9031121a$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $10a4276f9031121a$var$PredicateTransition.prototype, "toString", null);
$10a4276f9031121a$var$PredicateTransition = $10a4276f9031121a$var$__decorate([
    $10a4276f9031121a$var$__param(0, $4w9vi.NotNull)
], $10a4276f9031121a$var$PredicateTransition);
module.exports.PredicateTransition = $10a4276f9031121a$var$PredicateTransition; //# sourceMappingURL=PredicateTransition.js.map

});

parcelRegister("4Lzcj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractPredicateTransition = void 0;

var $151Ma = parcelRequire("151Ma");

/**
 *
 * @author Sam Harwell
 */ class $3786daba26d3b221$var$AbstractPredicateTransition extends $151Ma.Transition {
    constructor(target){
        super(target);
    }
}
module.exports.AbstractPredicateTransition = $3786daba26d3b221$var$AbstractPredicateTransition; //# sourceMappingURL=AbstractPredicateTransition.js.map

});

parcelRegister("151Ma", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0c97a2b9c36da1ee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0c97a2b9c36da1ee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transition = void 0;

var $4w9vi = parcelRequire("4w9vi");

/** An ATN transition between any two ATN states.  Subclasses define
 *  atom, set, epsilon, action, predicate, rule transitions.
 *
 *  This is a one way link.  It emanates from a state (usually via a list of
 *  transitions) and has a target state.
 *
 *  Since we never have to change the ATN transitions once we construct it,
 *  we can fix these transitions as specific classes. The DFA transitions
 *  on the other hand need to update the labels as it adds transitions to
 *  the states. We'll use the term Edge for the DFA to distinguish them from
 *  ATN transitions.
 */ let $0c97a2b9c36da1ee$var$Transition = class Transition {
    /**
     * Determines if the transition is an "epsilon" transition.
     *
     * The default implementation returns `false`.
     *
     * @returns `true` if traversing this transition in the ATN does not
     * consume an input symbol; otherwise, `false` if traversing this
     * transition consumes (matches) an input symbol.
     */ get isEpsilon() {
        return false;
    }
    get label() {
        return undefined;
    }
    constructor(target){
        if (target == null) throw new Error("target cannot be null.");
        this.target = target;
    }
};
$0c97a2b9c36da1ee$var$Transition.serializationNames = [
    "INVALID",
    "EPSILON",
    "RANGE",
    "RULE",
    "PREDICATE",
    "ATOM",
    "ACTION",
    "SET",
    "NOT_SET",
    "WILDCARD",
    "PRECEDENCE"
];
$0c97a2b9c36da1ee$var$__decorate([
    $4w9vi.NotNull
], $0c97a2b9c36da1ee$var$Transition.prototype, "target", void 0);
$0c97a2b9c36da1ee$var$Transition = $0c97a2b9c36da1ee$var$__decorate([
    $0c97a2b9c36da1ee$var$__param(0, $4w9vi.NotNull)
], $0c97a2b9c36da1ee$var$Transition);
module.exports.Transition = $0c97a2b9c36da1ee$var$Transition; //# sourceMappingURL=Transition.js.map

});

parcelRegister("cAJ3R", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $92abcd09b02af618$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $92abcd09b02af618$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SemanticContext = void 0;

var $eEYRR = parcelRequire("eEYRR");


var $io9eO = parcelRequire("io9eO");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");


var $gxIPs = parcelRequire("gxIPs");


var $1rLy7 = parcelRequire("1rLy7");

function $92abcd09b02af618$var$max(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison < 0) result = current;
    }
    return result;
}
function $92abcd09b02af618$var$min(items) {
    let result;
    for (let current of items){
        if (result === undefined) {
            result = current;
            continue;
        }
        let comparison = result.compareTo(current);
        if (comparison > 0) result = current;
    }
    return result;
}
/** A tree structure used to record the semantic context in which
 *  an ATN configuration is valid.  It's either a single predicate,
 *  a conjunction `p1&&p2`, or a sum of products `p1||p2`.
 *
 *  I have scoped the {@link AND}, {@link OR}, and {@link Predicate} subclasses of
 *  {@link SemanticContext} within the scope of this outer class.
 */ class $92abcd09b02af618$var$SemanticContext {
    /**
     * The default {@link SemanticContext}, which is semantically equivalent to
     * a predicate of the form `{true}?`.
     */ static get NONE() {
        if ($92abcd09b02af618$var$SemanticContext._NONE === undefined) $92abcd09b02af618$var$SemanticContext._NONE = new $92abcd09b02af618$var$SemanticContext.Predicate();
        return $92abcd09b02af618$var$SemanticContext._NONE;
    }
    /**
     * Evaluate the precedence predicates for the context and reduce the result.
     *
     * @param parser The parser instance.
     * @param parserCallStack
     * @returns The simplified semantic context after precedence predicates are
     * evaluated, which will be one of the following values.
     *
     * * {@link #NONE}: if the predicate simplifies to `true` after
     *   precedence predicates are evaluated.
     * * `undefined`: if the predicate simplifies to `false` after
     *   precedence predicates are evaluated.
     * * `this`: if the semantic context is not changed as a result of
     *   precedence predicate evaluation.
     * * A non-`undefined` {@link SemanticContext}: the new simplified
     *   semantic context after precedence predicates are evaluated.
     */ evalPrecedence(parser, parserCallStack) {
        return this;
    }
    static and(a, b) {
        if (!a || a === $92abcd09b02af618$var$SemanticContext.NONE) return b;
        if (b === $92abcd09b02af618$var$SemanticContext.NONE) return a;
        let result = new $92abcd09b02af618$var$SemanticContext.AND(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
    /**
     *
     *  @see ParserATNSimulator#getPredsForAmbigAlts
     */ static or(a, b) {
        if (!a) return b;
        if (a === $92abcd09b02af618$var$SemanticContext.NONE || b === $92abcd09b02af618$var$SemanticContext.NONE) return $92abcd09b02af618$var$SemanticContext.NONE;
        let result = new $92abcd09b02af618$var$SemanticContext.OR(a, b);
        if (result.opnds.length === 1) return result.opnds[0];
        return result;
    }
}
module.exports.SemanticContext = $92abcd09b02af618$var$SemanticContext;
(function(SemanticContext) {
    /**
     * This random 30-bit prime represents the value of `AND.class.hashCode()`.
     */ const AND_HASHCODE = 40363613;
    /**
     * This random 30-bit prime represents the value of `OR.class.hashCode()`.
     */ const OR_HASHCODE = 486279973;
    function filterPrecedencePredicates(collection) {
        let result = [];
        for(let i = 0; i < collection.length; i++){
            let context = collection[i];
            if (context instanceof SemanticContext.PrecedencePredicate) {
                result.push(context);
                // Remove the item from 'collection' and move i back so we look at the same index again
                collection.splice(i, 1);
                i--;
            }
        }
        return result;
    }
    class Predicate extends SemanticContext {
        eval(parser, parserCallStack) {
            let localctx = this.isCtxDependent ? parserCallStack : undefined;
            return parser.sempred(localctx, this.ruleIndex, this.predIndex);
        }
        hashCode() {
            let hashCode = $g3jfX.MurmurHash.initialize();
            hashCode = $g3jfX.MurmurHash.update(hashCode, this.ruleIndex);
            hashCode = $g3jfX.MurmurHash.update(hashCode, this.predIndex);
            hashCode = $g3jfX.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
            hashCode = $g3jfX.MurmurHash.finish(hashCode, 3);
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof Predicate)) return false;
            if (this === obj) return true;
            return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
        }
        toString() {
            return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
        }
        constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
            super();
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
    }
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], Predicate.prototype, "eval", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], Predicate.prototype, "hashCode", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], Predicate.prototype, "equals", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], Predicate.prototype, "toString", null);
    SemanticContext.Predicate = Predicate;
    class PrecedencePredicate extends SemanticContext {
        eval(parser, parserCallStack) {
            return parser.precpred(parserCallStack, this.precedence);
        }
        evalPrecedence(parser, parserCallStack) {
            if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
            else return undefined;
        }
        compareTo(o) {
            return this.precedence - o.precedence;
        }
        hashCode() {
            let hashCode = 1;
            hashCode = 31 * hashCode + this.precedence;
            return hashCode;
        }
        equals(obj) {
            if (!(obj instanceof PrecedencePredicate)) return false;
            if (this === obj) return true;
            return this.precedence === obj.precedence;
        }
        toString() {
            return "{" + this.precedence + ">=prec}?";
        }
        constructor(precedence){
            super();
            this.precedence = precedence;
        }
    }
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], PrecedencePredicate.prototype, "eval", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], PrecedencePredicate.prototype, "evalPrecedence", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], PrecedencePredicate.prototype, "compareTo", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], PrecedencePredicate.prototype, "hashCode", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], PrecedencePredicate.prototype, "equals", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], PrecedencePredicate.prototype, "toString", null);
    SemanticContext.PrecedencePredicate = PrecedencePredicate;
    /**
     * This is the base class for semantic context "operators", which operate on
     * a collection of semantic context "operands".
     *
     * @since 4.3
     */ class Operator extends SemanticContext {
    }
    SemanticContext.Operator = Operator;
    /**
     * A semantic context which is true whenever none of the contained contexts
     * is false.
     */ let AND = class AND extends Operator {
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof AND)) return false;
            return $io9eO.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $g3jfX.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (!opnd.eval(parser, parserCallStack)) return false;
            }
            return true;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated == null) // The AND context is false if any element is false
                return undefined;
                else if (evaluated !== SemanticContext.NONE) // Reduce the result by skipping true elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were true, so the AND context is true
            return SemanticContext.NONE;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
            return result;
        }
        toString() {
            return $1rLy7.join(this.opnds, "&&");
        }
        constructor(a, b){
            super();
            let operands = new $eEYRR.Array2DHashSet($gxIPs.ObjectEqualityComparator.INSTANCE);
            if (a instanceof AND) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof AND) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the lowest precedence
            let reduced = $92abcd09b02af618$var$min(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
    };
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], AND.prototype, "operands", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], AND.prototype, "equals", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], AND.prototype, "hashCode", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], AND.prototype, "eval", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], AND.prototype, "evalPrecedence", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], AND.prototype, "toString", null);
    AND = $92abcd09b02af618$var$__decorate([
        $92abcd09b02af618$var$__param(0, $4w9vi.NotNull),
        $92abcd09b02af618$var$__param(1, $4w9vi.NotNull)
    ], AND);
    SemanticContext.AND = AND;
    /**
     * A semantic context which is true whenever at least one of the contained
     * contexts is true.
     */ let OR = class OR extends Operator {
        get operands() {
            return this.opnds;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof OR)) return false;
            return $io9eO.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
        }
        hashCode() {
            return $g3jfX.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
        }
        /**
         * {@inheritDoc}
         *
         * The evaluation of predicates by this context is short-circuiting, but
         * unordered.
         */ eval(parser, parserCallStack) {
            for (let opnd of this.opnds){
                if (opnd.eval(parser, parserCallStack)) return true;
            }
            return false;
        }
        evalPrecedence(parser, parserCallStack) {
            let differs = false;
            let operands = [];
            for (let context of this.opnds){
                let evaluated = context.evalPrecedence(parser, parserCallStack);
                differs = differs || evaluated !== context;
                if (evaluated === SemanticContext.NONE) // The OR context is true if any element is true
                return SemanticContext.NONE;
                else if (evaluated) // Reduce the result by skipping false elements
                operands.push(evaluated);
            }
            if (!differs) return this;
            if (operands.length === 0) // all elements were false, so the OR context is false
            return undefined;
            let result = operands[0];
            for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
            return result;
        }
        toString() {
            return $1rLy7.join(this.opnds, "||");
        }
        constructor(a, b){
            super();
            let operands = new $eEYRR.Array2DHashSet($gxIPs.ObjectEqualityComparator.INSTANCE);
            if (a instanceof OR) operands.addAll(a.opnds);
            else operands.add(a);
            if (b instanceof OR) operands.addAll(b.opnds);
            else operands.add(b);
            this.opnds = operands.toArray();
            let precedencePredicates = filterPrecedencePredicates(this.opnds);
            // interested in the transition with the highest precedence
            let reduced = $92abcd09b02af618$var$max(precedencePredicates);
            if (reduced) this.opnds.push(reduced);
        }
    };
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], OR.prototype, "operands", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], OR.prototype, "equals", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], OR.prototype, "hashCode", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], OR.prototype, "eval", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], OR.prototype, "evalPrecedence", null);
    $92abcd09b02af618$var$__decorate([
        $4w9vi.Override
    ], OR.prototype, "toString", null);
    OR = $92abcd09b02af618$var$__decorate([
        $92abcd09b02af618$var$__param(0, $4w9vi.NotNull),
        $92abcd09b02af618$var$__param(1, $4w9vi.NotNull)
    ], OR);
    SemanticContext.OR = OR;
})($92abcd09b02af618$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {})); //# sourceMappingURL=SemanticContext.js.map

});

parcelRegister("1rLy7", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
function $10dd32592bfa172c$var$escapeWhitespace(s, escapeSpaces) {
    return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
}
module.exports.escapeWhitespace = $10dd32592bfa172c$var$escapeWhitespace;
// Seriously: why isn't this built in to java? ugh!
function $10dd32592bfa172c$var$join(collection, separator) {
    let buf = "";
    let first = true;
    for (let current of collection){
        if (first) first = false;
        else buf += separator;
        buf += current;
    }
    return buf;
}
module.exports.join = $10dd32592bfa172c$var$join;
function $10dd32592bfa172c$var$equals(x, y) {
    if (x === y) return true;
    if (x === undefined || y === undefined) return false;
    return x.equals(y);
}
module.exports.equals = $10dd32592bfa172c$var$equals;
// export function numNonnull(data: any[]): number {
// 	let n: number =  0;
// 	if ( data == null ) return n;
// 	for (let o of data) {
// 		if ( o!=null ) n++;
// 	}
// 	return n;
// }
// export function removeAllElements<T>(data: Collection<T>, value: T): void {
// 	if ( data==null ) return;
// 	while ( data.contains(value) ) data.remove(value);
// }
// export function writeFile(@NotNull file: File, @NotNull content: Uint8Array): void {
// 	let fos: FileOutputStream = new FileOutputStream(file);
// 	try {
// 		fos.write(content);
// 	} finally {
// 		fos.close();
// 	}
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string): void {
// 	writeFile(fileName, content, null);
// }
// export function writeFile(@NotNull fileName: string, @NotNull content: string, @Nullable encoding: string): void {
// 	let f: File =  new File(fileName);
// 	let fos: FileOutputStream =  new FileOutputStream(f);
// 	let osw: OutputStreamWriter;
// 	if (encoding != null) {
// 		osw = new OutputStreamWriter(fos, encoding);
// 	}
// 	else {
// 		osw = new OutputStreamWriter(fos);
// 	}
// 	try {
// 		osw.write(content);
// 	}
// 	finally {
// 		osw.close();
// 	}
// }
// @NotNull
// export function readFile(@NotNull fileName: string): char[] {
// 	return readFile(fileName, null);
// }
// @NotNull
// export function readFile(@NotNull fileName: string, @Nullable encoding: string): char[] {
// 	let f: File =  new File(fileName);
// 	let size: number =  (int)f.length();
// 	let isr: InputStreamReader;
// 	let fis: FileInputStream =  new FileInputStream(fileName);
// 	if ( encoding!=null ) {
// 		isr = new InputStreamReader(fis, encoding);
// 	}
// 	else {
// 		isr = new InputStreamReader(fis);
// 	}
// 	let data: char[] =  null;
// 	try {
// 		data = new char[size];
// 		let n: number =  isr.read(data);
// 		if (n < data.length) {
// 			data = Arrays.copyOf(data, n);
// 		}
// 	}
// 	finally {
// 		isr.close();
// 	}
// 	return data;
// }
// export function removeAll<T>(@NotNull predicate: List<T> list,@NotNull Predicate<? super T>): void {
// 	let j: number =  0;
// 	for (let i = 0; i < list.size; i++) {
// 		let item: T =  list.get(i);
// 		if (!predicate.eval(item)) {
// 			if (j != i) {
// 				list.set(j, item);
// 			}
// 			j++;
// 		}
// 	}
// 	if (j < list.size) {
// 		list.subList(j, list.size).clear();
// 	}
// }
// export function removeAll<T>(@NotNull predicate: Iterable<T> iterable,@NotNull Predicate<? super T>): void {
// 	if (iterable instanceof List<?>) {
// 		removeAll((List<T>)iterable, predicate);
// 		return;
// 	}
// 	for (Iterator<T> iterator = iterable.iterator(); iterator.hasNext(); ) {
// 		let item: T =  iterator.next();
// 		if (predicate.eval(item)) {
// 			iterator.remove();
// 		}
// 	}
// }
/** Convert array of strings to string&rarr;index map. Useful for
 *  converting rulenames to name&rarr;ruleindex map.
 */ function $10dd32592bfa172c$var$toMap(keys) {
    let m = new Map();
    for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
    return m;
}
module.exports.toMap = $10dd32592bfa172c$var$toMap;
function $10dd32592bfa172c$var$toCharArray(str) {
    if (typeof str === "string") {
        let result = new Uint16Array(str.length);
        for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
        return result;
    } else return str.toCharArray();
}
module.exports.toCharArray = $10dd32592bfa172c$var$toCharArray; // /**
 // 	* @since 4.5
 // 	*/
 // @NotNull
 // export function toSet(@NotNull bits: BitSet): IntervalSet {
 // 	let s: IntervalSet =  new IntervalSet();
 // 	let i: number =  bits.nextSetBit(0);
 // 	while ( i >= 0 ) {
 // 		s.add(i);
 // 		i = bits.nextSetBit(i+1);
 // 	}
 // 	return s;
 // }
 //# sourceMappingURL=Utils.js.map

});

parcelRegister("1GSEa", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $13b41a6b2585eeaa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $13b41a6b2585eeaa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InputMismatchException = void 0;

var $jzLQT = parcelRequire("jzLQT");


var $4w9vi = parcelRequire("4w9vi");

/** This signifies any kind of mismatched input exceptions such as
 *  when the current input does not match the expected token.
 */ let $13b41a6b2585eeaa$var$InputMismatchException = class InputMismatchException extends $jzLQT.RecognitionException {
    constructor(recognizer, state, context){
        if (context === undefined) context = recognizer.context;
        super(recognizer, recognizer.inputStream, context);
        if (state !== undefined) this.setOffendingState(state);
        this.setOffendingToken(recognizer, recognizer.currentToken);
    }
};
$13b41a6b2585eeaa$var$InputMismatchException = $13b41a6b2585eeaa$var$__decorate([
    $13b41a6b2585eeaa$var$__param(0, $4w9vi.NotNull)
], $13b41a6b2585eeaa$var$InputMismatchException);
module.exports.InputMismatchException = $13b41a6b2585eeaa$var$InputMismatchException; //# sourceMappingURL=InputMismatchException.js.map

});

parcelRegister("g8cb0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bbe6d6b39b3de508$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bbe6d6b39b3de508$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntervalSet = void 0;

var $io9eO = parcelRequire("io9eO");


var $kTbzO = parcelRequire("kTbzO");


var $kCyYI = parcelRequire("kCyYI");


var $hEcm0 = parcelRequire("hEcm0");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

/**
 * This class implements the {@link IntSet} backed by a sorted array of
 * non-overlapping intervals. It is particularly efficient for representing
 * large collections of numbers, where the majority of elements appear as part
 * of a sequential range of numbers that are all part of the set. For example,
 * the set { 1, 2, 3, 4, 7, 8 } may be represented as { [1, 4], [7, 8] }.
 *
 * This class is able to represent sets containing any combination of values in
 * the range {@link Integer#MIN_VALUE} to {@link Integer#MAX_VALUE}
 * (inclusive).
 */ class $bbe6d6b39b3de508$var$IntervalSet {
    static get COMPLETE_CHAR_SET() {
        if ($bbe6d6b39b3de508$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
            $bbe6d6b39b3de508$var$IntervalSet._COMPLETE_CHAR_SET = $bbe6d6b39b3de508$var$IntervalSet.of($hEcm0.Lexer.MIN_CHAR_VALUE, $hEcm0.Lexer.MAX_CHAR_VALUE);
            $bbe6d6b39b3de508$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
        }
        return $bbe6d6b39b3de508$var$IntervalSet._COMPLETE_CHAR_SET;
    }
    static get EMPTY_SET() {
        if ($bbe6d6b39b3de508$var$IntervalSet._EMPTY_SET == null) {
            $bbe6d6b39b3de508$var$IntervalSet._EMPTY_SET = new $bbe6d6b39b3de508$var$IntervalSet();
            $bbe6d6b39b3de508$var$IntervalSet._EMPTY_SET.setReadonly(true);
        }
        return $bbe6d6b39b3de508$var$IntervalSet._EMPTY_SET;
    }
    /**
     * Create a set with all ints within range [a..b] (inclusive). If b is omitted, the set contains the single element
     * a.
     */ static of(a, b = a) {
        let s = new $bbe6d6b39b3de508$var$IntervalSet();
        s.add(a, b);
        return s;
    }
    clear() {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        this._intervals.length = 0;
    }
    /** Add interval; i.e., add all integers from a to b to set.
     *  If b&lt;a, do nothing.
     *  Keep list in sorted order (by left range value).
     *  If overlap, combine ranges.  For example,
     *  If this is {1..5, 10..20}, adding 6..7 yields
     *  {1..5, 6..7, 10..20}.  Adding 4..8 yields {1..8, 10..20}.
     */ add(a, b = a) {
        this.addRange($kCyYI.Interval.of(a, b));
    }
    // copy on write so we can cache a..a intervals and sets of that
    addRange(addition) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        //System.out.println("add "+addition+" to "+intervals.toString());
        if (addition.b < addition.a) return;
        // find position in list
        // Use iterators as we modify list in place
        for(let i = 0; i < this._intervals.length; i++){
            let r = this._intervals[i];
            if (addition.equals(r)) return;
            if (addition.adjacent(r) || !addition.disjoint(r)) {
                // next to each other, make a single larger interval
                let bigger = addition.union(r);
                this._intervals[i] = bigger;
                // make sure we didn't just create an interval that
                // should be merged with next interval in list
                while(i < this._intervals.length - 1){
                    i++;
                    let next = this._intervals[i];
                    if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                    // if we bump up against or overlap next, merge
                    // remove this one
                    this._intervals.splice(i, 1);
                    i--;
                    // move backwards to what we just set
                    this._intervals[i] = bigger.union(next);
                // set to 3 merged ones
                }
                // first call to next after previous duplicates the result
                return;
            }
            if (addition.startsBeforeDisjoint(r)) {
                // insert before r
                this._intervals.splice(i, 0, addition);
                return;
            }
        // if disjoint and after r, a future iteration will handle it
        }
        // ok, must be after last interval (and disjoint from last interval)
        // just add it
        this._intervals.push(addition);
    }
    /** combine all sets in the array returned the or'd value */ static or(sets) {
        let r = new $bbe6d6b39b3de508$var$IntervalSet();
        for (let s of sets)r.addAll(s);
        return r;
    }
    addAll(set) {
        if (set == null) return this;
        if (set instanceof $bbe6d6b39b3de508$var$IntervalSet) {
            let other = set;
            // walk set and add each interval
            let n = other._intervals.length;
            for(let i = 0; i < n; i++){
                let I = other._intervals[i];
                this.add(I.a, I.b);
            }
        } else for (let value of set.toArray())this.add(value);
        return this;
    }
    complementRange(minElement, maxElement) {
        return this.complement($bbe6d6b39b3de508$var$IntervalSet.of(minElement, maxElement));
    }
    /** {@inheritDoc} */ complement(vocabulary) {
        if (vocabulary.isNil) // nothing in common with null set
        return $bbe6d6b39b3de508$var$IntervalSet.EMPTY_SET;
        let vocabularyIS;
        if (vocabulary instanceof $bbe6d6b39b3de508$var$IntervalSet) vocabularyIS = vocabulary;
        else {
            vocabularyIS = new $bbe6d6b39b3de508$var$IntervalSet();
            vocabularyIS.addAll(vocabulary);
        }
        return vocabularyIS.subtract(this);
    }
    subtract(a) {
        if (a == null || a.isNil) return new $bbe6d6b39b3de508$var$IntervalSet(this._intervals);
        if (a instanceof $bbe6d6b39b3de508$var$IntervalSet) return $bbe6d6b39b3de508$var$IntervalSet.subtract(this, a);
        let other = new $bbe6d6b39b3de508$var$IntervalSet();
        other.addAll(a);
        return $bbe6d6b39b3de508$var$IntervalSet.subtract(this, other);
    }
    /**
     * Compute the set difference between two interval sets. The specific
     * operation is `left - right`.
     */ static subtract(left, right) {
        if (left.isNil) return new $bbe6d6b39b3de508$var$IntervalSet();
        let result = new $bbe6d6b39b3de508$var$IntervalSet(left._intervals);
        if (right.isNil) // right set has no elements; just return the copy of the current set
        return result;
        let resultI = 0;
        let rightI = 0;
        while(resultI < result._intervals.length && rightI < right._intervals.length){
            let resultInterval = result._intervals[resultI];
            let rightInterval = right._intervals[rightI];
            // operation: (resultInterval - rightInterval) and update indexes
            if (rightInterval.b < resultInterval.a) {
                rightI++;
                continue;
            }
            if (rightInterval.a > resultInterval.b) {
                resultI++;
                continue;
            }
            let beforeCurrent;
            let afterCurrent;
            if (rightInterval.a > resultInterval.a) beforeCurrent = new $kCyYI.Interval(resultInterval.a, rightInterval.a - 1);
            if (rightInterval.b < resultInterval.b) afterCurrent = new $kCyYI.Interval(rightInterval.b + 1, resultInterval.b);
            if (beforeCurrent) {
                if (afterCurrent) {
                    // split the current interval into two
                    result._intervals[resultI] = beforeCurrent;
                    result._intervals.splice(resultI + 1, 0, afterCurrent);
                    resultI++;
                    rightI++;
                    continue;
                } else {
                    // replace the current interval
                    result._intervals[resultI] = beforeCurrent;
                    resultI++;
                    continue;
                }
            } else if (afterCurrent) {
                // replace the current interval
                result._intervals[resultI] = afterCurrent;
                rightI++;
                continue;
            } else {
                // remove the current interval (thus no need to increment resultI)
                result._intervals.splice(resultI, 1);
                continue;
            }
        }
        // If rightI reached right.intervals.size, no more intervals to subtract from result.
        // If resultI reached result.intervals.size, we would be subtracting from an empty set.
        // Either way, we are done.
        return result;
    }
    or(a) {
        let o = new $bbe6d6b39b3de508$var$IntervalSet();
        o.addAll(this);
        o.addAll(a);
        return o;
    }
    /** {@inheritDoc} */ and(other) {
        if (other.isNil) // nothing in common with null set
        return new $bbe6d6b39b3de508$var$IntervalSet();
        let myIntervals = this._intervals;
        let theirIntervals = other._intervals;
        let intersection;
        let mySize = myIntervals.length;
        let theirSize = theirIntervals.length;
        let i = 0;
        let j = 0;
        // iterate down both interval lists looking for nondisjoint intervals
        while(i < mySize && j < theirSize){
            let mine = myIntervals[i];
            let theirs = theirIntervals[j];
            //System.out.println("mine="+mine+" and theirs="+theirs);
            if (mine.startsBeforeDisjoint(theirs)) // move this iterator looking for interval that might overlap
            i++;
            else if (theirs.startsBeforeDisjoint(mine)) // move other iterator looking for interval that might overlap
            j++;
            else if (mine.properlyContains(theirs)) {
                // overlap, add intersection, get next theirs
                if (!intersection) intersection = new $bbe6d6b39b3de508$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                j++;
            } else if (theirs.properlyContains(mine)) {
                // overlap, add intersection, get next mine
                if (!intersection) intersection = new $bbe6d6b39b3de508$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                i++;
            } else if (!mine.disjoint(theirs)) {
                // overlap, add intersection
                if (!intersection) intersection = new $bbe6d6b39b3de508$var$IntervalSet();
                intersection.addRange(mine.intersection(theirs));
                // Move the iterator of lower range [a..b], but not
                // the upper range as it may contain elements that will collide
                // with the next iterator. So, if mine=[0..115] and
                // theirs=[115..200], then intersection is 115 and move mine
                // but not theirs as theirs may collide with the next range
                // in thisIter.
                // move both iterators to next ranges
                if (mine.startsAfterNonDisjoint(theirs)) j++;
                else if (theirs.startsAfterNonDisjoint(mine)) i++;
            }
        }
        if (!intersection) return new $bbe6d6b39b3de508$var$IntervalSet();
        return intersection;
    }
    /** {@inheritDoc} */ contains(el) {
        let n = this._intervals.length;
        let l = 0;
        let r = n - 1;
        // Binary search for the element in the (sorted, disjoint) array of intervals.
        while(l <= r){
            let m = l + r >> 1;
            let I = this._intervals[m];
            let a = I.a;
            let b = I.b;
            if (b < el) l = m + 1;
            else if (a > el) r = m - 1;
            else // el >= a && el <= b
            return true;
        }
        return false;
    }
    /** {@inheritDoc} */ get isNil() {
        return this._intervals == null || this._intervals.length === 0;
    }
    /**
     * Returns the maximum value contained in the set if not isNil.
     *
     * @return the maximum value contained in the set.
     * @throws RangeError if set is empty
     */ get maxElement() {
        if (this.isNil) throw new RangeError("set is empty");
        let last = this._intervals[this._intervals.length - 1];
        return last.b;
    }
    /**
     * Returns the minimum value contained in the set if not isNil.
     *
     * @return the minimum value contained in the set.
     * @throws RangeError if set is empty
     */ get minElement() {
        if (this.isNil) throw new RangeError("set is empty");
        return this._intervals[0].a;
    }
    /** Return a list of Interval objects. */ get intervals() {
        return this._intervals;
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        for (let I of this._intervals){
            hash = $g3jfX.MurmurHash.update(hash, I.a);
            hash = $g3jfX.MurmurHash.update(hash, I.b);
        }
        hash = $g3jfX.MurmurHash.finish(hash, this._intervals.length * 2);
        return hash;
    }
    /** Are two IntervalSets equal?  Because all intervals are sorted
     *  and disjoint, equals is a simple linear walk over both lists
     *  to make sure they are the same.  Interval.equals() is used
     *  by the List.equals() method to check the ranges.
     */ equals(o) {
        if (o == null || !(o instanceof $bbe6d6b39b3de508$var$IntervalSet)) return false;
        return $io9eO.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
    }
    toString(elemAreChar = false) {
        let buf = "";
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) {
                if (a === $lxPhv.Token.EOF) buf += "<EOF>";
                else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                else buf += a;
            } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
            else buf += a + ".." + b;
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    toStringVocabulary(vocabulary) {
        if (this._intervals == null || this._intervals.length === 0) return "{}";
        let buf = "";
        if (this.size > 1) buf += "{";
        let first = true;
        for (let I of this._intervals){
            if (first) first = false;
            else buf += ", ";
            let a = I.a;
            let b = I.b;
            if (a === b) buf += this.elementName(vocabulary, a);
            else for(let i = a; i <= b; i++){
                if (i > a) buf += ", ";
                buf += this.elementName(vocabulary, i);
            }
        }
        if (this.size > 1) buf += "}";
        return buf;
    }
    elementName(vocabulary, a) {
        if (a === $lxPhv.Token.EOF) return "<EOF>";
        else if (a === $lxPhv.Token.EPSILON) return "<EPSILON>";
        else return vocabulary.getDisplayName(a);
    }
    get size() {
        let n = 0;
        let numIntervals = this._intervals.length;
        if (numIntervals === 1) {
            let firstInterval = this._intervals[0];
            return firstInterval.b - firstInterval.a + 1;
        }
        for(let i = 0; i < numIntervals; i++){
            let I = this._intervals[i];
            n += I.b - I.a + 1;
        }
        return n;
    }
    toIntegerList() {
        let values = new $kTbzO.IntegerList(this.size);
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.add(v);
        }
        return values;
    }
    toSet() {
        let s = new Set();
        for (let I of this._intervals){
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)s.add(v);
        }
        return s;
    }
    toArray() {
        let values = new Array();
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            for(let v = a; v <= b; v++)values.push(v);
        }
        return values;
    }
    remove(el) {
        if (this.readonly) throw new Error("can't alter readonly IntervalSet");
        let n = this._intervals.length;
        for(let i = 0; i < n; i++){
            let I = this._intervals[i];
            let a = I.a;
            let b = I.b;
            if (el < a) break; // list is sorted and el is before this interval; not here
            // if whole interval x..x, rm
            if (el === a && el === b) {
                this._intervals.splice(i, 1);
                break;
            }
            // if on left edge x..b, adjust left
            if (el === a) {
                this._intervals[i] = $kCyYI.Interval.of(I.a + 1, I.b);
                break;
            }
            // if on right edge a..x, adjust right
            if (el === b) {
                this._intervals[i] = $kCyYI.Interval.of(I.a, I.b - 1);
                break;
            }
            // if in middle a..x..b, split interval
            if (el > a && el < b) {
                let oldb = I.b;
                this._intervals[i] = $kCyYI.Interval.of(I.a, el - 1); // [a..x-1]
                this.add(el + 1, oldb); // add [x+1..b]
            }
        }
    }
    get isReadonly() {
        return this.readonly;
    }
    setReadonly(readonly) {
        if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
        this.readonly = readonly;
    }
    constructor(intervals){
        this.readonly = false;
        if (intervals != null) this._intervals = intervals.slice(0);
        else this._intervals = [];
    }
}
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "addAll", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "complement", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "subtract", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "or", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "and", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "contains", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "isNil", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "hashCode", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "equals", null);
$bbe6d6b39b3de508$var$__decorate([
    $bbe6d6b39b3de508$var$__param(0, $4w9vi.NotNull)
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "toStringVocabulary", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.NotNull,
    $bbe6d6b39b3de508$var$__param(0, $4w9vi.NotNull)
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "elementName", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "size", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.Override
], $bbe6d6b39b3de508$var$IntervalSet.prototype, "remove", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.NotNull
], $bbe6d6b39b3de508$var$IntervalSet, "of", null);
$bbe6d6b39b3de508$var$__decorate([
    $4w9vi.NotNull
], $bbe6d6b39b3de508$var$IntervalSet, "subtract", null);
module.exports.IntervalSet = $bbe6d6b39b3de508$var$IntervalSet; //# sourceMappingURL=IntervalSet.js.map

});

parcelRegister("kCyYI", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f0327d3b940ca3b3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interval = void 0;

var $4w9vi = parcelRequire("4w9vi");

const $f0327d3b940ca3b3$var$INTERVAL_POOL_MAX_VALUE = 1000;
/** An immutable inclusive interval a..b */ class $f0327d3b940ca3b3$var$Interval {
    static get INVALID() {
        return $f0327d3b940ca3b3$var$Interval._INVALID;
    }
    /** Interval objects are used readonly so share all with the
     *  same single value a==b up to some max size.  Use an array as a perfect hash.
     *  Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
     *  Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
     *  have a..a (set with 1 element).
     */ static of(a, b) {
        // cache just a..a
        if (a !== b || a < 0 || a > $f0327d3b940ca3b3$var$INTERVAL_POOL_MAX_VALUE) return new $f0327d3b940ca3b3$var$Interval(a, b);
        if ($f0327d3b940ca3b3$var$Interval.cache[a] == null) $f0327d3b940ca3b3$var$Interval.cache[a] = new $f0327d3b940ca3b3$var$Interval(a, a);
        return $f0327d3b940ca3b3$var$Interval.cache[a];
    }
    /** return number of elements between a and b inclusively. x..x is length 1.
     *  if b &lt; a, then length is 0.  9..10 has length 2.
     */ get length() {
        if (this.b < this.a) return 0;
        return this.b - this.a + 1;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof $f0327d3b940ca3b3$var$Interval)) return false;
        return this.a === o.a && this.b === o.b;
    }
    hashCode() {
        let hash = 23;
        hash = hash * 31 + this.a;
        hash = hash * 31 + this.b;
        return hash;
    }
    /** Does this start completely before other? Disjoint */ startsBeforeDisjoint(other) {
        return this.a < other.a && this.b < other.a;
    }
    /** Does this start at or before other? Nondisjoint */ startsBeforeNonDisjoint(other) {
        return this.a <= other.a && this.b >= other.a;
    }
    /** Does this.a start after other.b? May or may not be disjoint */ startsAfter(other) {
        return this.a > other.a;
    }
    /** Does this start completely after other? Disjoint */ startsAfterDisjoint(other) {
        return this.a > other.b;
    }
    /** Does this start after other? NonDisjoint */ startsAfterNonDisjoint(other) {
        return this.a > other.a && this.a <= other.b; // this.b>=other.b implied
    }
    /** Are both ranges disjoint? I.e., no overlap? */ disjoint(other) {
        return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
    }
    /** Are two intervals adjacent such as 0..41 and 42..42? */ adjacent(other) {
        return this.a === other.b + 1 || this.b === other.a - 1;
    }
    properlyContains(other) {
        return other.a >= this.a && other.b <= this.b;
    }
    /** Return the interval computed from combining this and other */ union(other) {
        return $f0327d3b940ca3b3$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
    }
    /** Return the interval in common between this and o */ intersection(other) {
        return $f0327d3b940ca3b3$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
    }
    /** Return the interval with elements from `this` not in `other`;
     *  `other` must not be totally enclosed (properly contained)
     *  within `this`, which would result in two disjoint intervals
     *  instead of the single one returned by this method.
     */ differenceNotProperlyContained(other) {
        let diff;
        if (other.startsBeforeNonDisjoint(this)) // other.a to left of this.a (or same)
        diff = $f0327d3b940ca3b3$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
        else if (other.startsAfterNonDisjoint(this)) // other.a to right of this.a
        diff = $f0327d3b940ca3b3$var$Interval.of(this.a, other.a - 1);
        return diff;
    }
    toString() {
        return this.a + ".." + this.b;
    }
    /**
     * @param a The start of the interval
     * @param b The end of the interval (inclusive)
     */ constructor(a, b){
        this.a = a;
        this.b = b;
    }
}
$f0327d3b940ca3b3$var$Interval._INVALID = new $f0327d3b940ca3b3$var$Interval(-1, -2);
$f0327d3b940ca3b3$var$Interval.cache = new Array($f0327d3b940ca3b3$var$INTERVAL_POOL_MAX_VALUE + 1);
$f0327d3b940ca3b3$var$__decorate([
    $4w9vi.Override
], $f0327d3b940ca3b3$var$Interval.prototype, "equals", null);
$f0327d3b940ca3b3$var$__decorate([
    $4w9vi.Override
], $f0327d3b940ca3b3$var$Interval.prototype, "hashCode", null);
$f0327d3b940ca3b3$var$__decorate([
    $4w9vi.Override
], $f0327d3b940ca3b3$var$Interval.prototype, "toString", null);
module.exports.Interval = $f0327d3b940ca3b3$var$Interval; //# sourceMappingURL=Interval.js.map

});

parcelRegister("hEcm0", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $cd8fc1596fd47c0c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lexer = void 0;

var $aucRF = parcelRequire("aucRF");


var $9ETsS = parcelRequire("9ETsS");


var $kCyYI = parcelRequire("kCyYI");


var $eK8do = parcelRequire("eK8do");


var $l5Qwf = parcelRequire("l5Qwf");


var $1XGWL = parcelRequire("1XGWL");


var $4w9vi = parcelRequire("4w9vi");


var $lEpws = parcelRequire("lEpws");


var $lxPhv = parcelRequire("lxPhv");

/** A lexer is recognizer that draws input symbols from a character stream.
 *  lexer grammars result in a subclass of this object. A Lexer object
 *  uses simplified match() and error recovery mechanisms in the interest
 *  of speed.
 */ class $cd8fc1596fd47c0c$var$Lexer extends $lEpws.Recognizer {
    static get DEFAULT_TOKEN_CHANNEL() {
        return $lxPhv.Token.DEFAULT_CHANNEL;
    }
    static get HIDDEN() {
        return $lxPhv.Token.HIDDEN_CHANNEL;
    }
    reset(resetInput) {
        // wack Lexer state variables
        if (resetInput === undefined || resetInput) this._input.seek(0); // rewind the input
        this._token = undefined;
        this._type = $lxPhv.Token.INVALID_TYPE;
        this._channel = $lxPhv.Token.DEFAULT_CHANNEL;
        this._tokenStartCharIndex = -1;
        this._tokenStartCharPositionInLine = -1;
        this._tokenStartLine = -1;
        this._text = undefined;
        this._hitEOF = false;
        this._mode = $cd8fc1596fd47c0c$var$Lexer.DEFAULT_MODE;
        this._modeStack.clear();
        this.interpreter.reset();
    }
    /** Return a token from this source; i.e., match a token on the char
     *  stream.
     */ nextToken() {
        if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
        // Mark start location in char stream so unbuffered streams are
        // guaranteed at least have text of current token
        let tokenStartMarker = this._input.mark();
        try {
            outer: while(true){
                if (this._hitEOF) return this.emitEOF();
                this._token = undefined;
                this._channel = $lxPhv.Token.DEFAULT_CHANNEL;
                this._tokenStartCharIndex = this._input.index;
                this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                this._tokenStartLine = this.interpreter.line;
                this._text = undefined;
                do {
                    this._type = $lxPhv.Token.INVALID_TYPE;
                    //				System.out.println("nextToken line "+tokenStartLine+" at "+((char)input.LA(1))+
                    //								   " in mode "+mode+
                    //								   " at index "+input.index);
                    let ttype;
                    try {
                        ttype = this.interpreter.match(this._input, this._mode);
                    } catch (e) {
                        if (e instanceof $1XGWL.LexerNoViableAltException) {
                            this.notifyListeners(e); // report error
                            this.recover(e);
                            ttype = $cd8fc1596fd47c0c$var$Lexer.SKIP;
                        } else throw e;
                    }
                    if (this._input.LA(1) === $eK8do.IntStream.EOF) this._hitEOF = true;
                    if (this._type === $lxPhv.Token.INVALID_TYPE) this._type = ttype;
                    if (this._type === $cd8fc1596fd47c0c$var$Lexer.SKIP) continue outer;
                }while (this._type === $cd8fc1596fd47c0c$var$Lexer.MORE);
                if (this._token == null) return this.emit();
                return this._token;
            }
        } finally{
            // make sure we release marker after match or
            // unbuffered char stream will keep buffering
            this._input.release(tokenStartMarker);
        }
    }
    /** Instruct the lexer to skip creating a token for current lexer rule
     *  and look for another token.  nextToken() knows to keep looking when
     *  a lexer rule finishes with token set to SKIP_TOKEN.  Recall that
     *  if token==undefined at end of any token rule, it creates one for you
     *  and emits it.
     */ skip() {
        this._type = $cd8fc1596fd47c0c$var$Lexer.SKIP;
    }
    more() {
        this._type = $cd8fc1596fd47c0c$var$Lexer.MORE;
    }
    mode(m) {
        this._mode = m;
    }
    pushMode(m) {
        if ($l5Qwf.LexerATNSimulator.debug) console.log("pushMode " + m);
        this._modeStack.push(this._mode);
        this.mode(m);
    }
    popMode() {
        if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
        if ($l5Qwf.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
        this.mode(this._modeStack.pop());
        return this._mode;
    }
    get tokenFactory() {
        return this._factory;
    }
    // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the char stream and reset the lexer */ set inputStream(input) {
        this.reset(false);
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: this._input
        };
    }
    get sourceName() {
        return this._input.sourceName;
    }
    emit(token) {
        if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
        this._token = token;
        return token;
    }
    emitEOF() {
        let cpos = this.charPositionInLine;
        let line = this.line;
        let eof = this._factory.create(this._tokenFactorySourcePair, $lxPhv.Token.EOF, undefined, $lxPhv.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
        this.emit(eof);
        return eof;
    }
    get line() {
        return this.interpreter.line;
    }
    set line(line) {
        this.interpreter.line = line;
    }
    get charPositionInLine() {
        return this.interpreter.charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this.interpreter.charPositionInLine = charPositionInLine;
    }
    /** What is the index of the current character of lookahead? */ get charIndex() {
        return this._input.index;
    }
    /** Return the text matched so far for the current token or any
     *  text override.
     */ get text() {
        if (this._text != null) return this._text;
        return this.interpreter.getText(this._input);
    }
    /** Set the complete text of this token; it wipes any previous
     *  changes to the text.
     */ set text(text) {
        this._text = text;
    }
    /** Override if emitting multiple tokens. */ get token() {
        return this._token;
    }
    set token(_token) {
        this._token = _token;
    }
    set type(ttype) {
        this._type = ttype;
    }
    get type() {
        return this._type;
    }
    set channel(channel) {
        this._channel = channel;
    }
    get channel() {
        return this._channel;
    }
    /** Return a list of all Token objects in input char stream.
     *  Forces load of all tokens. Does not include EOF token.
     */ getAllTokens() {
        let tokens = [];
        let t = this.nextToken();
        while(t.type !== $lxPhv.Token.EOF){
            tokens.push(t);
            t = this.nextToken();
        }
        return tokens;
    }
    notifyListeners(e) {
        let text = this._input.getText($kCyYI.Interval.of(this._tokenStartCharIndex, this._input.index));
        let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
    }
    getErrorDisplay(s) {
        if (typeof s === "number") {
            switch(s){
                case $lxPhv.Token.EOF:
                    return "<EOF>";
                case 0x0a:
                    return "\\n";
                case 0x09:
                    return "\\t";
                case 0x0d:
                    return "\\r";
            }
            return String.fromCharCode(s);
        }
        return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    getCharErrorDisplay(c) {
        let s = this.getErrorDisplay(c);
        return "'" + s + "'";
    }
    recover(re) {
        if (re instanceof $1XGWL.LexerNoViableAltException) {
            if (this._input.LA(1) !== $eK8do.IntStream.EOF) // skip a char and try again
            this.interpreter.consume(this._input);
        } else //System.out.println("consuming char "+(char)input.LA(1)+" during recovery");
        //re.printStackTrace();
        // TODO: Do we lose character or line position information?
        this._input.consume();
    }
    constructor(input){
        super();
        /** How to create token objects */ this._factory = $aucRF.CommonTokenFactory.DEFAULT;
        /** What character index in the stream did the current token start at?
         *  Needed, for example, to get the text for current token.  Set at
         *  the start of nextToken.
         */ this._tokenStartCharIndex = -1;
        /** The line on which the first character of the token resides */ this._tokenStartLine = 0;
        /** The character position of first character within the line */ this._tokenStartCharPositionInLine = 0;
        /** Once we see EOF on char stream, next token will be EOF.
         *  If you have DONE : EOF ; then you see DONE EOF.
         */ this._hitEOF = false;
        /** The channel number for the current token */ this._channel = 0;
        /** The token type for the current token */ this._type = 0;
        this._modeStack = new $9ETsS.IntegerStack();
        this._mode = $cd8fc1596fd47c0c$var$Lexer.DEFAULT_MODE;
        this._input = input;
        this._tokenFactorySourcePair = {
            source: this,
            stream: input
        };
    }
}
$cd8fc1596fd47c0c$var$Lexer.DEFAULT_MODE = 0;
$cd8fc1596fd47c0c$var$Lexer.MORE = -2;
$cd8fc1596fd47c0c$var$Lexer.SKIP = -3;
$cd8fc1596fd47c0c$var$Lexer.MIN_CHAR_VALUE = 0x0000;
$cd8fc1596fd47c0c$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
$cd8fc1596fd47c0c$var$__decorate([
    $4w9vi.Override
], $cd8fc1596fd47c0c$var$Lexer.prototype, "nextToken", null);
$cd8fc1596fd47c0c$var$__decorate([
    $4w9vi.Override
], $cd8fc1596fd47c0c$var$Lexer.prototype, "tokenFactory", null);
$cd8fc1596fd47c0c$var$__decorate([
    $4w9vi.Override
], $cd8fc1596fd47c0c$var$Lexer.prototype, "inputStream", null);
$cd8fc1596fd47c0c$var$__decorate([
    $4w9vi.Override
], $cd8fc1596fd47c0c$var$Lexer.prototype, "sourceName", null);
$cd8fc1596fd47c0c$var$__decorate([
    $4w9vi.Override
], $cd8fc1596fd47c0c$var$Lexer.prototype, "line", null);
$cd8fc1596fd47c0c$var$__decorate([
    $4w9vi.Override
], $cd8fc1596fd47c0c$var$Lexer.prototype, "charPositionInLine", null);
module.exports.Lexer = $cd8fc1596fd47c0c$var$Lexer; //# sourceMappingURL=Lexer.js.map

});

parcelRegister("aucRF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7a26af5f80d8e36d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenFactory = void 0;

var $dasyL = parcelRequire("dasyL");


var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");

/**
 * This default implementation of {@link TokenFactory} creates
 * {@link CommonToken} objects.
 */ class $7a26af5f80d8e36d$var$CommonTokenFactory {
    create(source, type, text, channel, start, stop, line, charPositionInLine) {
        let t = new $dasyL.CommonToken(type, text, source, channel, start, stop);
        t.line = line;
        t.charPositionInLine = charPositionInLine;
        if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($kCyYI.Interval.of(start, stop));
        return t;
    }
    createSimple(type, text) {
        return new $dasyL.CommonToken(type, text);
    }
    /**
     * Constructs a {@link CommonTokenFactory} with the specified value for
     * {@link #copyText}.
     *
     * When `copyText` is `false`, the {@link #DEFAULT} instance
     * should be used instead of constructing a new instance.
     *
     * @param copyText The value for {@link #copyText}.
     */ constructor(copyText = false){
        this.copyText = copyText;
    }
}
$7a26af5f80d8e36d$var$__decorate([
    $4w9vi.Override
], $7a26af5f80d8e36d$var$CommonTokenFactory.prototype, "create", null);
$7a26af5f80d8e36d$var$__decorate([
    $4w9vi.Override
], $7a26af5f80d8e36d$var$CommonTokenFactory.prototype, "createSimple", null);
module.exports.CommonTokenFactory = $7a26af5f80d8e36d$var$CommonTokenFactory;
(function(CommonTokenFactory) {
    /**
     * The default {@link CommonTokenFactory} instance.
     *
     * This token factory does not explicitly copy token text when constructing
     * tokens.
     */ CommonTokenFactory.DEFAULT = new CommonTokenFactory();
})($7a26af5f80d8e36d$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {})); //# sourceMappingURL=CommonTokenFactory.js.map

});

parcelRegister("dasyL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $99625ce748b2ef29$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $99625ce748b2ef29$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonToken = void 0;

var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

let $99625ce748b2ef29$var$CommonToken = class CommonToken {
    /**
     * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
     *
     * If `oldToken` is also a {@link CommonToken} instance, the newly
     * constructed token will share a reference to the {@link #text} field and
     * the {@link Tuple2} stored in {@link #source}. Otherwise, {@link #text} will
     * be assigned the result of calling {@link #getText}, and {@link #source}
     * will be constructed from the result of {@link Token#getTokenSource} and
     * {@link Token#getInputStream}.
     *
     * @param oldToken The token to copy.
     */ static fromToken(oldToken) {
        let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
        result._line = oldToken.line;
        result.index = oldToken.tokenIndex;
        result._charPositionInLine = oldToken.charPositionInLine;
        if (oldToken instanceof CommonToken) {
            result._text = oldToken._text;
            result.source = oldToken.source;
        } else {
            result._text = oldToken.text;
            result.source = {
                source: oldToken.tokenSource,
                stream: oldToken.inputStream
            };
        }
        return result;
    }
    get type() {
        return this._type;
    }
    // @Override
    set type(type) {
        this._type = type;
    }
    get line() {
        return this._line;
    }
    // @Override
    set line(line) {
        this._line = line;
    }
    get text() {
        if (this._text != null) return this._text;
        let input = this.inputStream;
        if (input == null) return undefined;
        let n = input.size;
        if (this.start < n && this.stop < n) return input.getText($kCyYI.Interval.of(this.start, this.stop));
        else return "<EOF>";
    }
    /**
     * Explicitly set the text for this token. If {code text} is not
     * `undefined`, then {@link #getText} will return this value rather than
     * extracting the text from the input.
     *
     * @param text The explicit text of the token, or `undefined` if the text
     * should be obtained from the input along with the start and stop indexes
     * of the token.
     */ // @Override
    set text(text) {
        this._text = text;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    // @Override
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    get channel() {
        return this._channel;
    }
    // @Override
    set channel(channel) {
        this._channel = channel;
    }
    get startIndex() {
        return this.start;
    }
    set startIndex(start) {
        this.start = start;
    }
    get stopIndex() {
        return this.stop;
    }
    set stopIndex(stop) {
        this.stop = stop;
    }
    get tokenIndex() {
        return this.index;
    }
    // @Override
    set tokenIndex(index) {
        this.index = index;
    }
    get tokenSource() {
        return this.source.source;
    }
    get inputStream() {
        return this.source.stream;
    }
    toString(recognizer) {
        let channelStr = "";
        if (this._channel > 0) channelStr = ",channel=" + this._channel;
        let txt = this.text;
        if (txt != null) {
            txt = txt.replace(/\n/g, "\\n");
            txt = txt.replace(/\r/g, "\\r");
            txt = txt.replace(/\t/g, "\\t");
        } else txt = "<no text>";
        let typeString = String(this._type);
        if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
        return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
    }
    constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $lxPhv.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
        /**
         * This is the backing field for {@link #getLine} and {@link #setLine}.
         */ this._line = 0;
        /**
         * This is the backing field for {@link #getCharPositionInLine} and
         * {@link #setCharPositionInLine}.
         */ this._charPositionInLine = -1; // set to invalid position
        /**
         * This is the backing field for {@link #getChannel} and
         * {@link #setChannel}.
         */ this._channel = $lxPhv.Token.DEFAULT_CHANNEL;
        /**
         * This is the backing field for `tokenIndex`.
         */ this.index = -1;
        this._text = text;
        this._type = type;
        this.source = source;
        this._channel = channel;
        this.start = start;
        this.stop = stop;
        if (source.source != null) {
            this._line = source.source.line;
            this._charPositionInLine = source.source.charPositionInLine;
        }
    }
};
/**
 * An empty {@link Tuple2} which is used as the default value of
 * {@link #source} for tokens that do not have a source.
 */ $99625ce748b2ef29$var$CommonToken.EMPTY_SOURCE = {
    source: undefined,
    stream: undefined
};
$99625ce748b2ef29$var$__decorate([
    $4w9vi.NotNull
], $99625ce748b2ef29$var$CommonToken.prototype, "source", void 0);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "type", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "line", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "text", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "charPositionInLine", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "channel", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "startIndex", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "stopIndex", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "tokenIndex", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "tokenSource", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "inputStream", null);
$99625ce748b2ef29$var$__decorate([
    $4w9vi.Override
], $99625ce748b2ef29$var$CommonToken.prototype, "toString", null);
$99625ce748b2ef29$var$__decorate([
    $99625ce748b2ef29$var$__param(0, $4w9vi.NotNull)
], $99625ce748b2ef29$var$CommonToken, "fromToken", null);
$99625ce748b2ef29$var$CommonToken = $99625ce748b2ef29$var$__decorate([
    $99625ce748b2ef29$var$__param(2, $4w9vi.NotNull)
], $99625ce748b2ef29$var$CommonToken);
module.exports.CommonToken = $99625ce748b2ef29$var$CommonToken; //# sourceMappingURL=CommonToken.js.map

});

parcelRegister("lxPhv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Token = void 0;

var $eK8do = parcelRequire("eK8do");

var $faf475797c826878$var$Token;
(function(Token) {
    Token.INVALID_TYPE = 0;
    /** During lookahead operations, this "token" signifies we hit rule end ATN state
     *  and did not follow it despite needing to.
     */ Token.EPSILON = -2;
    Token.MIN_USER_TOKEN_TYPE = 1;
    Token.EOF = $eK8do.IntStream.EOF;
    /** All tokens go to the parser (unless skip() is called in that rule)
     *  on a particular "channel".  The parser tunes to a particular channel
     *  so that whitespace etc... can go to the parser on a "hidden" channel.
     */ Token.DEFAULT_CHANNEL = 0;
    /** Anything on different channel than DEFAULT_CHANNEL is not parsed
     *  by parser.
     */ Token.HIDDEN_CHANNEL = 1;
    /**
     * This is the minimum constant value which can be assigned to a
     * user-defined token channel.
     *
     * The non-negative numbers less than {@link #MIN_USER_CHANNEL_VALUE} are
     * assigned to the predefined channels {@link #DEFAULT_CHANNEL} and
     * {@link #HIDDEN_CHANNEL}.
     *
     * @see `Token.channel`
     */ Token.MIN_USER_CHANNEL_VALUE = 2;
})($faf475797c826878$var$Token = module.exports.Token || (module.exports.Token = {})); //# sourceMappingURL=Token.js.map

});

parcelRegister("l5Qwf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f5b2cdcb05275695$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f5b2cdcb05275695$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerATNSimulator = void 0;

var $7oXsf = parcelRequire("7oXsf");


var $EKDdQ = parcelRequire("EKDdQ");


var $gpoJu = parcelRequire("gpoJu");


var $51XoR = parcelRequire("51XoR");


var $gZszX = parcelRequire("gZszX");


var $iIwZu = parcelRequire("iIwZu");


var $kCyYI = parcelRequire("kCyYI");


var $eK8do = parcelRequire("eK8do");


var $hEcm0 = parcelRequire("hEcm0");


var $6HpQh = parcelRequire("6HpQh");


var $1XGWL = parcelRequire("1XGWL");


var $4w9vi = parcelRequire("4w9vi");


var $axLvN = parcelRequire("axLvN");


var $ca31u = parcelRequire("ca31u");


var $4eVci = parcelRequire("4eVci");


var $lxPhv = parcelRequire("lxPhv");


var $9ir1r = parcelRequire("9ir1r");

/** "dup" of ParserInterpreter */ let $f5b2cdcb05275695$var$LexerATNSimulator = class LexerATNSimulator extends $gZszX.ATNSimulator {
    copyState(simulator) {
        this._charPositionInLine = simulator.charPositionInLine;
        this._line = simulator._line;
        this.mode = simulator.mode;
        this.startIndex = simulator.startIndex;
    }
    match(input, mode) {
        this.mode = mode;
        let mark = input.mark();
        try {
            this.startIndex = input.index;
            this.prevAccept.reset();
            let s0 = this.atn.modeToDFA[mode].s0;
            if (s0 == null) return this.matchATN(input);
            else return this.execATN(input, s0);
        } finally{
            input.release(mark);
        }
    }
    reset() {
        this.prevAccept.reset();
        this.startIndex = -1;
        this._line = 1;
        this._charPositionInLine = 0;
        this.mode = $hEcm0.Lexer.DEFAULT_MODE;
    }
    matchATN(input) {
        let startState = this.atn.modeToStartState[this.mode];
        if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
        let old_mode = this.mode;
        let s0_closure = this.computeStartState(input, startState);
        let suppressEdge = s0_closure.hasSemanticContext;
        if (suppressEdge) s0_closure.hasSemanticContext = false;
        let next = this.addDFAState(s0_closure);
        if (!suppressEdge) {
            let dfa = this.atn.modeToDFA[this.mode];
            if (!dfa.s0) dfa.s0 = next;
            else next = dfa.s0;
        }
        let predict = this.execATN(input, next);
        if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
        return predict;
    }
    execATN(input, ds0) {
        // console.log("enter exec index "+input.index+" from "+ds0.configs);
        if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
        if (ds0.isAcceptState) // allow zero-length tokens
        this.captureSimState(this.prevAccept, input, ds0);
        let t = input.LA(1);
        // @NotNull
        let s = ds0; // s is current/from DFA state
        while(true){
            if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
            // As we move src->trg, src->trg, we keep track of the previous trg to
            // avoid looking up the DFA state again, which is expensive.
            // If the previous target was already part of the DFA, we might
            // be able to avoid doing a reach operation upon t. If s!=null,
            // it means that semantic predicates didn't prevent us from
            // creating a DFA state. Once we know s!=null, we check to see if
            // the DFA state has an edge already for t. If so, we can just reuse
            // it's configuration set; there's no point in re-computing it.
            // This is kind of like doing DFA simulation within the ATN
            // simulation because DFA simulation is really just a way to avoid
            // computing reach/closure sets. Technically, once we know that
            // we have a previously added DFA state, we could jump over to
            // the DFA simulator. But, that would mean popping back and forth
            // a lot and making things more complicated algorithmically.
            // This optimization makes a lot of sense for loops within DFA.
            // A character will take us back to an existing DFA state
            // that already has lots of edges out of it. e.g., .* in comments.
            let target = this.getExistingTargetState(s, t);
            if (target == null) target = this.computeTargetState(input, s, t);
            if (target === $gZszX.ATNSimulator.ERROR) break;
            // If this is a consumable input element, make sure to consume before
            // capturing the accept state so the input index, line, and char
            // position accurately reflect the state of the interpreter at the
            // end of the token.
            if (t !== $eK8do.IntStream.EOF) this.consume(input);
            if (target.isAcceptState) {
                this.captureSimState(this.prevAccept, input, target);
                if (t === $eK8do.IntStream.EOF) break;
            }
            t = input.LA(1);
            s = target; // flip; current DFA target becomes new src/from state
        }
        return this.failOrAccept(this.prevAccept, input, s.configs, t);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        let target = s.getTarget(t);
        if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
        return target;
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param input The input stream
     * @param s The current DFA state
     * @param t The next input symbol
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(input, s, t) {
        let reach = new $axLvN.OrderedATNConfigSet();
        // if we don't find an existing DFA state
        // Fill reach starting from closure, following t transitions
        this.getReachableConfigSet(input, s.configs, reach, t);
        if (reach.isEmpty) {
            if (!reach.hasSemanticContext) // we got nowhere on t, don't throw out this knowledge; it'd
            // cause a failover from DFA later.
            this.addDFAEdge(s, t, $gZszX.ATNSimulator.ERROR);
            // stop when we can't match any more char
            return $gZszX.ATNSimulator.ERROR;
        }
        // Add an edge from s to target DFA found/created for reach
        return this.addDFAEdge(s, t, reach);
    }
    failOrAccept(prevAccept, input, reach, t) {
        if (prevAccept.dfaState != null) {
            let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
            this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
            return prevAccept.dfaState.prediction;
        } else {
            // if no accept and EOF is first char, return EOF
            if (t === $eK8do.IntStream.EOF && input.index === this.startIndex) return $lxPhv.Token.EOF;
            throw new $1XGWL.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
        }
    }
    /** Given a starting configuration set, figure out all ATN configurations
     *  we can reach upon input `t`. Parameter `reach` is a return
     *  parameter.
     */ getReachableConfigSet(input, closure, reach, t) {
        // this is used to skip processing for configs which have a lower priority
        // than a config that already reached an accept state for the same rule
        let skipAlt = $EKDdQ.ATN.INVALID_ALT_NUMBER;
        for (let c of closure){
            let currentAltReachedAcceptState = c.alt === skipAlt;
            if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
            if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
            let n = c.state.numberOfOptimizedTransitions;
            for(let ti = 0; ti < n; ti++){
                let trans = c.state.getOptimizedTransition(ti);
                let target = this.getReachableTarget(trans, t);
                if (target != null) {
                    let lexerActionExecutor = c.lexerActionExecutor;
                    let config;
                    if (lexerActionExecutor != null) {
                        lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                        config = c.transform(target, true, lexerActionExecutor);
                    } else {
                        $9ir1r(c.lexerActionExecutor == null);
                        config = c.transform(target, true);
                    }
                    let treatEofAsEpsilon = t === $eK8do.IntStream.EOF;
                    if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                        // any remaining configs for this alt have a lower priority than
                        // the one that just reached an accept state.
                        skipAlt = c.alt;
                        break;
                    }
                }
            }
        }
    }
    accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
        if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
        // seek to after last char in token
        input.seek(index);
        this._line = line;
        this._charPositionInLine = charPos;
        if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
    }
    getReachableTarget(trans, t) {
        if (trans.matches(t, $hEcm0.Lexer.MIN_CHAR_VALUE, $hEcm0.Lexer.MAX_CHAR_VALUE)) return trans.target;
        return undefined;
    }
    computeStartState(input, p) {
        let initialContext = $ca31u.PredictionContext.EMPTY_FULL;
        let configs = new $axLvN.OrderedATNConfigSet();
        for(let i = 0; i < p.numberOfTransitions; i++){
            let target = p.transition(i).target;
            let c = $gpoJu.ATNConfig.create(target, i + 1, initialContext);
            this.closure(input, c, configs, false, false, false);
        }
        return configs;
    }
    /**
     * Since the alternatives within any lexer decision are ordered by
     * preference, this method stops pursuing the closure as soon as an accept
     * state is reached. After the first accept state is reached by depth-first
     * search from `config`, all other (potentially reachable) states for
     * this rule would have a lower priority.
     *
     * @returns `true` if an accept state is reached, otherwise
     * `false`.
     */ closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
        if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
        if (config.state instanceof $4eVci.RuleStopState) {
            if (LexerATNSimulator.debug) {
                if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                else console.log(`closure at rule stop ${config}`);
            }
            let context = config.context;
            if (context.isEmpty) {
                configs.add(config);
                return true;
            } else if (context.hasEmpty) {
                configs.add(config.transform(config.state, true, $ca31u.PredictionContext.EMPTY_FULL));
                currentAltReachedAcceptState = true;
            }
            for(let i = 0; i < context.size; i++){
                let returnStateNumber = context.getReturnState(i);
                if (returnStateNumber === $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                let newContext = context.getParent(i); // "pop" return state
                let returnState = this.atn.states[returnStateNumber];
                let c = config.transform(returnState, false, newContext);
                currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        // optimization
        if (!config.state.onlyHasEpsilonTransitions) {
            if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
        }
        let p = config.state;
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            let t = p.getOptimizedTransition(i);
            let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
            if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
        }
        return currentAltReachedAcceptState;
    }
    // side-effect: can alter configs.hasSemanticContext
    getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
        let c;
        switch(t.serializationType){
            case 3 /* RULE */ :
                let ruleTransition = t;
                if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                else {
                    let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                    c = config.transform(t.target, true, newContext);
                }
                break;
            case 10 /* PRECEDENCE */ :
                throw new Error("Precedence predicates are not supported in lexers.");
            case 4 /* PREDICATE */ :
                /*  Track traversing semantic predicates. If we traverse,
                    we cannot add a DFA state for this "reach" computation
                    because the DFA would not test the predicate again in the
                    future. Rather than creating collections of semantic predicates
                    like v3 and testing them on prediction, v4 will test them on the
                    fly all the time using the ATN not the DFA. This is slower but
                    semantically it's not used that often. One of the key elements to
                    this predicate mechanism is not adding DFA states that see
                    predicates immediately afterwards in the ATN. For example,
    
                    a : ID {p1}? | ID {p2}? ;
    
                    should create the start state for rule 'a' (to save start state
                    competition), but should not create target of ID state. The
                    collection of ATN states the following ID references includes
                    states reached by traversing predicates. Since this is when we
                    test them, we cannot cash the DFA state target of ID.
                */ let pt = t;
                if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                configs.hasSemanticContext = true;
                if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                else c = undefined;
                break;
            case 6 /* ACTION */ :
                if (config.context.hasEmpty) {
                    // execute actions anywhere in the start rule for a token.
                    //
                    // TODO: if the entry rule is invoked recursively, some
                    // actions may be executed during the recursive call. The
                    // problem can appear when hasEmpty is true but
                    // isEmpty is false. In this case, the config needs to be
                    // split into two contexts - one with just the empty path
                    // and another with everything but the empty path.
                    // Unfortunately, the current algorithm does not allow
                    // getEpsilonTarget to return two configurations, so
                    // additional modifications are needed before we can support
                    // the split operation.
                    let lexerActionExecutor = $6HpQh.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                    c = config.transform(t.target, true, lexerActionExecutor);
                    break;
                } else {
                    // ignore actions in referenced rules
                    c = config.transform(t.target, true);
                    break;
                }
            case 1 /* EPSILON */ :
                c = config.transform(t.target, true);
                break;
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                if (treatEofAsEpsilon) {
                    if (t.matches($eK8do.IntStream.EOF, $hEcm0.Lexer.MIN_CHAR_VALUE, $hEcm0.Lexer.MAX_CHAR_VALUE)) {
                        c = config.transform(t.target, false);
                        break;
                    }
                }
                c = undefined;
                break;
            default:
                c = undefined;
                break;
        }
        return c;
    }
    /**
     * Evaluate a predicate specified in the lexer.
     *
     * If `speculative` is `true`, this method was called before
     * {@link #consume} for the matched character. This method should call
     * {@link #consume} before evaluating the predicate to ensure position
     * sensitive values, including {@link Lexer#getText}, {@link Lexer#getLine},
     * and {@link Lexer#getCharPositionInLine}, properly reflect the current
     * lexer state. This method should restore `input` and the simulator
     * to the original state before returning (i.e. undo the actions made by the
     * call to {@link #consume}.
     *
     * @param input The input stream.
     * @param ruleIndex The rule containing the predicate.
     * @param predIndex The index of the predicate within the rule.
     * @param speculative `true` if the current index in `input` is
     * one character before the predicate's location.
     *
     * @returns `true` if the specified predicate evaluates to
     * `true`.
     */ evaluatePredicate(input, ruleIndex, predIndex, speculative) {
        // assume true if no recognizer was provided
        if (this.recog == null) return true;
        if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
        let savedCharPositionInLine = this._charPositionInLine;
        let savedLine = this._line;
        let index = input.index;
        let marker = input.mark();
        try {
            this.consume(input);
            return this.recog.sempred(undefined, ruleIndex, predIndex);
        } finally{
            this._charPositionInLine = savedCharPositionInLine;
            this._line = savedLine;
            input.seek(index);
            input.release(marker);
        }
    }
    captureSimState(settings, input, dfaState) {
        settings.index = input.index;
        settings.line = this._line;
        settings.charPos = this._charPositionInLine;
        settings.dfaState = dfaState;
    }
    addDFAEdge(p, t, q) {
        if (q instanceof $51XoR.ATNConfigSet) {
            /* leading to this call, ATNConfigSet.hasSemanticContext is used as a
            * marker indicating dynamic predicate evaluation makes this edge
            * dependent on the specific input sequence, so the static edge in the
            * DFA should be omitted. The target DFAState is still created since
            * execATN has the ability to resynchronize with the DFA state cache
            * following the predicate evaluation step.
            *
            * TJP notes: next time through the DFA, we see a pred again and eval.
            * If that gets us to a previously created (but dangling) DFA
            * state, we can continue in pure DFA mode from there.
            */ let suppressEdge = q.hasSemanticContext;
            if (suppressEdge) q.hasSemanticContext = false;
            // @NotNull
            let to = this.addDFAState(q);
            if (suppressEdge) return to;
            this.addDFAEdge(p, t, to);
            return to;
        } else {
            if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
            if (p != null) p.setTarget(t, q);
        }
    }
    /** Add a new DFA state if there isn't one with this set of
     * 	configurations already. This method also detects the first
     * 	configuration containing an ATN rule stop state. Later, when
     * 	traversing the DFA, we will know which rule to accept.
     */ addDFAState(configs) {
        /* the lexer evaluates predicates on-the-fly; by this point configs
         * should not contain any configurations with unevaluated predicates.
         */ $9ir1r(!configs.hasSemanticContext);
        let proposed = new $iIwZu.DFAState(configs);
        let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
        if (existing != null) return existing;
        configs.optimizeConfigs(this);
        let newState = new $iIwZu.DFAState(configs.clone(true));
        let firstConfigWithRuleStopState;
        for (let c of configs)if (c.state instanceof $4eVci.RuleStopState) {
            firstConfigWithRuleStopState = c;
            break;
        }
        if (firstConfigWithRuleStopState != null) {
            let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
            let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
            newState.acceptStateInfo = new $7oXsf.AcceptStateInfo(prediction, lexerActionExecutor);
        }
        return this.atn.modeToDFA[this.mode].addState(newState);
    }
    getDFA(mode) {
        return this.atn.modeToDFA[mode];
    }
    /** Get the text matched so far for the current token.
     */ getText(input) {
        // index is first lookahead char, don't include.
        return input.getText($kCyYI.Interval.of(this.startIndex, input.index - 1));
    }
    get line() {
        return this._line;
    }
    set line(line) {
        this._line = line;
    }
    get charPositionInLine() {
        return this._charPositionInLine;
    }
    set charPositionInLine(charPositionInLine) {
        this._charPositionInLine = charPositionInLine;
    }
    consume(input) {
        let curChar = input.LA(1);
        if (curChar === "\n".charCodeAt(0)) {
            this._line++;
            this._charPositionInLine = 0;
        } else this._charPositionInLine++;
        input.consume();
    }
    getTokenName(t) {
        if (t === -1) return "EOF";
        //if ( atn.g!=null ) return atn.g.getTokenDisplayName(t);
        return "'" + String.fromCharCode(t) + "'";
    }
    constructor(atn, recog){
        super(atn);
        this.optimize_tail_calls = true;
        /** The current token's starting index into the character stream.
         *  Shared across DFA to ATN simulation in case the ATN fails and the
         *  DFA did not have a previous accept state. In this case, we use the
         *  ATN-generated exception object.
         */ this.startIndex = -1;
        /** line number 1..n within the input */ this._line = 1;
        /** The index of the character relative to the beginning of the line 0..n-1 */ this._charPositionInLine = 0;
        this.mode = $hEcm0.Lexer.DEFAULT_MODE;
        /** Used during DFA/ATN exec to record the most recent accept configuration info */ this.prevAccept = new LexerATNSimulator.SimState();
        this.recog = recog;
    }
};
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "prevAccept", void 0);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "copyState", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "match", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.Override
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "reset", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "matchATN", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "execATN", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull,
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "computeTargetState", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(2, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "accept", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull,
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "computeStartState", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(2, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "closure", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(2, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(3, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(1, $4w9vi.NotNull),
    $f5b2cdcb05275695$var$__param(2, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "captureSimState", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull,
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "addDFAState", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "getDFA", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull,
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "getText", null);
$f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "consume", null);
$f5b2cdcb05275695$var$__decorate([
    $4w9vi.NotNull
], $f5b2cdcb05275695$var$LexerATNSimulator.prototype, "getTokenName", null);
$f5b2cdcb05275695$var$LexerATNSimulator = $f5b2cdcb05275695$var$__decorate([
    $f5b2cdcb05275695$var$__param(0, $4w9vi.NotNull)
], $f5b2cdcb05275695$var$LexerATNSimulator);
module.exports.LexerATNSimulator = $f5b2cdcb05275695$var$LexerATNSimulator;
(function(LexerATNSimulator) {
    LexerATNSimulator.debug = false;
    LexerATNSimulator.dfa_debug = false;
    /** When we hit an accept state in either the DFA or the ATN, we
     *  have to notify the character stream to start buffering characters
     *  via {@link IntStream#mark} and record the current state. The current sim state
     *  includes the current index into the input, the current line,
     *  and current character position in that line. Note that the Lexer is
     *  tracking the starting line and characterization of the token. These
     *  variables track the "state" of the simulator when it hits an accept state.
     *
     *  We track these variables separately for the DFA and ATN simulation
     *  because the DFA simulation often has to fail over to the ATN
     *  simulation. If the ATN simulation fails, we need the DFA to fall
     *  back to its previously accepted state, if any. If the ATN succeeds,
     *  then the ATN does the accept and the DFA simulator that invoked it
     *  can simply return the predicted token type.
     */ class SimState {
        reset() {
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
            this.dfaState = undefined;
        }
        constructor(){
            this.index = -1;
            this.line = 0;
            this.charPos = -1;
        }
    }
    LexerATNSimulator.SimState = SimState;
})($f5b2cdcb05275695$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
module.exports.LexerATNSimulator = $f5b2cdcb05275695$var$LexerATNSimulator; //# sourceMappingURL=LexerATNSimulator.js.map

});

parcelRegister("EKDdQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $07a7e89c100f466e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $07a7e89c100f466e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATN = void 0;

var $ei6xC = parcelRequire("ei6xC");


var $lgmvT = parcelRequire("lgmvT");


var $g8cb0 = parcelRequire("g8cb0");


var $ktBtp = parcelRequire("ktBtp");


var $e6I92 = parcelRequire("e6I92");


var $4w9vi = parcelRequire("4w9vi");


var $gxIPs = parcelRequire("gxIPs");


var $ca31u = parcelRequire("ca31u");


var $lxPhv = parcelRequire("lxPhv");


var $9ir1r = parcelRequire("9ir1r");

/** */ let $07a7e89c100f466e$var$ATN = class ATN {
    clearDFA() {
        this.decisionToDFA = new Array(this.decisionToState.length);
        for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $lgmvT.DFA(this.decisionToState[i], i);
        this.modeToDFA = new Array(this.modeToStartState.length);
        for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $lgmvT.DFA(this.modeToStartState[i]);
        this.contextCache.clear();
        this.LL1Table.clear();
    }
    get contextCacheSize() {
        return this.contextCache.size;
    }
    getCachedContext(context) {
        return $ca31u.PredictionContext.getCachedContext(context, this.contextCache, new $ca31u.PredictionContext.IdentityHashMap());
    }
    getDecisionToDFA() {
        $9ir1r(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
        return this.decisionToDFA;
    }
    nextTokens(s, ctx) {
        if (ctx) {
            let anal = new $e6I92.LL1Analyzer(this);
            let next = anal.LOOK(s, ctx);
            return next;
        } else {
            if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
            s.nextTokenWithinRule = this.nextTokens(s, $ca31u.PredictionContext.EMPTY_LOCAL);
            s.nextTokenWithinRule.setReadonly(true);
            return s.nextTokenWithinRule;
        }
    }
    addState(state) {
        state.atn = this;
        state.stateNumber = this.states.length;
        this.states.push(state);
    }
    removeState(state) {
        // just replace the state, don't shift states in list
        let invalidState = new $ktBtp.InvalidState();
        invalidState.atn = this;
        invalidState.stateNumber = state.stateNumber;
        this.states[state.stateNumber] = invalidState;
    }
    defineMode(name, s) {
        this.modeNameToStartState.set(name, s);
        this.modeToStartState.push(s);
        this.modeToDFA.push(new $lgmvT.DFA(s));
        this.defineDecisionState(s);
    }
    defineDecisionState(s) {
        this.decisionToState.push(s);
        s.decision = this.decisionToState.length - 1;
        this.decisionToDFA.push(new $lgmvT.DFA(s, s.decision));
        return s.decision;
    }
    getDecisionState(decision) {
        if (this.decisionToState.length > 0) return this.decisionToState[decision];
        return undefined;
    }
    get numberOfDecisions() {
        return this.decisionToState.length;
    }
    /**
     * Computes the set of input symbols which could follow ATN state number
     * `stateNumber` in the specified full `context`. This method
     * considers the complete parser context, but does not evaluate semantic
     * predicates (i.e. all predicates encountered during the calculation are
     * assumed true). If a path in the ATN exists from the starting state to the
     * {@link RuleStopState} of the outermost context without matching any
     * symbols, {@link Token#EOF} is added to the returned set.
     *
     * If `context` is `undefined`, it is treated as
     * {@link ParserRuleContext#EMPTY}.
     *
     * Note that this does NOT give you the set of all tokens that could
     * appear at a given token position in the input phrase.  In other words, it
     * does not answer:
     *
     * > Given a specific partial input phrase, return the set of all
     * > tokens that can follow the last token in the input phrase.
     *
     * The big difference is that with just the input, the parser could land
     * right in the middle of a lookahead decision. Getting all
     * *possible* tokens given a partial input stream is a separate
     * computation. See https://github.com/antlr/antlr4/issues/1428
     *
     * For this function, we are specifying an ATN state and call stack to
     * compute what token(s) can come next and specifically: outside of a
     * lookahead decision. That is what you want for error reporting and
     * recovery upon parse error.
     *
     * @param stateNumber the ATN state number
     * @param context the full parse context
     * @returns The set of potentially valid input symbols which could follow the
     * specified state in the specified context.
     * @ if the ATN does not contain a state with
     * number `stateNumber`
     */ getExpectedTokens(stateNumber, context) {
        if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
        let ctx = context;
        let s = this.states[stateNumber];
        let following = this.nextTokens(s);
        if (!following.contains($lxPhv.Token.EPSILON)) return following;
        let expected = new $g8cb0.IntervalSet();
        expected.addAll(following);
        expected.remove($lxPhv.Token.EPSILON);
        while(ctx != null && ctx.invokingState >= 0 && following.contains($lxPhv.Token.EPSILON)){
            let invokingState = this.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = this.nextTokens(rt.followState);
            expected.addAll(following);
            expected.remove($lxPhv.Token.EPSILON);
            ctx = ctx._parent;
        }
        if (following.contains($lxPhv.Token.EPSILON)) expected.add($lxPhv.Token.EOF);
        return expected;
    }
    /** Used for runtime deserialization of ATNs from strings */ constructor(grammarType, maxTokenType){
        this.states = [];
        /** Each subrule/rule is a decision point and we must track them so we
         *  can go back later and build DFA predictors for them.  This includes
         *  all the rules, subrules, optional blocks, ()+, ()* etc...
         */ this.decisionToState = [];
        this.modeNameToStartState = new Map();
        this.modeToStartState = [];
        this.contextCache = new $ei6xC.Array2DHashMap($gxIPs.ObjectEqualityComparator.INSTANCE);
        this.decisionToDFA = [];
        this.modeToDFA = [];
        this.LL1Table = new Map();
        this.grammarType = grammarType;
        this.maxTokenType = maxTokenType;
    }
};
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "states", void 0);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "decisionToState", void 0);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "modeNameToStartState", void 0);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "modeToStartState", void 0);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "decisionToDFA", void 0);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "modeToDFA", void 0);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "nextTokens", null);
$07a7e89c100f466e$var$__decorate([
    $07a7e89c100f466e$var$__param(0, $4w9vi.NotNull)
], $07a7e89c100f466e$var$ATN.prototype, "removeState", null);
$07a7e89c100f466e$var$__decorate([
    $07a7e89c100f466e$var$__param(0, $4w9vi.NotNull),
    $07a7e89c100f466e$var$__param(1, $4w9vi.NotNull)
], $07a7e89c100f466e$var$ATN.prototype, "defineMode", null);
$07a7e89c100f466e$var$__decorate([
    $07a7e89c100f466e$var$__param(0, $4w9vi.NotNull)
], $07a7e89c100f466e$var$ATN.prototype, "defineDecisionState", null);
$07a7e89c100f466e$var$__decorate([
    $4w9vi.NotNull
], $07a7e89c100f466e$var$ATN.prototype, "getExpectedTokens", null);
$07a7e89c100f466e$var$ATN = $07a7e89c100f466e$var$__decorate([
    $07a7e89c100f466e$var$__param(0, $4w9vi.NotNull)
], $07a7e89c100f466e$var$ATN);
module.exports.ATN = $07a7e89c100f466e$var$ATN;
(function(ATN) {
    ATN.INVALID_ALT_NUMBER = 0;
})($07a7e89c100f466e$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
module.exports.ATN = $07a7e89c100f466e$var$ATN; //# sourceMappingURL=ATN.js.map

});

parcelRegister("51XoR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3a9b1f527627a877$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfigSet = void 0;

var $ei6xC = parcelRequire("ei6xC");


var $eEYRR = parcelRequire("eEYRR");


var $io9eO = parcelRequire("io9eO");


var $EKDdQ = parcelRequire("EKDdQ");


var $gpoJu = parcelRequire("gpoJu");


var $6YKio = parcelRequire("6YKio");


var $4w9vi = parcelRequire("4w9vi");


var $gxIPs = parcelRequire("gxIPs");


var $ca31u = parcelRequire("ca31u");


var $fAz7Q = parcelRequire("fAz7Q");


var $cAJ3R = parcelRequire("cAJ3R");


var $9ir1r = parcelRequire("9ir1r");


var $1rLy7 = parcelRequire("1rLy7");

class $3a9b1f527627a877$var$KeyTypeEqualityComparer {
    hashCode(key) {
        return key.state ^ key.alt;
    }
    equals(a, b) {
        return a.state === b.state && a.alt === b.alt;
    }
}
$3a9b1f527627a877$var$KeyTypeEqualityComparer.INSTANCE = new $3a9b1f527627a877$var$KeyTypeEqualityComparer();
function $3a9b1f527627a877$var$NewKeyedConfigMap(map) {
    if (map) return new $ei6xC.Array2DHashMap(map);
    else return new $ei6xC.Array2DHashMap($3a9b1f527627a877$var$KeyTypeEqualityComparer.INSTANCE);
}
/**
 * Represents a set of ATN configurations (see `ATNConfig`). As configurations are added to the set, they are merged
 * with other `ATNConfig` instances already in the set when possible using the graph-structured stack.
 *
 * An instance of this class represents the complete set of positions (with context) in an ATN which would be associated
 * with a single DFA state. Its internal representation is more complex than traditional state used for NFA to DFA
 * conversion due to performance requirements (both improving speed and reducing memory overhead) as well as supporting
 * features such as semantic predicates and non-greedy operators in a form to support ANTLR's prediction algorithm.
 *
 * @author Sam Harwell
 */ class $3a9b1f527627a877$var$ATNConfigSet {
    /**
     * Get the set of all alternatives represented by configurations in this
     * set.
     */ getRepresentedAlternatives() {
        if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
        let alts = new $6YKio.BitSet();
        for (let config of this)alts.set(config.alt);
        return alts;
    }
    get isReadOnly() {
        return this.mergedConfigs == null;
    }
    get isOutermostConfigSet() {
        return this.outermostConfigSet;
    }
    set isOutermostConfigSet(outermostConfigSet) {
        if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
        $9ir1r(!outermostConfigSet || !this._dipsIntoOuterContext);
        this.outermostConfigSet = outermostConfigSet;
    }
    getStates() {
        let states = new $eEYRR.Array2DHashSet($gxIPs.ObjectEqualityComparator.INSTANCE);
        for (let c of this.configs)states.add(c.state);
        return states;
    }
    optimizeConfigs(interpreter) {
        if (this.configs.length === 0) return;
        for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
    }
    clone(readonly) {
        let copy = new $3a9b1f527627a877$var$ATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this.configs);
        return copy;
    }
    get size() {
        return this.configs.length;
    }
    get isEmpty() {
        return this.configs.length === 0;
    }
    contains(o) {
        if (!(o instanceof $gpoJu.ATNConfig)) return false;
        if (this.mergedConfigs && this.unmerged) {
            let config = o;
            let configKey = this.getKey(config);
            let mergedConfig = this.mergedConfigs.get(configKey);
            if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
            for (let c of this.unmerged){
                if (c.contains(o)) return true;
            }
        } else for (let c of this.configs){
            if (c.contains(o)) return true;
        }
        return false;
    }
    *[Symbol.iterator]() {
        yield* this.configs;
    }
    toArray() {
        return this.configs;
    }
    add(e, contextCache) {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        $9ir1r(!this.outermostConfigSet || !e.reachesIntoOuterContext);
        if (contextCache == null) contextCache = $fAz7Q.PredictionContextCache.UNCACHED;
        let addKey;
        let key = this.getKey(e);
        let mergedConfig = this.mergedConfigs.get(key);
        addKey = mergedConfig == null;
        if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
            mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
            if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
            let joined = $ca31u.PredictionContext.join(mergedConfig.context, e.context, contextCache);
            this.updatePropertiesForMergedConfig(e);
            if (mergedConfig.context === joined) return false;
            mergedConfig.context = joined;
            return true;
        }
        for(let i = 0; i < this.unmerged.length; i++){
            let unmergedConfig = this.unmerged[i];
            if (this.canMerge(e, key, unmergedConfig)) {
                unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $ca31u.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (unmergedConfig.context === joined) return false;
                unmergedConfig.context = joined;
                if (addKey) {
                    this.mergedConfigs.put(key, unmergedConfig);
                    this.unmerged.splice(i, 1);
                }
                return true;
            }
        }
        this.configs.push(e);
        if (addKey) this.mergedConfigs.put(key, e);
        else this.unmerged.push(e);
        this.updatePropertiesForAddedConfig(e);
        return true;
    }
    updatePropertiesForMergedConfig(config) {
        // merged configs can't change the alt or semantic context
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $9ir1r(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    updatePropertiesForAddedConfig(config) {
        if (this.configs.length === 1) this._uniqueAlt = config.alt;
        else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $EKDdQ.ATN.INVALID_ALT_NUMBER;
        this._hasSemanticContext = this._hasSemanticContext || !$cAJ3R.SemanticContext.NONE.equals(config.semanticContext);
        this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
        $9ir1r(!this.outermostConfigSet || !this._dipsIntoOuterContext);
    }
    canMerge(left, leftKey, right) {
        if (left.state.stateNumber !== right.state.stateNumber) return false;
        if (leftKey.alt !== right.alt) return false;
        return left.semanticContext.equals(right.semanticContext);
    }
    getKey(e) {
        return {
            state: e.state.stateNumber,
            alt: e.alt
        };
    }
    containsAll(c) {
        for (let o of c){
            if (!(o instanceof $gpoJu.ATNConfig)) return false;
            if (!this.contains(o)) return false;
        }
        return true;
    }
    addAll(c, contextCache) {
        this.ensureWritable();
        let changed = false;
        for (let group of c)if (this.add(group, contextCache)) changed = true;
        return changed;
    }
    clear() {
        this.ensureWritable();
        if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
        this.mergedConfigs.clear();
        this.unmerged.length = 0;
        this.configs.length = 0;
        this._dipsIntoOuterContext = false;
        this._hasSemanticContext = false;
        this._uniqueAlt = $EKDdQ.ATN.INVALID_ALT_NUMBER;
        this._conflictInfo = undefined;
    }
    equals(obj) {
        if (this === obj) return true;
        if (!(obj instanceof $3a9b1f527627a877$var$ATNConfigSet)) return false;
        return this.outermostConfigSet === obj.outermostConfigSet && $1rLy7.equals(this._conflictInfo, obj._conflictInfo) && $io9eO.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
    }
    hashCode() {
        if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
        let hashCode = 1;
        hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
        hashCode = 5 * hashCode ^ $io9eO.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
        if (this.isReadOnly) this.cachedHashCode = hashCode;
        return hashCode;
    }
    toString(showContext) {
        if (showContext == null) showContext = false;
        let buf = "";
        let sortedConfigs = this.configs.slice(0);
        sortedConfigs.sort((o1, o2)=>{
            if (o1.alt !== o2.alt) return o1.alt - o2.alt;
            else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
            else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
        });
        buf += "[";
        for(let i = 0; i < sortedConfigs.length; i++){
            if (i > 0) buf += ", ";
            buf += sortedConfigs[i].toString(undefined, true, showContext);
        }
        buf += "]";
        if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
        if (this._uniqueAlt !== $EKDdQ.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
        if (this._conflictInfo != null) {
            buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
            if (!this._conflictInfo.isExact) buf += "*";
        }
        if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
        return buf.toString();
    }
    get uniqueAlt() {
        return this._uniqueAlt;
    }
    get hasSemanticContext() {
        return this._hasSemanticContext;
    }
    set hasSemanticContext(value) {
        this.ensureWritable();
        this._hasSemanticContext = value;
    }
    get conflictInfo() {
        return this._conflictInfo;
    }
    set conflictInfo(conflictInfo) {
        this.ensureWritable();
        this._conflictInfo = conflictInfo;
    }
    get conflictingAlts() {
        if (this._conflictInfo == null) return undefined;
        return this._conflictInfo.conflictedAlts;
    }
    get isExactConflict() {
        if (this._conflictInfo == null) return false;
        return this._conflictInfo.isExact;
    }
    get dipsIntoOuterContext() {
        return this._dipsIntoOuterContext;
    }
    get(index) {
        return this.configs[index];
    }
    ensureWritable() {
        if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
    }
    constructor(set, readonly){
        this._uniqueAlt = 0;
        // Used in parser and lexer. In lexer, it indicates we hit a pred
        // while computing a closure operation.  Don't make a DFA state from this.
        this._hasSemanticContext = false;
        this._dipsIntoOuterContext = false;
        /**
         * When `true`, this config set represents configurations where the entire
         * outer context has been consumed by the ATN interpreter. This prevents the
         * {@link ParserATNSimulator#closure} from pursuing the global FOLLOW when a
         * rule stop state is reached with an empty prediction context.
         *
         * Note: `outermostConfigSet` and {@link #dipsIntoOuterContext} should never
         * be true at the same time.
         */ this.outermostConfigSet = false;
        this.cachedHashCode = -1;
        if (!set) {
            this.mergedConfigs = $3a9b1f527627a877$var$NewKeyedConfigMap();
            this.unmerged = [];
            this.configs = [];
            this._uniqueAlt = $EKDdQ.ATN.INVALID_ALT_NUMBER;
        } else {
            if (readonly) {
                this.mergedConfigs = undefined;
                this.unmerged = undefined;
            } else if (!set.isReadOnly) {
                this.mergedConfigs = $3a9b1f527627a877$var$NewKeyedConfigMap(set.mergedConfigs);
                this.unmerged = set.unmerged.slice(0);
            } else {
                this.mergedConfigs = $3a9b1f527627a877$var$NewKeyedConfigMap();
                this.unmerged = [];
            }
            this.configs = set.configs.slice(0);
            this._dipsIntoOuterContext = set._dipsIntoOuterContext;
            this._hasSemanticContext = set._hasSemanticContext;
            this.outermostConfigSet = set.outermostConfigSet;
            if (readonly || !set.isReadOnly) {
                this._uniqueAlt = set._uniqueAlt;
                this._conflictInfo = set._conflictInfo;
            }
        // if (!readonly && set.isReadOnly) -> addAll is called from clone()
        }
    }
}
$3a9b1f527627a877$var$__decorate([
    $4w9vi.NotNull
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "size", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "isEmpty", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "contains", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, Symbol.iterator, null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "toArray", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "containsAll", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "clear", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "equals", null);
$3a9b1f527627a877$var$__decorate([
    $4w9vi.Override
], $3a9b1f527627a877$var$ATNConfigSet.prototype, "hashCode", null);
module.exports.ATNConfigSet = $3a9b1f527627a877$var$ATNConfigSet; //# sourceMappingURL=ATNConfigSet.js.map

});

parcelRegister("gpoJu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $bf222a8b65de8e53$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $bf222a8b65de8e53$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNConfig = void 0;

var $ei6xC = parcelRequire("ei6xC");


var $frUMD = parcelRequire("frUMD");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");


var $gxIPs = parcelRequire("gxIPs");


var $ca31u = parcelRequire("ca31u");


var $cAJ3R = parcelRequire("cAJ3R");


var $9ir1r = parcelRequire("9ir1r");

/**
 * This field stores the bit mask for implementing the
 * {@link #isPrecedenceFilterSuppressed} property as a bit within the
 * existing {@link #altAndOuterContextDepth} field.
 */ const $bf222a8b65de8e53$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
/**
 * Represents a location with context in an ATN. The location is identified by the following values:
 *
 * * The current ATN state
 * * The predicted alternative
 * * The semantic context which must be true for this configuration to be enabled
 * * The syntactic context, which is represented as a graph-structured stack whose path(s) lead to the root of the rule
 *   invocations leading to this state
 *
 * In addition to these values, `ATNConfig` stores several properties about paths taken to get to the location which
 * were added over time to help with performance, correctness, and/or debugging.
 *
 * * `reachesIntoOuterContext`:: Used to ensure semantic predicates are not evaluated in the wrong context.
 * * `hasPassedThroughNonGreedyDecision`: Used for enabling first-match-wins instead of longest-match-wins after
 *   crossing a non-greedy decision.
 * * `lexerActionExecutor`: Used for tracking the lexer action(s) to execute should this instance be selected during
 *   lexing.
 * * `isPrecedenceFilterSuppressed`: A state variable for one of the dynamic disambiguation strategies employed by
 *   `ParserATNSimulator.applyPrecedenceFilter`.
 *
 * Due to the use of a graph-structured stack, a single `ATNConfig` is capable of representing many individual ATN
 * configurations which reached the same location in an ATN by following different paths.
 *
 * PERF: To conserve memory, `ATNConfig` is split into several different concrete types. `ATNConfig` itself stores the
 * minimum amount of information typically used to define an `ATNConfig` instance. Various derived types provide
 * additional storage space for cases where a non-default value is used for some of the object properties. The
 * `ATNConfig.create` and `ATNConfig.transform` methods automatically select the smallest concrete type capable of
 * representing the unique information for any given `ATNConfig`.
 */ let $bf222a8b65de8e53$var$ATNConfig = class ATNConfig {
    static create(state, alt, context, semanticContext = $cAJ3R.SemanticContext.NONE, lexerActionExecutor) {
        if (semanticContext !== $cAJ3R.SemanticContext.NONE) {
            if (lexerActionExecutor != null) return new $bf222a8b65de8e53$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
            else return new $bf222a8b65de8e53$var$SemanticContextATNConfig(semanticContext, state, alt, context);
        } else if (lexerActionExecutor != null) return new $bf222a8b65de8e53$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
        else return new ATNConfig(state, alt, context);
    }
    /** Gets the ATN state associated with this configuration */ get state() {
        return this._state;
    }
    /** What alt (or lexer rule) is predicted by this configuration */ get alt() {
        return this.altAndOuterContextDepth & 0x00FFFFFF;
    }
    get context() {
        return this._context;
    }
    set context(context) {
        this._context = context;
    }
    get reachesIntoOuterContext() {
        return this.outerContextDepth !== 0;
    }
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth &gt; 0.  Note that it may not be totally accurate depth since I
     * don't ever decrement. TODO: make it a boolean then
     */ get outerContextDepth() {
        return this.altAndOuterContextDepth >>> 24 & 0x7F;
    }
    set outerContextDepth(outerContextDepth) {
        $9ir1r(outerContextDepth >= 0);
        // saturate at 0x7F - everything but zero/positive is only used for debug information anyway
        outerContextDepth = Math.min(outerContextDepth, 0x7F);
        this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
    }
    get lexerActionExecutor() {
        return undefined;
    }
    get semanticContext() {
        return $cAJ3R.SemanticContext.NONE;
    }
    get hasPassedThroughNonGreedyDecision() {
        return false;
    }
    clone() {
        return this.transform(this.state, false);
    }
    transform(/*@NotNull*/ state, checkNonGreedy, arg2) {
        if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $ca31u.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
        else if (arg2 instanceof $cAJ3R.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
        else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
    }
    transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
        let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
        if (semanticContext !== $cAJ3R.SemanticContext.NONE) {
            if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bf222a8b65de8e53$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
            else return new $bf222a8b65de8e53$var$SemanticContextATNConfig(semanticContext, state, this, context);
        } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bf222a8b65de8e53$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
        else return new ATNConfig(state, this, context);
    }
    static checkNonGreedyDecision(source, target) {
        return source.hasPassedThroughNonGreedyDecision || target instanceof $frUMD.DecisionState && target.nonGreedy;
    }
    appendContext(context, contextCache) {
        if (typeof context === "number") {
            let appendedContext = this.context.appendSingleContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        } else {
            let appendedContext = this.context.appendContext(context, contextCache);
            let result = this.transform(this.state, false, appendedContext);
            return result;
        }
    }
    /**
     * Determines if this `ATNConfig` fully contains another `ATNConfig`.
     *
     * An ATN configuration represents a position (including context) in an ATN during parsing. Since `ATNConfig` stores
     * the context as a graph, a single `ATNConfig` instance is capable of representing many ATN configurations which
     * are all in the same "location" but have different contexts. These `ATNConfig` instances are again merged when
     * they are added to an `ATNConfigSet`. This method supports `ATNConfigSet.contains` by evaluating whether a
     * particular `ATNConfig` contains all of the ATN configurations represented by another `ATNConfig`.
     *
     * An `ATNConfig` _a_ contains another `ATNConfig` _b_ if all of the following conditions are met:
     *
     * * The configurations are in the same state (`state`)
     * * The configurations predict the same alternative (`alt`)
     * * The semantic context of _a_ implies the semantic context of _b_ (this method performs a weaker equality check)
     * * Joining the prediction contexts of _a_ and _b_ results in the prediction context of _a_
     *
     * This method implements a conservative approximation of containment. As a result, when this method returns `true`
     * it is known that parsing from `subconfig` can only recognize a subset of the inputs which can be recognized
     * starting at the current `ATNConfig`. However, due to the imprecise evaluation of implication for the semantic
     * contexts, no assumptions can be made about the relationship between the configurations when this method returns
     * `false`.
     *
     * @param subconfig The sub configuration.
     * @returns `true` if this configuration contains `subconfig`; otherwise, `false`.
     */ contains(subconfig) {
        if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
        let leftWorkList = [];
        let rightWorkList = [];
        leftWorkList.push(this.context);
        rightWorkList.push(subconfig.context);
        while(true){
            let left = leftWorkList.pop();
            let right = rightWorkList.pop();
            if (!left || !right) break;
            if (left === right) return true;
            if (left.size < right.size) return false;
            if (right.isEmpty) return left.hasEmpty;
            else for(let i = 0; i < right.size; i++){
                let index = left.findReturnState(right.getReturnState(i));
                if (index < 0) // assumes invokingStates has no duplicate entries
                return false;
                leftWorkList.push(left.getParent(index));
                rightWorkList.push(right.getParent(i));
            }
        }
        return false;
    }
    get isPrecedenceFilterSuppressed() {
        return (this.altAndOuterContextDepth & $bf222a8b65de8e53$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
    }
    set isPrecedenceFilterSuppressed(value) {
        if (value) this.altAndOuterContextDepth |= $bf222a8b65de8e53$var$SUPPRESS_PRECEDENCE_FILTER;
        else this.altAndOuterContextDepth &= ~$bf222a8b65de8e53$var$SUPPRESS_PRECEDENCE_FILTER;
    }
    /** An ATN configuration is equal to another if both have
     *  the same state, they predict the same alternative, and
     *  syntactic/semantic contexts are the same.
     */ equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ATNConfig)) return false;
        return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $gxIPs.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
    }
    hashCode() {
        let hashCode = $g3jfX.MurmurHash.initialize(7);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.state.stateNumber);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.alt);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.context);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.semanticContext);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
        hashCode = $g3jfX.MurmurHash.update(hashCode, this.lexerActionExecutor);
        hashCode = $g3jfX.MurmurHash.finish(hashCode, 7);
        return hashCode;
    }
    /**
     * Returns a graphical representation of the current `ATNConfig` in Graphviz format. The graph can be stored to a
     * **.dot** file and then rendered to an image using Graphviz.
     *
     * @returns A Graphviz graph representing the current `ATNConfig`.
     *
     * @see http://www.graphviz.org/
     */ toDotString() {
        let builder = "";
        builder += "digraph G {\n";
        builder += "rankdir=LR;\n";
        let visited = new $ei6xC.Array2DHashMap($ca31u.PredictionContext.IdentityEqualityComparator.INSTANCE);
        let workList = [];
        function getOrAddContext(context) {
            let newNumber = visited.size;
            let result = visited.putIfAbsent(context, newNumber);
            if (result != null) // Already saw this context
            return result;
            workList.push(context);
            return newNumber;
        }
        workList.push(this.context);
        visited.put(this.context, 0);
        while(true){
            let current = workList.pop();
            if (!current) break;
            for(let i = 0; i < current.size; i++){
                builder += "  s" + getOrAddContext(current);
                builder += "->";
                builder += "s" + getOrAddContext(current.getParent(i));
                builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
            }
        }
        builder += "}\n";
        return builder.toString();
    }
    toString(recog, showAlt, showContext) {
        // Must check showContext before showAlt to preserve original overload behavior
        if (showContext == null) showContext = showAlt != null;
        if (showAlt == null) showAlt = true;
        let buf = "";
        // if (this.state.ruleIndex >= 0) {
        // 	if (recog != null) {
        // 		buf += (recog.ruleNames[this.state.ruleIndex] + ":");
        // 	} else {
        // 		buf += (this.state.ruleIndex + ":");
        // 	}
        // }
        let contexts;
        if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
        else contexts = [
            "?"
        ];
        let first = true;
        for (let contextDesc of contexts){
            if (first) first = false;
            else buf += ", ";
            buf += "(";
            buf += this.state;
            if (showAlt) {
                buf += ",";
                buf += this.alt;
            }
            if (this.context) {
                buf += ",";
                buf += contextDesc;
            }
            if (this.semanticContext !== $cAJ3R.SemanticContext.NONE) {
                buf += ",";
                buf += this.semanticContext;
            }
            if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
            buf += ")";
        }
        return buf.toString();
    }
    constructor(state, altOrConfig, context){
        if (typeof altOrConfig === "number") {
            $9ir1r((altOrConfig & 0xFFFFFF) === altOrConfig);
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig;
            this._context = context;
        } else {
            this._state = state;
            this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
            this._context = context;
        }
    }
};
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.NotNull
], $bf222a8b65de8e53$var$ATNConfig.prototype, "_state", void 0);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.NotNull
], $bf222a8b65de8e53$var$ATNConfig.prototype, "_context", void 0);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.NotNull
], $bf222a8b65de8e53$var$ATNConfig.prototype, "state", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.NotNull,
    $bf222a8b65de8e53$var$__param(0, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$ATNConfig.prototype, "context", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.NotNull
], $bf222a8b65de8e53$var$ATNConfig.prototype, "semanticContext", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ATNConfig.prototype, "clone", null);
$bf222a8b65de8e53$var$__decorate([
    $bf222a8b65de8e53$var$__param(0, $4w9vi.NotNull),
    $bf222a8b65de8e53$var$__param(2, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$ATNConfig.prototype, "transformImpl", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ATNConfig.prototype, "equals", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ATNConfig.prototype, "hashCode", null);
$bf222a8b65de8e53$var$__decorate([
    $bf222a8b65de8e53$var$__param(0, $4w9vi.NotNull),
    $bf222a8b65de8e53$var$__param(3, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$ATNConfig, "create", null);
$bf222a8b65de8e53$var$ATNConfig = $bf222a8b65de8e53$var$__decorate([
    $bf222a8b65de8e53$var$__param(0, $4w9vi.NotNull),
    $bf222a8b65de8e53$var$__param(2, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$ATNConfig);
module.exports.ATNConfig = $bf222a8b65de8e53$var$ATNConfig;
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bf222a8b65de8e53$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bf222a8b65de8e53$var$ATNConfig {
    get semanticContext() {
        return this._semanticContext;
    }
    constructor(semanticContext, state, altOrConfig, context){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else super(state, altOrConfig, context);
        this._semanticContext = semanticContext;
    }
};
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.NotNull
], $bf222a8b65de8e53$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$SemanticContextATNConfig.prototype, "semanticContext", null);
$bf222a8b65de8e53$var$SemanticContextATNConfig = $bf222a8b65de8e53$var$__decorate([
    $bf222a8b65de8e53$var$__param(1, $4w9vi.NotNull),
    $bf222a8b65de8e53$var$__param(2, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$SemanticContextATNConfig);
/**
 * This class was derived from `ATNConfig` purely as a memory optimization. It allows for the creation of an `ATNConfig`
 * with a lexer action.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bf222a8b65de8e53$var$ActionATNConfig = class ActionATNConfig extends $bf222a8b65de8e53$var$ATNConfig {
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
    constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(state, altOrConfig, context);
        else {
            super(state, altOrConfig, context);
            if (altOrConfig.semanticContext !== $cAJ3R.SemanticContext.NONE) throw new Error("Not supported");
        }
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
};
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$bf222a8b65de8e53$var$ActionATNConfig = $bf222a8b65de8e53$var$__decorate([
    $bf222a8b65de8e53$var$__param(1, $4w9vi.NotNull),
    $bf222a8b65de8e53$var$__param(2, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$ActionATNConfig);
/**
 * This class was derived from `SemanticContextATNConfig` purely as a memory optimization. It allows for the creation of
 * an `ATNConfig` with both a lexer action and a non-default semantic context.
 *
 * See the `ATNConfig` documentation for more information about conserving memory through the use of several concrete
 * types.
 */ let $bf222a8b65de8e53$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bf222a8b65de8e53$var$SemanticContextATNConfig {
    get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    get hasPassedThroughNonGreedyDecision() {
        return this.passedThroughNonGreedyDecision;
    }
    constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
        if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
        else super(semanticContext, state, altOrConfig, context);
        this._lexerActionExecutor = lexerActionExecutor;
        this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
    }
};
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
$bf222a8b65de8e53$var$__decorate([
    $4w9vi.Override
], $bf222a8b65de8e53$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
$bf222a8b65de8e53$var$ActionSemanticContextATNConfig = $bf222a8b65de8e53$var$__decorate([
    $bf222a8b65de8e53$var$__param(1, $4w9vi.NotNull),
    $bf222a8b65de8e53$var$__param(2, $4w9vi.NotNull)
], $bf222a8b65de8e53$var$ActionSemanticContextATNConfig); //# sourceMappingURL=ATNConfig.js.map

});

parcelRegister("frUMD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecisionState = void 0;

var $ltT8J = parcelRequire("ltT8J");

class $b3f56ca3f978c024$var$DecisionState extends $ltT8J.ATNState {
    constructor(){
        super(...arguments);
        this.decision = -1;
        this.nonGreedy = false;
        this.sll = false;
    }
}
module.exports.DecisionState = $b3f56ca3f978c024$var$DecisionState; //# sourceMappingURL=DecisionState.js.map

});

parcelRegister("ca31u", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8da8c3887ef195b4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8da8c3887ef195b4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;

var $ei6xC = parcelRequire("ei6xC");


var $eEYRR = parcelRequire("eEYRR");


var $l7ijV = parcelRequire("l7ijV");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");


var $fAz7Q = parcelRequire("fAz7Q");


var $9ir1r = parcelRequire("9ir1r");

const $8da8c3887ef195b4$var$INITIAL_HASH = 1;
class $8da8c3887ef195b4$var$PredictionContext {
    static calculateEmptyHashCode() {
        let hash = $g3jfX.MurmurHash.initialize($8da8c3887ef195b4$var$INITIAL_HASH);
        hash = $g3jfX.MurmurHash.finish(hash, 0);
        return hash;
    }
    static calculateSingleHashCode(parent, returnState) {
        let hash = $g3jfX.MurmurHash.initialize($8da8c3887ef195b4$var$INITIAL_HASH);
        hash = $g3jfX.MurmurHash.update(hash, parent);
        hash = $g3jfX.MurmurHash.update(hash, returnState);
        hash = $g3jfX.MurmurHash.finish(hash, 2);
        return hash;
    }
    static calculateHashCode(parents, returnStates) {
        let hash = $g3jfX.MurmurHash.initialize($8da8c3887ef195b4$var$INITIAL_HASH);
        for (let parent of parents)hash = $g3jfX.MurmurHash.update(hash, parent);
        for (let returnState of returnStates)hash = $g3jfX.MurmurHash.update(hash, returnState);
        hash = $g3jfX.MurmurHash.finish(hash, 2 * parents.length);
        return hash;
    }
    static fromRuleContext(atn, outerContext, fullContext = true) {
        if (outerContext.isEmpty) return fullContext ? $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL : $8da8c3887ef195b4$var$PredictionContext.EMPTY_LOCAL;
        let parent;
        if (outerContext._parent) parent = $8da8c3887ef195b4$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
        else parent = fullContext ? $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL : $8da8c3887ef195b4$var$PredictionContext.EMPTY_LOCAL;
        let state = atn.states[outerContext.invokingState];
        let transition = state.transition(0);
        return parent.getChild(transition.followState.stateNumber);
    }
    static addEmptyContext(context) {
        return context.addEmptyContext();
    }
    static removeEmptyContext(context) {
        return context.removeEmptyContext();
    }
    static join(context0, context1, contextCache = $fAz7Q.PredictionContextCache.UNCACHED) {
        if (context0 === context1) return context0;
        if (context0.isEmpty) return $8da8c3887ef195b4$var$PredictionContext.isEmptyLocal(context0) ? context0 : $8da8c3887ef195b4$var$PredictionContext.addEmptyContext(context1);
        else if (context1.isEmpty) return $8da8c3887ef195b4$var$PredictionContext.isEmptyLocal(context1) ? context1 : $8da8c3887ef195b4$var$PredictionContext.addEmptyContext(context0);
        let context0size = context0.size;
        let context1size = context1.size;
        if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
            let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
            if (merged === context0.getParent(0)) return context0;
            else if (merged === context1.getParent(0)) return context1;
            else return merged.getChild(context0.getReturnState(0));
        }
        let count = 0;
        let parentsList = new Array(context0size + context1size);
        let returnStatesList = new Array(parentsList.length);
        let leftIndex = 0;
        let rightIndex = 0;
        let canReturnLeft = true;
        let canReturnRight = true;
        while(leftIndex < context0size && rightIndex < context1size){
            if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                leftIndex++;
                rightIndex++;
            } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                canReturnRight = false;
                leftIndex++;
            } else {
                $9ir1r(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                canReturnLeft = false;
                rightIndex++;
            }
            count++;
        }
        while(leftIndex < context0size){
            parentsList[count] = context0.getParent(leftIndex);
            returnStatesList[count] = context0.getReturnState(leftIndex);
            leftIndex++;
            canReturnRight = false;
            count++;
        }
        while(rightIndex < context1size){
            parentsList[count] = context1.getParent(rightIndex);
            returnStatesList[count] = context1.getReturnState(rightIndex);
            rightIndex++;
            canReturnLeft = false;
            count++;
        }
        if (canReturnLeft) return context0;
        else if (canReturnRight) return context1;
        if (count < parentsList.length) {
            parentsList = parentsList.slice(0, count);
            returnStatesList = returnStatesList.slice(0, count);
        }
        if (parentsList.length === 0) // if one of them was EMPTY_LOCAL, it would be empty and handled at the beginning of the method
        return $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL;
        else if (parentsList.length === 1) return new $8da8c3887ef195b4$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
        else return new $8da8c3887ef195b4$var$ArrayPredictionContext(parentsList, returnStatesList);
    }
    static isEmptyLocal(context) {
        return context === $8da8c3887ef195b4$var$PredictionContext.EMPTY_LOCAL;
    }
    static getCachedContext(context, contextCache, visited) {
        if (context.isEmpty) return context;
        let existing = visited.get(context);
        if (existing) return existing;
        existing = contextCache.get(context);
        if (existing) {
            visited.put(context, existing);
            return existing;
        }
        let changed = false;
        let parents = new Array(context.size);
        for(let i = 0; i < parents.length; i++){
            let parent = $8da8c3887ef195b4$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
            if (changed || parent !== context.getParent(i)) {
                if (!changed) {
                    parents = new Array(context.size);
                    for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                    changed = true;
                }
                parents[i] = parent;
            }
        }
        if (!changed) {
            existing = contextCache.putIfAbsent(context, context);
            visited.put(context, existing != null ? existing : context);
            return context;
        }
        // We know parents.length>0 because context.isEmpty is checked at the beginning of the method.
        let updated;
        if (parents.length === 1) updated = new $8da8c3887ef195b4$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
        else {
            let returnStates = new Array(context.size);
            for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
            updated = new $8da8c3887ef195b4$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
        }
        existing = contextCache.putIfAbsent(updated, updated);
        visited.put(updated, existing || updated);
        visited.put(context, existing || updated);
        return updated;
    }
    appendSingleContext(returnContext, contextCache) {
        return this.appendContext($8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
    }
    getChild(returnState) {
        return new $8da8c3887ef195b4$var$SingletonPredictionContext(this, returnState);
    }
    hashCode() {
        return this.cachedHashCode;
    }
    toStrings(recognizer, currentState, stop = $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL) {
        let result = [];
        outer: for(let perm = 0;; perm++){
            let offset = 0;
            let last = true;
            let p = this;
            let stateNumber = currentState;
            let localBuffer = "";
            localBuffer += "[";
            while(!p.isEmpty && p !== stop){
                let index = 0;
                if (p.size > 0) {
                    let bits = 1;
                    while(1 << bits >>> 0 < p.size)bits++;
                    let mask = (1 << bits >>> 0) - 1;
                    index = perm >> offset & mask;
                    last = last && index >= p.size - 1;
                    if (index >= p.size) continue outer;
                    offset += bits;
                }
                if (recognizer) {
                    if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                    localBuffer += " ";
                    let atn = recognizer.atn;
                    let s = atn.states[stateNumber];
                    let ruleName = recognizer.ruleNames[s.ruleIndex];
                    localBuffer += ruleName;
                } else if (p.getReturnState(index) !== $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (!p.isEmpty) {
                        if (localBuffer.length > 1) // first char is '[', if more than that this isn't the first rule
                        localBuffer += " ";
                        localBuffer += p.getReturnState(index);
                    }
                }
                stateNumber = p.getReturnState(index);
                p = p.getParent(index);
            }
            localBuffer += "]";
            result.push(localBuffer);
            if (last) break;
        }
        return result;
    }
    constructor(cachedHashCode){
        this.cachedHashCode = cachedHashCode;
    }
}
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$PredictionContext.prototype, "hashCode", null);
$8da8c3887ef195b4$var$__decorate([
    $8da8c3887ef195b4$var$__param(0, $4w9vi.NotNull),
    $8da8c3887ef195b4$var$__param(1, $4w9vi.NotNull),
    $8da8c3887ef195b4$var$__param(2, $4w9vi.NotNull)
], $8da8c3887ef195b4$var$PredictionContext, "join", null);
$8da8c3887ef195b4$var$__decorate([
    $8da8c3887ef195b4$var$__param(0, $4w9vi.NotNull),
    $8da8c3887ef195b4$var$__param(1, $4w9vi.NotNull),
    $8da8c3887ef195b4$var$__param(2, $4w9vi.NotNull)
], $8da8c3887ef195b4$var$PredictionContext, "getCachedContext", null);
module.exports.PredictionContext = $8da8c3887ef195b4$var$PredictionContext;
class $8da8c3887ef195b4$var$EmptyPredictionContext extends $8da8c3887ef195b4$var$PredictionContext {
    get isFullContext() {
        return this.fullContext;
    }
    addEmptyContext() {
        return this;
    }
    removeEmptyContext() {
        throw new Error("Cannot remove the empty context from itself.");
    }
    getParent(index) {
        throw new Error("index out of bounds");
    }
    getReturnState(index) {
        throw new Error("index out of bounds");
    }
    findReturnState(returnState) {
        return -1;
    }
    get size() {
        return 0;
    }
    appendSingleContext(returnContext, contextCache) {
        return contextCache.getChild(this, returnContext);
    }
    appendContext(suffix, contextCache) {
        return suffix;
    }
    get isEmpty() {
        return true;
    }
    get hasEmpty() {
        return true;
    }
    equals(o) {
        return this === o;
    }
    toStrings(recognizer, currentState, stop) {
        return [
            "[]"
        ];
    }
    constructor(fullContext){
        super($8da8c3887ef195b4$var$PredictionContext.calculateEmptyHashCode());
        this.fullContext = fullContext;
    }
}
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "getParent", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "getReturnState", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "findReturnState", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "size", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "appendContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "isEmpty", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "hasEmpty", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "equals", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$EmptyPredictionContext.prototype, "toStrings", null);
let $8da8c3887ef195b4$var$ArrayPredictionContext = class ArrayPredictionContext extends $8da8c3887ef195b4$var$PredictionContext {
    getParent(index) {
        return this.parents[index];
    }
    getReturnState(index) {
        return this.returnStates[index];
    }
    findReturnState(returnState) {
        return $l7ijV.Arrays.binarySearch(this.returnStates, returnState);
    }
    get size() {
        return this.returnStates.length;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return this.returnStates[this.returnStates.length - 1] === $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL_STATE_KEY;
    }
    addEmptyContext() {
        if (this.hasEmpty) return this;
        let parents2 = this.parents.slice(0);
        let returnStates2 = this.returnStates.slice(0);
        parents2.push($8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL);
        returnStates2.push($8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL_STATE_KEY);
        return new ArrayPredictionContext(parents2, returnStates2);
    }
    removeEmptyContext() {
        if (!this.hasEmpty) return this;
        if (this.returnStates.length === 2) return new $8da8c3887ef195b4$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
        else {
            let parents2 = this.parents.slice(0, this.parents.length - 1);
            let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
    }
    appendContext(suffix, contextCache) {
        return ArrayPredictionContext.appendContextImpl(this, suffix, new $8da8c3887ef195b4$var$PredictionContext.IdentityHashMap());
    }
    static appendContextImpl(context, suffix, visited) {
        if (suffix.isEmpty) {
            if ($8da8c3887ef195b4$var$PredictionContext.isEmptyLocal(suffix)) {
                if (context.hasEmpty) return $8da8c3887ef195b4$var$PredictionContext.EMPTY_LOCAL;
                throw new Error("what to do here?");
            }
            return context;
        }
        if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
        let result = visited.get(context);
        if (!result) {
            if (context.isEmpty) result = suffix;
            else {
                let parentCount = context.size;
                if (context.hasEmpty) parentCount--;
                let updatedParents = new Array(parentCount);
                let updatedReturnStates = new Array(parentCount);
                for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                if (updatedParents.length === 1) result = new $8da8c3887ef195b4$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                else {
                    $9ir1r(updatedParents.length > 1);
                    result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                }
                if (context.hasEmpty) result = $8da8c3887ef195b4$var$PredictionContext.join(result, suffix);
            }
            visited.put(context, result);
        }
        return result;
    }
    equals(o) {
        if (this === o) return true;
        else if (!(o instanceof ArrayPredictionContext)) return false;
        if (this.hashCode() !== o.hashCode()) // can't be same if hash is different
        return false;
        let other = o;
        return this.equalsImpl(other, new $eEYRR.Array2DHashSet());
    }
    equalsImpl(other, visited) {
        let selfWorkList = [];
        let otherWorkList = [];
        selfWorkList.push(this);
        otherWorkList.push(other);
        while(true){
            let currentSelf = selfWorkList.pop();
            let currentOther = otherWorkList.pop();
            if (!currentSelf || !currentOther) break;
            let operands = new $fAz7Q.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
            if (!visited.add(operands)) continue;
            let selfSize = operands.x.size;
            if (selfSize === 0) {
                if (!operands.x.equals(operands.y)) return false;
                continue;
            }
            let otherSize = operands.y.size;
            if (selfSize !== otherSize) return false;
            for(let i = 0; i < selfSize; i++){
                if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                let selfParent = operands.x.getParent(i);
                let otherParent = operands.y.getParent(i);
                if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                if (selfParent !== otherParent) {
                    selfWorkList.push(selfParent);
                    otherWorkList.push(otherParent);
                }
            }
        }
        return true;
    }
    constructor(parents, returnStates, hashCode){
        super(hashCode || $8da8c3887ef195b4$var$PredictionContext.calculateHashCode(parents, returnStates));
        $9ir1r(parents.length === returnStates.length);
        $9ir1r(returnStates.length > 1 || returnStates[0] !== $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
        this.parents = parents;
        this.returnStates = returnStates;
    }
};
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.NotNull
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "parents", void 0);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.NotNull
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "returnStates", void 0);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "getParent", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "getReturnState", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "findReturnState", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "size", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "isEmpty", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "hasEmpty", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "appendContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$ArrayPredictionContext.prototype, "equals", null);
$8da8c3887ef195b4$var$ArrayPredictionContext = $8da8c3887ef195b4$var$__decorate([
    $8da8c3887ef195b4$var$__param(0, $4w9vi.NotNull)
], $8da8c3887ef195b4$var$ArrayPredictionContext);
let $8da8c3887ef195b4$var$SingletonPredictionContext = class SingletonPredictionContext extends $8da8c3887ef195b4$var$PredictionContext {
    getParent(index) {
        // assert(index == 0);
        return this.parent;
    }
    getReturnState(index) {
        // assert(index == 0);
        return this.returnState;
    }
    findReturnState(returnState) {
        return this.returnState === returnState ? 0 : -1;
    }
    get size() {
        return 1;
    }
    get isEmpty() {
        return false;
    }
    get hasEmpty() {
        return false;
    }
    appendContext(suffix, contextCache) {
        return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
    }
    addEmptyContext() {
        let parents = [
            this.parent,
            $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL
        ];
        let returnStates = [
            this.returnState,
            $8da8c3887ef195b4$var$PredictionContext.EMPTY_FULL_STATE_KEY
        ];
        return new $8da8c3887ef195b4$var$ArrayPredictionContext(parents, returnStates);
    }
    removeEmptyContext() {
        return this;
    }
    equals(o) {
        if (o === this) return true;
        else if (!(o instanceof SingletonPredictionContext)) return false;
        let other = o;
        if (this.hashCode() !== other.hashCode()) return false;
        return this.returnState === other.returnState && this.parent.equals(other.parent);
    }
    constructor(parent, returnState){
        super($8da8c3887ef195b4$var$PredictionContext.calculateSingleHashCode(parent, returnState));
        // assert(returnState != PredictionContext.EMPTY_FULL_STATE_KEY && returnState != PredictionContext.EMPTY_LOCAL_STATE_KEY);
        this.parent = parent;
        this.returnState = returnState;
    }
};
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.NotNull
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "parent", void 0);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "getParent", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "getReturnState", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "findReturnState", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "size", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "isEmpty", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "hasEmpty", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "appendContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
$8da8c3887ef195b4$var$__decorate([
    $4w9vi.Override
], $8da8c3887ef195b4$var$SingletonPredictionContext.prototype, "equals", null);
$8da8c3887ef195b4$var$SingletonPredictionContext = $8da8c3887ef195b4$var$__decorate([
    $8da8c3887ef195b4$var$__param(0, $4w9vi.NotNull)
], $8da8c3887ef195b4$var$SingletonPredictionContext);
module.exports.SingletonPredictionContext = $8da8c3887ef195b4$var$SingletonPredictionContext;
(function(PredictionContext) {
    PredictionContext.EMPTY_LOCAL = new $8da8c3887ef195b4$var$EmptyPredictionContext(false);
    PredictionContext.EMPTY_FULL = new $8da8c3887ef195b4$var$EmptyPredictionContext(true);
    PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
    PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
    class IdentityHashMap extends $ei6xC.Array2DHashMap {
        constructor(){
            super(IdentityEqualityComparator.INSTANCE);
        }
    }
    PredictionContext.IdentityHashMap = IdentityHashMap;
    class IdentityEqualityComparator {
        IdentityEqualityComparator() {
        // intentionally empty
        }
        hashCode(obj) {
            return obj.hashCode();
        }
        equals(a, b) {
            return a === b;
        }
    }
    IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
    $8da8c3887ef195b4$var$__decorate([
        $4w9vi.Override
    ], IdentityEqualityComparator.prototype, "hashCode", null);
    $8da8c3887ef195b4$var$__decorate([
        $4w9vi.Override
    ], IdentityEqualityComparator.prototype, "equals", null);
    PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
})($8da8c3887ef195b4$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {})); //# sourceMappingURL=PredictionContext.js.map

});

parcelRegister("fAz7Q", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b59576fe23a92505$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionContextCache = void 0;

var $ei6xC = parcelRequire("ei6xC");


var $4w9vi = parcelRequire("4w9vi");


var $gxIPs = parcelRequire("gxIPs");


var $ca31u = parcelRequire("ca31u");


var $9ir1r = parcelRequire("9ir1r");

/** Used to cache {@link PredictionContext} objects. Its used for the shared
 *  context cash associated with contexts in DFA states. This cache
 *  can be used for both lexers and parsers.
 *
 * @author Sam Harwell
 */ class $b59576fe23a92505$var$PredictionContextCache {
    getAsCached(context) {
        if (!this.enableCache) return context;
        let result = this.contexts.get(context);
        if (!result) {
            result = context;
            this.contexts.put(context, context);
        }
        return result;
    }
    getChild(context, invokingState) {
        if (!this.enableCache) return context.getChild(invokingState);
        let operands = new $b59576fe23a92505$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
        let result = this.childContexts.get(operands);
        if (!result) {
            result = context.getChild(invokingState);
            result = this.getAsCached(result);
            this.childContexts.put(operands, result);
        }
        return result;
    }
    join(x, y) {
        if (!this.enableCache) return $ca31u.PredictionContext.join(x, y, this);
        let operands = new $b59576fe23a92505$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
        let result = this.joinContexts.get(operands);
        if (result) return result;
        result = $ca31u.PredictionContext.join(x, y, this);
        result = this.getAsCached(result);
        this.joinContexts.put(operands, result);
        return result;
    }
    constructor(enableCache = true){
        this.contexts = new $ei6xC.Array2DHashMap($gxIPs.ObjectEqualityComparator.INSTANCE);
        this.childContexts = new $ei6xC.Array2DHashMap($gxIPs.ObjectEqualityComparator.INSTANCE);
        this.joinContexts = new $ei6xC.Array2DHashMap($gxIPs.ObjectEqualityComparator.INSTANCE);
        this.enableCache = enableCache;
    }
}
module.exports.PredictionContextCache = $b59576fe23a92505$var$PredictionContextCache;
$b59576fe23a92505$var$PredictionContextCache.UNCACHED = new $b59576fe23a92505$var$PredictionContextCache(false);
(function(PredictionContextCache) {
    class PredictionContextAndInt {
        equals(obj) {
            if (!(obj instanceof PredictionContextAndInt)) return false;
            else if (obj === this) return true;
            let other = obj;
            return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
        }
        hashCode() {
            let hashCode = 5;
            hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
            hashCode = 7 * hashCode + this.value;
            return hashCode;
        }
        constructor(obj, value){
            this.obj = obj;
            this.value = value;
        }
    }
    $b59576fe23a92505$var$__decorate([
        $4w9vi.Override
    ], PredictionContextAndInt.prototype, "equals", null);
    $b59576fe23a92505$var$__decorate([
        $4w9vi.Override
    ], PredictionContextAndInt.prototype, "hashCode", null);
    PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
    class IdentityCommutativePredictionContextOperands {
        get x() {
            return this._x;
        }
        get y() {
            return this._y;
        }
        equals(o) {
            if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
            else if (this === o) return true;
            let other = o;
            return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
        }
        hashCode() {
            return this._x.hashCode() ^ this._y.hashCode();
        }
        constructor(x, y){
            $9ir1r(x != null);
            $9ir1r(y != null);
            this._x = x;
            this._y = y;
        }
    }
    $b59576fe23a92505$var$__decorate([
        $4w9vi.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
    $b59576fe23a92505$var$__decorate([
        $4w9vi.Override
    ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
    PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
})($b59576fe23a92505$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {})); //# sourceMappingURL=PredictionContextCache.js.map

});

parcelRegister("gZszX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c5e883078aea59f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c5e883078aea59f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNSimulator = void 0;

var $51XoR = parcelRequire("51XoR");


var $iIwZu = parcelRequire("iIwZu");


var $4w9vi = parcelRequire("4w9vi");


var $ca31u = parcelRequire("ca31u");

let $c5e883078aea59f9$var$ATNSimulator = class ATNSimulator {
    static get ERROR() {
        if (!ATNSimulator._ERROR) {
            ATNSimulator._ERROR = new $iIwZu.DFAState(new $51XoR.ATNConfigSet());
            ATNSimulator._ERROR.stateNumber = $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        return ATNSimulator._ERROR;
    }
    /**
     * Clear the DFA cache used by the current instance. Since the DFA cache may
     * be shared by multiple ATN simulators, this method may affect the
     * performance (but not accuracy) of other parsers which are being used
     * concurrently.
     *
     * @ if the current instance does not
     * support clearing the DFA.
     *
     * @since 4.3
     */ clearDFA() {
        this.atn.clearDFA();
    }
    constructor(atn){
        this.atn = atn;
    }
};
$c5e883078aea59f9$var$__decorate([
    $4w9vi.NotNull
], $c5e883078aea59f9$var$ATNSimulator.prototype, "atn", void 0);
$c5e883078aea59f9$var$__decorate([
    $4w9vi.NotNull
], $c5e883078aea59f9$var$ATNSimulator, "ERROR", null);
$c5e883078aea59f9$var$ATNSimulator = $c5e883078aea59f9$var$__decorate([
    $c5e883078aea59f9$var$__param(0, $4w9vi.NotNull)
], $c5e883078aea59f9$var$ATNSimulator);
module.exports.ATNSimulator = $c5e883078aea59f9$var$ATNSimulator;
(function(ATNSimulator) {
    const RULE_VARIANT_DELIMITER = "$";
    const RULE_LF_VARIANT_MARKER = "$lf$";
    const RULE_NOLF_VARIANT_MARKER = "$nolf$";
})($c5e883078aea59f9$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
module.exports.ATNSimulator = $c5e883078aea59f9$var$ATNSimulator; //# sourceMappingURL=ATNSimulator.js.map

});

parcelRegister("lEpws", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fc3121a348604ffa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fc3121a348604ffa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Recognizer = void 0;

var $lwiXx = parcelRequire("lwiXx");


var $fPBfc = parcelRequire("fPBfc");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");


var $1rLy7 = parcelRequire("1rLy7");

class $fc3121a348604ffa$var$Recognizer {
    /**
     * Get a map from token names to token types.
     *
     * Used for XPath and tree pattern compilation.
     */ getTokenTypeMap() {
        let vocabulary = this.vocabulary;
        let result = $fc3121a348604ffa$var$Recognizer.tokenTypeMapCache.get(vocabulary);
        if (result == null) {
            let intermediateResult = new Map();
            for(let i = 0; i <= this.atn.maxTokenType; i++){
                let literalName = vocabulary.getLiteralName(i);
                if (literalName != null) intermediateResult.set(literalName, i);
                let symbolicName = vocabulary.getSymbolicName(i);
                if (symbolicName != null) intermediateResult.set(symbolicName, i);
            }
            intermediateResult.set("EOF", $lxPhv.Token.EOF);
            result = intermediateResult;
            $fc3121a348604ffa$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
        }
        return result;
    }
    /**
     * Get a map from rule names to rule indexes.
     *
     * Used for XPath and tree pattern compilation.
     */ getRuleIndexMap() {
        let ruleNames = this.ruleNames;
        if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
        let result = $fc3121a348604ffa$var$Recognizer.ruleIndexMapCache.get(ruleNames);
        if (result == null) {
            result = $1rLy7.toMap(ruleNames);
            $fc3121a348604ffa$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
        }
        return result;
    }
    getTokenType(tokenName) {
        let ttype = this.getTokenTypeMap().get(tokenName);
        if (ttype != null) return ttype;
        return $lxPhv.Token.INVALID_TYPE;
    }
    /**
     * If this recognizer was generated, it will have a serialized ATN
     * representation of the grammar.
     *
     * For interpreters, we don't know their serialized ATN despite having
     * created the interpreter from it.
     */ get serializedATN() {
        throw new Error("there is no serialized ATN");
    }
    /**
     * Get the {@link ATN} used by the recognizer for prediction.
     *
     * @returns The {@link ATN} used by the recognizer for prediction.
     */ get atn() {
        return this._interp.atn;
    }
    /**
     * Get the ATN interpreter used by the recognizer for prediction.
     *
     * @returns The ATN interpreter used by the recognizer for prediction.
     */ get interpreter() {
        return this._interp;
    }
    /**
     * Set the ATN interpreter used by the recognizer for prediction.
     *
     * @param interpreter The ATN interpreter used by the recognizer for
     * prediction.
     */ set interpreter(interpreter) {
        this._interp = interpreter;
    }
    /** If profiling during the parse/lex, this will return DecisionInfo records
     *  for each decision in recognizer in a ParseInfo object.
     *
     * @since 4.3
     */ get parseInfo() {
        return Promise.resolve(undefined);
    }
    /** What is the error header, normally line/character position information? */ getErrorHeader(e) {
        let token = e.getOffendingToken();
        if (!token) return "";
        let line = token.line;
        let charPositionInLine = token.charPositionInLine;
        return "line " + line + ":" + charPositionInLine;
    }
    /**
     * @exception NullPointerException if `listener` is `undefined`.
     */ addErrorListener(listener) {
        if (!listener) throw new TypeError("listener must not be null");
        this._listeners.push(listener);
    }
    removeErrorListener(listener) {
        let position = this._listeners.indexOf(listener);
        if (position !== -1) this._listeners.splice(position, 1);
    }
    removeErrorListeners() {
        this._listeners.length = 0;
    }
    getErrorListeners() {
        return this._listeners.slice(0);
    }
    getErrorListenerDispatch() {
        return new $fPBfc.ProxyErrorListener(this.getErrorListeners());
    }
    // subclass needs to override these if there are sempreds or actions
    // that the ATN interp needs to execute
    sempred(_localctx, ruleIndex, actionIndex) {
        return true;
    }
    precpred(localctx, precedence) {
        return true;
    }
    action(_localctx, ruleIndex, actionIndex) {
    // intentionally empty
    }
    get state() {
        return this._stateNumber;
    }
    /** Indicate that the recognizer has changed internal state that is
     *  consistent with the ATN state passed in.  This way we always know
     *  where we are in the ATN as the parser goes along. The rule
     *  context objects form a stack that lets us see the stack of
     *  invoking rules. Combine this and we have complete ATN
     *  configuration information.
     */ set state(atnState) {
        //		System.err.println("setState "+atnState);
        this._stateNumber = atnState;
    //		if ( traceATNStates ) _ctx.trace(atnState);
    }
    constructor(){
        this._listeners = [
            $lwiXx.ConsoleErrorListener.INSTANCE
        ];
        this._stateNumber = -1;
    }
}
$fc3121a348604ffa$var$Recognizer.EOF = -1;
$fc3121a348604ffa$var$Recognizer.tokenTypeMapCache = new WeakMap();
$fc3121a348604ffa$var$Recognizer.ruleIndexMapCache = new WeakMap();
$fc3121a348604ffa$var$__decorate([
    $4w9vi.SuppressWarnings("serial"),
    $4w9vi.NotNull
], $fc3121a348604ffa$var$Recognizer.prototype, "_listeners", void 0);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull
], $fc3121a348604ffa$var$Recognizer.prototype, "getTokenTypeMap", null);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull
], $fc3121a348604ffa$var$Recognizer.prototype, "getRuleIndexMap", null);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull
], $fc3121a348604ffa$var$Recognizer.prototype, "serializedATN", null);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull
], $fc3121a348604ffa$var$Recognizer.prototype, "atn", null);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull,
    $fc3121a348604ffa$var$__param(0, $4w9vi.NotNull)
], $fc3121a348604ffa$var$Recognizer.prototype, "interpreter", null);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull,
    $fc3121a348604ffa$var$__param(0, $4w9vi.NotNull)
], $fc3121a348604ffa$var$Recognizer.prototype, "getErrorHeader", null);
$fc3121a348604ffa$var$__decorate([
    $fc3121a348604ffa$var$__param(0, $4w9vi.NotNull)
], $fc3121a348604ffa$var$Recognizer.prototype, "addErrorListener", null);
$fc3121a348604ffa$var$__decorate([
    $fc3121a348604ffa$var$__param(0, $4w9vi.NotNull)
], $fc3121a348604ffa$var$Recognizer.prototype, "removeErrorListener", null);
$fc3121a348604ffa$var$__decorate([
    $4w9vi.NotNull
], $fc3121a348604ffa$var$Recognizer.prototype, "getErrorListeners", null);
module.exports.Recognizer = $fc3121a348604ffa$var$Recognizer; //# sourceMappingURL=Recognizer.js.map

});

parcelRegister("lwiXx", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleErrorListener = void 0;
/**
 *
 * @author Sam Harwell
 */ class $faab4b08509f0a1e$var$ConsoleErrorListener {
    /**
     * {@inheritDoc}
     *
     * This implementation prints messages to {@link System#err} containing the
     * values of `line`, `charPositionInLine`, and `msg` using
     * the following format.
     *
     * <pre>
     * line *line*:*charPositionInLine* *msg*
     * </pre>
     */ syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        console.error(`line ${line}:${charPositionInLine} ${msg}`);
    }
}
module.exports.ConsoleErrorListener = $faab4b08509f0a1e$var$ConsoleErrorListener;
/**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */ $faab4b08509f0a1e$var$ConsoleErrorListener.INSTANCE = new $faab4b08509f0a1e$var$ConsoleErrorListener(); //# sourceMappingURL=ConsoleErrorListener.js.map

});

parcelRegister("fPBfc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b868825662912552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b868825662912552$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyErrorListener = void 0;

var $4w9vi = parcelRequire("4w9vi");

/**
 * This implementation of {@link ANTLRErrorListener} dispatches all calls to a
 * collection of delegate listeners. This reduces the effort required to support multiple
 * listeners.
 *
 * @author Sam Harwell
 */ class $b868825662912552$var$ProxyErrorListener {
    getDelegates() {
        return this.delegates;
    }
    syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
        this.delegates.forEach((listener)=>{
            if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
        });
    }
    constructor(delegates){
        this.delegates = delegates;
        if (!delegates) throw new Error("Invalid delegates");
    }
}
$b868825662912552$var$__decorate([
    $4w9vi.Override,
    $b868825662912552$var$__param(0, $4w9vi.NotNull),
    $b868825662912552$var$__param(4, $4w9vi.NotNull)
], $b868825662912552$var$ProxyErrorListener.prototype, "syntaxError", null);
module.exports.ProxyErrorListener = $b868825662912552$var$ProxyErrorListener; //# sourceMappingURL=ProxyErrorListener.js.map

});

parcelRegister("auHu3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7a3e6faf55213f7b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VocabularyImpl = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

/**
 * This class provides a default implementation of the {@link Vocabulary}
 * interface.
 *
 * @author Sam Harwell
 */ class $7a3e6faf55213f7b$var$VocabularyImpl {
    get maxTokenType() {
        return this._maxTokenType;
    }
    getLiteralName(tokenType) {
        if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
        return undefined;
    }
    getSymbolicName(tokenType) {
        if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
        if (tokenType === $lxPhv.Token.EOF) return "EOF";
        return undefined;
    }
    getDisplayName(tokenType) {
        if (tokenType >= 0 && tokenType < this.displayNames.length) {
            let displayName = this.displayNames[tokenType];
            if (displayName) return displayName;
        }
        let literalName = this.getLiteralName(tokenType);
        if (literalName) return literalName;
        let symbolicName = this.getSymbolicName(tokenType);
        if (symbolicName) return symbolicName;
        return String(tokenType);
    }
    /**
     * Constructs a new instance of {@link VocabularyImpl} from the specified
     * literal, symbolic, and display token names.
     *
     * @param literalNames The literal names assigned to tokens, or an empty array
     * if no literal names are assigned.
     * @param symbolicNames The symbolic names assigned to tokens, or
     * an empty array if no symbolic names are assigned.
     * @param displayNames The display names assigned to tokens, or an empty array
     * to use the values in `literalNames` and `symbolicNames` as
     * the source of display names, as described in
     * {@link #getDisplayName(int)}.
     *
     * @see #getLiteralName(int)
     * @see #getSymbolicName(int)
     * @see #getDisplayName(int)
     */ constructor(literalNames, symbolicNames, displayNames){
        this.literalNames = literalNames;
        this.symbolicNames = symbolicNames;
        this.displayNames = displayNames;
        // See note here on -1 part: https://github.com/antlr/antlr4/pull/1146
        this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
    }
}
/**
 * Gets an empty {@link Vocabulary} instance.
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */ $7a3e6faf55213f7b$var$VocabularyImpl.EMPTY_VOCABULARY = new $7a3e6faf55213f7b$var$VocabularyImpl([], [], []);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.NotNull
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "literalNames", void 0);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.NotNull
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "symbolicNames", void 0);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.NotNull
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "displayNames", void 0);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.Override
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "maxTokenType", null);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.Override
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "getLiteralName", null);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.Override
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "getSymbolicName", null);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $7a3e6faf55213f7b$var$VocabularyImpl.prototype, "getDisplayName", null);
$7a3e6faf55213f7b$var$__decorate([
    $4w9vi.NotNull
], $7a3e6faf55213f7b$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
module.exports.VocabularyImpl = $7a3e6faf55213f7b$var$VocabularyImpl; //# sourceMappingURL=VocabularyImpl.js.map

});

parcelRegister("9nX6N", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6d541cc1c1f27955$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopEntryState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $6YKio = parcelRequire("6YKio");


var $frUMD = parcelRequire("frUMD");


var $4w9vi = parcelRequire("4w9vi");

class $6d541cc1c1f27955$var$StarLoopEntryState extends $frUMD.DecisionState {
    get stateType() {
        return $jW0J3.ATNStateType.STAR_LOOP_ENTRY;
    }
    constructor(){
        super(...arguments);
        /**
         * Indicates whether this state can benefit from a precedence DFA during SLL
         * decision making.
         *
         * This is a computed property that is calculated during ATN deserialization
         * and stored for use in {@link ParserATNSimulator} and
         * {@link ParserInterpreter}.
         *
         * @see `DFA.isPrecedenceDfa`
         */ this.precedenceRuleDecision = false;
        /**
         * For precedence decisions, this set marks states *S* which have all
         * of the following characteristics:
         *
         * * One or more invocation sites of the current rule returns to
         *   *S*.
         * * The closure from *S* includes the current decision without
         *   passing through any rule invocations or stepping out of the current
         *   rule.
         *
         * This field is not used when {@link #precedenceRuleDecision} is
         * `false`.
         */ this.precedenceLoopbackStates = new $6YKio.BitSet();
    }
}
$6d541cc1c1f27955$var$__decorate([
    $4w9vi.Override
], $6d541cc1c1f27955$var$StarLoopEntryState.prototype, "stateType", null);
module.exports.StarLoopEntryState = $6d541cc1c1f27955$var$StarLoopEntryState; //# sourceMappingURL=StarLoopEntryState.js.map

});

parcelRegister("ktBtp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ee83957eafe0b19d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $cNyYW = parcelRequire("cNyYW");


var $4w9vi = parcelRequire("4w9vi");

/**
 *
 * @author Sam Harwell
 */ class $ee83957eafe0b19d$var$InvalidState extends $cNyYW.BasicState {
    get stateType() {
        return $jW0J3.ATNStateType.INVALID_TYPE;
    }
}
$ee83957eafe0b19d$var$__decorate([
    $4w9vi.Override
], $ee83957eafe0b19d$var$InvalidState.prototype, "stateType", null);
module.exports.InvalidState = $ee83957eafe0b19d$var$InvalidState; //# sourceMappingURL=InvalidState.js.map

});

parcelRegister("cNyYW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $95153254c5180211$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicState = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $4w9vi = parcelRequire("4w9vi");

/**
 *
 * @author Sam Harwell
 */ class $95153254c5180211$var$BasicState extends $ltT8J.ATNState {
    get stateType() {
        return $jW0J3.ATNStateType.BASIC;
    }
}
$95153254c5180211$var$__decorate([
    $4w9vi.Override
], $95153254c5180211$var$BasicState.prototype, "stateType", null);
module.exports.BasicState = $95153254c5180211$var$BasicState; //# sourceMappingURL=BasicState.js.map

});

parcelRegister("e6I92", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a453de6f62827cb8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a453de6f62827cb8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LL1Analyzer = void 0;

var $4Lzcj = parcelRequire("4Lzcj");


var $eEYRR = parcelRequire("eEYRR");


var $gpoJu = parcelRequire("gpoJu");


var $6YKio = parcelRequire("6YKio");


var $g8cb0 = parcelRequire("g8cb0");


var $4w9vi = parcelRequire("4w9vi");


var $kUcH8 = parcelRequire("kUcH8");


var $gxIPs = parcelRequire("gxIPs");


var $ca31u = parcelRequire("ca31u");


var $4eVci = parcelRequire("4eVci");


var $1q038 = parcelRequire("1q038");


var $lxPhv = parcelRequire("lxPhv");


var $3uASk = parcelRequire("3uASk");

let $a453de6f62827cb8$var$LL1Analyzer = class LL1Analyzer {
    /**
     * Calculates the SLL(1) expected lookahead set for each outgoing transition
     * of an {@link ATNState}. The returned array has one element for each
     * outgoing transition in `s`. If the closure from transition
     * *i* leads to a semantic predicate before matching a symbol, the
     * element at index *i* of the result will be `undefined`.
     *
     * @param s the ATN state
     * @returns the expected symbols for each outgoing transition of `s`.
     */ getDecisionLookahead(s) {
        //		System.out.println("LOOK("+s.stateNumber+")");
        if (s == null) return undefined;
        let look = new Array(s.numberOfTransitions);
        for(let alt = 0; alt < s.numberOfTransitions; alt++){
            let current = new $g8cb0.IntervalSet();
            look[alt] = current;
            let lookBusy = new $eEYRR.Array2DHashSet($gxIPs.ObjectEqualityComparator.INSTANCE);
            let seeThruPreds = false; // fail to get lookahead upon pred
            this._LOOK(s.transition(alt).target, undefined, $ca31u.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $6YKio.BitSet(), seeThruPreds, false);
            // Wipe out lookahead for this alternative if we found nothing
            // or we had a predicate when we !seeThruPreds
            if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                current = undefined;
                look[alt] = current;
            }
        }
        return look;
    }
    LOOK(s, ctx, stopState) {
        if (stopState === undefined) {
            if (s.atn == null) throw new Error("Illegal state");
            stopState = s.atn.ruleToStopState[s.ruleIndex];
        } else if (stopState === null) // This is an explicit request to pass undefined as the stopState to _LOOK. Used to distinguish an overload
        // from the method which simply omits the stopState parameter.
        stopState = undefined;
        let r = new $g8cb0.IntervalSet();
        let seeThruPreds = true; // ignore preds; get all lookahead
        let addEOF = true;
        this._LOOK(s, stopState, ctx, r, new $eEYRR.Array2DHashSet(), new $6YKio.BitSet(), seeThruPreds, addEOF);
        return r;
    }
    /**
     * Compute set of tokens that can follow `s` in the ATN in the
     * specified `ctx`.
     * <p/>
     * If `ctx` is {@link PredictionContext#EMPTY_LOCAL} and
     * `stopState` or the end of the rule containing `s` is reached,
     * {@link Token#EPSILON} is added to the result set. If `ctx` is not
     * {@link PredictionContext#EMPTY_LOCAL} and `addEOF` is `true`
     * and `stopState` or the end of the outermost rule is reached,
     * {@link Token#EOF} is added to the result set.
     *
     * @param s the ATN state.
     * @param stopState the ATN state to stop at. This can be a
     * {@link BlockEndState} to detect epsilon paths through a closure.
     * @param ctx The outer context, or {@link PredictionContext#EMPTY_LOCAL} if
     * the outer context should not be used.
     * @param look The result lookahead set.
     * @param lookBusy A set used for preventing epsilon closures in the ATN
     * from causing a stack overflow. Outside code should pass
     * `new HashSet<ATNConfig>` for this argument.
     * @param calledRuleStack A set used for preventing left recursion in the
     * ATN from causing a stack overflow. Outside code should pass
     * `new BitSet()` for this argument.
     * @param seeThruPreds `true` to true semantic predicates as
     * implicitly `true` and "see through them", otherwise `false`
     * to treat semantic predicates as opaque and add {@link #HIT_PRED} to the
     * result if one is encountered.
     * @param addEOF Add {@link Token#EOF} to the result if the end of the
     * outermost context is reached. This parameter has no effect if `ctx`
     * is {@link PredictionContext#EMPTY_LOCAL}.
     */ _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
        //		System.out.println("_LOOK("+s.stateNumber+", ctx="+ctx);
        let c = $gpoJu.ATNConfig.create(s, 0, ctx);
        if (!lookBusy.add(c)) return;
        if (s === stopState) {
            if ($ca31u.PredictionContext.isEmptyLocal(ctx)) {
                look.add($lxPhv.Token.EPSILON);
                return;
            } else if (ctx.isEmpty) {
                if (addEOF) look.add($lxPhv.Token.EOF);
                return;
            }
        }
        if (s instanceof $4eVci.RuleStopState) {
            if (ctx.isEmpty && !$ca31u.PredictionContext.isEmptyLocal(ctx)) {
                if (addEOF) look.add($lxPhv.Token.EOF);
                return;
            }
            let removed = calledRuleStack.get(s.ruleIndex);
            try {
                calledRuleStack.clear(s.ruleIndex);
                for(let i = 0; i < ctx.size; i++){
                    if (ctx.getReturnState(i) === $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let returnState = this.atn.states[ctx.getReturnState(i)];
                    //					System.out.println("popping back to "+retState);
                    this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                }
            } finally{
                if (removed) calledRuleStack.set(s.ruleIndex);
            }
        }
        let n = s.numberOfTransitions;
        for(let i = 0; i < n; i++){
            let t = s.transition(i);
            if (t instanceof $1q038.RuleTransition) {
                if (calledRuleStack.get(t.ruleIndex)) continue;
                let newContext = ctx.getChild(t.followState.stateNumber);
                try {
                    calledRuleStack.set(t.ruleIndex);
                    this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                } finally{
                    calledRuleStack.clear(t.ruleIndex);
                }
            } else if (t instanceof $4Lzcj.AbstractPredicateTransition) {
                if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else look.add(LL1Analyzer.HIT_PRED);
            } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
            else if (t instanceof $3uASk.WildcardTransition) look.addAll($g8cb0.IntervalSet.of($lxPhv.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
            else {
                //				System.out.println("adding "+ t);
                let set = t.label;
                if (set != null) {
                    if (t instanceof $kUcH8.NotSetTransition) set = set.complement($g8cb0.IntervalSet.of($lxPhv.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                    look.addAll(set);
                }
            }
        }
    }
    constructor(atn){
        this.atn = atn;
    }
};
/** Special value added to the lookahead sets to indicate that we hit
 *  a predicate during analysis if `seeThruPreds==false`.
 */ $a453de6f62827cb8$var$LL1Analyzer.HIT_PRED = $lxPhv.Token.INVALID_TYPE;
$a453de6f62827cb8$var$__decorate([
    $4w9vi.NotNull
], $a453de6f62827cb8$var$LL1Analyzer.prototype, "atn", void 0);
$a453de6f62827cb8$var$__decorate([
    $4w9vi.NotNull,
    $a453de6f62827cb8$var$__param(0, $4w9vi.NotNull),
    $a453de6f62827cb8$var$__param(1, $4w9vi.NotNull)
], $a453de6f62827cb8$var$LL1Analyzer.prototype, "LOOK", null);
$a453de6f62827cb8$var$__decorate([
    $a453de6f62827cb8$var$__param(0, $4w9vi.NotNull),
    $a453de6f62827cb8$var$__param(2, $4w9vi.NotNull),
    $a453de6f62827cb8$var$__param(3, $4w9vi.NotNull),
    $a453de6f62827cb8$var$__param(4, $4w9vi.NotNull),
    $a453de6f62827cb8$var$__param(5, $4w9vi.NotNull)
], $a453de6f62827cb8$var$LL1Analyzer.prototype, "_LOOK", null);
$a453de6f62827cb8$var$LL1Analyzer = $a453de6f62827cb8$var$__decorate([
    $a453de6f62827cb8$var$__param(0, $4w9vi.NotNull)
], $a453de6f62827cb8$var$LL1Analyzer);
module.exports.LL1Analyzer = $a453de6f62827cb8$var$LL1Analyzer; //# sourceMappingURL=LL1Analyzer.js.map

});

parcelRegister("kUcH8", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f382e2829808ceb2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f382e2829808ceb2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotSetTransition = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $7grDB = parcelRequire("7grDB");

let $f382e2829808ceb2$var$NotSetTransition = class NotSetTransition extends $7grDB.SetTransition {
    get serializationType() {
        return 8 /* NOT_SET */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
    }
    toString() {
        return "~" + super.toString();
    }
    constructor(target, set){
        super(target, set);
    }
};
$f382e2829808ceb2$var$__decorate([
    $4w9vi.Override
], $f382e2829808ceb2$var$NotSetTransition.prototype, "serializationType", null);
$f382e2829808ceb2$var$__decorate([
    $4w9vi.Override
], $f382e2829808ceb2$var$NotSetTransition.prototype, "matches", null);
$f382e2829808ceb2$var$__decorate([
    $4w9vi.Override
], $f382e2829808ceb2$var$NotSetTransition.prototype, "toString", null);
$f382e2829808ceb2$var$NotSetTransition = $f382e2829808ceb2$var$__decorate([
    $f382e2829808ceb2$var$__param(0, $4w9vi.NotNull),
    $f382e2829808ceb2$var$__param(1, $4w9vi.Nullable)
], $f382e2829808ceb2$var$NotSetTransition);
module.exports.NotSetTransition = $f382e2829808ceb2$var$NotSetTransition; //# sourceMappingURL=NotSetTransition.js.map

});

parcelRegister("7grDB", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $549f774b4b925a9f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $549f774b4b925a9f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTransition = void 0;

var $g8cb0 = parcelRequire("g8cb0");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");


var $151Ma = parcelRequire("151Ma");

/** A transition containing a set of values. */ let $549f774b4b925a9f$var$SetTransition = class SetTransition extends $151Ma.Transition {
    get serializationType() {
        return 7 /* SET */ ;
    }
    get label() {
        return this.set;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this.set.contains(symbol);
    }
    toString() {
        return this.set.toString();
    }
    // TODO (sam): should we really allow undefined here?
    constructor(target, set){
        super(target);
        if (set == null) set = $g8cb0.IntervalSet.of($lxPhv.Token.INVALID_TYPE);
        this.set = set;
    }
};
$549f774b4b925a9f$var$__decorate([
    $4w9vi.NotNull
], $549f774b4b925a9f$var$SetTransition.prototype, "set", void 0);
$549f774b4b925a9f$var$__decorate([
    $4w9vi.Override
], $549f774b4b925a9f$var$SetTransition.prototype, "serializationType", null);
$549f774b4b925a9f$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $549f774b4b925a9f$var$SetTransition.prototype, "label", null);
$549f774b4b925a9f$var$__decorate([
    $4w9vi.Override
], $549f774b4b925a9f$var$SetTransition.prototype, "matches", null);
$549f774b4b925a9f$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $549f774b4b925a9f$var$SetTransition.prototype, "toString", null);
$549f774b4b925a9f$var$SetTransition = $549f774b4b925a9f$var$__decorate([
    $549f774b4b925a9f$var$__param(0, $4w9vi.NotNull),
    $549f774b4b925a9f$var$__param(1, $4w9vi.Nullable)
], $549f774b4b925a9f$var$SetTransition);
module.exports.SetTransition = $549f774b4b925a9f$var$SetTransition; //# sourceMappingURL=SetTransition.js.map

});

parcelRegister("4eVci", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $3164d66a625949d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStopState = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $4w9vi = parcelRequire("4w9vi");

/** The last node in the ATN for a rule, unless that rule is the start symbol.
 *  In that case, there is one transition to EOF. Later, we might encode
 *  references to all calls to this rule to compute FOLLOW sets for
 *  error handling.
 */ class $3164d66a625949d1$var$RuleStopState extends $ltT8J.ATNState {
    get nonStopStateNumber() {
        return -1;
    }
    get stateType() {
        return $jW0J3.ATNStateType.RULE_STOP;
    }
}
$3164d66a625949d1$var$__decorate([
    $4w9vi.Override
], $3164d66a625949d1$var$RuleStopState.prototype, "nonStopStateNumber", null);
$3164d66a625949d1$var$__decorate([
    $4w9vi.Override
], $3164d66a625949d1$var$RuleStopState.prototype, "stateType", null);
module.exports.RuleStopState = $3164d66a625949d1$var$RuleStopState; //# sourceMappingURL=RuleStopState.js.map

});

parcelRegister("1q038", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $108841f9fa123bbf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $108841f9fa123bbf$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleTransition = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $151Ma = parcelRequire("151Ma");

/** */ let $108841f9fa123bbf$var$RuleTransition = class RuleTransition extends $151Ma.Transition {
    get serializationType() {
        return 3 /* RULE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    constructor(ruleStart, ruleIndex, precedence, followState){
        super(ruleStart);
        this.tailCall = false;
        this.optimizedTailCall = false;
        this.ruleIndex = ruleIndex;
        this.precedence = precedence;
        this.followState = followState;
    }
};
$108841f9fa123bbf$var$__decorate([
    $4w9vi.NotNull
], $108841f9fa123bbf$var$RuleTransition.prototype, "followState", void 0);
$108841f9fa123bbf$var$__decorate([
    $4w9vi.Override
], $108841f9fa123bbf$var$RuleTransition.prototype, "serializationType", null);
$108841f9fa123bbf$var$__decorate([
    $4w9vi.Override
], $108841f9fa123bbf$var$RuleTransition.prototype, "isEpsilon", null);
$108841f9fa123bbf$var$__decorate([
    $4w9vi.Override
], $108841f9fa123bbf$var$RuleTransition.prototype, "matches", null);
$108841f9fa123bbf$var$RuleTransition = $108841f9fa123bbf$var$__decorate([
    $108841f9fa123bbf$var$__param(0, $4w9vi.NotNull),
    $108841f9fa123bbf$var$__param(3, $4w9vi.NotNull)
], $108841f9fa123bbf$var$RuleTransition);
module.exports.RuleTransition = $108841f9fa123bbf$var$RuleTransition; //# sourceMappingURL=RuleTransition.js.map

});

parcelRegister("3uASk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $28b0c71d5ffa3d40$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $28b0c71d5ffa3d40$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardTransition = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $151Ma = parcelRequire("151Ma");

let $28b0c71d5ffa3d40$var$WildcardTransition = class WildcardTransition extends $151Ma.Transition {
    get serializationType() {
        return 9 /* WILDCARD */ ;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
    }
    toString() {
        return ".";
    }
    constructor(target){
        super(target);
    }
};
$28b0c71d5ffa3d40$var$__decorate([
    $4w9vi.Override
], $28b0c71d5ffa3d40$var$WildcardTransition.prototype, "serializationType", null);
$28b0c71d5ffa3d40$var$__decorate([
    $4w9vi.Override
], $28b0c71d5ffa3d40$var$WildcardTransition.prototype, "matches", null);
$28b0c71d5ffa3d40$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $28b0c71d5ffa3d40$var$WildcardTransition.prototype, "toString", null);
$28b0c71d5ffa3d40$var$WildcardTransition = $28b0c71d5ffa3d40$var$__decorate([
    $28b0c71d5ffa3d40$var$__param(0, $4w9vi.NotNull)
], $28b0c71d5ffa3d40$var$WildcardTransition);
module.exports.WildcardTransition = $28b0c71d5ffa3d40$var$WildcardTransition; //# sourceMappingURL=WildcardTransition.js.map

});

parcelRegister("6HpQh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $4e0acdfaec0933ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $4e0acdfaec0933ec$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerActionExecutor = void 0;

var $io9eO = parcelRequire("io9eO");


var $OG2zS = parcelRequire("OG2zS");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Represents an executor for a sequence of lexer actions which traversed during
 * the matching operation of a lexer rule (token).
 *
 * The executor tracks position information for position-dependent lexer actions
 * efficiently, ensuring that actions appearing only at the end of the rule do
 * not cause bloating of the {@link DFA} created for the lexer.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $4e0acdfaec0933ec$var$LexerActionExecutor = class LexerActionExecutor {
    /**
     * Creates a {@link LexerActionExecutor} which executes the actions for
     * the input `lexerActionExecutor` followed by a specified
     * `lexerAction`.
     *
     * @param lexerActionExecutor The executor for actions already traversed by
     * the lexer while matching a token within a particular
     * {@link ATNConfig}. If this is `undefined`, the method behaves as though
     * it were an empty executor.
     * @param lexerAction The lexer action to execute after the actions
     * specified in `lexerActionExecutor`.
     *
     * @returns A {@link LexerActionExecutor} for executing the combine actions
     * of `lexerActionExecutor` and `lexerAction`.
     */ static append(lexerActionExecutor, lexerAction) {
        if (!lexerActionExecutor) return new LexerActionExecutor([
            lexerAction
        ]);
        let lexerActions = lexerActionExecutor._lexerActions.slice(0);
        lexerActions.push(lexerAction);
        return new LexerActionExecutor(lexerActions);
    }
    /**
     * Creates a {@link LexerActionExecutor} which encodes the current offset
     * for position-dependent lexer actions.
     *
     * Normally, when the executor encounters lexer actions where
     * {@link LexerAction#isPositionDependent} returns `true`, it calls
     * {@link IntStream#seek} on the input {@link CharStream} to set the input
     * position to the *end* of the current token. This behavior provides
     * for efficient DFA representation of lexer actions which appear at the end
     * of a lexer rule, even when the lexer rule matches a variable number of
     * characters.
     *
     * Prior to traversing a match transition in the ATN, the current offset
     * from the token start index is assigned to all position-dependent lexer
     * actions which have not already been assigned a fixed offset. By storing
     * the offsets relative to the token start index, the DFA representation of
     * lexer actions which appear in the middle of tokens remains efficient due
     * to sharing among tokens of the same length, regardless of their absolute
     * position in the input stream.
     *
     * If the current executor already has offsets assigned to all
     * position-dependent lexer actions, the method returns `this`.
     *
     * @param offset The current offset to assign to all position-dependent
     * lexer actions which do not already have offsets assigned.
     *
     * @returns A {@link LexerActionExecutor} which stores input stream offsets
     * for all position-dependent lexer actions.
     */ fixOffsetBeforeMatch(offset) {
        let updatedLexerActions;
        for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $OG2zS.LexerIndexedCustomAction)) {
            if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
            updatedLexerActions[i] = new $OG2zS.LexerIndexedCustomAction(offset, this._lexerActions[i]);
        }
        if (!updatedLexerActions) return this;
        return new LexerActionExecutor(updatedLexerActions);
    }
    /**
     * Gets the lexer actions to be executed by this executor.
     * @returns The lexer actions to be executed by this executor.
     */ get lexerActions() {
        return this._lexerActions;
    }
    /**
     * Execute the actions encapsulated by this executor within the context of a
     * particular {@link Lexer}.
     *
     * This method calls {@link IntStream#seek} to set the position of the
     * `input` {@link CharStream} prior to calling
     * {@link LexerAction#execute} on a position-dependent action. Before the
     * method returns, the input position will be restored to the same position
     * it was in when the method was invoked.
     *
     * @param lexer The lexer instance.
     * @param input The input stream which is the source for the current token.
     * When this method is called, the current {@link IntStream#index} for
     * `input` should be the start of the following token, i.e. 1
     * character past the end of the current token.
     * @param startIndex The token start index. This value may be passed to
     * {@link IntStream#seek} to set the `input` position to the beginning
     * of the token.
     */ execute(lexer, input, startIndex) {
        let requiresSeek = false;
        let stopIndex = input.index;
        try {
            for (let lexerAction of this._lexerActions){
                if (lexerAction instanceof $OG2zS.LexerIndexedCustomAction) {
                    let offset = lexerAction.offset;
                    input.seek(startIndex + offset);
                    lexerAction = lexerAction.action;
                    requiresSeek = startIndex + offset !== stopIndex;
                } else if (lexerAction.isPositionDependent) {
                    input.seek(stopIndex);
                    requiresSeek = false;
                }
                lexerAction.execute(lexer);
            }
        } finally{
            if (requiresSeek) input.seek(stopIndex);
        }
    }
    hashCode() {
        return this.cachedHashCode;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerActionExecutor)) return false;
        return this.cachedHashCode === obj.cachedHashCode && $io9eO.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
    }
    /**
     * Constructs an executor for a sequence of {@link LexerAction} actions.
     * @param lexerActions The lexer actions to execute.
     */ constructor(lexerActions){
        this._lexerActions = lexerActions;
        let hash = $g3jfX.MurmurHash.initialize();
        for (let lexerAction of lexerActions)hash = $g3jfX.MurmurHash.update(hash, lexerAction);
        this.cachedHashCode = $g3jfX.MurmurHash.finish(hash, lexerActions.length);
    }
};
$4e0acdfaec0933ec$var$__decorate([
    $4w9vi.NotNull
], $4e0acdfaec0933ec$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
$4e0acdfaec0933ec$var$__decorate([
    $4w9vi.NotNull
], $4e0acdfaec0933ec$var$LexerActionExecutor.prototype, "lexerActions", null);
$4e0acdfaec0933ec$var$__decorate([
    $4e0acdfaec0933ec$var$__param(0, $4w9vi.NotNull)
], $4e0acdfaec0933ec$var$LexerActionExecutor.prototype, "execute", null);
$4e0acdfaec0933ec$var$__decorate([
    $4w9vi.Override
], $4e0acdfaec0933ec$var$LexerActionExecutor.prototype, "hashCode", null);
$4e0acdfaec0933ec$var$__decorate([
    $4w9vi.Override
], $4e0acdfaec0933ec$var$LexerActionExecutor.prototype, "equals", null);
$4e0acdfaec0933ec$var$__decorate([
    $4w9vi.NotNull,
    $4e0acdfaec0933ec$var$__param(1, $4w9vi.NotNull)
], $4e0acdfaec0933ec$var$LexerActionExecutor, "append", null);
$4e0acdfaec0933ec$var$LexerActionExecutor = $4e0acdfaec0933ec$var$__decorate([
    $4e0acdfaec0933ec$var$__param(0, $4w9vi.NotNull)
], $4e0acdfaec0933ec$var$LexerActionExecutor);
module.exports.LexerActionExecutor = $4e0acdfaec0933ec$var$LexerActionExecutor; //# sourceMappingURL=LexerActionExecutor.js.map

});

parcelRegister("OG2zS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0985480245ff7487$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0985480245ff7487$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerIndexedCustomAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * This implementation of {@link LexerAction} is used for tracking input offsets
 * for position-dependent actions within a {@link LexerActionExecutor}.
 *
 * This action is not serialized as part of the ATN, and is only required for
 * position-dependent lexer actions which appear at a location other than the
 * end of a rule. For more information about DFA optimizations employed for
 * lexer actions, see {@link LexerActionExecutor#append} and
 * {@link LexerActionExecutor#fixOffsetBeforeMatch}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ let $0985480245ff7487$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
    /**
     * Gets the location in the input {@link CharStream} at which the lexer
     * action should be executed. The value is interpreted as an offset relative
     * to the token start index.
     *
     * @returns The location in the input {@link CharStream} at which the lexer
     * action should be executed.
     */ get offset() {
        return this._offset;
    }
    /**
     * Gets the lexer action to execute.
     *
     * @returns A {@link LexerAction} object which executes the lexer action.
     */ get action() {
        return this._action;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns the result of calling {@link #getActionType}
     * on the {@link LexerAction} returned by {@link #getAction}.
     */ get actionType() {
        return this._action.actionType;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * This method calls {@link #execute} on the result of {@link #getAction}
     * using the provided `lexer`.
     */ execute(lexer) {
        // assume the input stream position was properly set by the calling code
        this._action.execute(lexer);
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this._offset);
        hash = $g3jfX.MurmurHash.update(hash, this._action);
        return $g3jfX.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof LexerIndexedCustomAction)) return false;
        return this._offset === obj._offset && this._action.equals(obj._action);
    }
    /**
     * Constructs a new indexed custom action by associating a character offset
     * with a {@link LexerAction}.
     *
     * Note: This class is only required for lexer actions for which
     * {@link LexerAction#isPositionDependent} returns `true`.
     *
     * @param offset The offset into the input {@link CharStream}, relative to
     * the token start index, at which the specified lexer action should be
     * executed.
     * @param action The lexer action to execute at a particular offset in the
     * input {@link CharStream}.
     */ constructor(offset, action){
        this._offset = offset;
        this._action = action;
    }
};
$0985480245ff7487$var$__decorate([
    $4w9vi.NotNull
], $0985480245ff7487$var$LexerIndexedCustomAction.prototype, "action", null);
$0985480245ff7487$var$__decorate([
    $4w9vi.Override
], $0985480245ff7487$var$LexerIndexedCustomAction.prototype, "actionType", null);
$0985480245ff7487$var$__decorate([
    $4w9vi.Override
], $0985480245ff7487$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
$0985480245ff7487$var$__decorate([
    $4w9vi.Override
], $0985480245ff7487$var$LexerIndexedCustomAction.prototype, "execute", null);
$0985480245ff7487$var$__decorate([
    $4w9vi.Override
], $0985480245ff7487$var$LexerIndexedCustomAction.prototype, "hashCode", null);
$0985480245ff7487$var$__decorate([
    $4w9vi.Override
], $0985480245ff7487$var$LexerIndexedCustomAction.prototype, "equals", null);
$0985480245ff7487$var$LexerIndexedCustomAction = $0985480245ff7487$var$__decorate([
    $0985480245ff7487$var$__param(1, $4w9vi.NotNull)
], $0985480245ff7487$var$LexerIndexedCustomAction);
module.exports.LexerIndexedCustomAction = $0985480245ff7487$var$LexerIndexedCustomAction; //# sourceMappingURL=LexerIndexedCustomAction.js.map

});

parcelRegister("1XGWL", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $16dc9d7caaf1a817$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $16dc9d7caaf1a817$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerNoViableAltException = void 0;

var $jzLQT = parcelRequire("jzLQT");


var $4w9vi = parcelRequire("4w9vi");


var $kCyYI = parcelRequire("kCyYI");


var $1rLy7 = parcelRequire("1rLy7");

let $16dc9d7caaf1a817$var$LexerNoViableAltException = class LexerNoViableAltException extends $jzLQT.RecognitionException {
    get startIndex() {
        return this._startIndex;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    get inputStream() {
        return super.inputStream;
    }
    toString() {
        let symbol = "";
        if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
            symbol = this.inputStream.getText($kCyYI.Interval.of(this._startIndex, this._startIndex));
            symbol = $1rLy7.escapeWhitespace(symbol, false);
        }
        // return String.format(Locale.getDefault(), "%s('%s')", LexerNoViableAltException.class.getSimpleName(), symbol);
        return `LexerNoViableAltException('${symbol}')`;
    }
    constructor(lexer, input, startIndex, deadEndConfigs){
        super(lexer, input);
        this._startIndex = startIndex;
        this._deadEndConfigs = deadEndConfigs;
    }
};
$16dc9d7caaf1a817$var$__decorate([
    $4w9vi.Override
], $16dc9d7caaf1a817$var$LexerNoViableAltException.prototype, "inputStream", null);
$16dc9d7caaf1a817$var$__decorate([
    $4w9vi.Override
], $16dc9d7caaf1a817$var$LexerNoViableAltException.prototype, "toString", null);
$16dc9d7caaf1a817$var$LexerNoViableAltException = $16dc9d7caaf1a817$var$__decorate([
    $16dc9d7caaf1a817$var$__param(1, $4w9vi.NotNull)
], $16dc9d7caaf1a817$var$LexerNoViableAltException);
module.exports.LexerNoViableAltException = $16dc9d7caaf1a817$var$LexerNoViableAltException; //# sourceMappingURL=LexerNoViableAltException.js.map

});

parcelRegister("axLvN", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7ad1d74e04d6ba60$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OrderedATNConfigSet = void 0;

var $51XoR = parcelRequire("51XoR");


var $4w9vi = parcelRequire("4w9vi");

/**
 *
 * @author Sam Harwell
 */ class $7ad1d74e04d6ba60$var$OrderedATNConfigSet extends $51XoR.ATNConfigSet {
    clone(readonly) {
        let copy = new $7ad1d74e04d6ba60$var$OrderedATNConfigSet(this, readonly);
        if (!readonly && this.isReadOnly) copy.addAll(this);
        return copy;
    }
    getKey(e) {
        // This is a specially crafted key to ensure configurations are only merged if they are equal
        return {
            state: 0,
            alt: e.hashCode()
        };
    }
    canMerge(left, leftKey, right) {
        return left.equals(right);
    }
    constructor(set, readonly){
        if (set != null && readonly != null) super(set, readonly);
        else super();
    }
}
$7ad1d74e04d6ba60$var$__decorate([
    $4w9vi.Override
], $7ad1d74e04d6ba60$var$OrderedATNConfigSet.prototype, "clone", null);
$7ad1d74e04d6ba60$var$__decorate([
    $4w9vi.Override
], $7ad1d74e04d6ba60$var$OrderedATNConfigSet.prototype, "getKey", null);
$7ad1d74e04d6ba60$var$__decorate([
    $4w9vi.Override
], $7ad1d74e04d6ba60$var$OrderedATNConfigSet.prototype, "canMerge", null);
module.exports.OrderedATNConfigSet = $7ad1d74e04d6ba60$var$OrderedATNConfigSet; //# sourceMappingURL=OrderedATNConfigSet.js.map

});

parcelRegister("dF72r", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9f249059c8bb8b50$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoViableAltException = void 0;

var $dCLTv = parcelRequire("dCLTv");


var $jzLQT = parcelRequire("jzLQT");


var $4w9vi = parcelRequire("4w9vi");

/** Indicates that the parser could not decide which of two or more paths
 *  to take based upon the remaining input. It tracks the starting token
 *  of the offending input and also knows where the parser was
 *  in the various paths when the error. Reported by reportNoViableAlternative()
 */ class $9f249059c8bb8b50$var$NoViableAltException extends $jzLQT.RecognitionException {
    get startToken() {
        return this._startToken;
    }
    get deadEndConfigs() {
        return this._deadEndConfigs;
    }
    constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
        if (recognizer instanceof $dCLTv.Parser) {
            if (input === undefined) input = recognizer.inputStream;
            if (startToken === undefined) startToken = recognizer.currentToken;
            if (offendingToken === undefined) offendingToken = recognizer.currentToken;
            if (ctx === undefined) ctx = recognizer.context;
        }
        super(recognizer, input, ctx);
        this._deadEndConfigs = deadEndConfigs;
        this._startToken = startToken;
        this.setOffendingToken(recognizer, offendingToken);
    }
}
$9f249059c8bb8b50$var$__decorate([
    $4w9vi.NotNull
], $9f249059c8bb8b50$var$NoViableAltException.prototype, "_startToken", void 0);
module.exports.NoViableAltException = $9f249059c8bb8b50$var$NoViableAltException; //# sourceMappingURL=NoViableAltException.js.map

});

parcelRegister("dCLTv", function(module, exports) {

var $kyRHQ = parcelRequire("kyRHQ");

"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $9eb3f9c65d3551d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $9eb3f9c65d3551d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
var $9eb3f9c65d3551d6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $1rLy7 = parcelRequire("1rLy7");


var $19eQd = parcelRequire("19eQd");


var $fetTS = parcelRequire("fetTS");


var $goW0A = parcelRequire("goW0A");


var $e3JhD = parcelRequire("e3JhD");


var $9ETsS = parcelRequire("9ETsS");


var $hEcm0 = parcelRequire("hEcm0");


var $4w9vi = parcelRequire("4w9vi");


var $8eluj = parcelRequire("8eluj");


var $e2oSX = parcelRequire("e2oSX");


var $lINPT = parcelRequire("lINPT");


var $lEpws = parcelRequire("lEpws");


var $kNZsc = parcelRequire("kNZsc");


var $lxPhv = parcelRequire("lxPhv");

class $9eb3f9c65d3551d6$var$TraceListener {
    enterEveryRule(ctx) {
        console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    exitEveryRule(ctx) {
        console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
    }
    visitErrorNode(node) {
    // intentionally empty
    }
    visitTerminal(node) {
        let parent = node.parent.ruleContext;
        let token = node.symbol;
        console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
    }
    constructor(ruleNames, tokenStream){
        this.ruleNames = ruleNames;
        this.tokenStream = tokenStream;
    }
}
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$TraceListener.prototype, "enterEveryRule", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$TraceListener.prototype, "exitEveryRule", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$TraceListener.prototype, "visitErrorNode", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$TraceListener.prototype, "visitTerminal", null);



/** This is all the parsing support code essentially; most of it is error recovery stuff. */ class $9eb3f9c65d3551d6$var$Parser extends $lEpws.Recognizer {
    reset(resetInput) {
        // Note: this method executes when not parsing, so _ctx can be undefined
        if (resetInput === undefined || resetInput) this.inputStream.seek(0);
        this._errHandler.reset(this);
        this._ctx = undefined;
        this._syntaxErrors = 0;
        this.matchedEOF = false;
        this.isTrace = false;
        this._precedenceStack.clear();
        this._precedenceStack.push(0);
        let interpreter = this.interpreter;
        if (interpreter != null) interpreter.reset();
    }
    /**
     * Match current input symbol against `ttype`. If the symbol type
     * matches, {@link ANTLRErrorStrategy#reportMatch} and {@link #consume} are
     * called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @param ttype the token type to match
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * `ttype` and the error strategy could not recover from the
     * mismatched symbol
     */ match(ttype) {
        let t = this.currentToken;
        if (t.type === ttype) {
            if (ttype === $lxPhv.Token.EOF) this.matchedEOF = true;
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Match current input symbol as a wildcard. If the symbol type matches
     * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy#reportMatch}
     * and {@link #consume} are called to complete the match process.
     *
     * If the symbol type does not match,
     * {@link ANTLRErrorStrategy#recoverInline} is called on the current error
     * strategy to attempt recovery. If {@link #getBuildParseTree} is
     * `true` and the token index of the symbol returned by
     * {@link ANTLRErrorStrategy#recoverInline} is -1, the symbol is added to
     * the parse tree by calling {@link Parser#createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)}.
     *
     * @returns the matched symbol
     * @ if the current input symbol did not match
     * a wildcard and the error strategy could not recover from the mismatched
     * symbol
     */ matchWildcard() {
        let t = this.currentToken;
        if (t.type > 0) {
            this._errHandler.reportMatch(this);
            this.consume();
        } else {
            t = this._errHandler.recoverInline(this);
            if (this._buildParseTrees && t.tokenIndex === -1) // we must have conjured up a new token during single token insertion
            // if it's not the current symbol
            this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
        }
        return t;
    }
    /**
     * Track the {@link ParserRuleContext} objects during the parse and hook
     * them up using the {@link ParserRuleContext#children} list so that it
     * forms a parse tree. The {@link ParserRuleContext} returned from the start
     * rule represents the root of the parse tree.
     *
     * Note that if we are not building parse trees, rule contexts only point
     * upwards. When a rule exits, it returns the context but that gets garbage
     * collected if nobody holds a reference. It points upwards but nobody
     * points at it.
     *
     * When we build parse trees, we are adding all of these contexts to
     * {@link ParserRuleContext#children} list. Contexts are then not candidates
     * for garbage collection.
     */ set buildParseTree(buildParseTrees) {
        this._buildParseTrees = buildParseTrees;
    }
    /**
     * Gets whether or not a complete parse tree will be constructed while
     * parsing. This property is `true` for a newly constructed parser.
     *
     * @returns `true` if a complete parse tree will be constructed while
     * parsing, otherwise `false`
     */ get buildParseTree() {
        return this._buildParseTrees;
    }
    getParseListeners() {
        return this._parseListeners;
    }
    /**
     * Registers `listener` to receive events during the parsing process.
     *
     * To support output-preserving grammar transformations (including but not
     * limited to left-recursion removal, automated left-factoring, and
     * optimized code generation), calls to listener methods during the parse
     * may differ substantially from calls made by
     * {@link ParseTreeWalker#DEFAULT} used after the parse is complete. In
     * particular, rule entry and exit events may occur in a different order
     * during the parse than after the parser. In addition, calls to certain
     * rule entry methods may be omitted.
     *
     * With the following specific exceptions, calls to listener events are
     * *deterministic*, i.e. for identical input the calls to listener
     * methods will be the same.
     *
     * * Alterations to the grammar used to generate code may change the
     *   behavior of the listener calls.
     * * Alterations to the command line options passed to ANTLR 4 when
     *   generating the parser may change the behavior of the listener calls.
     * * Changing the version of the ANTLR Tool used to generate the parser
     *   may change the behavior of the listener calls.
     *
     * @param listener the listener to add
     *
     * @throws {@link TypeError} if `listener` is `undefined`
     */ addParseListener(listener) {
        if (listener == null) throw new TypeError("listener cannot be null");
        this._parseListeners.push(listener);
    }
    /**
     * Remove `listener` from the list of parse listeners.
     *
     * If `listener` is `undefined` or has not been added as a parse
     * listener, this method does nothing.
     *
     * @see #addParseListener
     *
     * @param listener the listener to remove
     */ removeParseListener(listener) {
        let index = this._parseListeners.findIndex((l)=>l === listener);
        if (index !== -1) this._parseListeners.splice(index, 1);
    }
    /**
     * Remove all parse listeners.
     *
     * @see #addParseListener
     */ removeParseListeners() {
        this._parseListeners.length = 0;
    }
    /**
     * Notify any parse listeners of an enter rule event.
     *
     * @see #addParseListener
     */ triggerEnterRuleEvent() {
        for (let listener of this._parseListeners){
            if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
            this._ctx.enterRule(listener);
        }
    }
    /**
     * Notify any parse listeners of an exit rule event.
     *
     * @see #addParseListener
     */ triggerExitRuleEvent() {
        // reverse order walk of listeners
        for(let i = this._parseListeners.length - 1; i >= 0; i--){
            let listener = this._parseListeners[i];
            this._ctx.exitRule(listener);
            if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
        }
    }
    /**
     * Gets the number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     *
     * @see #notifyErrorListeners
     */ get numberOfSyntaxErrors() {
        return this._syntaxErrors;
    }
    get tokenFactory() {
        return this._input.tokenSource.tokenFactory;
    }
    /**
     * The ATN with bypass alternatives is expensive to create so we create it
     * lazily.
     *
     * @ if the current parser does not
     * implement the `serializedATN` property.
     */ getATNWithBypassAlts() {
        let serializedAtn = this.serializedATN;
        if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
        let result = $9eb3f9c65d3551d6$var$Parser.bypassAltsAtnCache.get(serializedAtn);
        if (result == null) {
            let deserializationOptions = new $19eQd.ATNDeserializationOptions();
            deserializationOptions.isGenerateRuleBypassTransitions = true;
            result = new $fetTS.ATNDeserializer(deserializationOptions).deserialize($1rLy7.toCharArray(serializedAtn));
            $9eb3f9c65d3551d6$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
        }
        return result;
    }
    compileParseTreePattern(pattern, patternRuleIndex, lexer) {
        return $9eb3f9c65d3551d6$var$__awaiter(this, void 0, void 0, function*() {
            if (!lexer) {
                if (this.inputStream) {
                    let tokenSource = this.inputStream.tokenSource;
                    if (tokenSource instanceof $hEcm0.Lexer) lexer = tokenSource;
                }
                if (!lexer) throw new Error("Parser can't discover a lexer to use");
            }
            let currentLexer = lexer;
            let m = yield Promise.resolve().then(()=>(parcelRequire("bRhh0")));
            let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
            return matcher.compile(pattern, patternRuleIndex);
        });
    }
    get errorHandler() {
        return this._errHandler;
    }
    set errorHandler(handler) {
        this._errHandler = handler;
    }
    get inputStream() {
        return this._input;
    }
    /** Set the token stream and reset the parser. */ set inputStream(input) {
        this.reset(false);
        this._input = input;
    }
    /** Match needs to return the current input symbol, which gets put
     *  into the label for the associated token ref; e.g., x=ID.
     */ get currentToken() {
        return this._input.LT(1);
    }
    notifyErrorListeners(msg, offendingToken, e) {
        if (offendingToken === undefined) offendingToken = this.currentToken;
        else if (offendingToken === null) offendingToken = undefined;
        this._syntaxErrors++;
        let line = -1;
        let charPositionInLine = -1;
        if (offendingToken != null) {
            line = offendingToken.line;
            charPositionInLine = offendingToken.charPositionInLine;
        }
        let listener = this.getErrorListenerDispatch();
        if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
    }
    /**
     * Consume and return the [current symbol](`currentToken`).
     *
     * E.g., given the following input with `A` being the current
     * lookahead symbol, this function moves the cursor to `B` and returns
     * `A`.
     *
     * ```
     * A B
     * ^
     * ```
     *
     * If the parser is not in error recovery mode, the consumed symbol is added
     * to the parse tree using {@link ParserRuleContext#addChild(TerminalNode)}, and
     * {@link ParseTreeListener#visitTerminal} is called on any parse listeners.
     * If the parser *is* in error recovery mode, the consumed symbol is
     * added to the parse tree using {@link #createErrorNode(ParserRuleContext, Token)} then
     * {@link ParserRuleContext#addErrorNode(ErrorNode)} and
     * {@link ParseTreeListener#visitErrorNode} is called on any parse
     * listeners.
     */ consume() {
        let o = this.currentToken;
        if (o.type !== $9eb3f9c65d3551d6$var$Parser.EOF) this.inputStream.consume();
        let hasListener = this._parseListeners.length !== 0;
        if (this._buildParseTrees || hasListener) {
            if (this._errHandler.inErrorRecoveryMode(this)) {
                let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                }
            } else {
                let node = this.createTerminalNode(this._ctx, o);
                this._ctx.addChild(node);
                if (hasListener) {
                    for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                }
            }
        }
        return o;
    }
    /**
     * How to create a token leaf node associated with a parent.
     * Typically, the terminal node to create is not a function of the parent.
     *
     * @since 4.7
     */ createTerminalNode(parent, t) {
        return new $kNZsc.TerminalNode(t);
    }
    /**
     * How to create an error node, given a token, associated with a parent.
     * Typically, the error node to create is not a function of the parent.
     *
     * @since 4.7
     */ createErrorNode(parent, t) {
        return new $e3JhD.ErrorNode(t);
    }
    addContextToParseTree() {
        let parent = this._ctx._parent;
        // add current context to parent if we have a parent
        if (parent != null) parent.addChild(this._ctx);
    }
    /**
     * Always called by generated parsers upon entry to a rule. Access field
     * {@link #_ctx} get the current context.
     */ enterRule(localctx, state, ruleIndex) {
        this.state = state;
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    enterLeftFactoredRule(localctx, state, ruleIndex) {
        this.state = state;
        if (this._buildParseTrees) {
            let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
            this._ctx.removeLastChild();
            factoredContext._parent = localctx;
            localctx.addChild(factoredContext);
        }
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        if (this._buildParseTrees) this.addContextToParseTree();
        this.triggerEnterRuleEvent();
    }
    exitRule() {
        if (this.matchedEOF) // if we have matched EOF, it cannot consume past EOF so we use LT(1) here
        this._ctx._stop = this._input.LT(1); // LT(1) will be end of file
        else this._ctx._stop = this._input.tryLT(-1); // stop node is what we just matched
        // trigger event on _ctx, before it reverts to parent
        this.triggerExitRuleEvent();
        this.state = this._ctx.invokingState;
        this._ctx = this._ctx._parent;
    }
    enterOuterAlt(localctx, altNum) {
        localctx.altNumber = altNum;
        // if we have new localctx, make sure we replace existing ctx
        // that is previous child of parse tree
        if (this._buildParseTrees && this._ctx !== localctx) {
            let parent = this._ctx._parent;
            if (parent != null) {
                parent.removeLastChild();
                parent.addChild(localctx);
            }
        }
        this._ctx = localctx;
    }
    /**
     * Get the precedence level for the top-most precedence rule.
     *
     * @returns The precedence level for the top-most precedence rule, or -1 if
     * the parser context is not nested within a precedence rule.
     */ get precedence() {
        if (this._precedenceStack.isEmpty) return -1;
        return this._precedenceStack.peek();
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this.state = state;
        this._precedenceStack.push(precedence);
        this._ctx = localctx;
        this._ctx._start = this._input.LT(1);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    /** Like {@link #enterRule} but for recursive rules.
     *  Make the current context the child of the incoming localctx.
     */ pushNewRecursionContext(localctx, state, ruleIndex) {
        let previous = this._ctx;
        previous._parent = localctx;
        previous.invokingState = state;
        previous._stop = this._input.tryLT(-1);
        this._ctx = localctx;
        this._ctx._start = previous._start;
        if (this._buildParseTrees) this._ctx.addChild(previous);
        this.triggerEnterRuleEvent(); // simulates rule entry for left-recursive rules
    }
    unrollRecursionContexts(_parentctx) {
        this._precedenceStack.pop();
        this._ctx._stop = this._input.tryLT(-1);
        let retctx = this._ctx; // save current ctx (return value)
        // unroll so _ctx is as it was before call to recursive method
        if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
            this.triggerExitRuleEvent();
            this._ctx = this._ctx._parent;
        }
        else this._ctx = _parentctx;
        // hook into tree
        retctx._parent = _parentctx;
        if (this._buildParseTrees && _parentctx != null) // add return ctx into invoking rule's tree
        _parentctx.addChild(retctx);
    }
    getInvokingContext(ruleIndex) {
        let p = this._ctx;
        while(p && p.ruleIndex !== ruleIndex)p = p._parent;
        return p;
    }
    get context() {
        return this._ctx;
    }
    set context(ctx) {
        this._ctx = ctx;
    }
    precpred(localctx, precedence) {
        return precedence >= this._precedenceStack.peek();
    }
    getErrorListenerDispatch() {
        return new $lINPT.ProxyParserErrorListener(this.getErrorListeners());
    }
    inContext(context) {
        // TODO: useful in parser?
        return false;
    }
    /**
     * Checks whether or not `symbol` can follow the current state in the
     * ATN. The behavior of this method is equivalent to the following, but is
     * implemented such that the complete context-sensitive follow set does not
     * need to be explicitly constructed.
     *
     * ```
     * return getExpectedTokens().contains(symbol);
     * ```
     *
     * @param symbol the symbol type to check
     * @returns `true` if `symbol` can follow the current state in
     * the ATN, otherwise `false`.
     */ isExpectedToken(symbol) {
        //   		return interpreter.atn.nextTokens(_ctx);
        let atn = this.interpreter.atn;
        let ctx = this._ctx;
        let s = atn.states[this.state];
        let following = atn.nextTokens(s);
        if (following.contains(symbol)) return true;
        //        System.out.println("following "+s+"="+following);
        if (!following.contains($lxPhv.Token.EPSILON)) return false;
        while(ctx != null && ctx.invokingState >= 0 && following.contains($lxPhv.Token.EPSILON)){
            let invokingState = atn.states[ctx.invokingState];
            let rt = invokingState.transition(0);
            following = atn.nextTokens(rt.followState);
            if (following.contains(symbol)) return true;
            ctx = ctx._parent;
        }
        if (following.contains($lxPhv.Token.EPSILON) && symbol === $lxPhv.Token.EOF) return true;
        return false;
    }
    get isMatchedEOF() {
        return this.matchedEOF;
    }
    /**
     * Computes the set of input symbols which could follow the current parser
     * state and context, as given by {@link #getState} and {@link #getContext},
     * respectively.
     *
     * @see ATN#getExpectedTokens(int, RuleContext)
     */ getExpectedTokens() {
        return this.atn.getExpectedTokens(this.state, this.context);
    }
    getExpectedTokensWithinCurrentRule() {
        let atn = this.interpreter.atn;
        let s = atn.states[this.state];
        return atn.nextTokens(s);
    }
    /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */ getRuleIndex(ruleName) {
        let ruleIndex = this.getRuleIndexMap().get(ruleName);
        if (ruleIndex != null) return ruleIndex;
        return -1;
    }
    get ruleContext() {
        return this._ctx;
    }
    /** Return List&lt;String&gt; of the rule names in your parser instance
     *  leading up to a call to the current rule.  You could override if
     *  you want more details such as the file/line info of where
     *  in the ATN a rule is invoked.
     *
     *  This is very useful for error messages.
     */ getRuleInvocationStack(ctx = this._ctx) {
        let p = ctx; // Workaround for Microsoft/TypeScript#14487
        let ruleNames = this.ruleNames;
        let stack = [];
        while(p != null){
            // compute what follows who invoked us
            let ruleIndex = p.ruleIndex;
            if (ruleIndex < 0) stack.push("n/a");
            else stack.push(ruleNames[ruleIndex]);
            p = p._parent;
        }
        return stack;
    }
    /** For debugging and other purposes. */ getDFAStrings() {
        let s = [];
        for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
        return s;
    }
    /** For debugging and other purposes. */ dumpDFA() {
        let seenOne = false;
        for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
            if (seenOne) console.log();
            console.log("Decision " + dfa.decision + ":");
            $kyRHQ.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
            seenOne = true;
        }
    }
    get sourceName() {
        return this._input.sourceName;
    }
    get parseInfo() {
        return Promise.resolve().then(()=>(parcelRequire("gcyqD"))).then((m)=>{
            let interp = this.interpreter;
            if (interp instanceof m.ProfilingATNSimulator) return new $8eluj.ParseInfo(interp);
            return undefined;
        });
    }
    /**
     * @since 4.3
     */ setProfile(profile) {
        return $9eb3f9c65d3551d6$var$__awaiter(this, void 0, void 0, function*() {
            let m = yield Promise.resolve().then(()=>(parcelRequire("gcyqD")));
            let interp = this.interpreter;
            if (profile) {
                if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
            } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $e2oSX.ParserATNSimulator(this.atn, this);
            this.interpreter.setPredictionMode(interp.getPredictionMode());
        });
    }
    /** During a parse is sometimes useful to listen in on the rule entry and exit
     *  events as well as token matches. This is for quick and dirty debugging.
     */ set isTrace(trace) {
        if (!trace) {
            if (this._tracer) {
                this.removeParseListener(this._tracer);
                this._tracer = undefined;
            }
        } else {
            if (this._tracer) this.removeParseListener(this._tracer);
            else this._tracer = new $9eb3f9c65d3551d6$var$TraceListener(this.ruleNames, this._input);
            this.addParseListener(this._tracer);
        }
    }
    /**
     * Gets whether a {@link TraceListener} is registered as a parse listener
     * for the parser.
     */ get isTrace() {
        return this._tracer != null;
    }
    constructor(input){
        super();
        /**
         * The error handling strategy for the parser. The default value is a new
         * instance of {@link DefaultErrorStrategy}.
         *
         * @see #getErrorHandler
         * @see #setErrorHandler
         */ this._errHandler = new $goW0A.DefaultErrorStrategy();
        this._precedenceStack = new $9ETsS.IntegerStack();
        /**
         * Specifies whether or not the parser should construct a parse tree during
         * the parsing process. The default value is `true`.
         *
         * @see `buildParseTree`
         */ this._buildParseTrees = true;
        /**
         * The list of {@link ParseTreeListener} listeners registered to receive
         * events during the parse.
         *
         * @see #addParseListener
         */ this._parseListeners = [];
        /**
         * The number of syntax errors reported during parsing. This value is
         * incremented each time {@link #notifyErrorListeners} is called.
         */ this._syntaxErrors = 0;
        /** Indicates parser has match()ed EOF token. See {@link #exitRule()}. */ this.matchedEOF = false;
        this._precedenceStack.push(0);
        this.inputStream = input;
    }
}
/**
 * This field maps from the serialized ATN string to the deserialized {@link ATN} with
 * bypass alternatives.
 *
 * @see ATNDeserializationOptions.isGenerateRuleBypassTransitions
 */ $9eb3f9c65d3551d6$var$Parser.bypassAltsAtnCache = new Map();
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "_errHandler", void 0);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "match", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "matchWildcard", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "getParseListeners", null);
$9eb3f9c65d3551d6$var$__decorate([
    $9eb3f9c65d3551d6$var$__param(0, $4w9vi.NotNull)
], $9eb3f9c65d3551d6$var$Parser.prototype, "addParseListener", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "getATNWithBypassAlts", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull,
    $9eb3f9c65d3551d6$var$__param(0, $4w9vi.NotNull)
], $9eb3f9c65d3551d6$var$Parser.prototype, "errorHandler", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$Parser.prototype, "inputStream", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "currentToken", null);
$9eb3f9c65d3551d6$var$__decorate([
    $9eb3f9c65d3551d6$var$__param(0, $4w9vi.NotNull)
], $9eb3f9c65d3551d6$var$Parser.prototype, "enterRule", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override,
    $9eb3f9c65d3551d6$var$__param(0, $4w9vi.Nullable)
], $9eb3f9c65d3551d6$var$Parser.prototype, "precpred", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$Parser.prototype, "getErrorListenerDispatch", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "getExpectedTokens", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.NotNull
], $9eb3f9c65d3551d6$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
$9eb3f9c65d3551d6$var$__decorate([
    $4w9vi.Override
], $9eb3f9c65d3551d6$var$Parser.prototype, "parseInfo", null);
module.exports.Parser = $9eb3f9c65d3551d6$var$Parser; //# sourceMappingURL=Parser.js.map

});

parcelRegister("19eQd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0d6224df844d6c37$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializationOptions = void 0;

var $4w9vi = parcelRequire("4w9vi");

/**
 *
 * @author Sam Harwell
 */ class $0d6224df844d6c37$var$ATNDeserializationOptions {
    static get defaultOptions() {
        if ($0d6224df844d6c37$var$ATNDeserializationOptions._defaultOptions == null) {
            $0d6224df844d6c37$var$ATNDeserializationOptions._defaultOptions = new $0d6224df844d6c37$var$ATNDeserializationOptions();
            $0d6224df844d6c37$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
        }
        return $0d6224df844d6c37$var$ATNDeserializationOptions._defaultOptions;
    }
    get isReadOnly() {
        return this.readOnly;
    }
    makeReadOnly() {
        this.readOnly = true;
    }
    get isVerifyATN() {
        return this.verifyATN;
    }
    set isVerifyATN(verifyATN) {
        this.throwIfReadOnly();
        this.verifyATN = verifyATN;
    }
    get isGenerateRuleBypassTransitions() {
        return this.generateRuleBypassTransitions;
    }
    set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
        this.throwIfReadOnly();
        this.generateRuleBypassTransitions = generateRuleBypassTransitions;
    }
    get isOptimize() {
        return this.optimize;
    }
    set isOptimize(optimize) {
        this.throwIfReadOnly();
        this.optimize = optimize;
    }
    throwIfReadOnly() {
        if (this.isReadOnly) throw new Error("The object is read only.");
    }
    constructor(options){
        this.readOnly = false;
        if (options) {
            this.verifyATN = options.verifyATN;
            this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
            this.optimize = options.optimize;
        } else {
            this.verifyATN = true;
            this.generateRuleBypassTransitions = false;
            this.optimize = true;
        }
    }
}
$0d6224df844d6c37$var$__decorate([
    $4w9vi.NotNull
], $0d6224df844d6c37$var$ATNDeserializationOptions, "defaultOptions", null);
module.exports.ATNDeserializationOptions = $0d6224df844d6c37$var$ATNDeserializationOptions; //# sourceMappingURL=ATNDeserializationOptions.js.map

});

parcelRegister("fetTS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b16f5b5d6c59373f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b16f5b5d6c59373f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ATNDeserializer = void 0;

var $1rhri = parcelRequire("1rhri");


var $eEYRR = parcelRequire("eEYRR");


var $EKDdQ = parcelRequire("EKDdQ");


var $19eQd = parcelRequire("19eQd");


var $jW0J3 = parcelRequire("jW0J3");


var $2zmHG = parcelRequire("2zmHG");


var $h9Cpp = parcelRequire("h9Cpp");


var $cNyYW = parcelRequire("cNyYW");


var $6YKio = parcelRequire("6YKio");


var $kkzaV = parcelRequire("kkzaV");


var $lvaZD = parcelRequire("lvaZD");


var $frUMD = parcelRequire("frUMD");


var $lgmvT = parcelRequire("lgmvT");


var $7o3Uc = parcelRequire("7o3Uc");


var $g8cb0 = parcelRequire("g8cb0");


var $ktBtp = parcelRequire("ktBtp");


var $8p14t = parcelRequire("8p14t");


var $49Z7g = parcelRequire("49Z7g");


var $lQYka = parcelRequire("lQYka");


var $liA1k = parcelRequire("liA1k");


var $fQogW = parcelRequire("fQogW");


var $a58jV = parcelRequire("a58jV");


var $bDA2t = parcelRequire("bDA2t");


var $9P8rd = parcelRequire("9P8rd");


var $i2y55 = parcelRequire("i2y55");


var $4w9vi = parcelRequire("4w9vi");


var $kUcH8 = parcelRequire("kUcH8");


var $e2oSX = parcelRequire("e2oSX");


var $5KAQQ = parcelRequire("5KAQQ");


var $02msZ = parcelRequire("02msZ");


var $ucBKb = parcelRequire("ucBKb");


var $1qA0P = parcelRequire("1qA0P");


var $i8IS6 = parcelRequire("i8IS6");


var $juHvA = parcelRequire("juHvA");


var $4eVci = parcelRequire("4eVci");


var $1q038 = parcelRequire("1q038");


var $7grDB = parcelRequire("7grDB");


var $97ZDg = parcelRequire("97ZDg");


var $3sdjf = parcelRequire("3sdjf");


var $9nX6N = parcelRequire("9nX6N");


var $lxPhv = parcelRequire("lxPhv");


var $1dk9Y = parcelRequire("1dk9Y");


var $eKmKF = parcelRequire("eKmKF");


var $3uASk = parcelRequire("3uASk");

var $b16f5b5d6c59373f$var$UnicodeDeserializingMode;
(function(UnicodeDeserializingMode) {
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
    UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
})($b16f5b5d6c59373f$var$UnicodeDeserializingMode || ($b16f5b5d6c59373f$var$UnicodeDeserializingMode = {}));
/**
 *
 * @author Sam Harwell
 */ class $b16f5b5d6c59373f$var$ATNDeserializer {
    static get SERIALIZED_VERSION() {
        /* This value should never change. Updates following this version are
         * reflected as change in the unique ID SERIALIZED_UUID.
         */ return 3;
    }
    /**
     * Determines if a particular serialized representation of an ATN supports
     * a particular feature, identified by the {@link UUID} used for serializing
     * the ATN at the time the feature was first introduced.
     *
     * @param feature The {@link UUID} marking the first time the feature was
     * supported in the serialized ATN.
     * @param actualUuid The {@link UUID} of the actual serialized ATN which is
     * currently being deserialized.
     * @returns `true` if the `actualUuid` value represents a
     * serialized ATN at or after the feature identified by `feature` was
     * introduced; otherwise, `false`.
     */ static isFeatureSupported(feature, actualUuid) {
        let featureIndex = $b16f5b5d6c59373f$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
        if (featureIndex < 0) return false;
        return $b16f5b5d6c59373f$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
    }
    static getUnicodeDeserializer(mode) {
        if (mode === 0 /* UNICODE_BMP */ ) return {
            readUnicode: (data, p)=>{
                return $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p]);
            },
            size: 1
        };
        else return {
            readUnicode: (data, p)=>{
                return $b16f5b5d6c59373f$var$ATNDeserializer.toInt32(data, p);
            },
            size: 2
        };
    }
    deserialize(data) {
        data = data.slice(0);
        // Each Uint16 value in data is shifted by +2 at the entry to this method. This is an encoding optimization
        // targeting the serialized values 0 and -1 (serialized to 0xFFFF), each of which are very common in the
        // serialized form of the ATN. In the modified UTF-8 that Java uses for compiled string literals, these two
        // character values have multi-byte forms. By shifting each value by +2, they become characters 2 and 1 prior to
        // writing the string, each of which have single-byte representations. Since the shift occurs in the tool during
        // ATN serialization, each target is responsible for adjusting the values during deserialization.
        //
        // As a special case, note that the first element of data is not adjusted because it contains the major version
        // number of the serialized ATN, which was fixed at 3 at the time the value shifting was implemented.
        for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
        let p = 0;
        let version = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        if (version !== $b16f5b5d6c59373f$var$ATNDeserializer.SERIALIZED_VERSION) {
            let reason = `Could not deserialize ATN with version ${version} (expected ${$b16f5b5d6c59373f$var$ATNDeserializer.SERIALIZED_VERSION}).`;
            throw new Error(reason);
        }
        let uuid = $b16f5b5d6c59373f$var$ATNDeserializer.toUUID(data, p);
        p += 8;
        if ($b16f5b5d6c59373f$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
            let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$b16f5b5d6c59373f$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
            throw new Error(reason);
        }
        let supportsLexerActions = $b16f5b5d6c59373f$var$ATNDeserializer.isFeatureSupported($b16f5b5d6c59373f$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
        let grammarType = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        let maxTokenType = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        let atn = new $EKDdQ.ATN(grammarType, maxTokenType);
        //
        // STATES
        //
        let loopBackStateNumbers = [];
        let endStateNumbers = [];
        let nstates = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nstates; i++){
            let stype = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            // ignore bad type of states
            if (stype === $jW0J3.ATNStateType.INVALID_TYPE) {
                atn.addState(new $ktBtp.InvalidState());
                continue;
            }
            let ruleIndex = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            if (ruleIndex === 0xFFFF) ruleIndex = -1;
            let s = this.stateFactory(stype, ruleIndex);
            if (stype === $jW0J3.ATNStateType.LOOP_END) {
                let loopBackStateNumber = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                loopBackStateNumbers.push([
                    s,
                    loopBackStateNumber
                ]);
            } else if (s instanceof $lvaZD.BlockStartState) {
                let endStateNumber = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                endStateNumbers.push([
                    s,
                    endStateNumber
                ]);
            }
            atn.addState(s);
        }
        // delay the assignment of loop back and end states until we know all the state instances have been initialized
        for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
        for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
        let numNonGreedyStates = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numNonGreedyStates; i++){
            let stateNumber = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].nonGreedy = true;
        }
        let numSllDecisions = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numSllDecisions; i++){
            let stateNumber = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].sll = true;
        }
        let numPrecedenceStates = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < numPrecedenceStates; i++){
            let stateNumber = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            atn.states[stateNumber].isPrecedenceRule = true;
        }
        //
        // RULES
        //
        let nrules = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        if (atn.grammarType === 0 /* LEXER */ ) atn.ruleToTokenType = new Int32Array(nrules);
        atn.ruleToStartState = new Array(nrules);
        for(let i = 0; i < nrules; i++){
            let s = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            let startState = atn.states[s];
            startState.leftFactored = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]) !== 0;
            atn.ruleToStartState[i] = startState;
            if (atn.grammarType === 0 /* LEXER */ ) {
                let tokenType = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                if (tokenType === 0xFFFF) tokenType = $lxPhv.Token.EOF;
                atn.ruleToTokenType[i] = tokenType;
                if (!$b16f5b5d6c59373f$var$ATNDeserializer.isFeatureSupported($b16f5b5d6c59373f$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                    // this piece of unused metadata was serialized prior to the
                    // addition of LexerAction
                    let actionIndexIgnored = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                    if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                }
            }
        }
        atn.ruleToStopState = new Array(nrules);
        for (let state of atn.states){
            if (!(state instanceof $4eVci.RuleStopState)) continue;
            atn.ruleToStopState[state.ruleIndex] = state;
            atn.ruleToStartState[state.ruleIndex].stopState = state;
        }
        //
        // MODES
        //
        let nmodes = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nmodes; i++){
            let s = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            atn.modeToStartState.push(atn.states[s]);
        }
        atn.modeToDFA = new Array(nmodes);
        for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $lgmvT.DFA(atn.modeToStartState[i]);
        //
        // SETS
        //
        let sets = [];
        // First, read all sets with 16-bit Unicode code points <= U+FFFF.
        p = this.deserializeSets(data, p, sets, $b16f5b5d6c59373f$var$ATNDeserializer.getUnicodeDeserializer(0 /* UNICODE_BMP */ ));
        // Next, if the ATN was serialized with the Unicode SMP feature,
        // deserialize sets with 32-bit arguments <= U+10FFFF.
        if ($b16f5b5d6c59373f$var$ATNDeserializer.isFeatureSupported($b16f5b5d6c59373f$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $b16f5b5d6c59373f$var$ATNDeserializer.getUnicodeDeserializer(1 /* UNICODE_SMP */ ));
        //
        // EDGES
        //
        let nedges = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nedges; i++){
            let src = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p]);
            let trg = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p + 1]);
            let ttype = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p + 2]);
            let arg1 = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p + 3]);
            let arg2 = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p + 4]);
            let arg3 = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p + 5]);
            let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
            // console.log(`EDGE ${trans.constructor.name} ${src}->${trg} ${Transition.serializationNames[ttype]} ${arg1},${arg2},${arg3}`);
            let srcState = atn.states[src];
            srcState.addTransition(trans);
            p += 6;
        }
        let returnTransitionsSet = new $eEYRR.Array2DHashSet({
            hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
            equals: (a, b)=>{
                return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
            }
        });
        let returnTransitions = [];
        for (let state of atn.states){
            let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
            for(let i = 0; i < state.numberOfTransitions; i++){
                let t = state.transition(i);
                if (!(t instanceof $1q038.RuleTransition)) continue;
                let ruleTransition = t;
                let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                if (!returningFromLeftFactored && returningToLeftFactored) continue;
                let outermostPrecedenceReturn = -1;
                if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                    if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                }
                let current = {
                    stopState: ruleTransition.target.ruleIndex,
                    returnState: ruleTransition.followState.stateNumber,
                    outermostPrecedenceReturn: outermostPrecedenceReturn
                };
                if (returnTransitionsSet.add(current)) returnTransitions.push(current);
            }
        }
        // Add all elements from returnTransitions to the ATN
        for (let returnTransition of returnTransitions){
            let transition = new $7o3Uc.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
            atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
        }
        for (let state of atn.states){
            if (state instanceof $lvaZD.BlockStartState) {
                // we need to know the end state to set its start state
                if (state.endState === undefined) throw new Error("IllegalStateException");
                // block end states can only be associated to a single block start state
                if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                state.endState.startState = state;
            }
            if (state instanceof $02msZ.PlusLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $5KAQQ.PlusBlockStartState) target.loopBackState = loopbackState;
                }
            } else if (state instanceof $3sdjf.StarLoopbackState) {
                let loopbackState = state;
                for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                    let target = loopbackState.transition(i).target;
                    if (target instanceof $9nX6N.StarLoopEntryState) target.loopBackState = loopbackState;
                }
            }
        }
        //
        // DECISIONS
        //
        let ndecisions = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 1; i <= ndecisions; i++){
            let s = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
            let decState = atn.states[s];
            atn.decisionToState.push(decState);
            decState.decision = i - 1;
        }
        //
        // LEXER ACTIONS
        //
        if (atn.grammarType === 0 /* LEXER */ ) {
            if (supportsLexerActions) {
                atn.lexerActions = new Array($b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]));
                for(let i = 0; i < atn.lexerActions.length; i++){
                    let actionType = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                    let data1 = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                    if (data1 === 0xFFFF) data1 = -1;
                    let data2 = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
                    if (data2 === 0xFFFF) data2 = -1;
                    let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                    atn.lexerActions[i] = lexerAction;
                }
            } else {
                // for compatibility with older serialized ATNs, convert the old
                // serialized action index for action transitions to the new
                // form, which is the index of a LexerCustomAction
                let legacyLexerActions = [];
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $1rhri.ActionTransition)) continue;
                    let ruleIndex = transition.ruleIndex;
                    let actionIndex = transition.actionIndex;
                    let lexerAction = new $49Z7g.LexerCustomAction(ruleIndex, actionIndex);
                    state.setTransition(i, new $1rhri.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                    legacyLexerActions.push(lexerAction);
                }
                atn.lexerActions = legacyLexerActions;
            }
        }
        this.markPrecedenceDecisions(atn);
        atn.decisionToDFA = new Array(ndecisions);
        for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $lgmvT.DFA(atn.decisionToState[i], i);
        if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
        if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1 /* PARSER */ ) {
            atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let bypassStart = new $h9Cpp.BasicBlockStartState();
                bypassStart.ruleIndex = i;
                atn.addState(bypassStart);
                let bypassStop = new $kkzaV.BlockEndState();
                bypassStop.ruleIndex = i;
                atn.addState(bypassStop);
                bypassStart.endState = bypassStop;
                atn.defineDecisionState(bypassStart);
                bypassStop.startState = bypassStart;
                let endState;
                let excludeTransition;
                if (atn.ruleToStartState[i].isPrecedenceRule) {
                    // wrap from the beginning of the rule to the StarLoopEntryState
                    endState = undefined;
                    for (let state of atn.states){
                        if (state.ruleIndex !== i) continue;
                        if (!(state instanceof $9nX6N.StarLoopEntryState)) continue;
                        let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                        if (!(maybeLoopEndState instanceof $i2y55.LoopEndState)) continue;
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4eVci.RuleStopState) {
                            endState = state;
                            break;
                        }
                    }
                    if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                    excludeTransition = endState.loopBackState.transition(0);
                } else endState = atn.ruleToStopState[i];
                // all non-excluded transitions that currently target end state need to target blockEnd instead
                for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (transition === excludeTransition) continue;
                    if (transition.target === endState) transition.target = bypassStop;
                }
                // all transitions leaving the rule start state need to leave blockStart instead
                while(atn.ruleToStartState[i].numberOfTransitions > 0){
                    let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                    bypassStart.addTransition(transition);
                }
                // link the new states
                atn.ruleToStartState[i].addTransition(new $7o3Uc.EpsilonTransition(bypassStart));
                bypassStop.addTransition(new $7o3Uc.EpsilonTransition(endState));
                let matchState = new $cNyYW.BasicState();
                atn.addState(matchState);
                matchState.addTransition(new $2zmHG.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                bypassStart.addTransition(new $7o3Uc.EpsilonTransition(matchState));
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        if (this.deserializationOptions.isOptimize) {
            while(true){
                let optimizationCount = 0;
                optimizationCount += $b16f5b5d6c59373f$var$ATNDeserializer.inlineSetRules(atn);
                optimizationCount += $b16f5b5d6c59373f$var$ATNDeserializer.combineChainedEpsilons(atn);
                let preserveOrder = atn.grammarType === 0 /* LEXER */ ;
                optimizationCount += $b16f5b5d6c59373f$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                if (optimizationCount === 0) break;
            }
            if (this.deserializationOptions.isVerifyATN) // reverify after modification
            this.verifyATN(atn);
        }
        $b16f5b5d6c59373f$var$ATNDeserializer.identifyTailCalls(atn);
        return atn;
    }
    deserializeSets(data, p, sets, unicodeDeserializer) {
        let nsets = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]);
        for(let i = 0; i < nsets; i++){
            let nintervals = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p]);
            p++;
            let set = new $g8cb0.IntervalSet();
            sets.push(set);
            let containsEof = $b16f5b5d6c59373f$var$ATNDeserializer.toInt(data[p++]) !== 0;
            if (containsEof) set.add(-1);
            for(let j = 0; j < nintervals; j++){
                let a = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                let b = unicodeDeserializer.readUnicode(data, p);
                p += unicodeDeserializer.size;
                set.add(a, b);
            }
        }
        return p;
    }
    /**
     * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
     * the {@link StarLoopEntryState#precedenceRuleDecision} field to the
     * correct value.
     *
     * @param atn The ATN.
     */ markPrecedenceDecisions(atn) {
        // Map rule index -> precedence decision for that rule
        let rulePrecedenceDecisions = new Map();
        for (let state of atn.states){
            if (!(state instanceof $9nX6N.StarLoopEntryState)) continue;
            /* We analyze the ATN to determine if this ATN decision state is the
             * decision for the closure block that determines whether a
             * precedence rule should continue or complete.
             */ if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                if (maybeLoopEndState instanceof $i2y55.LoopEndState) {
                    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4eVci.RuleStopState) {
                        rulePrecedenceDecisions.set(state.ruleIndex, state);
                        state.precedenceRuleDecision = true;
                        state.precedenceLoopbackStates = new $6YKio.BitSet(atn.states.length);
                    }
                }
            }
        }
        // After marking precedence decisions, we go back through and fill in
        // StarLoopEntryState.precedenceLoopbackStates.
        for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
            if (transition.serializationType !== 1 /* EPSILON */ ) continue;
            let epsilonTransition = transition;
            if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
            precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
        }
    }
    verifyATN(atn) {
        // verify assumptions
        for (let state of atn.states){
            this.checkCondition(state !== undefined, "ATN states should not be undefined.");
            if (state.stateType === $jW0J3.ATNStateType.INVALID_TYPE) continue;
            this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
            if (state instanceof $5KAQQ.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $9nX6N.StarLoopEntryState) {
                let starLoopEntryState = state;
                this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                if (starLoopEntryState.transition(0).target instanceof $97ZDg.StarBlockStartState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $i2y55.LoopEndState);
                    this.checkCondition(!starLoopEntryState.nonGreedy);
                } else if (starLoopEntryState.transition(0).target instanceof $i2y55.LoopEndState) {
                    this.checkCondition(starLoopEntryState.transition(1).target instanceof $97ZDg.StarBlockStartState);
                    this.checkCondition(starLoopEntryState.nonGreedy);
                } else throw new Error("IllegalStateException");
            }
            if (state instanceof $3sdjf.StarLoopbackState) {
                this.checkCondition(state.numberOfTransitions === 1);
                this.checkCondition(state.transition(0).target instanceof $9nX6N.StarLoopEntryState);
            }
            if (state instanceof $i2y55.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
            if (state instanceof $juHvA.RuleStartState) this.checkCondition(state.stopState !== undefined);
            if (state instanceof $lvaZD.BlockStartState) this.checkCondition(state.endState !== undefined);
            if (state instanceof $kkzaV.BlockEndState) this.checkCondition(state.startState !== undefined);
            if (state instanceof $frUMD.DecisionState) {
                let decisionState = state;
                this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
            } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4eVci.RuleStopState);
        }
    }
    checkCondition(condition, message) {
        if (!condition) throw new Error("IllegalStateException: " + message);
    }
    static inlineSetRules(atn) {
        let inlinedCalls = 0;
        let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
        for(let i = 0; i < atn.ruleToStartState.length; i++){
            let startState = atn.ruleToStartState[i];
            let middleState = startState;
            while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1 /* EPSILON */ )middleState = middleState.getOptimizedTransition(0).target;
            if (middleState.numberOfOptimizedTransitions !== 1) continue;
            let matchTransition = middleState.getOptimizedTransition(0);
            let matchTarget = matchTransition.target;
            if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4eVci.RuleStopState)) continue;
            switch(matchTransition.serializationType){
                case 5 /* ATOM */ :
                case 2 /* RANGE */ :
                case 7 /* SET */ :
                    ruleToInlineTransition[i] = matchTransition;
                    break;
                case 8 /* NOT_SET */ :
                case 9 /* WILDCARD */ :
                    continue;
                default:
                    continue;
            }
        }
        for (let state of atn.states){
            if (state.ruleIndex < 0) continue;
            let optimizedTransitions;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $1q038.RuleTransition)) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                let ruleTransition = transition;
                let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                if (effective === undefined) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue;
                }
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                }
                inlinedCalls++;
                let target = ruleTransition.followState;
                let intermediateState = new $cNyYW.BasicState();
                intermediateState.setRuleIndex(target.ruleIndex);
                atn.addState(intermediateState);
                optimizedTransitions.push(new $7o3Uc.EpsilonTransition(intermediateState));
                switch(effective.serializationType){
                    case 5 /* ATOM */ :
                        intermediateState.addTransition(new $2zmHG.AtomTransition(target, effective._label));
                        break;
                    case 2 /* RANGE */ :
                        intermediateState.addTransition(new $i8IS6.RangeTransition(target, effective.from, effective.to));
                        break;
                    case 7 /* SET */ :
                        intermediateState.addTransition(new $7grDB.SetTransition(target, effective.label));
                        break;
                    default:
                        throw new Error("UnsupportedOperationException");
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($e2oSX.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
        return inlinedCalls;
    }
    static combineChainedEpsilons(atn) {
        let removedEdges = 0;
        for (let state of atn.states){
            if (!state.onlyHasEpsilonTransitions || state instanceof $4eVci.RuleStopState) continue;
            let optimizedTransitions;
            nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                let intermediate = transition.target;
                if (transition.serializationType !== 1 /* EPSILON */  || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $jW0J3.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 /* EPSILON */  || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                    if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                    continue nextTransition;
                }
                removedEdges++;
                if (optimizedTransitions === undefined) {
                    optimizedTransitions = [];
                    for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                }
                for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                    let target = intermediate.getOptimizedTransition(j).target;
                    optimizedTransitions.push(new $7o3Uc.EpsilonTransition(target));
                }
            }
            if (optimizedTransitions !== undefined) {
                if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
            }
        }
        if ($e2oSX.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
        return removedEdges;
    }
    static optimizeSets(atn, preserveOrder) {
        if (preserveOrder) // this optimization currently doesn't preserve edge order.
        return 0;
        let removedPaths = 0;
        let decisions = atn.decisionToState;
        for (let decision of decisions){
            let setTransitions = new $g8cb0.IntervalSet();
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                let epsTransition = decision.getOptimizedTransition(i);
                if (!(epsTransition instanceof $7o3Uc.EpsilonTransition)) continue;
                if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                let transition = epsTransition.target.getOptimizedTransition(0);
                if (!(transition.target instanceof $kkzaV.BlockEndState)) continue;
                if (transition instanceof $kUcH8.NotSetTransition) continue;
                if (transition instanceof $2zmHG.AtomTransition || transition instanceof $i8IS6.RangeTransition || transition instanceof $7grDB.SetTransition) setTransitions.add(i);
            }
            if (setTransitions.size <= 1) continue;
            let optimizedTransitions = [];
            for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
            let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
            let matchSet = new $g8cb0.IntervalSet();
            for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                if (matchTransition instanceof $kUcH8.NotSetTransition) throw new Error("Not yet implemented.");
                else matchSet.addAll(matchTransition.label);
            }
            let newTransition;
            if (matchSet.intervals.length === 1) {
                if (matchSet.size === 1) newTransition = new $2zmHG.AtomTransition(blockEndState, matchSet.minElement);
                else {
                    let matchInterval = matchSet.intervals[0];
                    newTransition = new $i8IS6.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                }
            } else newTransition = new $7grDB.SetTransition(blockEndState, matchSet);
            let setOptimizedState = new $cNyYW.BasicState();
            setOptimizedState.setRuleIndex(decision.ruleIndex);
            atn.addState(setOptimizedState);
            setOptimizedState.addTransition(newTransition);
            optimizedTransitions.push(new $7o3Uc.EpsilonTransition(setOptimizedState));
            removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
            if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
            for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
        }
        if ($e2oSX.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
        return removedPaths;
    }
    static identifyTailCalls(atn) {
        for (let state of atn.states){
            for(let i = 0; i < state.numberOfTransitions; i++){
                let transition = state.transition(i);
                if (!(transition instanceof $1q038.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
            if (!state.isOptimized) continue;
            for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                let transition = state.getOptimizedTransition(i);
                if (!(transition instanceof $1q038.RuleTransition)) continue;
                transition.tailCall = this.testTailCall(atn, transition, false);
                transition.optimizedTailCall = this.testTailCall(atn, transition, true);
            }
        }
    }
    static testTailCall(atn, transition, optimizedPath) {
        if (!optimizedPath && transition.tailCall) return true;
        if (optimizedPath && transition.optimizedTailCall) return true;
        let reachable = new $6YKio.BitSet(atn.states.length);
        let worklist = [];
        worklist.push(transition.followState);
        while(true){
            let state = worklist.pop();
            if (!state) break;
            if (reachable.get(state.stateNumber)) continue;
            if (state instanceof $4eVci.RuleStopState) continue;
            if (!state.onlyHasEpsilonTransitions) return false;
            let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
            for(let i = 0; i < transitionCount; i++){
                let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                if (t.serializationType !== 1 /* EPSILON */ ) return false;
                worklist.push(t.target);
            }
        }
        return true;
    }
    static toInt(c) {
        return c;
    }
    static toInt32(data, offset) {
        return (data[offset] | data[offset + 1] << 16) >>> 0;
    }
    static toUUID(data, offset) {
        let leastSigBits = $b16f5b5d6c59373f$var$ATNDeserializer.toInt32(data, offset);
        let lessSigBits = $b16f5b5d6c59373f$var$ATNDeserializer.toInt32(data, offset + 2);
        let moreSigBits = $b16f5b5d6c59373f$var$ATNDeserializer.toInt32(data, offset + 4);
        let mostSigBits = $b16f5b5d6c59373f$var$ATNDeserializer.toInt32(data, offset + 6);
        return new $eKmKF.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
        let target = atn.states[trg];
        switch(type){
            case 1 /* EPSILON */ :
                return new $7o3Uc.EpsilonTransition(target);
            case 2 /* RANGE */ :
                if (arg3 !== 0) return new $i8IS6.RangeTransition(target, $lxPhv.Token.EOF, arg2);
                else return new $i8IS6.RangeTransition(target, arg1, arg2);
            case 3 /* RULE */ :
                let rt = new $1q038.RuleTransition(atn.states[arg1], arg2, arg3, target);
                return rt;
            case 4 /* PREDICATE */ :
                let pt = new $1qA0P.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                return pt;
            case 10 /* PRECEDENCE */ :
                return new $ucBKb.PrecedencePredicateTransition(target, arg1);
            case 5 /* ATOM */ :
                if (arg3 !== 0) return new $2zmHG.AtomTransition(target, $lxPhv.Token.EOF);
                else return new $2zmHG.AtomTransition(target, arg1);
            case 6 /* ACTION */ :
                let a = new $1rhri.ActionTransition(target, arg1, arg2, arg3 !== 0);
                return a;
            case 7 /* SET */ :
                return new $7grDB.SetTransition(target, sets[arg1]);
            case 8 /* NOT_SET */ :
                return new $kUcH8.NotSetTransition(target, sets[arg1]);
            case 9 /* WILDCARD */ :
                return new $3uASk.WildcardTransition(target);
        }
        throw new Error("The specified transition type is not valid.");
    }
    stateFactory(type, ruleIndex) {
        let s;
        switch(type){
            case $jW0J3.ATNStateType.INVALID_TYPE:
                return new $ktBtp.InvalidState();
            case $jW0J3.ATNStateType.BASIC:
                s = new $cNyYW.BasicState();
                break;
            case $jW0J3.ATNStateType.RULE_START:
                s = new $juHvA.RuleStartState();
                break;
            case $jW0J3.ATNStateType.BLOCK_START:
                s = new $h9Cpp.BasicBlockStartState();
                break;
            case $jW0J3.ATNStateType.PLUS_BLOCK_START:
                s = new $5KAQQ.PlusBlockStartState();
                break;
            case $jW0J3.ATNStateType.STAR_BLOCK_START:
                s = new $97ZDg.StarBlockStartState();
                break;
            case $jW0J3.ATNStateType.TOKEN_START:
                s = new $1dk9Y.TokensStartState();
                break;
            case $jW0J3.ATNStateType.RULE_STOP:
                s = new $4eVci.RuleStopState();
                break;
            case $jW0J3.ATNStateType.BLOCK_END:
                s = new $kkzaV.BlockEndState();
                break;
            case $jW0J3.ATNStateType.STAR_LOOP_BACK:
                s = new $3sdjf.StarLoopbackState();
                break;
            case $jW0J3.ATNStateType.STAR_LOOP_ENTRY:
                s = new $9nX6N.StarLoopEntryState();
                break;
            case $jW0J3.ATNStateType.PLUS_LOOP_BACK:
                s = new $02msZ.PlusLoopbackState();
                break;
            case $jW0J3.ATNStateType.LOOP_END:
                s = new $i2y55.LoopEndState();
                break;
            default:
                let message = `The specified state type ${type} is not valid.`;
                throw new Error(message);
        }
        s.ruleIndex = ruleIndex;
        return s;
    }
    lexerActionFactory(type, data1, data2) {
        switch(type){
            case 0 /* CHANNEL */ :
                return new $8p14t.LexerChannelAction(data1);
            case 1 /* CUSTOM */ :
                return new $49Z7g.LexerCustomAction(data1, data2);
            case 2 /* MODE */ :
                return new $lQYka.LexerModeAction(data1);
            case 3 /* MORE */ :
                return $liA1k.LexerMoreAction.INSTANCE;
            case 4 /* POP_MODE */ :
                return $fQogW.LexerPopModeAction.INSTANCE;
            case 5 /* PUSH_MODE */ :
                return new $a58jV.LexerPushModeAction(data1);
            case 6 /* SKIP */ :
                return $bDA2t.LexerSkipAction.INSTANCE;
            case 7 /* TYPE */ :
                return new $9P8rd.LexerTypeAction(data1);
            default:
                let message = `The specified lexer action type ${type} is not valid.`;
                throw new Error(message);
        }
    }
    constructor(deserializationOptions){
        if (deserializationOptions === undefined) deserializationOptions = $19eQd.ATNDeserializationOptions.defaultOptions;
        this.deserializationOptions = deserializationOptions;
    }
}
/* WARNING: DO NOT MERGE THESE LINES. If UUIDs differ during a merge,
 * resolve the conflict by generating a new ID!
 */ /**
 * This is the earliest supported serialized UUID.
 */ $b16f5b5d6c59373f$var$ATNDeserializer.BASE_SERIALIZED_UUID = $eKmKF.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
/**
 * This UUID indicates an extension of {@link #ADDED_PRECEDENCE_TRANSITIONS}
 * for the addition of lexer actions encoded as a sequence of
 * {@link LexerAction} instances.
 */ $b16f5b5d6c59373f$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $eKmKF.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
/**
 * This UUID indicates the serialized ATN contains two sets of
 * IntervalSets, where the second set's values are encoded as
 * 32-bit integers to support the full Unicode SMP range up to U+10FFFF.
 */ $b16f5b5d6c59373f$var$ATNDeserializer.ADDED_UNICODE_SMP = $eKmKF.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
/**
 * This list contains all of the currently supported UUIDs, ordered by when
 * the feature first appeared in this branch.
 */ $b16f5b5d6c59373f$var$ATNDeserializer.SUPPORTED_UUIDS = [
    $b16f5b5d6c59373f$var$ATNDeserializer.BASE_SERIALIZED_UUID,
    $b16f5b5d6c59373f$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
    $b16f5b5d6c59373f$var$ATNDeserializer.ADDED_UNICODE_SMP
];
/**
 * This is the current serialized UUID.
 */ $b16f5b5d6c59373f$var$ATNDeserializer.SERIALIZED_UUID = $b16f5b5d6c59373f$var$ATNDeserializer.ADDED_UNICODE_SMP;
$b16f5b5d6c59373f$var$__decorate([
    $4w9vi.NotNull
], $b16f5b5d6c59373f$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
$b16f5b5d6c59373f$var$__decorate([
    $b16f5b5d6c59373f$var$__param(0, $4w9vi.NotNull)
], $b16f5b5d6c59373f$var$ATNDeserializer.prototype, "deserialize", null);
$b16f5b5d6c59373f$var$__decorate([
    $b16f5b5d6c59373f$var$__param(0, $4w9vi.NotNull)
], $b16f5b5d6c59373f$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
$b16f5b5d6c59373f$var$__decorate([
    $4w9vi.NotNull,
    $b16f5b5d6c59373f$var$__param(0, $4w9vi.NotNull)
], $b16f5b5d6c59373f$var$ATNDeserializer.prototype, "edgeFactory", null);
module.exports.ATNDeserializer = $b16f5b5d6c59373f$var$ATNDeserializer; //# sourceMappingURL=ATNDeserializer.js.map

});

parcelRegister("1rhri", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $10c5d71c19350f25$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $10c5d71c19350f25$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionTransition = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $151Ma = parcelRequire("151Ma");

let $10c5d71c19350f25$var$ActionTransition = class ActionTransition extends $151Ma.Transition {
    get serializationType() {
        return 6 /* ACTION */ ;
    }
    get isEpsilon() {
        return true; // we are to be ignored by analysis 'cept for predicates
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "action_" + this.ruleIndex + ":" + this.actionIndex;
    }
    constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
        super(target);
        this.ruleIndex = ruleIndex;
        this.actionIndex = actionIndex;
        this.isCtxDependent = isCtxDependent;
    }
};
$10c5d71c19350f25$var$__decorate([
    $4w9vi.Override
], $10c5d71c19350f25$var$ActionTransition.prototype, "serializationType", null);
$10c5d71c19350f25$var$__decorate([
    $4w9vi.Override
], $10c5d71c19350f25$var$ActionTransition.prototype, "isEpsilon", null);
$10c5d71c19350f25$var$__decorate([
    $4w9vi.Override
], $10c5d71c19350f25$var$ActionTransition.prototype, "matches", null);
$10c5d71c19350f25$var$__decorate([
    $4w9vi.Override
], $10c5d71c19350f25$var$ActionTransition.prototype, "toString", null);
$10c5d71c19350f25$var$ActionTransition = $10c5d71c19350f25$var$__decorate([
    $10c5d71c19350f25$var$__param(0, $4w9vi.NotNull)
], $10c5d71c19350f25$var$ActionTransition);
module.exports.ActionTransition = $10c5d71c19350f25$var$ActionTransition; //# sourceMappingURL=ActionTransition.js.map

});

parcelRegister("2zmHG", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $1df076188f766d58$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $1df076188f766d58$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AtomTransition = void 0;

var $g8cb0 = parcelRequire("g8cb0");


var $4w9vi = parcelRequire("4w9vi");


var $151Ma = parcelRequire("151Ma");

/** TODO: make all transitions sets? no, should remove set edges */ let $1df076188f766d58$var$AtomTransition = class AtomTransition extends $151Ma.Transition {
    get serializationType() {
        return 5 /* ATOM */ ;
    }
    get label() {
        return $g8cb0.IntervalSet.of(this._label);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return this._label === symbol;
    }
    toString() {
        return String(this.label);
    }
    constructor(target, label){
        super(target);
        this._label = label;
    }
};
$1df076188f766d58$var$__decorate([
    $4w9vi.Override
], $1df076188f766d58$var$AtomTransition.prototype, "serializationType", null);
$1df076188f766d58$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $1df076188f766d58$var$AtomTransition.prototype, "label", null);
$1df076188f766d58$var$__decorate([
    $4w9vi.Override
], $1df076188f766d58$var$AtomTransition.prototype, "matches", null);
$1df076188f766d58$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $1df076188f766d58$var$AtomTransition.prototype, "toString", null);
$1df076188f766d58$var$AtomTransition = $1df076188f766d58$var$__decorate([
    $1df076188f766d58$var$__param(0, $4w9vi.NotNull)
], $1df076188f766d58$var$AtomTransition);
module.exports.AtomTransition = $1df076188f766d58$var$AtomTransition; //# sourceMappingURL=AtomTransition.js.map

});

parcelRegister("h9Cpp", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c7d1121eb2691b0c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicBlockStartState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $lvaZD = parcelRequire("lvaZD");


var $4w9vi = parcelRequire("4w9vi");

/**
 *
 * @author Sam Harwell
 */ class $c7d1121eb2691b0c$var$BasicBlockStartState extends $lvaZD.BlockStartState {
    get stateType() {
        return $jW0J3.ATNStateType.BLOCK_START;
    }
}
$c7d1121eb2691b0c$var$__decorate([
    $4w9vi.Override
], $c7d1121eb2691b0c$var$BasicBlockStartState.prototype, "stateType", null);
module.exports.BasicBlockStartState = $c7d1121eb2691b0c$var$BasicBlockStartState; //# sourceMappingURL=BasicBlockStartState.js.map

});

parcelRegister("lvaZD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockStartState = void 0;

var $frUMD = parcelRequire("frUMD");

/**  The start of a regular `(...)` block. */ class $fa75054007b63755$var$BlockStartState extends $frUMD.DecisionState {
}
module.exports.BlockStartState = $fa75054007b63755$var$BlockStartState; //# sourceMappingURL=BlockStartState.js.map

});

parcelRegister("kkzaV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $ecd0f5fcf1934f1d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockEndState = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $4w9vi = parcelRequire("4w9vi");

/** Terminal node of a simple `(a|b|c)` block. */ class $ecd0f5fcf1934f1d$var$BlockEndState extends $ltT8J.ATNState {
    get stateType() {
        return $jW0J3.ATNStateType.BLOCK_END;
    }
}
$ecd0f5fcf1934f1d$var$__decorate([
    $4w9vi.Override
], $ecd0f5fcf1934f1d$var$BlockEndState.prototype, "stateType", null);
module.exports.BlockEndState = $ecd0f5fcf1934f1d$var$BlockEndState; //# sourceMappingURL=BlockEndState.js.map

});

parcelRegister("7o3Uc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $560dcddb41a1b44b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $560dcddb41a1b44b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EpsilonTransition = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $151Ma = parcelRequire("151Ma");

let $560dcddb41a1b44b$var$EpsilonTransition = class EpsilonTransition extends $151Ma.Transition {
    /**
     * @returns the rule index of a precedence rule for which this transition is
     * returning from, where the precedence value is 0; otherwise, -1.
     *
     * @see ATNConfig.isPrecedenceFilterSuppressed
     * @see ParserATNSimulator#applyPrecedenceFilter(ATNConfigSet, ParserRuleContext, PredictionContextCache)
     * @since 4.4.1
     */ get outermostPrecedenceReturn() {
        return this._outermostPrecedenceReturn;
    }
    get serializationType() {
        return 1 /* EPSILON */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    toString() {
        return "epsilon";
    }
    constructor(target, outermostPrecedenceReturn = -1){
        super(target);
        this._outermostPrecedenceReturn = outermostPrecedenceReturn;
    }
};
$560dcddb41a1b44b$var$__decorate([
    $4w9vi.Override
], $560dcddb41a1b44b$var$EpsilonTransition.prototype, "serializationType", null);
$560dcddb41a1b44b$var$__decorate([
    $4w9vi.Override
], $560dcddb41a1b44b$var$EpsilonTransition.prototype, "isEpsilon", null);
$560dcddb41a1b44b$var$__decorate([
    $4w9vi.Override
], $560dcddb41a1b44b$var$EpsilonTransition.prototype, "matches", null);
$560dcddb41a1b44b$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $560dcddb41a1b44b$var$EpsilonTransition.prototype, "toString", null);
$560dcddb41a1b44b$var$EpsilonTransition = $560dcddb41a1b44b$var$__decorate([
    $560dcddb41a1b44b$var$__param(0, $4w9vi.NotNull)
], $560dcddb41a1b44b$var$EpsilonTransition);
module.exports.EpsilonTransition = $560dcddb41a1b44b$var$EpsilonTransition; //# sourceMappingURL=EpsilonTransition.js.map

});

parcelRegister("8p14t", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $61e17d3a83a5d94d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $61e17d3a83a5d94d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerChannelAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `channel` lexer action by calling
 * {@link Lexer#setChannel} with the assigned channel.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $61e17d3a83a5d94d$var$LexerChannelAction {
    /**
     * Gets the channel to use for the {@link Token} created by the lexer.
     *
     * @returns The channel to use for the {@link Token} created by the lexer.
     */ get channel() {
        return this._channel;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#CHANNEL}.
     */ get actionType() {
        return 0 /* CHANNEL */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#setChannel} with the
     * value provided by {@link #getChannel}.
     */ execute(lexer) {
        lexer.channel = this._channel;
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        hash = $g3jfX.MurmurHash.update(hash, this._channel);
        return $g3jfX.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $61e17d3a83a5d94d$var$LexerChannelAction)) return false;
        return this._channel === obj._channel;
    }
    toString() {
        return `channel(${this._channel})`;
    }
    /**
     * Constructs a new `channel` action with the specified channel value.
     * @param channel The channel value to pass to {@link Lexer#setChannel}.
     */ constructor(channel){
        this._channel = channel;
    }
}
$61e17d3a83a5d94d$var$__decorate([
    $4w9vi.Override
], $61e17d3a83a5d94d$var$LexerChannelAction.prototype, "actionType", null);
$61e17d3a83a5d94d$var$__decorate([
    $4w9vi.Override
], $61e17d3a83a5d94d$var$LexerChannelAction.prototype, "isPositionDependent", null);
$61e17d3a83a5d94d$var$__decorate([
    $4w9vi.Override,
    $61e17d3a83a5d94d$var$__param(0, $4w9vi.NotNull)
], $61e17d3a83a5d94d$var$LexerChannelAction.prototype, "execute", null);
$61e17d3a83a5d94d$var$__decorate([
    $4w9vi.Override
], $61e17d3a83a5d94d$var$LexerChannelAction.prototype, "hashCode", null);
$61e17d3a83a5d94d$var$__decorate([
    $4w9vi.Override
], $61e17d3a83a5d94d$var$LexerChannelAction.prototype, "equals", null);
$61e17d3a83a5d94d$var$__decorate([
    $4w9vi.Override
], $61e17d3a83a5d94d$var$LexerChannelAction.prototype, "toString", null);
module.exports.LexerChannelAction = $61e17d3a83a5d94d$var$LexerChannelAction; //# sourceMappingURL=LexerChannelAction.js.map

});

parcelRegister("49Z7g", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $30776913afbcdd7d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $30776913afbcdd7d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerCustomAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Executes a custom lexer action by calling {@link Recognizer#action} with the
 * rule and action indexes assigned to the custom action. The implementation of
 * a custom action is added to the generated code for the lexer in an override
 * of {@link Recognizer#action} when the grammar is compiled.
 *
 * This class may represent embedded actions created with the `{...}`
 * syntax in ANTLR 4, as well as actions created for lexer commands where the
 * command argument could not be evaluated when the grammar was compiled.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $30776913afbcdd7d$var$LexerCustomAction {
    /**
     * Gets the rule index to use for calls to {@link Recognizer#action}.
     *
     * @returns The rule index for the custom action.
     */ get ruleIndex() {
        return this._ruleIndex;
    }
    /**
     * Gets the action index to use for calls to {@link Recognizer#action}.
     *
     * @returns The action index for the custom action.
     */ get actionIndex() {
        return this._actionIndex;
    }
    /**
     * {@inheritDoc}
     *
     * @returns This method returns {@link LexerActionType#CUSTOM}.
     */ get actionType() {
        return 1 /* CUSTOM */ ;
    }
    /**
     * Gets whether the lexer action is position-dependent. Position-dependent
     * actions may have different semantics depending on the {@link CharStream}
     * index at the time the action is executed.
     *
     * Custom actions are position-dependent since they may represent a
     * user-defined embedded action which makes calls to methods like
     * {@link Lexer#getText}.
     *
     * @returns This method returns `true`.
     */ get isPositionDependent() {
        return true;
    }
    /**
     * {@inheritDoc}
     *
     * Custom actions are implemented by calling {@link Lexer#action} with the
     * appropriate rule and action indexes.
     */ execute(lexer) {
        lexer.action(undefined, this._ruleIndex, this._actionIndex);
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        hash = $g3jfX.MurmurHash.update(hash, this._ruleIndex);
        hash = $g3jfX.MurmurHash.update(hash, this._actionIndex);
        return $g3jfX.MurmurHash.finish(hash, 3);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $30776913afbcdd7d$var$LexerCustomAction)) return false;
        return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
    }
    /**
     * Constructs a custom lexer action with the specified rule and action
     * indexes.
     *
     * @param ruleIndex The rule index to use for calls to
     * {@link Recognizer#action}.
     * @param actionIndex The action index to use for calls to
     * {@link Recognizer#action}.
     */ constructor(ruleIndex, actionIndex){
        this._ruleIndex = ruleIndex;
        this._actionIndex = actionIndex;
    }
}
$30776913afbcdd7d$var$__decorate([
    $4w9vi.Override
], $30776913afbcdd7d$var$LexerCustomAction.prototype, "actionType", null);
$30776913afbcdd7d$var$__decorate([
    $4w9vi.Override
], $30776913afbcdd7d$var$LexerCustomAction.prototype, "isPositionDependent", null);
$30776913afbcdd7d$var$__decorate([
    $4w9vi.Override,
    $30776913afbcdd7d$var$__param(0, $4w9vi.NotNull)
], $30776913afbcdd7d$var$LexerCustomAction.prototype, "execute", null);
$30776913afbcdd7d$var$__decorate([
    $4w9vi.Override
], $30776913afbcdd7d$var$LexerCustomAction.prototype, "hashCode", null);
$30776913afbcdd7d$var$__decorate([
    $4w9vi.Override
], $30776913afbcdd7d$var$LexerCustomAction.prototype, "equals", null);
module.exports.LexerCustomAction = $30776913afbcdd7d$var$LexerCustomAction; //# sourceMappingURL=LexerCustomAction.js.map

});

parcelRegister("lQYka", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fe8d3f77ba6a9875$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $fe8d3f77ba6a9875$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerModeAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `mode` lexer action by calling {@link Lexer#mode} with
 * the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $fe8d3f77ba6a9875$var$LexerModeAction {
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `mode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MODE}.
     */ get actionType() {
        return 2 /* MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#mode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.mode(this._mode);
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        hash = $g3jfX.MurmurHash.update(hash, this._mode);
        return $g3jfX.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $fe8d3f77ba6a9875$var$LexerModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `mode(${this._mode})`;
    }
    /**
     * Constructs a new `mode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#mode}.
     */ constructor(mode){
        this._mode = mode;
    }
}
$fe8d3f77ba6a9875$var$__decorate([
    $4w9vi.Override
], $fe8d3f77ba6a9875$var$LexerModeAction.prototype, "actionType", null);
$fe8d3f77ba6a9875$var$__decorate([
    $4w9vi.Override
], $fe8d3f77ba6a9875$var$LexerModeAction.prototype, "isPositionDependent", null);
$fe8d3f77ba6a9875$var$__decorate([
    $4w9vi.Override,
    $fe8d3f77ba6a9875$var$__param(0, $4w9vi.NotNull)
], $fe8d3f77ba6a9875$var$LexerModeAction.prototype, "execute", null);
$fe8d3f77ba6a9875$var$__decorate([
    $4w9vi.Override
], $fe8d3f77ba6a9875$var$LexerModeAction.prototype, "hashCode", null);
$fe8d3f77ba6a9875$var$__decorate([
    $4w9vi.Override
], $fe8d3f77ba6a9875$var$LexerModeAction.prototype, "equals", null);
$fe8d3f77ba6a9875$var$__decorate([
    $4w9vi.Override
], $fe8d3f77ba6a9875$var$LexerModeAction.prototype, "toString", null);
module.exports.LexerModeAction = $fe8d3f77ba6a9875$var$LexerModeAction; //# sourceMappingURL=LexerModeAction.js.map

});

parcelRegister("liA1k", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f817385325f70fd2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f817385325f70fd2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerMoreAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `more` lexer action by calling {@link Lexer#more}.
 *
 * The `more` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $f817385325f70fd2$var$LexerMoreAction {
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#MORE}.
     */ get actionType() {
        return 3 /* MORE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#more}.
     */ execute(lexer) {
        lexer.more();
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        return $g3jfX.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "more";
    }
    /**
     * Constructs the singleton instance of the lexer `more` command.
     */ constructor(){
    // intentionally empty
    }
}
$f817385325f70fd2$var$__decorate([
    $4w9vi.Override
], $f817385325f70fd2$var$LexerMoreAction.prototype, "actionType", null);
$f817385325f70fd2$var$__decorate([
    $4w9vi.Override
], $f817385325f70fd2$var$LexerMoreAction.prototype, "isPositionDependent", null);
$f817385325f70fd2$var$__decorate([
    $4w9vi.Override,
    $f817385325f70fd2$var$__param(0, $4w9vi.NotNull)
], $f817385325f70fd2$var$LexerMoreAction.prototype, "execute", null);
$f817385325f70fd2$var$__decorate([
    $4w9vi.Override
], $f817385325f70fd2$var$LexerMoreAction.prototype, "hashCode", null);
$f817385325f70fd2$var$__decorate([
    $4w9vi.Override
], $f817385325f70fd2$var$LexerMoreAction.prototype, "equals", null);
$f817385325f70fd2$var$__decorate([
    $4w9vi.Override
], $f817385325f70fd2$var$LexerMoreAction.prototype, "toString", null);
module.exports.LexerMoreAction = $f817385325f70fd2$var$LexerMoreAction;
(function(LexerMoreAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerMoreAction.INSTANCE = new LexerMoreAction();
})($f817385325f70fd2$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {})); //# sourceMappingURL=LexerMoreAction.js.map

});

parcelRegister("fQogW", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $b88e8a54df9d14c0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $b88e8a54df9d14c0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPopModeAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `popMode` lexer action by calling {@link Lexer#popMode}.
 *
 * The `popMode` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $b88e8a54df9d14c0$var$LexerPopModeAction {
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#POP_MODE}.
     */ get actionType() {
        return 4 /* POP_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#popMode}.
     */ execute(lexer) {
        lexer.popMode();
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        return $g3jfX.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "popMode";
    }
    /**
     * Constructs the singleton instance of the lexer `popMode` command.
     */ constructor(){
    // intentionally empty
    }
}
$b88e8a54df9d14c0$var$__decorate([
    $4w9vi.Override
], $b88e8a54df9d14c0$var$LexerPopModeAction.prototype, "actionType", null);
$b88e8a54df9d14c0$var$__decorate([
    $4w9vi.Override
], $b88e8a54df9d14c0$var$LexerPopModeAction.prototype, "isPositionDependent", null);
$b88e8a54df9d14c0$var$__decorate([
    $4w9vi.Override,
    $b88e8a54df9d14c0$var$__param(0, $4w9vi.NotNull)
], $b88e8a54df9d14c0$var$LexerPopModeAction.prototype, "execute", null);
$b88e8a54df9d14c0$var$__decorate([
    $4w9vi.Override
], $b88e8a54df9d14c0$var$LexerPopModeAction.prototype, "hashCode", null);
$b88e8a54df9d14c0$var$__decorate([
    $4w9vi.Override
], $b88e8a54df9d14c0$var$LexerPopModeAction.prototype, "equals", null);
$b88e8a54df9d14c0$var$__decorate([
    $4w9vi.Override
], $b88e8a54df9d14c0$var$LexerPopModeAction.prototype, "toString", null);
module.exports.LexerPopModeAction = $b88e8a54df9d14c0$var$LexerPopModeAction;
(function(LexerPopModeAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerPopModeAction.INSTANCE = new LexerPopModeAction();
})($b88e8a54df9d14c0$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {})); //# sourceMappingURL=LexerPopModeAction.js.map

});

parcelRegister("a58jV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7570d3414012feed$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7570d3414012feed$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerPushModeAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `pushMode` lexer action by calling
 * {@link Lexer#pushMode} with the assigned mode.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $7570d3414012feed$var$LexerPushModeAction {
    /**
     * Get the lexer mode this action should transition the lexer to.
     *
     * @returns The lexer mode for this `pushMode` command.
     */ get mode() {
        return this._mode;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#PUSH_MODE}.
     */ get actionType() {
        return 5 /* PUSH_MODE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#pushMode} with the
     * value provided by {@link #getMode}.
     */ execute(lexer) {
        lexer.pushMode(this._mode);
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        hash = $g3jfX.MurmurHash.update(hash, this._mode);
        return $g3jfX.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $7570d3414012feed$var$LexerPushModeAction)) return false;
        return this._mode === obj._mode;
    }
    toString() {
        return `pushMode(${this._mode})`;
    }
    /**
     * Constructs a new `pushMode` action with the specified mode value.
     * @param mode The mode value to pass to {@link Lexer#pushMode}.
     */ constructor(mode){
        this._mode = mode;
    }
}
$7570d3414012feed$var$__decorate([
    $4w9vi.Override
], $7570d3414012feed$var$LexerPushModeAction.prototype, "actionType", null);
$7570d3414012feed$var$__decorate([
    $4w9vi.Override
], $7570d3414012feed$var$LexerPushModeAction.prototype, "isPositionDependent", null);
$7570d3414012feed$var$__decorate([
    $4w9vi.Override,
    $7570d3414012feed$var$__param(0, $4w9vi.NotNull)
], $7570d3414012feed$var$LexerPushModeAction.prototype, "execute", null);
$7570d3414012feed$var$__decorate([
    $4w9vi.Override
], $7570d3414012feed$var$LexerPushModeAction.prototype, "hashCode", null);
$7570d3414012feed$var$__decorate([
    $4w9vi.Override
], $7570d3414012feed$var$LexerPushModeAction.prototype, "equals", null);
$7570d3414012feed$var$__decorate([
    $4w9vi.Override
], $7570d3414012feed$var$LexerPushModeAction.prototype, "toString", null);
module.exports.LexerPushModeAction = $7570d3414012feed$var$LexerPushModeAction; //# sourceMappingURL=LexerPushModeAction.js.map

});

parcelRegister("bDA2t", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $878f4ac8c263c0f7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $878f4ac8c263c0f7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerSkipAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `skip` lexer action by calling {@link Lexer#skip}.
 *
 * The `skip` command does not have any parameters, so this action is
 * implemented as a singleton instance exposed by {@link #INSTANCE}.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $878f4ac8c263c0f7$var$LexerSkipAction {
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#SKIP}.
     */ get actionType() {
        return 6 /* SKIP */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by calling {@link Lexer#skip}.
     */ execute(lexer) {
        lexer.skip();
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        return $g3jfX.MurmurHash.finish(hash, 1);
    }
    equals(obj) {
        return obj === this;
    }
    toString() {
        return "skip";
    }
    /**
     * Constructs the singleton instance of the lexer `skip` command.
     */ constructor(){
    // intentionally empty
    }
}
$878f4ac8c263c0f7$var$__decorate([
    $4w9vi.Override
], $878f4ac8c263c0f7$var$LexerSkipAction.prototype, "actionType", null);
$878f4ac8c263c0f7$var$__decorate([
    $4w9vi.Override
], $878f4ac8c263c0f7$var$LexerSkipAction.prototype, "isPositionDependent", null);
$878f4ac8c263c0f7$var$__decorate([
    $4w9vi.Override,
    $878f4ac8c263c0f7$var$__param(0, $4w9vi.NotNull)
], $878f4ac8c263c0f7$var$LexerSkipAction.prototype, "execute", null);
$878f4ac8c263c0f7$var$__decorate([
    $4w9vi.Override
], $878f4ac8c263c0f7$var$LexerSkipAction.prototype, "hashCode", null);
$878f4ac8c263c0f7$var$__decorate([
    $4w9vi.Override
], $878f4ac8c263c0f7$var$LexerSkipAction.prototype, "equals", null);
$878f4ac8c263c0f7$var$__decorate([
    $4w9vi.Override
], $878f4ac8c263c0f7$var$LexerSkipAction.prototype, "toString", null);
module.exports.LexerSkipAction = $878f4ac8c263c0f7$var$LexerSkipAction;
(function(LexerSkipAction) {
    /**
     * Provides a singleton instance of this parameterless lexer action.
     */ LexerSkipAction.INSTANCE = new LexerSkipAction();
})($878f4ac8c263c0f7$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {})); //# sourceMappingURL=LexerSkipAction.js.map

});

parcelRegister("9P8rd", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $726f6c13b4e04939$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $726f6c13b4e04939$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerTypeAction = void 0;

var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Implements the `type` lexer action by setting `Lexer.type`
 * with the assigned type.
 *
 * @author Sam Harwell
 * @since 4.2
 */ class $726f6c13b4e04939$var$LexerTypeAction {
    /**
     * Gets the type to assign to a token created by the lexer.
     * @returns The type to assign to a token created by the lexer.
     */ get type() {
        return this._type;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns {@link LexerActionType#TYPE}.
     */ get actionType() {
        return 7 /* TYPE */ ;
    }
    /**
     * {@inheritDoc}
     * @returns This method returns `false`.
     */ get isPositionDependent() {
        return false;
    }
    /**
     * {@inheritDoc}
     *
     * This action is implemented by setting `Lexer.type` with the
     * value provided by `type`.
     */ execute(lexer) {
        lexer.type = this._type;
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        hash = $g3jfX.MurmurHash.update(hash, this.actionType);
        hash = $g3jfX.MurmurHash.update(hash, this._type);
        return $g3jfX.MurmurHash.finish(hash, 2);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $726f6c13b4e04939$var$LexerTypeAction)) return false;
        return this._type === obj._type;
    }
    toString() {
        return `type(${this._type})`;
    }
    /**
     * Constructs a new `type` action with the specified token type value.
     * @param type The type to assign to the token using `Lexer.type`.
     */ constructor(type){
        this._type = type;
    }
}
$726f6c13b4e04939$var$__decorate([
    $4w9vi.Override
], $726f6c13b4e04939$var$LexerTypeAction.prototype, "actionType", null);
$726f6c13b4e04939$var$__decorate([
    $4w9vi.Override
], $726f6c13b4e04939$var$LexerTypeAction.prototype, "isPositionDependent", null);
$726f6c13b4e04939$var$__decorate([
    $4w9vi.Override,
    $726f6c13b4e04939$var$__param(0, $4w9vi.NotNull)
], $726f6c13b4e04939$var$LexerTypeAction.prototype, "execute", null);
$726f6c13b4e04939$var$__decorate([
    $4w9vi.Override
], $726f6c13b4e04939$var$LexerTypeAction.prototype, "hashCode", null);
$726f6c13b4e04939$var$__decorate([
    $4w9vi.Override
], $726f6c13b4e04939$var$LexerTypeAction.prototype, "equals", null);
$726f6c13b4e04939$var$__decorate([
    $4w9vi.Override
], $726f6c13b4e04939$var$LexerTypeAction.prototype, "toString", null);
module.exports.LexerTypeAction = $726f6c13b4e04939$var$LexerTypeAction; //# sourceMappingURL=LexerTypeAction.js.map

});

parcelRegister("i2y55", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d222d9ac6ab6aa4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoopEndState = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $4w9vi = parcelRequire("4w9vi");

/** Mark the end of a * or + loop. */ class $d222d9ac6ab6aa4f$var$LoopEndState extends $ltT8J.ATNState {
    get stateType() {
        return $jW0J3.ATNStateType.LOOP_END;
    }
}
$d222d9ac6ab6aa4f$var$__decorate([
    $4w9vi.Override
], $d222d9ac6ab6aa4f$var$LoopEndState.prototype, "stateType", null);
module.exports.LoopEndState = $d222d9ac6ab6aa4f$var$LoopEndState; //# sourceMappingURL=LoopEndState.js.map

});

parcelRegister("e2oSX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a3848e5489b578cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a3848e5489b578cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserATNSimulator = void 0;

var $7oXsf = parcelRequire("7oXsf");


var $1rhri = parcelRequire("1rhri");


var $eEYRR = parcelRequire("eEYRR");


var $l7ijV = parcelRequire("l7ijV");


var $EKDdQ = parcelRequire("EKDdQ");


var $gpoJu = parcelRequire("gpoJu");


var $51XoR = parcelRequire("51XoR");


var $gZszX = parcelRequire("gZszX");


var $jW0J3 = parcelRequire("jW0J3");


var $2zmHG = parcelRequire("2zmHG");


var $6YKio = parcelRequire("6YKio");


var $9lU7d = parcelRequire("9lU7d");


var $frUMD = parcelRequire("frUMD");


var $iIwZu = parcelRequire("iIwZu");


var $kTbzO = parcelRequire("kTbzO");


var $kCyYI = parcelRequire("kCyYI");


var $eK8do = parcelRequire("eK8do");


var $4w9vi = parcelRequire("4w9vi");


var $kUcH8 = parcelRequire("kUcH8");


var $dF72r = parcelRequire("dF72r");


var $gxIPs = parcelRequire("gxIPs");


var $7EUlr = parcelRequire("7EUlr");


var $ca31u = parcelRequire("ca31u");


var $fAz7Q = parcelRequire("fAz7Q");


var $aC2pn = parcelRequire("aC2pn");


var $4eVci = parcelRequire("4eVci");


var $1q038 = parcelRequire("1q038");


var $cAJ3R = parcelRequire("cAJ3R");


var $7grDB = parcelRequire("7grDB");


var $XQBih = parcelRequire("XQBih");


var $lxPhv = parcelRequire("lxPhv");


var $auHu3 = parcelRequire("auHu3");


var $9ir1r = parcelRequire("9ir1r");

const $a3848e5489b578cc$var$MAX_SHORT_VALUE = 0xFFFF;
const $a3848e5489b578cc$var$MIN_INTEGER_VALUE = -2147483648;
/**
 * The embodiment of the adaptive LL(*), ALL(*), parsing strategy.
 *
 * The basic complexity of the adaptive strategy makes it harder to understand.
 * We begin with ATN simulation to build paths in a DFA. Subsequent prediction
 * requests go through the DFA first. If they reach a state without an edge for
 * the current symbol, the algorithm fails over to the ATN simulation to
 * complete the DFA path for the current input (until it finds a conflict state
 * or uniquely predicting state).
 *
 * All of that is done without using the outer context because we want to create
 * a DFA that is not dependent upon the rule invocation stack when we do a
 * prediction. One DFA works in all contexts. We avoid using context not
 * necessarily because it's slower, although it can be, but because of the DFA
 * caching problem. The closure routine only considers the rule invocation stack
 * created during prediction beginning in the decision rule. For example, if
 * prediction occurs without invoking another rule's ATN, there are no context
 * stacks in the configurations. When lack of context leads to a conflict, we
 * don't know if it's an ambiguity or a weakness in the strong LL(*) parsing
 * strategy (versus full LL(*)).
 *
 * When SLL yields a configuration set with conflict, we rewind the input and
 * retry the ATN simulation, this time using full outer context without adding
 * to the DFA. Configuration context stacks will be the full invocation stacks
 * from the start rule. If we get a conflict using full context, then we can
 * definitively say we have a true ambiguity for that input sequence. If we
 * don't get a conflict, it implies that the decision is sensitive to the outer
 * context. (It is not context-sensitive in the sense of context-sensitive
 * grammars.)
 *
 * The next time we reach this DFA state with an SLL conflict, through DFA
 * simulation, we will again retry the ATN simulation using full context mode.
 * This is slow because we can't save the results and have to "interpret" the
 * ATN each time we get that input.
 *
 * **CACHING FULL CONTEXT PREDICTIONS**
 *
 * We could cache results from full context to predicted alternative easily and
 * that saves a lot of time but doesn't work in presence of predicates. The set
 * of visible predicates from the ATN start state changes depending on the
 * context, because closure can fall off the end of a rule. I tried to cache
 * tuples (stack context, semantic context, predicted alt) but it was slower
 * than interpreting and much more complicated. Also required a huge amount of
 * memory. The goal is not to create the world's fastest parser anyway. I'd like
 * to keep this algorithm simple. By launching multiple threads, we can improve
 * the speed of parsing across a large number of files.
 *
 * There is no strict ordering between the amount of input used by SLL vs LL,
 * which makes it really hard to build a cache for full context. Let's say that
 * we have input A B C that leads to an SLL conflict with full context X. That
 * implies that using X we might only use A B but we could also use A B C D to
 * resolve conflict. Input A B C D could predict alternative 1 in one position
 * in the input and A B C E could predict alternative 2 in another position in
 * input. The conflicting SLL configurations could still be non-unique in the
 * full context prediction, which would lead us to requiring more input than the
 * original A B C.	To make a	prediction cache work, we have to track	the exact
 * input	used during the previous prediction. That amounts to a cache that maps
 * X to a specific DFA for that context.
 *
 * Something should be done for left-recursive expression predictions. They are
 * likely LL(1) + pred eval. Easier to do the whole SLL unless error and retry
 * with full LL thing Sam does.
 *
 * **AVOIDING FULL CONTEXT PREDICTION**
 *
 * We avoid doing full context retry when the outer context is empty, we did not
 * dip into the outer context by falling off the end of the decision state rule,
 * or when we force SLL mode.
 *
 * As an example of the not dip into outer context case, consider as super
 * constructor calls versus function calls. One grammar might look like
 * this:
 *
 * ```antlr
 * ctorBody
 *   : '{' superCall? stat* '}'
 *   ;
 * ```
 *
 * Or, you might see something like
 *
 * ```antlr
 * stat
 *   : superCall ';'
 *   | expression ';'
 *   | ...
 *   ;
 * ```
 *
 * In both cases I believe that no closure operations will dip into the outer
 * context. In the first case ctorBody in the worst case will stop at the '}'.
 * In the 2nd case it should stop at the ';'. Both cases should stay within the
 * entry rule and not dip into the outer context.
 *
 * **PREDICATES**
 *
 * Predicates are always evaluated if present in either SLL or LL both. SLL and
 * LL simulation deals with predicates differently. SLL collects predicates as
 * it performs closure operations like ANTLR v3 did. It delays predicate
 * evaluation until it reaches and accept state. This allows us to cache the SLL
 * ATN simulation whereas, if we had evaluated predicates on-the-fly during
 * closure, the DFA state configuration sets would be different and we couldn't
 * build up a suitable DFA.
 *
 * When building a DFA accept state during ATN simulation, we evaluate any
 * predicates and return the sole semantically valid alternative. If there is
 * more than 1 alternative, we report an ambiguity. If there are 0 alternatives,
 * we throw an exception. Alternatives without predicates act like they have
 * true predicates. The simple way to think about it is to strip away all
 * alternatives with false predicates and choose the minimum alternative that
 * remains.
 *
 * When we start in the DFA and reach an accept state that's predicated, we test
 * those and return the minimum semantically viable alternative. If no
 * alternatives are viable, we throw an exception.
 *
 * During full LL ATN simulation, closure always evaluates predicates and
 * on-the-fly. This is crucial to reducing the configuration set size during
 * closure. It hits a landmine when parsing with the Java grammar, for example,
 * without this on-the-fly evaluation.
 *
 * **SHARING DFA**
 *
 * All instances of the same parser share the same decision DFAs through a
 * static field. Each instance gets its own ATN simulator but they share the
 * same {@link ATN#decisionToDFA} field. They also share a
 * {@link PredictionContextCache} object that makes sure that all
 * {@link PredictionContext} objects are shared among the DFA states. This makes
 * a big size difference.
 *
 * **THREAD SAFETY**
 *
 * The {@link ParserATNSimulator} locks on the {@link ATN#decisionToDFA} field when
 * it adds a new DFA object to that array. {@link #addDFAEdge}
 * locks on the DFA for the current decision when setting the
 * {@link DFAState#edges} field. {@link #addDFAState} locks on
 * the DFA for the current decision when looking up a DFA state to see if it
 * already exists. We must make sure that all requests to add DFA states that
 * are equivalent result in the same shared DFA object. This is because lots of
 * threads will be trying to update the DFA at once. The
 * {@link #addDFAState} method also locks inside the DFA lock
 * but this time on the shared context cache when it rebuilds the
 * configurations' {@link PredictionContext} objects using cached
 * subgraphs/nodes. No other locking occurs, even during DFA simulation. This is
 * safe as long as we can guarantee that all threads referencing
 * `s.edge[t]` get the same physical target {@link DFAState}, or
 * `undefined`. Once into the DFA, the DFA simulation does not reference the
 * {@link DFA#states} map. It follows the {@link DFAState#edges} field to new
 * targets. The DFA simulator will either find {@link DFAState#edges} to be
 * `undefined`, to be non-`undefined` and `dfa.edges[t]` undefined, or
 * `dfa.edges[t]` to be non-undefined. The
 * {@link #addDFAEdge} method could be racing to set the field
 * but in either case the DFA simulator works; if `undefined`, and requests ATN
 * simulation. It could also race trying to get `dfa.edges[t]`, but either
 * way it will work because it's not doing a test and set operation.
 *
 * **Starting with SLL then failing to combined SLL/LL (Two-Stage
 * Parsing)**
 *
 * Sam pointed out that if SLL does not give a syntax error, then there is no
 * point in doing full LL, which is slower. We only have to try LL if we get a
 * syntax error. For maximum speed, Sam starts the parser set to pure SLL
 * mode with the {@link BailErrorStrategy}:
 *
 * ```
 * parser.interpreter.{@link #setPredictionMode setPredictionMode}`(`{@link PredictionMode#SLL}`)`;
 * parser.{@link Parser#setErrorHandler setErrorHandler}(new {@link BailErrorStrategy}());
 * ```
 *
 * If it does not get a syntax error, then we're done. If it does get a syntax
 * error, we need to retry with the combined SLL/LL strategy.
 *
 * The reason this works is as follows. If there are no SLL conflicts, then the
 * grammar is SLL (at least for that input set). If there is an SLL conflict,
 * the full LL analysis must yield a set of viable alternatives which is a
 * subset of the alternatives reported by SLL. If the LL set is a singleton,
 * then the grammar is LL but not SLL. If the LL set is the same size as the SLL
 * set, the decision is SLL. If the LL set has size &gt; 1, then that decision
 * is truly ambiguous on the current input. If the LL set is smaller, then the
 * SLL conflict resolution might choose an alternative that the full LL would
 * rule out as a possibility based upon better context information. If that's
 * the case, then the SLL parse will definitely get an error because the full LL
 * analysis says it's not viable. If SLL conflict resolution chooses an
 * alternative within the LL set, them both SLL and LL would choose the same
 * alternative because they both choose the minimum of multiple conflicting
 * alternatives.
 *
 * Let's say we have a set of SLL conflicting alternatives `{1, 2, 3}` and
 * a smaller LL set called *s*. If *s* is `{2, 3}`, then SLL
 * parsing will get an error because SLL will pursue alternative 1. If
 * *s* is `{1, 2}` or `{1, 3}` then both SLL and LL will
 * choose the same alternative because alternative one is the minimum of either
 * set. If *s* is `{2}` or `{3}` then SLL will get a syntax
 * error. If *s* is `{1}` then SLL will succeed.
 *
 * Of course, if the input is invalid, then we will get an error for sure in
 * both SLL and LL parsing. Erroneous input will therefore require 2 passes over
 * the input.
 */ let $a3848e5489b578cc$var$ParserATNSimulator = class ParserATNSimulator extends $gZszX.ATNSimulator {
    getPredictionMode() {
        return this.predictionMode;
    }
    setPredictionMode(predictionMode) {
        this.predictionMode = predictionMode;
    }
    reset() {
    // intentionally empty
    }
    adaptivePredict(input, decision, outerContext, useContext) {
        if (useContext === undefined) useContext = false;
        let dfa = this.atn.decisionToDFA[decision];
        $9ir1r(dfa != null);
        if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
            let ll_1 = input.LA(1);
            if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                let key = (decision << 16 >>> 0) + ll_1;
                let alt = this.atn.LL1Table.get(key);
                if (alt != null) return alt;
            }
        }
        this.dfa = dfa;
        if (this.force_global_context) useContext = true;
        else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
        this.userWantsCtxSensitive = useContext || this.predictionMode !== $aC2pn.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
        if (outerContext == null) outerContext = $7EUlr.ParserRuleContext.emptyContext();
        let state;
        if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
        if (state == null) {
            if (outerContext == null) outerContext = $7EUlr.ParserRuleContext.emptyContext();
            if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            state = this.computeStartState(dfa, outerContext, useContext);
        }
        let m = input.mark();
        let index = input.index;
        try {
            let alt = this.execDFA(dfa, input, index, state);
            if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            return alt;
        } finally{
            this.dfa = undefined;
            input.seek(index);
            input.release(m);
        }
    }
    getStartState(dfa, input, outerContext, useContext) {
        if (!useContext) {
            if (dfa.isPrecedenceDfa) {
                // the start state for a precedence DFA depends on the current
                // parser precedence, and is provided by a DFA method.
                let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                if (state == null) return undefined;
                return new $XQBih.SimulatorState(outerContext, state, false, outerContext);
            } else {
                if (dfa.s0 == null) return undefined;
                return new $XQBih.SimulatorState(outerContext, dfa.s0, false, outerContext);
            }
        }
        if (!this.enable_global_context_dfa) return undefined;
        let remainingContext = outerContext;
        $9ir1r(outerContext != null);
        let s0;
        if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
        else s0 = dfa.s0full;
        while(remainingContext != null && s0 != null && s0.isContextSensitive){
            remainingContext = this.skipTailCalls(remainingContext);
            s0 = s0.getContextTarget(this.getReturnState(remainingContext));
            if (remainingContext.isEmpty) $9ir1r(s0 == null || !s0.isContextSensitive);
            else remainingContext = remainingContext.parent;
        }
        if (s0 == null) return undefined;
        return new $XQBih.SimulatorState(outerContext, s0, useContext, remainingContext);
    }
    execDFA(dfa, input, startIndex, state) {
        let outerContext = state.outerContext;
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
        if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
        let s = state.s0;
        let t = input.LA(1);
        let remainingOuterContext = state.remainingOuterContext;
        while(true){
            if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
            if (state.useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingOuterContext != null) {
                    remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                    next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                }
                if (next == null) {
                    // fail over to ATN
                    let initialState = new $XQBih.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                    return this.execATN(dfa, input, startIndex, initialState);
                }
                $9ir1r(remainingOuterContext != null);
                remainingOuterContext = remainingOuterContext.parent;
                s = next;
            }
            if (this.isAcceptState(s, state.useContext)) {
                if (s.predicates != null) {
                    if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                break;
            }
            // t is not updated if one of these states is reached
            $9ir1r(!this.isAcceptState(s, state.useContext));
            // if no edge, pop over to ATN interpreter, update DFA and return
            let target = this.getExistingTargetState(s, t);
            if (target == null) {
                if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                let alt;
                if (ParserATNSimulator.dfa_debug) {
                    let interval = $kCyYI.Interval.of(startIndex, this._parser.inputStream.index);
                    console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                }
                let initialState = new $XQBih.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                alt = this.execATN(dfa, input, startIndex, initialState);
                if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                // action already executed
                if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                return alt; // we've updated DFA, exec'd action, and have our deepest answer
            } else if (target === $gZszX.ATNSimulator.ERROR) {
                let errorState = new $XQBih.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                return this.handleNoViableAlt(input, startIndex, errorState);
            }
            s = target;
            if (!this.isAcceptState(s, state.useContext) && t !== $eK8do.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
        //		if ( acceptState==null ) {
        //			if ( debug ) System.out.println("!!! no viable alt in dfa");
        //			return -1;
        //		}
        if (!state.useContext && s.configs.conflictInfo != null) {
            if (dfa.atnStartState instanceof $frUMD.DecisionState) {
                if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                else {
                    $9ir1r(!state.useContext);
                    // Before attempting full context prediction, check to see if there are
                    // disambiguating or validating predicates to evaluate which allow an
                    // immediate decision
                    let conflictingAlts;
                    let predicates = s.predicates;
                    if (predicates != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                        if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                    if (this.reportAmbiguities) {
                        let conflictState = new $XQBih.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                        this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                    }
                    input.seek(startIndex);
                    return this.adaptivePredict(input, dfa.decision, outerContext, true);
                }
            }
        }
        // Before jumping to prediction, check to see if there are
        // disambiguating or validating predicates to evaluate
        let predicates = s.predicates;
        if (predicates != null) {
            let stopIndex = input.index;
            if (startIndex !== stopIndex) input.seek(startIndex);
            let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $aC2pn.PredictionMode.LL_EXACT_AMBIG_DETECTION);
            switch(alts.cardinality()){
                case 0:
                    throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                case 1:
                    return alts.nextSetBit(0);
                default:
                    // report ambiguity after predicate evaluation to make sure the correct
                    // set of ambig alts is reported.
                    if (startIndex !== stopIndex) input.seek(stopIndex);
                    this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                    return alts.nextSetBit(0);
            }
        }
        if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
        return s.prediction;
    }
    /**
     * Determines if a particular DFA state should be treated as an accept state
     * for the current prediction mode. In addition to the `useContext`
     * parameter, the {@link #getPredictionMode()} method provides the
     * prediction mode controlling the prediction algorithm as a whole.
     *
     * The default implementation simply returns the value of
     * `DFAState.isAcceptState` except for conflict states when
     * `useContext` is `true` and {@link #getPredictionMode()} is
     * {@link PredictionMode#LL_EXACT_AMBIG_DETECTION}. In that case, only
     * conflict states where {@link ATNConfigSet#isExactConflict} is
     * `true` are considered accept states.
     *
     * @param state The DFA state to check.
     * @param useContext `true` if the prediction algorithm is currently
     * considering the full parser context; otherwise, `false` if the
     * algorithm is currently performing a local context prediction.
     *
     * @returns `true` if the specified `state` is an accept state;
     * otherwise, `false`.
     */ isAcceptState(state, useContext) {
        if (!state.isAcceptState) return false;
        if (state.configs.conflictingAlts == null) // unambiguous
        return true;
        // More picky when we need exact conflicts
        if (useContext && this.predictionMode === $aC2pn.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
        return true;
    }
    /** Performs ATN simulation to compute a predicted alternative based
     *  upon the remaining input, but also updates the DFA cache to avoid
     *  having to traverse the ATN again for the same input sequence.
     *
     * There are some key conditions we're looking for after computing a new
     * set of ATN configs (proposed DFA state):
     *
     * * if the set is empty, there is no viable alternative for current symbol
     * * does the state uniquely predict an alternative?
     * * does the state have a conflict that would prevent us from
     *   putting it on the work list?
     * * if in non-greedy decision is there a config at a rule stop state?
     *
     * We also have some key operations to do:
     *
     * * add an edge from previous DFA state to potentially new DFA state, D,
     *   upon current symbol but only if adding to work list, which means in all
     *   cases except no viable alternative (and possibly non-greedy decisions?)
     * * collecting predicates and adding semantic context to DFA accept states
     * * adding rule context to context-sensitive DFA accept states
     * * consuming an input symbol
     * * reporting a conflict
     * * reporting an ambiguity
     * * reporting a context sensitivity
     * * reporting insufficient predicates
     *
     * We should isolate those operations, which are side-effecting, to the
     * main work loop. We can isolate lots of code into other functions, but
     * they should be side effect free. They can return package that
     * indicates whether we should report something, whether we need to add a
     * DFA edge, whether we need to augment accept state with semantic
     * context or rule invocation context. Actually, it seems like we always
     * add predicates if they exist, so that can simply be done in the main
     * loop for any accept state creation or modification request.
     *
     * cover these cases:
     *   dead end
     *   single alt
     *   single alt + preds
     *   conflict
     *   conflict + preds
     *
     * TODO: greedy + those
     */ execATN(dfa, input, startIndex, initialState) {
        if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
        let outerContext = initialState.outerContext;
        let useContext = initialState.useContext;
        let t = input.LA(1);
        let previous = initialState;
        let contextCache = new $fAz7Q.PredictionContextCache();
        while(true){
            let nextState = this.computeReachSet(dfa, previous, t, contextCache);
            if (nextState == null) {
                this.setDFAEdge(previous.s0, input.LA(1), $gZszX.ATNSimulator.ERROR);
                return this.handleNoViableAlt(input, startIndex, previous);
            }
            let D = nextState.s0;
            // predicted alt => accept state
            $9ir1r(D.isAcceptState || D.prediction === $EKDdQ.ATN.INVALID_ALT_NUMBER);
            // conflicted => accept state
            $9ir1r(D.isAcceptState || D.configs.conflictInfo == null);
            if (this.isAcceptState(D, useContext)) {
                let conflictingAlts = D.configs.conflictingAlts;
                let predictedAlt = conflictingAlts == null ? D.prediction : $EKDdQ.ATN.INVALID_ALT_NUMBER;
                if (predictedAlt !== $EKDdQ.ATN.INVALID_ALT_NUMBER) {
                    if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                        if (t >= 0 && t <= $a3848e5489b578cc$var$MAX_SHORT_VALUE) {
                            let key = (dfa.decision << 16 >>> 0) + t;
                            this.atn.LL1Table.set(key, predictedAlt);
                        }
                    }
                    if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                }
                predictedAlt = D.prediction;
                //				int k = input.index - startIndex + 1; // how much input we used
                //				System.out.println("used k="+k);
                let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                if (attemptFullContext) // Only exact conflicts are known to be ambiguous when local
                // prediction does not step out of the decision rule.
                attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                if (D.configs.hasSemanticContext) {
                    let predPredictions = D.predicates;
                    if (predPredictions != null) {
                        let conflictIndex = input.index;
                        if (conflictIndex !== startIndex) input.seek(startIndex);
                        // use complete evaluation here if we'll want to retry with full context if still ambiguous
                        conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                        switch(conflictingAlts.cardinality()){
                            case 0:
                                throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                            case 1:
                                return conflictingAlts.nextSetBit(0);
                            default:
                                break;
                        }
                        if (conflictIndex !== startIndex) // restore the index so reporting the fallback to full
                        // context occurs with the index at the correct spot
                        input.seek(conflictIndex);
                    }
                }
                if (!attemptFullContext) {
                    if (conflictingAlts != null) {
                        if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                        predictedAlt = conflictingAlts.nextSetBit(0);
                    }
                    return predictedAlt;
                } else {
                    $9ir1r(!useContext);
                    $9ir1r(this.isAcceptState(D, false));
                    if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                    let fullContextState = this.computeStartState(dfa, outerContext, true);
                    if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                    input.seek(startIndex);
                    return this.execATN(dfa, input, startIndex, fullContextState);
                }
            }
            previous = nextState;
            if (t !== $eK8do.IntStream.EOF) {
                input.consume();
                t = input.LA(1);
            }
        }
    }
    /**
     * This method is used to improve the localization of error messages by
     * choosing an alternative rather than throwing a
     * {@link NoViableAltException} in particular prediction scenarios where the
     * {@link #ERROR} state was reached during ATN simulation.
     *
     * The default implementation of this method uses the following
     * algorithm to identify an ATN configuration which successfully parsed the
     * decision entry rule. Choosing such an alternative ensures that the
     * {@link ParserRuleContext} returned by the calling rule will be complete
     * and valid, and the syntax error will be reported later at a more
     * localized location.
     *
     * * If no configuration in `configs` reached the end of the
     *   decision rule, return {@link ATN#INVALID_ALT_NUMBER}.
     * * If all configurations in `configs` which reached the end of the
     *   decision rule predict the same alternative, return that alternative.
     * * If the configurations in `configs` which reached the end of the
     *   decision rule predict multiple alternatives (call this *S*),
     *   choose an alternative in the following order.
     *
     *     1. Filter the configurations in `configs` to only those
     *        configurations which remain viable after evaluating semantic predicates.
     *        If the set of these filtered configurations which also reached the end of
     *        the decision rule is not empty, return the minimum alternative
     *        represented in this set.
     *     1. Otherwise, choose the minimum alternative in *S*.
     *
     * In some scenarios, the algorithm described above could predict an
     * alternative which will result in a {@link FailedPredicateException} in
     * parser. Specifically, this could occur if the *only* configuration
     * capable of successfully parsing to the end of the decision rule is
     * blocked by a semantic predicate. By choosing this alternative within
     * {@link #adaptivePredict} instead of throwing a
     * {@link NoViableAltException}, the resulting
     * {@link FailedPredicateException} in the parser will identify the specific
     * predicate which is preventing the parser from successfully parsing the
     * decision rule, which helps developers identify and correct logic errors
     * in semantic predicates.
     *
     * @param input The input {@link TokenStream}
     * @param startIndex The start index for the current prediction, which is
     * the input index where any semantic context in `configs` should be
     * evaluated
     * @param previous The ATN simulation state immediately before the
     * {@link #ERROR} state was reached
     *
     * @returns The value to return from {@link #adaptivePredict}, or
     * {@link ATN#INVALID_ALT_NUMBER} if a suitable alternative was not
     * identified and {@link #adaptivePredict} should report an error instead.
     */ handleNoViableAlt(input, startIndex, previous) {
        if (previous.s0 != null) {
            let alts = new $6YKio.BitSet();
            let maxAlt = 0;
            for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4eVci.RuleStopState) {
                alts.set(config.alt);
                maxAlt = Math.max(maxAlt, config.alt);
            }
            switch(alts.cardinality()){
                case 0:
                    break;
                case 1:
                    return alts.nextSetBit(0);
                default:
                    if (!previous.s0.configs.hasSemanticContext) // configs doesn't contain any predicates, so the predicate
                    // filtering code below would be pointless
                    return alts.nextSetBit(0);
                    /*
                     * Try to find a configuration set that not only dipped into the outer
                     * context, but also isn't eliminated by a predicate.
                     */ let filteredConfigs = new $51XoR.ATNConfigSet();
                    for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4eVci.RuleStopState) filteredConfigs.add(config);
                    /* The following code blocks are adapted from predicateDFAState with
                     * the following key changes.
                     *
                     *  1. The code operates on an ATNConfigSet rather than a DFAState.
                     *  2. Predicates are collected for all alternatives represented in
                     *     filteredConfigs, rather than restricting the evaluation to
                     *     conflicting and/or unique configurations.
                     */ let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                    if (altToPred != null) {
                        let predicates = this.getPredicatePredictions(alts, altToPred);
                        if (predicates != null) {
                            let stopIndex = input.index;
                            try {
                                input.seek(startIndex);
                                let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                            } finally{
                                input.seek(stopIndex);
                            }
                        }
                    }
                    return alts.nextSetBit(0);
            }
        }
        throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
    }
    computeReachSet(dfa, previous, t, contextCache) {
        let useContext = previous.useContext;
        let remainingGlobalContext = previous.remainingOuterContext;
        let s = previous.s0;
        if (useContext) while(s.isContextSymbol(t)){
            let next;
            if (remainingGlobalContext != null) {
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
            }
            if (next == null) break;
            $9ir1r(remainingGlobalContext != null);
            remainingGlobalContext = remainingGlobalContext.parent;
            s = next;
        }
        $9ir1r(!this.isAcceptState(s, useContext));
        if (this.isAcceptState(s, useContext)) return new $XQBih.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
        let s0 = s;
        let target = this.getExistingTargetState(s0, t);
        if (target == null) {
            let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
            target = result[0];
            remainingGlobalContext = result[1];
        }
        if (target === $gZszX.ATNSimulator.ERROR) return undefined;
        $9ir1r(!useContext || !target.configs.dipsIntoOuterContext);
        return new $XQBih.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
    }
    /**
     * Get an existing target state for an edge in the DFA. If the target state
     * for the edge has not yet been computed or is otherwise not available,
     * this method returns `undefined`.
     *
     * @param s The current DFA state
     * @param t The next input symbol
     * @returns The existing target DFA state for the given input symbol
     * `t`, or `undefined` if the target state for this edge is not
     * already cached
     */ getExistingTargetState(s, t) {
        return s.getTarget(t);
    }
    /**
     * Compute a target state for an edge in the DFA, and attempt to add the
     * computed state and corresponding edge to the DFA.
     *
     * @param dfa
     * @param s The current DFA state
     * @param remainingGlobalContext
     * @param t The next input symbol
     * @param useContext
     * @param contextCache
     *
     * @returns The computed target DFA state for the given input symbol
     * `t`. If `t` does not lead to a valid DFA state, this method
     * returns {@link #ERROR}.
     */ computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
        let closureConfigs = s.configs.toArray();
        let contextElements;
        let reach = new $51XoR.ATNConfigSet();
        let stepIntoGlobal;
        do {
            let hasMoreContext = !useContext || remainingGlobalContext != null;
            if (!hasMoreContext) reach.isOutermostConfigSet = true;
            let reachIntermediate = new $51XoR.ATNConfigSet();
            /* Configurations already in a rule stop state indicate reaching the end
             * of the decision rule (local context) or end of the start rule (full
             * context). Once reached, these configurations are never updated by a
             * closure operation, so they are handled separately for the performance
             * advantage of having a smaller intermediate set when calling closure.
             *
             * For full-context reach operations, separate handling is required to
             * ensure that the alternative matching the longest overall sequence is
             * chosen when multiple such configurations can match the input.
             */ let skippedStopStates;
            for (let c of closureConfigs){
                if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                if (c.state instanceof $4eVci.RuleStopState) {
                    $9ir1r(c.context.isEmpty);
                    if (useContext && !c.reachesIntoOuterContext || t === $eK8do.IntStream.EOF) {
                        if (skippedStopStates == null) skippedStopStates = [];
                        skippedStopStates.push(c);
                    }
                    continue;
                }
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(c, trans, t);
                    if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                }
            }
            /* This block optimizes the reach operation for intermediate sets which
             * trivially indicate a termination state for the overall
             * adaptivePredict operation.
             *
             * The conditions assume that intermediate
             * contains all configurations relevant to the reach set, but this
             * condition is not true when one or more configurations have been
             * withheld in skippedStopStates, or when the current symbol is EOF.
             */ if (this.optimize_unique_closure && skippedStopStates == null && t !== $lxPhv.Token.EOF && reachIntermediate.uniqueAlt !== $EKDdQ.ATN.INVALID_ALT_NUMBER) {
                reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                reach = reachIntermediate;
                break;
            }
            /* If the reach set could not be trivially determined, perform a closure
             * operation on the intermediate set to compute its initial value.
             */ let collectPredicates = false;
            let treatEofAsEpsilon = t === $lxPhv.Token.EOF;
            this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
            stepIntoGlobal = reach.dipsIntoOuterContext;
            if (t === $eK8do.IntStream.EOF) /* After consuming EOF no additional input is possible, so we are
                 * only interested in configurations which reached the end of the
                 * decision rule (local context) or end of the start rule (full
                 * context). Update reach to contain only these configurations. This
                 * handles both explicit EOF transitions in the grammar and implicit
                 * EOF transitions following the end of the decision or start rule.
                 *
                 * This is handled before the configurations in skippedStopStates,
                 * because any configurations potentially added from that list are
                 * already guaranteed to meet this condition whether or not it's
                 * required.
                 */ reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
            /* If skippedStopStates is not undefined, then it contains at least one
             * configuration. For full-context reach operations, these
             * configurations reached the end of the start rule, in which case we
             * only add them back to reach if no configuration during the current
             * closure operation reached such a state. This ensures adaptivePredict
             * chooses an alternative matching the longest overall sequence when
             * multiple alternatives are viable.
             */ if (skippedStopStates != null && (!useContext || !$aC2pn.PredictionMode.hasConfigInRuleStopState(reach))) {
                $9ir1r(skippedStopStates.length > 0);
                for (let c of skippedStopStates)reach.add(c, contextCache);
            }
            if (useContext && stepIntoGlobal) {
                reach.clear();
                // We know remainingGlobalContext is not undefined at this point (why?)
                remainingGlobalContext;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (contextElements == null) contextElements = new $kTbzO.IntegerList();
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                contextElements.add(nextContextElement);
                if (nextContextElement !== $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
            }
        }while (useContext && stepIntoGlobal);
        if (reach.isEmpty) {
            this.setDFAEdge(s, t, $gZszX.ATNSimulator.ERROR);
            return [
                $gZszX.ATNSimulator.ERROR,
                remainingGlobalContext
            ];
        }
        let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
        return [
            result,
            remainingGlobalContext
        ];
    }
    /**
     * Return a configuration set containing only the configurations from
     * `configs` which are in a {@link RuleStopState}. If all
     * configurations in `configs` are already in a rule stop state, this
     * method simply returns `configs`.
     *
     * @param configs the configuration set to update
     * @param contextCache the {@link PredictionContext} cache
     *
     * @returns `configs` if all configurations in `configs` are in a
     * rule stop state, otherwise return a new configuration set containing only
     * the configurations from `configs` which are in a rule stop state
     */ removeAllConfigsNotInRuleStopState(configs, contextCache) {
        if ($aC2pn.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
        let result = new $51XoR.ATNConfigSet();
        for (let config of configs){
            if (!(config.state instanceof $4eVci.RuleStopState)) continue;
            result.add(config, contextCache);
        }
        return result;
    }
    computeStartState(dfa, globalContext, useContext) {
        let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
        if (s0 != null) {
            if (!useContext) return new $XQBih.SimulatorState(globalContext, s0, useContext, globalContext);
            s0.setContextSensitive(this.atn);
        }
        let decision = dfa.decision;
        // @NotNull
        let p = dfa.atnStartState;
        let previousContext = 0;
        let remainingGlobalContext = globalContext;
        let initialContext = useContext ? $ca31u.PredictionContext.EMPTY_FULL : $ca31u.PredictionContext.EMPTY_LOCAL; // always at least the implicit call to start rule
        let contextCache = new $fAz7Q.PredictionContextCache();
        if (useContext) {
            if (!this.enable_global_context_dfa) {
                while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                    previousContext = $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
            }
            while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                let next;
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) {
                    next = s0.getContextTarget($ca31u.PredictionContext.EMPTY_FULL_STATE_KEY);
                    previousContext = $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY;
                    remainingGlobalContext = undefined;
                } else {
                    previousContext = this.getReturnState(remainingGlobalContext);
                    next = s0.getContextTarget(previousContext);
                    initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                    remainingGlobalContext = remainingGlobalContext.parent;
                }
                if (next == null) break;
                s0 = next;
            }
        }
        if (s0 != null && !s0.isContextSensitive) return new $XQBih.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        let configs = new $51XoR.ATNConfigSet();
        while(true){
            let reachIntermediate = new $51XoR.ATNConfigSet();
            let n = p.numberOfTransitions;
            for(let ti = 0; ti < n; ti++){
                // for each transition
                let target = p.transition(ti).target;
                reachIntermediate.add($gpoJu.ATNConfig.create(target, ti + 1, initialContext));
            }
            let hasMoreContext = remainingGlobalContext != null;
            if (!hasMoreContext) configs.isOutermostConfigSet = true;
            let collectPredicates = true;
            this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
            let stepIntoGlobal = configs.dipsIntoOuterContext;
            let next;
            if (useContext && !this.enable_global_context_dfa) {
                s0 = this.addDFAState(dfa, configs, contextCache);
                break;
            } else if (s0 == null) {
                if (!dfa.isPrecedenceDfa) {
                    next = this.addDFAState(dfa, configs, contextCache);
                    if (useContext) {
                        if (!dfa.s0full) dfa.s0full = next;
                        else next = dfa.s0full;
                    } else if (!dfa.s0) dfa.s0 = next;
                    else next = dfa.s0;
                } else {
                    /* If this is a precedence DFA, we use applyPrecedenceFilter
                     * to convert the computed start state to a precedence start
                     * state. We then use DFA.setPrecedenceStartState to set the
                     * appropriate start state for the precedence level rather
                     * than simply setting DFA.s0.
                     */ configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                }
            } else {
                if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                next = this.addDFAState(dfa, configs, contextCache);
                s0.setContextTarget(previousContext, next);
            }
            s0 = next;
            if (!useContext || !stepIntoGlobal) break;
            // TODO: make sure it distinguishes empty stack states
            next.setContextSensitive(this.atn);
            // We know remainingGlobalContext is not undefined at this point (why?)
            remainingGlobalContext;
            configs.clear();
            remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
            let nextContextElement = this.getReturnState(remainingGlobalContext);
            if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
            else remainingGlobalContext = remainingGlobalContext.parent;
            if (nextContextElement !== $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
            previousContext = nextContextElement;
        }
        return new $XQBih.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
    }
    /**
     * This method transforms the start state computed by
     * {@link #computeStartState} to the special start state used by a
     * precedence DFA for a particular precedence value. The transformation
     * process applies the following changes to the start state's configuration
     * set.
     *
     * 1. Evaluate the precedence predicates for each configuration using
     *    {@link SemanticContext#evalPrecedence}.
     * 1. When {@link ATNConfig#isPrecedenceFilterSuppressed} is `false`,
     *    remove all configurations which predict an alternative greater than 1,
     *    for which another configuration that predicts alternative 1 is in the
     *    same ATN state with the same prediction context. This transformation is
     *    valid for the following reasons:
     *
     *     * The closure block cannot contain any epsilon transitions which bypass
     *       the body of the closure, so all states reachable via alternative 1 are
     *       part of the precedence alternatives of the transformed left-recursive
     *       rule.
     *     * The "primary" portion of a left recursive rule cannot contain an
     *       epsilon transition, so the only way an alternative other than 1 can exist
     *       in a state that is also reachable via alternative 1 is by nesting calls
     *       to the left-recursive rule, with the outer calls not being at the
     *       preferred precedence level. The
     *       {@link ATNConfig#isPrecedenceFilterSuppressed} property marks ATN
     *       configurations which do not meet this condition, and therefore are not
     *       eligible for elimination during the filtering process.
     *
     * The prediction context must be considered by this filter to address
     * situations like the following.
     *
     * ```antlr
     * grammar TA;
     * prog: statement* EOF;
     * statement: letterA | statement letterA 'b' ;
     * letterA: 'a';
     * ```
     *
     * If the above grammar, the ATN state immediately before the token
     * reference `'a'` in `letterA` is reachable from the left edge
     * of both the primary and closure blocks of the left-recursive rule
     * `statement`. The prediction context associated with each of these
     * configurations distinguishes between them, and prevents the alternative
     * which stepped out to `prog` (and then back in to `statement`
     * from being eliminated by the filter.
     *
     * @param configs The configuration set computed by
     * {@link #computeStartState} as the start state for the DFA.
     * @returns The transformed configuration set representing the start state
     * for a precedence DFA at a particular precedence level (determined by
     * calling {@link Parser#getPrecedence}).
     */ applyPrecedenceFilter(configs, globalContext, contextCache) {
        let statesFromAlt1 = new Map();
        let configSet = new $51XoR.ATNConfigSet();
        for (let config of configs){
            // handle alt 1 first
            if (config.alt !== 1) continue;
            let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
            if (updatedContext == null) continue;
            statesFromAlt1.set(config.state.stateNumber, config.context);
            if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
            else configSet.add(config, contextCache);
        }
        for (let config of configs){
            if (config.alt === 1) continue;
            if (!config.isPrecedenceFilterSuppressed) {
                /* In the future, this elimination step could be updated to also
                 * filter the prediction context for alternatives predicting alt>1
                 * (basically a graph subtraction algorithm).
                 */ let context = statesFromAlt1.get(config.state.stateNumber);
                if (context != null && context.equals(config.context)) continue;
            }
            configSet.add(config, contextCache);
        }
        return configSet;
    }
    getReachableTarget(source, trans, ttype) {
        if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
        return undefined;
    }
    /** collect and set D's semantic context */ predicateDFAState(D, configs, nalts) {
        let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
        if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
        if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
        let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
        // altToPred[uniqueAlt] is now our validating predicate (if any)
        let predPredictions;
        if (altToPred != null) {
            // we have a validating predicate; test it
            // Update DFA so reach becomes accept state with predicate
            predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
            D.predicates = predPredictions;
        }
        return predPredictions;
    }
    getPredsForAmbigAlts(ambigAlts, configs, nalts) {
        // REACH=[1|1|[]|0:0, 1|2|[]|0:1]
        /* altToPred starts as an array of all undefined contexts. The entry at index i
         * corresponds to alternative i. altToPred[i] may have one of three values:
         *   1. undefined: no ATNConfig c is found such that c.alt===i
         *   2. SemanticContext.NONE: At least one ATNConfig c exists such that
         *      c.alt===i and c.semanticContext===SemanticContext.NONE. In other words,
         *      alt i has at least one unpredicated config.
         *   3. Non-NONE Semantic Context: There exists at least one, and for all
         *      ATNConfig c such that c.alt===i, c.semanticContext!==SemanticContext.NONE.
         *
         * From this, it is clear that NONE||anything==NONE.
         */ let altToPred = new Array(nalts + 1);
        let n = altToPred.length;
        for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $cAJ3R.SemanticContext.or(altToPred[c.alt], c.semanticContext);
        let nPredAlts = 0;
        for(let i = 0; i < n; i++){
            if (altToPred[i] == null) altToPred[i] = $cAJ3R.SemanticContext.NONE;
            else if (altToPred[i] !== $cAJ3R.SemanticContext.NONE) nPredAlts++;
        }
        // At this point we know `altToPred` doesn't contain any undefined entries
        let result = altToPred;
        // nonambig alts are undefined in result
        if (nPredAlts === 0) result = undefined;
        if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $l7ijV.Arrays.toString(result) : "undefined"));
        return result;
    }
    getPredicatePredictions(ambigAlts, altToPred) {
        let pairs = [];
        let containsPredicate = false;
        for(let i = 1; i < altToPred.length; i++){
            let pred = altToPred[i];
            // unpredicated is indicated by SemanticContext.NONE
            $9ir1r(pred != null);
            // find first unpredicated but ambig alternative, if any.
            // Only ambiguous alternatives will have SemanticContext.NONE.
            // Any unambig alts or ambig naked alts after first ambig naked are ignored
            // (undefined, i) means alt i is the default prediction
            // if no (undefined, i), then no default prediction.
            if (ambigAlts != null && ambigAlts.get(i) && pred === $cAJ3R.SemanticContext.NONE) pairs.push(new $iIwZu.DFAState.PredPrediction(pred, i));
            else if (pred !== $cAJ3R.SemanticContext.NONE) {
                containsPredicate = true;
                pairs.push(new $iIwZu.DFAState.PredPrediction(pred, i));
            }
        }
        if (!containsPredicate) return undefined;
        //		System.out.println(Arrays.toString(altToPred)+"->"+pairs);
        return pairs;
    }
    /** Look through a list of predicate/alt pairs, returning alts for the
     *  pairs that win. An `undefined` predicate indicates an alt containing an
     *  unpredicated config which behaves as "always true."
     */ evalSemanticContext(predPredictions, outerContext, complete) {
        let predictions = new $6YKio.BitSet();
        for (let pair of predPredictions){
            if (pair.pred === $cAJ3R.SemanticContext.NONE) {
                predictions.set(pair.alt);
                if (!complete) break;
                continue;
            }
            let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
            if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
            if (evaluatedResult) {
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                predictions.set(pair.alt);
                if (!complete) break;
            }
        }
        return predictions;
    }
    /**
     * Evaluate a semantic context within a specific parser context.
     *
     * This method might not be called for every semantic context evaluated
     * during the prediction process. In particular, we currently do not
     * evaluate the following but it may change in the future:
     *
     * * Precedence predicates (represented by
     *   {@link SemanticContext.PrecedencePredicate}) are not currently evaluated
     *   through this method.
     * * Operator predicates (represented by {@link SemanticContext.AND} and
     *   {@link SemanticContext.OR}) are evaluated as a single semantic
     *   context, rather than evaluating the operands individually.
     *   Implementations which require evaluation results from individual
     *   predicates should override this method to explicitly handle evaluation of
     *   the operands within operator predicates.
     *
     * @param pred The semantic context to evaluate
     * @param parserCallStack The parser context in which to evaluate the
     * semantic context
     * @param alt The alternative which is guarded by `pred`
     *
     * @since 4.3
     */ evalSemanticContextImpl(pred, parserCallStack, alt) {
        return pred.eval(this._parser, parserCallStack);
    }
    /* TODO: If we are doing predicates, there is no point in pursuing
         closure operations if we reach a DFA state that uniquely predicts
         alternative. We will not be caching that DFA state and it is a
         waste to pursue the closure. Might have to advance when we do
         ambig detection thought :(
          */ closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
        if (contextCache == null) contextCache = $fAz7Q.PredictionContextCache.UNCACHED;
        let currentConfigs = sourceConfigs;
        let closureBusy = new $eEYRR.Array2DHashSet($gxIPs.ObjectEqualityComparator.INSTANCE);
        while(currentConfigs.size > 0){
            let intermediate = new $51XoR.ATNConfigSet();
            for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
            currentConfigs = intermediate;
        }
    }
    closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
        if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
        if (config.state instanceof $4eVci.RuleStopState) {
            // We hit rule end. If we have context info, use it
            if (!config.context.isEmpty) {
                let hasEmpty = config.context.hasEmpty;
                let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                for(let i = 0; i < nonEmptySize; i++){
                    let newContext = config.context.getParent(i); // "pop" return state
                    let returnState = this.atn.states[config.context.getReturnState(i)];
                    let c = $gpoJu.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                    // While we have context to pop back from, we may have
                    // gotten that context AFTER having fallen off a rule.
                    // Make sure we track that we are now out of context.
                    c.outerContextDepth = config.outerContextDepth;
                    c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                    $9ir1r(depth > $a3848e5489b578cc$var$MIN_INTEGER_VALUE);
                    this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                }
                if (!hasEmpty || !hasMoreContexts) return;
                config = config.transform(config.state, false, $ca31u.PredictionContext.EMPTY_LOCAL);
            } else if (!hasMoreContexts) {
                configs.add(config, contextCache);
                return;
            } else {
                // else if we have no context info, just chase follow links (if greedy)
                if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                if (config.context === $ca31u.PredictionContext.EMPTY_FULL) // no need to keep full context overhead when we step out
                config = config.transform(config.state, false, $ca31u.PredictionContext.EMPTY_LOCAL);
                else if (!config.reachesIntoOuterContext && $ca31u.PredictionContext.isEmptyLocal(config.context)) // add stop state when leaving decision rule for the first time
                configs.add(config, contextCache);
            }
        }
        let p = config.state;
        // optimization
        if (!p.onlyHasEpsilonTransitions) {
            configs.add(config, contextCache);
            // make sure to not return here, because EOF transitions can act as
            // both epsilon transitions and non-epsilon transitions.
            if (ParserATNSimulator.debug) console.log("added config " + configs);
        }
        for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
            // This block implements first-edge elimination of ambiguous LR
            // alternatives as part of dynamic disambiguation during prediction.
            // See antlr/antlr4#1398.
            if (i === 0 && p.stateType === $jW0J3.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                let precedenceDecision = p;
                // When suppress is true, it means the outgoing edge i==0 is
                // ambiguous with the outgoing edge i==1, and thus the closure
                // operation can dynamically disambiguate by suppressing this
                // edge during the closure operation.
                let suppress = true;
                for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                    suppress = false;
                    break;
                }
                if (suppress) continue;
            }
            let t = p.getOptimizedTransition(i);
            let continueCollecting = !(t instanceof $1rhri.ActionTransition) && collectPredicates;
            let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
            if (c != null) {
                if (t instanceof $1q038.RuleTransition) {
                    if (intermediate != null && !collectPredicates) {
                        intermediate.add(c, contextCache);
                        continue;
                    }
                }
                let newDepth = depth;
                if (config.state instanceof $4eVci.RuleStopState) {
                    // target fell off end of rule; mark resulting c as having dipped into outer context
                    // We can't get here if incoming config was rule stop and we had context
                    // track how far we dip into outer context.  Might
                    // come in handy and we avoid evaluating context dependent
                    // preds if this is > 0.
                    if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                        let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                        if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                    }
                    c.outerContextDepth = c.outerContextDepth + 1;
                    if (!closureBusy.add(c)) continue;
                    $9ir1r(newDepth > $a3848e5489b578cc$var$MIN_INTEGER_VALUE);
                    newDepth--;
                    if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                } else if (t instanceof $1q038.RuleTransition) {
                    if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$ca31u.PredictionContext.isEmptyLocal(config.context))) {
                        $9ir1r(c.context === config.context);
                        if (newDepth === 0) {
                            // the pop/push of a tail call would keep the depth
                            // constant, except we latch if it goes negative
                            newDepth--;
                            if (!this.tail_call_preserves_sll && $ca31u.PredictionContext.isEmptyLocal(config.context)) // make sure the SLL config "dips into the outer context" or prediction may not fall back to LL on conflict
                            c.outerContextDepth = c.outerContextDepth + 1;
                        }
                    } else // latch when newDepth goes negative - once we step out of the entry context we can't return
                    if (newDepth >= 0) newDepth++;
                } else {
                    if (!t.isEpsilon && !closureBusy.add(c)) continue;
                }
                this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
            }
        }
    }
    getRuleName(index) {
        if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
        return "<rule " + index + ">";
    }
    getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
        switch(t.serializationType){
            case 3 /* RULE */ :
                return this.ruleTransition(config, t, contextCache);
            case 10 /* PRECEDENCE */ :
                return this.precedenceTransition(config, t, collectPredicates, inContext);
            case 4 /* PREDICATE */ :
                return this.predTransition(config, t, collectPredicates, inContext);
            case 6 /* ACTION */ :
                return this.actionTransition(config, t);
            case 1 /* EPSILON */ :
                return config.transform(t.target, false);
            case 5 /* ATOM */ :
            case 2 /* RANGE */ :
            case 7 /* SET */ :
                // EOF transitions act like epsilon transitions after the first EOF
                // transition is traversed
                if (treatEofAsEpsilon) {
                    if (t.matches($lxPhv.Token.EOF, 0, 1)) return config.transform(t.target, false);
                }
                return undefined;
            default:
                return undefined;
        }
    }
    actionTransition(config, t) {
        if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
        return config.transform(t.target, false);
    }
    precedenceTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && inContext) {
            let newSemCtx = $cAJ3R.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    predTransition(config, pt, collectPredicates, inContext) {
        if (ParserATNSimulator.debug) {
            console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
            if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
        }
        let c;
        if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
            let newSemCtx = $cAJ3R.SemanticContext.and(config.semanticContext, pt.predicate);
            c = config.transform(pt.target, false, newSemCtx);
        } else c = config.transform(pt.target, false);
        if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
        return c;
    }
    ruleTransition(config, t, contextCache) {
        if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
        let returnState = t.followState;
        let newContext;
        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$ca31u.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
        else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
        else newContext = config.context.getChild(returnState.stateNumber);
        return config.transform(t.target, false, newContext);
    }
    isConflicted(configset, contextCache) {
        if (configset.uniqueAlt !== $EKDdQ.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
        let configs = configset.toArray();
        configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
        let exact = !configset.dipsIntoOuterContext;
        let alts = new $6YKio.BitSet();
        let minAlt = configs[0].alt;
        alts.set(minAlt);
        /* Quick checks come first (single pass, no context joining):
         *  1. Make sure first config in the sorted list predicts the minimum
         *     represented alternative.
         *  2. Make sure every represented state has at least one configuration
         *     which predicts the minimum represented alternative.
         *  3. (exact only) make sure every represented state has at least one
         *     configuration which predicts each represented alternative.
         */ // quick check 1 & 2 => if we assume #1 holds and check #2 against the
        // minAlt from the first state, #2 will fail if the assumption was
        // incorrect
        let currentState = configs[0].state.nonStopStateNumber;
        for (let config of configs){
            let stateNumber = config.state.nonStopStateNumber;
            if (stateNumber !== currentState) {
                if (config.alt !== minAlt) return undefined;
                currentState = stateNumber;
            }
        }
        let representedAlts;
        if (exact) {
            currentState = configs[0].state.nonStopStateNumber;
            // get the represented alternatives of the first state
            representedAlts = new $6YKio.BitSet();
            let maxAlt = minAlt;
            for (let config of configs){
                if (config.state.nonStopStateNumber !== currentState) break;
                let alt = config.alt;
                representedAlts.set(alt);
                maxAlt = alt;
            }
            // quick check #3:
            currentState = configs[0].state.nonStopStateNumber;
            let currentAlt = minAlt;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                let alt = config.alt;
                if (stateNumber !== currentState) {
                    if (currentAlt !== maxAlt) {
                        exact = false;
                        break;
                    }
                    currentState = stateNumber;
                    currentAlt = minAlt;
                } else if (alt !== currentAlt) {
                    if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                        exact = false;
                        break;
                    }
                    currentAlt = alt;
                }
            }
        }
        currentState = configs[0].state.nonStopStateNumber;
        let firstIndexCurrentState = 0;
        let lastIndexCurrentStateMinAlt = 0;
        let joinedCheckContext = configs[0].context;
        for(let i = 1; i < configs.length; i++){
            let config = configs[i];
            if (config.alt !== minAlt) break;
            if (config.state.nonStopStateNumber !== currentState) break;
            lastIndexCurrentStateMinAlt = i;
            joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
        }
        for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
            let config = configs[i];
            let state = config.state;
            alts.set(config.alt);
            if (state.nonStopStateNumber !== currentState) {
                currentState = state.nonStopStateNumber;
                firstIndexCurrentState = i;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = config.context;
                for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== minAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateMinAlt = j;
                    joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                }
                i = lastIndexCurrentStateMinAlt;
                continue;
            }
            let joinedCheckContext2 = config.context;
            let currentAlt = config.alt;
            let lastIndexCurrentStateCurrentAlt = i;
            for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                let config2 = configs[j];
                if (config2.alt !== currentAlt) break;
                if (config2.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateCurrentAlt = j;
                joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
            }
            i = lastIndexCurrentStateCurrentAlt;
            let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
            if (!joinedCheckContext.equals(check)) return undefined;
            // update exact if necessary
            exact = exact && joinedCheckContext.equals(joinedCheckContext2);
        }
        return new $9lU7d.ConflictInfo(alts, exact);
    }
    getConflictingAltsFromConfigSet(configs) {
        let conflictingAlts = configs.conflictingAlts;
        if (conflictingAlts == null && configs.uniqueAlt !== $EKDdQ.ATN.INVALID_ALT_NUMBER) {
            conflictingAlts = new $6YKio.BitSet();
            conflictingAlts.set(configs.uniqueAlt);
        }
        return conflictingAlts;
    }
    getTokenName(t) {
        if (t === $lxPhv.Token.EOF) return "EOF";
        let vocabulary = this._parser != null ? this._parser.vocabulary : $auHu3.VocabularyImpl.EMPTY_VOCABULARY;
        let displayName = vocabulary.getDisplayName(t);
        if (displayName === String(t)) return displayName;
        return displayName + "<" + t + ">";
    }
    getLookaheadName(input) {
        return this.getTokenName(input.LA(1));
    }
    dumpDeadEndConfigs(nvae) {
        console.log("dead end configs: ");
        let deadEndConfigs = nvae.deadEndConfigs;
        if (!deadEndConfigs) return;
        for (let c of deadEndConfigs){
            let trans = "no edges";
            if (c.state.numberOfOptimizedTransitions > 0) {
                let t = c.state.getOptimizedTransition(0);
                if (t instanceof $2zmHG.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                else if (t instanceof $7grDB.SetTransition) {
                    let not = t instanceof $kUcH8.NotSetTransition;
                    trans = (not ? "~" : "") + "Set " + t.set.toString();
                }
            }
            console.log(c.toString(this._parser, true) + ":" + trans);
        }
    }
    noViableAlt(input, outerContext, configs, startIndex) {
        return new $dF72r.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
    }
    getUniqueAlt(configs) {
        let alt = $EKDdQ.ATN.INVALID_ALT_NUMBER;
        for (let c of configs){
            if (alt === $EKDdQ.ATN.INVALID_ALT_NUMBER) alt = c.alt; // found first alt
            else if (c.alt !== alt) return $EKDdQ.ATN.INVALID_ALT_NUMBER;
        }
        return alt;
    }
    configWithAltAtStopState(configs, alt) {
        for (let c of configs)if (c.alt === alt) {
            if (c.state instanceof $4eVci.RuleStopState) return true;
        }
        return false;
    }
    addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
        $9ir1r(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
        let from = fromState;
        let to = this.addDFAState(dfa, toConfigs, contextCache);
        if (contextTransitions != null) for (let context of contextTransitions.toArray()){
            if (context === $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) {
                if (from.configs.isOutermostConfigSet) continue;
            }
            from.setContextSensitive(this.atn);
            from.setContextSymbol(t);
            let next = from.getContextTarget(context);
            if (next != null) {
                from = next;
                continue;
            }
            next = this.addDFAContextState(dfa, from.configs, context, contextCache);
            $9ir1r(context !== $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
            from.setContextTarget(context, next);
            from = next;
        }
        if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
        this.setDFAEdge(from, t, to);
        if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $auHu3.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
        return to;
    }
    setDFAEdge(p, t, q) {
        if (p != null) p.setTarget(t, q);
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAContextState(dfa, configs, returnContext, contextCache) {
        if (returnContext !== $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) {
            let contextConfigs = new $51XoR.ATNConfigSet();
            for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
            return this.addDFAState(dfa, contextConfigs, contextCache);
        } else {
            $9ir1r(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
            configs = configs.clone(true);
            configs.isOutermostConfigSet = true;
            return this.addDFAState(dfa, configs, contextCache);
        }
    }
    /** See comment on LexerInterpreter.addDFAState. */ addDFAState(dfa, configs, contextCache) {
        let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
        if (enableDfa) {
            if (!configs.isReadOnly) configs.optimizeConfigs(this);
            let proposed = this.createDFAState(dfa, configs);
            let existing = dfa.states.get(proposed);
            if (existing != null) return existing;
        }
        if (!configs.isReadOnly) {
            if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
        }
        let newState = this.createDFAState(dfa, configs.clone(true));
        // getDecisionState won't return undefined when we request a known valid decision
        let decisionState = this.atn.getDecisionState(dfa.decision);
        let predictedAlt = this.getUniqueAlt(configs);
        if (predictedAlt !== $EKDdQ.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $7oXsf.AcceptStateInfo(predictedAlt);
        else if (configs.conflictingAlts != null) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts) newState.acceptStateInfo = new $7oXsf.AcceptStateInfo(conflictingAlts.nextSetBit(0));
        }
        if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
        if (!enableDfa) return newState;
        let added = dfa.addState(newState);
        if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
        return added;
    }
    createDFAState(dfa, configs) {
        return new $iIwZu.DFAState(configs);
    }
    reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $kCyYI.Interval.of(startIndex, stopIndex);
            console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        }
    }
    reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $kCyYI.Interval.of(startIndex, stopIndex);
            console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
        }
    }
    /** If context sensitive parsing, we know it's ambiguity not conflict */ reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
            let interval = $kCyYI.Interval.of(startIndex, stopIndex);
            console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
        }
        if (this._parser != null) {
            let listener = this._parser.getErrorListenerDispatch();
            if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        }
    }
    getReturnState(context) {
        if (context.isEmpty) return $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY;
        let state = this.atn.states[context.invokingState];
        let transition = state.transition(0);
        return transition.followState.stateNumber;
    }
    skipTailCalls(context) {
        if (!this.optimize_tail_calls) return context;
        while(!context.isEmpty){
            let state = this.atn.states[context.invokingState];
            $9ir1r(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3 /* RULE */ );
            let transition = state.transition(0);
            if (!transition.tailCall) break;
            // This method requires that the root ancestor of the ParserRuleContext be empty. If we make it to this
            // line, we know the current node is not empty, which means it does have a parent.
            context = context.parent;
        }
        return context;
    }
    /**
     * @since 4.3
     */ get parser() {
        return this._parser;
    }
    constructor(atn, parser){
        super(atn);
        this.predictionMode = $aC2pn.PredictionMode.LL;
        this.force_global_context = false;
        this.always_try_local_context = true;
        /**
         * Determines whether the DFA is used for full-context predictions. When
         * `true`, the DFA stores transition information for both full-context
         * and SLL parsing; otherwise, the DFA only stores SLL transition
         * information.
         *
         * For some grammars, enabling the full-context DFA can result in a
         * substantial performance improvement. However, this improvement typically
         * comes at the expense of memory used for storing the cached DFA states,
         * configuration sets, and prediction contexts.
         *
         * The default value is `false`.
         */ this.enable_global_context_dfa = false;
        this.optimize_unique_closure = true;
        this.optimize_ll1 = true;
        this.optimize_tail_calls = true;
        this.tail_call_preserves_sll = true;
        this.treat_sllk1_conflict_as_ambiguity = false;
        /**
         * When `true`, ambiguous alternatives are reported when they are
         * encountered within {@link #execATN}. When `false`, these messages
         * are suppressed. The default is `false`.
         *
         * When messages about ambiguous alternatives are not required, setting this
         * to `false` enables additional internal optimizations which may lose
         * this information.
         */ this.reportAmbiguities = false;
        /** By default we do full context-sensitive LL(*) parsing not
         *  Strong LL(*) parsing. If we fail with Strong LL(*) we
         *  try full LL(*). That means we rewind and use context information
         *  when closure operations fall off the end of the rule that
         *  holds the decision were evaluating.
         */ this.userWantsCtxSensitive = true;
        this._parser = parser;
    }
};
$a3848e5489b578cc$var$ParserATNSimulator.debug = false;
$a3848e5489b578cc$var$ParserATNSimulator.dfa_debug = false;
$a3848e5489b578cc$var$ParserATNSimulator.retry_debug = false;
$a3848e5489b578cc$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
    let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
    if (diff !== 0) return diff;
    diff = o1.alt - o2.alt;
    if (diff !== 0) return diff;
    return 0;
};
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "predictionMode", void 0);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getPredictionMode", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "setPredictionMode", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.Override
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "reset", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "adaptivePredict", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getStartState", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(3, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "execDFA", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(3, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "execATN", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "computeTargetState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "computeStartState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getReachableTarget", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(4, $4w9vi.Nullable)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "closure", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.Nullable),
    $a3848e5489b578cc$var$__param(3, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(6, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "closureImpl", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getRuleName", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "actionTransition", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.Nullable,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "precedenceTransition", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.Nullable,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "predTransition", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.Nullable)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "ruleTransition", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "isConflicted", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getTokenName", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "noViableAlt", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(4, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "addDFAEdge", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.Nullable),
    $a3848e5489b578cc$var$__param(2, $4w9vi.Nullable)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "setDFAEdge", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "addDFAContextState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "addDFAState", null);
$a3848e5489b578cc$var$__decorate([
    $4w9vi.NotNull,
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(1, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "createDFAState", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(2, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
$a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(5, $4w9vi.NotNull),
    $a3848e5489b578cc$var$__param(6, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
$a3848e5489b578cc$var$ParserATNSimulator = $a3848e5489b578cc$var$__decorate([
    $a3848e5489b578cc$var$__param(0, $4w9vi.NotNull)
], $a3848e5489b578cc$var$ParserATNSimulator);
module.exports.ParserATNSimulator = $a3848e5489b578cc$var$ParserATNSimulator; //# sourceMappingURL=ParserATNSimulator.js.map

});

parcelRegister("9lU7d", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6cf19a954ea4c91d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictInfo = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $1rLy7 = parcelRequire("1rLy7");

/**
 * This class stores information about a configuration conflict.
 *
 * @author Sam Harwell
 */ class $6cf19a954ea4c91d$var$ConflictInfo {
    /**
     * Gets the set of conflicting alternatives for the configuration set.
     */ get conflictedAlts() {
        return this._conflictedAlts;
    }
    /**
     * Gets whether or not the configuration conflict is an exact conflict.
     * An exact conflict occurs when the prediction algorithm determines that
     * the represented alternatives for a particular configuration set cannot be
     * further reduced by consuming additional input. After reaching an exact
     * conflict during an SLL prediction, only switch to full-context prediction
     * could reduce the set of viable alternatives. In LL prediction, an exact
     * conflict indicates a true ambiguity in the input.
     *
     * For the {@link PredictionMode#LL_EXACT_AMBIG_DETECTION} prediction mode,
     * accept states are conflicting but not exact are treated as non-accept
     * states.
     */ get isExact() {
        return this.exact;
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $6cf19a954ea4c91d$var$ConflictInfo)) return false;
        return this.isExact === obj.isExact && $1rLy7.equals(this.conflictedAlts, obj.conflictedAlts);
    }
    hashCode() {
        return this.conflictedAlts.hashCode();
    }
    constructor(conflictedAlts, exact){
        this._conflictedAlts = conflictedAlts;
        this.exact = exact;
    }
}
$6cf19a954ea4c91d$var$__decorate([
    $4w9vi.Override
], $6cf19a954ea4c91d$var$ConflictInfo.prototype, "equals", null);
$6cf19a954ea4c91d$var$__decorate([
    $4w9vi.Override
], $6cf19a954ea4c91d$var$ConflictInfo.prototype, "hashCode", null);
module.exports.ConflictInfo = $6cf19a954ea4c91d$var$ConflictInfo; //# sourceMappingURL=ConflictInfo.js.map

});

parcelRegister("7EUlr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5937f9b8926b6e27$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserRuleContext = void 0;

var $e3JhD = parcelRequire("e3JhD");


var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");


var $cVMBX = parcelRequire("cVMBX");


var $kNZsc = parcelRequire("kNZsc");

/** A rule invocation record for parsing.
 *
 *  Contains all of the information about the current rule not stored in the
 *  RuleContext. It handles parse tree children list, Any ATN state
 *  tracing, and the default values available for rule invocations:
 *  start, stop, rule index, current alt number.
 *
 *  Subclasses made for each rule and grammar track the parameters,
 *  return values, locals, and labels specific to that rule. These
 *  are the objects that are returned from rules.
 *
 *  Note text is not an actual field of a rule return value; it is computed
 *  from start and stop using the input stream's toString() method.  I
 *  could add a ctor to this so that we can pass in and store the input
 *  stream, but I'm not sure we want to do that.  It would seem to be undefined
 *  to get the .text property anyway if the rule matches tokens from multiple
 *  input streams.
 *
 *  I do not use getters for fields of objects that are used simply to
 *  group values such as this aggregate.  The getters/setters are there to
 *  satisfy the superclass interface.
 */ class $5937f9b8926b6e27$var$ParserRuleContext extends $cVMBX.RuleContext {
    static emptyContext() {
        return $5937f9b8926b6e27$var$ParserRuleContext.EMPTY;
    }
    /**
     * COPY a ctx (I'm deliberately not using copy constructor) to avoid
     * confusion with creating node with parent. Does not copy children
     * (except error leaves).
     *
     * This is used in the generated parser code to flip a generic XContext
     * node for rule X to a YContext for alt label Y. In that sense, it is not
     * really a generic copy function.
     *
     * If we do an error sync() at start of a rule, we might add error nodes
     * to the generic XContext so this function must copy those nodes to the
     * YContext as well else they are lost!
     */ copyFrom(ctx) {
        this._parent = ctx._parent;
        this.invokingState = ctx.invokingState;
        this._start = ctx._start;
        this._stop = ctx._stop;
        // copy any error nodes to alt label node
        if (ctx.children) {
            this.children = [];
            // reset parent pointer for any error nodes
            for (let child of ctx.children)if (child instanceof $e3JhD.ErrorNode) this.addChild(child);
        }
    }
    // Double dispatch methods for listeners
    enterRule(listener) {
    // intentionally empty
    }
    exitRule(listener) {
    // intentionally empty
    }
    /** Add a parse tree node to this as a child.  Works for
     *  internal and leaf nodes. Does not set parent link;
     *  other add methods must do that. Other addChild methods
     *  call this.
     *
     *  We cannot set the parent pointer of the incoming node
     *  because the existing interfaces do not have a setParent()
     *  method and I don't want to break backward compatibility for this.
     *
     *  @since 4.7
     */ addAnyChild(t) {
        if (!this.children) this.children = [
            t
        ];
        else this.children.push(t);
        return t;
    }
    addChild(t) {
        let result;
        if (t instanceof $kNZsc.TerminalNode) {
            t.setParent(this);
            this.addAnyChild(t);
            return;
        } else if (t instanceof $cVMBX.RuleContext) {
            // Does not set parent link
            this.addAnyChild(t);
            return;
        } else {
            // Deprecated code path
            t = new $kNZsc.TerminalNode(t);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    addErrorNode(node) {
        if (node instanceof $e3JhD.ErrorNode) {
            const errorNode = node;
            errorNode.setParent(this);
            return this.addAnyChild(errorNode);
        } else {
            // deprecated path
            const badToken = node;
            let t = new $e3JhD.ErrorNode(badToken);
            this.addAnyChild(t);
            t.setParent(this);
            return t;
        }
    }
    //	public void trace(int s) {
    //		if ( states==null ) states = new ArrayList<Integer>();
    //		states.add(s);
    //	}
    /** Used by enterOuterAlt to toss out a RuleContext previously added as
     *  we entered a rule. If we have # label, we will need to remove
     *  generic ruleContext object.
     */ removeLastChild() {
        if (this.children) this.children.pop();
    }
    get parent() {
        let parent = super.parent;
        if (parent === undefined || parent instanceof $5937f9b8926b6e27$var$ParserRuleContext) return parent;
        throw new TypeError("Invalid parent type for ParserRuleContext");
    }
    // Note: in TypeScript, order or arguments reversed
    getChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
        if (ctxType == null) return this.children[i];
        let result = this.tryGetChild(i, ctxType);
        if (result === undefined) throw new Error("The specified node does not exist");
        return result;
    }
    tryGetChild(i, ctxType) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what node with ctxType have we found?
        for (let o of this.children)if (o instanceof ctxType) {
            j++;
            if (j === i) return o;
        }
        return undefined;
    }
    getToken(ttype, i) {
        let result = this.tryGetToken(ttype, i);
        if (result === undefined) throw new Error("The specified token does not exist");
        return result;
    }
    tryGetToken(ttype, i) {
        if (!this.children || i < 0 || i >= this.children.length) return undefined;
        let j = -1; // what token with ttype have we found?
        for (let o of this.children)if (o instanceof $kNZsc.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) {
                j++;
                if (j === i) return o;
            }
        }
        return undefined;
    }
    getTokens(ttype) {
        let tokens = [];
        if (!this.children) return tokens;
        for (let o of this.children)if (o instanceof $kNZsc.TerminalNode) {
            let symbol = o.symbol;
            if (symbol.type === ttype) tokens.push(o);
        }
        return tokens;
    }
    get ruleContext() {
        return this;
    }
    // NOTE: argument order change from Java version
    getRuleContext(i, ctxType) {
        return this.getChild(i, ctxType);
    }
    tryGetRuleContext(i, ctxType) {
        return this.tryGetChild(i, ctxType);
    }
    getRuleContexts(ctxType) {
        let contexts = [];
        if (!this.children) return contexts;
        for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
        return contexts;
    }
    get childCount() {
        return this.children ? this.children.length : 0;
    }
    get sourceInterval() {
        if (!this._start) return $kCyYI.Interval.INVALID;
        if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $kCyYI.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1); // empty
        return $kCyYI.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
    }
    /**
     * Get the initial token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may exceed stop.
     */ get start() {
        return this._start;
    }
    /**
     * Get the final token in this context.
     * Note that the range from start to stop is inclusive, so for rules that do not consume anything
     * (for example, zero length or error productions) this token may precede start.
     */ get stop() {
        return this._stop;
    }
    /** Used for rule context info debugging during parse-time, not so much for ATN debugging */ toInfoString(recognizer) {
        let rules = recognizer.getRuleInvocationStack(this).reverse();
        return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
    }
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber == null) super();
        else super(parent, invokingStateNumber);
    }
}
$5937f9b8926b6e27$var$ParserRuleContext.EMPTY = new $5937f9b8926b6e27$var$ParserRuleContext();
$5937f9b8926b6e27$var$__decorate([
    $4w9vi.Override
], $5937f9b8926b6e27$var$ParserRuleContext.prototype, "parent", null);
$5937f9b8926b6e27$var$__decorate([
    $4w9vi.Override
], $5937f9b8926b6e27$var$ParserRuleContext.prototype, "childCount", null);
$5937f9b8926b6e27$var$__decorate([
    $4w9vi.Override
], $5937f9b8926b6e27$var$ParserRuleContext.prototype, "sourceInterval", null);
module.exports.ParserRuleContext = $5937f9b8926b6e27$var$ParserRuleContext; //# sourceMappingURL=ParserRuleContext.js.map

});

parcelRegister("kNZsc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f2580db4a2ce2e31$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerminalNode = void 0;

var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

class $f2580db4a2ce2e31$var$TerminalNode {
    getChild(i) {
        throw new RangeError("Terminal Node has no children.");
    }
    get symbol() {
        return this._symbol;
    }
    get parent() {
        return this._parent;
    }
    setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this._symbol;
    }
    get sourceInterval() {
        let tokenIndex = this._symbol.tokenIndex;
        return new $kCyYI.Interval(tokenIndex, tokenIndex);
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitTerminal(this);
    }
    get text() {
        return this._symbol.text || "";
    }
    toStringTree(parser) {
        return this.toString();
    }
    toString() {
        if (this._symbol.type === $lxPhv.Token.EOF) return "<EOF>";
        return this._symbol.text || "";
    }
    constructor(symbol){
        this._symbol = symbol;
    }
}
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "getChild", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "parent", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "setParent", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "payload", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "sourceInterval", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "childCount", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "accept", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "text", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "toStringTree", null);
$f2580db4a2ce2e31$var$__decorate([
    $4w9vi.Override
], $f2580db4a2ce2e31$var$TerminalNode.prototype, "toString", null);
module.exports.TerminalNode = $f2580db4a2ce2e31$var$TerminalNode; //# sourceMappingURL=TerminalNode.js.map

});

parcelRegister("cVMBX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $96a084196e6b505e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContext = void 0;

var $EKDdQ = parcelRequire("EKDdQ");


var $lEpws = parcelRequire("lEpws");


var $cxadZ = parcelRequire("cxadZ");


var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");


var $ifNch = parcelRequire("ifNch");


var $7EUlr = parcelRequire("7EUlr");

/** A rule context is a record of a single rule invocation.
 *
 *  We form a stack of these context objects using the parent
 *  pointer. A parent pointer of `undefined` indicates that the current
 *  context is the bottom of the stack. The ParserRuleContext subclass
 *  as a children list so that we can turn this data structure into a
 *  tree.
 *
 *  The root node always has a `undefined` pointer and invokingState of -1.
 *
 *  Upon entry to parsing, the first invoked rule function creates a
 *  context object (a subclass specialized for that rule such as
 *  SContext) and makes it the root of a parse tree, recorded by field
 *  Parser._ctx.
 *
 *  public final SContext s() throws RecognitionException {
 *      SContext _localctx = new SContext(_ctx, state); <-- create new node
 *      enterRule(_localctx, 0, RULE_s);                     <-- push it
 *      ...
 *      exitRule();                                          <-- pop back to _localctx
 *      return _localctx;
 *  }
 *
 *  A subsequent rule invocation of r from the start rule s pushes a
 *  new context object for r whose parent points at s and use invoking
 *  state is the state with r emanating as edge label.
 *
 *  The invokingState fields from a context object to the root
 *  together form a stack of rule indication states where the root
 *  (bottom of the stack) has a -1 sentinel value. If we invoke start
 *  symbol s then call r1, which calls r2, the  would look like
 *  this:
 *
 *     SContext[-1]   <- root node (bottom of the stack)
 *     R1Context[p]   <- p in rule s called r1
 *     R2Context[q]   <- q in rule r1 called r2
 *
 *  So the top of the stack, _ctx, represents a call to the current
 *  rule and it holds the return address from another rule that invoke
 *  to this rule. To invoke a rule, we must always have a current context.
 *
 *  The parent contexts are useful for computing lookahead sets and
 *  getting error information.
 *
 *  These objects are used during parsing and prediction.
 *  For the special case of parsers, we use the subclass
 *  ParserRuleContext.
 *
 *  @see ParserRuleContext
 */ class $96a084196e6b505e$var$RuleContext extends $cxadZ.RuleNode {
    static getChildContext(parent, invokingState) {
        return new $96a084196e6b505e$var$RuleContext(parent, invokingState);
    }
    depth() {
        let n = 0;
        let p = this;
        while(p){
            p = p._parent;
            n++;
        }
        return n;
    }
    /** A context is empty if there is no invoking state; meaning nobody called
     *  current context.
     */ get isEmpty() {
        return this.invokingState === -1;
    }
    // satisfy the ParseTree / SyntaxTree interface
    get sourceInterval() {
        return $kCyYI.Interval.INVALID;
    }
    get ruleContext() {
        return this;
    }
    get parent() {
        return this._parent;
    }
    /** @since 4.7. {@see ParseTree#setParent} comment */ setParent(parent) {
        this._parent = parent;
    }
    get payload() {
        return this;
    }
    /** Return the combined text of all child nodes. This method only considers
     *  tokens which have been added to the parse tree.
     *
     *  Since tokens on hidden channels (e.g. whitespace or comments) are not
     *  added to the parse trees, they will not appear in the output of this
     *  method.
     */ get text() {
        if (this.childCount === 0) return "";
        let builder = "";
        for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
        return builder.toString();
    }
    get ruleIndex() {
        return -1;
    }
    /** For rule associated with this parse tree internal node, return
     *  the outer alternative number used to match the input. Default
     *  implementation does not compute nor store this alt num. Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *  to set it.
     *
     *  @since 4.5.3
     */ get altNumber() {
        return $EKDdQ.ATN.INVALID_ALT_NUMBER;
    }
    /** Set the outer alternative number for this context node. Default
     *  implementation does nothing to avoid backing field overhead for
     *  trees that don't need it.  Create
     *  a subclass of ParserRuleContext with backing field and set
     *  option contextSuperClass.
     *
     *  @since 4.5.3
     */ set altNumber(altNumber) {
    // intentionally ignored by the base implementation
    }
    getChild(i) {
        throw new RangeError("i must be greater than or equal to 0 and less than childCount");
    }
    get childCount() {
        return 0;
    }
    accept(visitor) {
        return visitor.visitChildren(this);
    }
    toStringTree(recog) {
        return $ifNch.Trees.toStringTree(this, recog);
    }
    toString(arg1, stop) {
        const ruleNames = arg1 instanceof $lEpws.Recognizer ? arg1.ruleNames : arg1;
        stop = stop || $7EUlr.ParserRuleContext.emptyContext();
        let buf = "";
        let p = this;
        buf += "[";
        while(p && p !== stop){
            if (!ruleNames) {
                if (!p.isEmpty) buf += p.invokingState;
            } else {
                let ruleIndex = p.ruleIndex;
                let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                buf += ruleName;
            }
            if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
            p = p._parent;
        }
        buf += "]";
        return buf.toString();
    }
    constructor(parent, invokingState){
        super();
        this._parent = parent;
        this.invokingState = invokingState != null ? invokingState : -1;
    }
}
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "sourceInterval", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "ruleContext", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "parent", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "setParent", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "payload", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "text", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "getChild", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "childCount", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "accept", null);
$96a084196e6b505e$var$__decorate([
    $4w9vi.Override
], $96a084196e6b505e$var$RuleContext.prototype, "toStringTree", null);
module.exports.RuleContext = $96a084196e6b505e$var$RuleContext; //# sourceMappingURL=RuleContext.js.map

});

parcelRegister("cxadZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleNode = void 0;
class $92007f7b0a92297e$var$RuleNode {
}
module.exports.RuleNode = $92007f7b0a92297e$var$RuleNode; //# sourceMappingURL=RuleNode.js.map

});

parcelRegister("ifNch", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d49fca39055a9f82$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d49fca39055a9f82$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Trees = void 0;

var $EKDdQ = parcelRequire("EKDdQ");


var $dasyL = parcelRequire("dasyL");


var $e3JhD = parcelRequire("e3JhD");


var $4w9vi = parcelRequire("4w9vi");


var $dCLTv = parcelRequire("dCLTv");


var $7EUlr = parcelRequire("7EUlr");


var $cxadZ = parcelRequire("cxadZ");


var $kNZsc = parcelRequire("kNZsc");


var $lxPhv = parcelRequire("lxPhv");


var $1rLy7 = parcelRequire("1rLy7");

/** A set of utility routines useful for all kinds of ANTLR trees. */ class $d49fca39055a9f82$var$Trees {
    static toStringTree(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dCLTv.Parser) ruleNames = arg2.ruleNames;
        else ruleNames = arg2;
        let s = $1rLy7.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        if (t.childCount === 0) return s;
        let buf = "";
        buf += "(";
        s = $1rLy7.escapeWhitespace(this.getNodeText(t, ruleNames), false);
        buf += s;
        buf += " ";
        for(let i = 0; i < t.childCount; i++){
            if (i > 0) buf += " ";
            buf += this.toStringTree(t.getChild(i), ruleNames);
        }
        buf += ")";
        return buf;
    }
    static getNodeText(t, arg2) {
        let ruleNames;
        if (arg2 instanceof $dCLTv.Parser) ruleNames = arg2.ruleNames;
        else if (arg2) ruleNames = arg2;
        else {
            // no recog or rule names
            let payload = t.payload;
            if (typeof payload.text === "string") return payload.text;
            return t.payload.toString();
        }
        if (t instanceof $cxadZ.RuleNode) {
            let ruleContext = t.ruleContext;
            let ruleIndex = ruleContext.ruleIndex;
            let ruleName = ruleNames[ruleIndex];
            let altNumber = ruleContext.altNumber;
            if (altNumber !== $EKDdQ.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
            return ruleName;
        } else if (t instanceof $e3JhD.ErrorNode) return t.toString();
        else if (t instanceof $kNZsc.TerminalNode) {
            let symbol = t.symbol;
            return symbol.text || "";
        }
        throw new TypeError("Unexpected node type");
    }
    static getChildren(t) {
        let kids = [];
        for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
        return kids;
    }
    static getAncestors(t) {
        let ancestors = [];
        let p = t.parent;
        while(p){
            ancestors.unshift(p); // insert at start
            p = p.parent;
        }
        return ancestors;
    }
    /** Return true if t is u's parent or a node on path to root from u.
     *  Use === not equals().
     *
     *  @since 4.5.1
     */ static isAncestorOf(t, u) {
        if (!t || !u || !t.parent) return false;
        let p = u.parent;
        while(p){
            if (t === p) return true;
            p = p.parent;
        }
        return false;
    }
    static findAllTokenNodes(t, ttype) {
        return $d49fca39055a9f82$var$Trees.findAllNodes(t, ttype, true);
    }
    static findAllRuleNodes(t, ruleIndex) {
        return $d49fca39055a9f82$var$Trees.findAllNodes(t, ruleIndex, false);
    }
    static findAllNodes(t, index, findTokens) {
        let nodes = [];
        $d49fca39055a9f82$var$Trees._findAllNodes(t, index, findTokens, nodes);
        return nodes;
    }
    static _findAllNodes(t, index, findTokens, nodes) {
        // check this node (the root) first
        if (findTokens && t instanceof $kNZsc.TerminalNode) {
            if (t.symbol.type === index) nodes.push(t);
        } else if (!findTokens && t instanceof $7EUlr.ParserRuleContext) {
            if (t.ruleIndex === index) nodes.push(t);
        }
        // check children
        for(let i = 0; i < t.childCount; i++)$d49fca39055a9f82$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
    }
    /** Get all descendents; includes t itself.
     *
     * @since 4.5.1
     */ static getDescendants(t) {
        let nodes = [];
        function recurse(e) {
            nodes.push(e);
            const n = e.childCount;
            for(let i = 0; i < n; i++)recurse(e.getChild(i));
        }
        recurse(t);
        return nodes;
    }
    /** Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
     *  inclusively using postorder traversal.  Recursive depth-first-search.
     *
     *  @since 4.5
     */ static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let child = t.getChild(i);
            let r = $d49fca39055a9f82$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
            if (r) return r;
        }
        if (t instanceof $7EUlr.ParserRuleContext) {
            let stopToken = t.stop;
            if (startTokenIndex >= t.start.tokenIndex && // is range fully contained in t?
            (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) // note: r.stop==null likely implies that we bailed out of parser and there's nothing to the right
            return t;
        }
        return undefined;
    }
    /** Replace any subtree siblings of root that are completely to left
     *  or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
     *  node. The source interval for t is not altered to suit smaller range!
     *
     *  WARNING: destructive to t.
     *
     *  @since 4.5.1
     */ static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
        if (!t) return;
        let count = t.childCount;
        for(let i = 0; i < count; i++){
            let child = t.getChild(i);
            let range = child.sourceInterval;
            if (child instanceof $7EUlr.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                if ($d49fca39055a9f82$var$Trees.isAncestorOf(child, root)) {
                    let abbrev = new $dasyL.CommonToken($lxPhv.Token.INVALID_TYPE, "...");
                    t.children[i] = new $kNZsc.TerminalNode(abbrev); // HACK access to private
                }
            }
        }
    }
    static findNodeSuchThat(t, pred) {
        // No type check needed as long as users only use one of the available overloads
        if (pred(t)) return t;
        let n = t.childCount;
        for(let i = 0; i < n; i++){
            let u = $d49fca39055a9f82$var$Trees.findNodeSuchThat(t.getChild(i), pred);
            if (u !== undefined) return u;
        }
        return undefined;
    }
}
$d49fca39055a9f82$var$__decorate([
    $d49fca39055a9f82$var$__param(0, $4w9vi.NotNull)
], $d49fca39055a9f82$var$Trees, "toStringTree", null);
$d49fca39055a9f82$var$__decorate([
    $4w9vi.NotNull,
    $d49fca39055a9f82$var$__param(0, $4w9vi.NotNull)
], $d49fca39055a9f82$var$Trees, "getAncestors", null);
$d49fca39055a9f82$var$__decorate([
    $d49fca39055a9f82$var$__param(0, $4w9vi.NotNull)
], $d49fca39055a9f82$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
module.exports.Trees = $d49fca39055a9f82$var$Trees; //# sourceMappingURL=Trees.js.map

});

parcelRegister("aC2pn", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7b9f52377c275fce$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionMode = void 0;

var $ei6xC = parcelRequire("ei6xC");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");


var $4eVci = parcelRequire("4eVci");

/**
 * This enumeration defines the prediction modes available in ANTLR 4 along with
 * utility methods for analyzing configuration sets for conflicts and/or
 * ambiguities.
 */ var $7b9f52377c275fce$var$PredictionMode;
(function(PredictionMode) {
    /**
     * The SLL(*) prediction mode. This prediction mode ignores the current
     * parser context when making predictions. This is the fastest prediction
     * mode, and provides correct results for many grammars. This prediction
     * mode is more powerful than the prediction mode provided by ANTLR 3, but
     * may result in syntax errors for grammar and input combinations which are
     * not SLL.
     *
     * When using this prediction mode, the parser will either return a correct
     * parse tree (i.e. the same parse tree that would be returned with the
     * {@link #LL} prediction mode), or it will report a syntax error. If a
     * syntax error is encountered when using the {@link #SLL} prediction mode,
     * it may be due to either an actual syntax error in the input or indicate
     * that the particular combination of grammar and input requires the more
     * powerful {@link #LL} prediction abilities to complete successfully.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
    /**
     * The LL(*) prediction mode. This prediction mode allows the current parser
     * context to be used for resolving SLL conflicts that occur during
     * prediction. This is the fastest prediction mode that guarantees correct
     * parse results for all combinations of grammars with syntactically correct
     * inputs.
     *
     * When using this prediction mode, the parser will make correct decisions
     * for all syntactically-correct grammar and input combinations. However, in
     * cases where the grammar is truly ambiguous this prediction mode might not
     * report a precise answer for *exactly which* alternatives are
     * ambiguous.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL"] = 1] = "LL";
    /**
     * The LL(*) prediction mode with exact ambiguity detection. In addition to
     * the correctness guarantees provided by the {@link #LL} prediction mode,
     * this prediction mode instructs the prediction algorithm to determine the
     * complete and exact set of ambiguous alternatives for every ambiguous
     * decision encountered while parsing.
     *
     * This prediction mode may be used for diagnosing ambiguities during
     * grammar development. Due to the performance overhead of calculating sets
     * of ambiguous alternatives, this prediction mode should be avoided when
     * the exact results are not necessary.
     *
     * This prediction mode does not provide any guarantees for prediction
     * behavior for syntactically-incorrect inputs.
     */ PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
})($7b9f52377c275fce$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
(function(PredictionMode) {
    /** A Map that uses just the state and the stack context as the key. */ // NOTE: Base type used to be FlexibleHashMap<ATNConfig, BitSet>
    class AltAndContextMap extends $ei6xC.Array2DHashMap {
        constructor(){
            super(AltAndContextConfigEqualityComparator.INSTANCE);
        }
    }
    class AltAndContextConfigEqualityComparator {
        AltAndContextConfigEqualityComparator() {
        // intentionally empty
        }
        /**
         * The hash code is only a function of the {@link ATNState#stateNumber}
         * and {@link ATNConfig#context}.
         */ hashCode(o) {
            let hashCode = $g3jfX.MurmurHash.initialize(7);
            hashCode = $g3jfX.MurmurHash.update(hashCode, o.state.stateNumber);
            hashCode = $g3jfX.MurmurHash.update(hashCode, o.context);
            hashCode = $g3jfX.MurmurHash.finish(hashCode, 2);
            return hashCode;
        }
        equals(a, b) {
            if (a === b) return true;
            if (a == null || b == null) return false;
            return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
        }
    }
    AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
    $7b9f52377c275fce$var$__decorate([
        $4w9vi.Override
    ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
    $7b9f52377c275fce$var$__decorate([
        $4w9vi.Override
    ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
    /**
     * Checks if any configuration in `configs` is in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if any configuration in `configs` is in a
     * {@link RuleStopState}, otherwise `false`
     */ function hasConfigInRuleStopState(configs) {
        for (let c of configs){
            if (c.state instanceof $4eVci.RuleStopState) return true;
        }
        return false;
    }
    PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
    /**
     * Checks if all configurations in `configs` are in a
     * {@link RuleStopState}. Configurations meeting this condition have reached
     * the end of the decision rule (local context) or end of start rule (full
     * context).
     *
     * @param configs the configuration set to test
     * @returns `true` if all configurations in `configs` are in a
     * {@link RuleStopState}, otherwise `false`
     */ function allConfigsInRuleStopStates(/*@NotNull*/ configs) {
        for (let config of configs){
            if (!(config.state instanceof $4eVci.RuleStopState)) return false;
        }
        return true;
    }
    PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
})($7b9f52377c275fce$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {})); //# sourceMappingURL=PredictionMode.js.map

});

parcelRegister("XQBih", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0b3e502b472ff9a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $0b3e502b472ff9a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimulatorState = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $7EUlr = parcelRequire("7EUlr");

/**
 *
 * @author Sam Harwell
 */ let $0b3e502b472ff9a7$var$SimulatorState = class SimulatorState {
    constructor(outerContext, s0, useContext, remainingOuterContext){
        this.outerContext = outerContext != null ? outerContext : $7EUlr.ParserRuleContext.emptyContext();
        this.s0 = s0;
        this.useContext = useContext;
        this.remainingOuterContext = remainingOuterContext;
    }
};
$0b3e502b472ff9a7$var$SimulatorState = $0b3e502b472ff9a7$var$__decorate([
    $0b3e502b472ff9a7$var$__param(1, $4w9vi.NotNull)
], $0b3e502b472ff9a7$var$SimulatorState);
module.exports.SimulatorState = $0b3e502b472ff9a7$var$SimulatorState; //# sourceMappingURL=SimulatorState.js.map

});

parcelRegister("5KAQQ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $42fdd58a54abf462$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusBlockStartState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $lvaZD = parcelRequire("lvaZD");


var $4w9vi = parcelRequire("4w9vi");

/** Start of `(A|B|...)+` loop. Technically a decision state, but
 *  we don't use for code generation; somebody might need it, so I'm defining
 *  it for completeness. In reality, the {@link PlusLoopbackState} node is the
 *  real decision-making note for `A+`.
 */ class $42fdd58a54abf462$var$PlusBlockStartState extends $lvaZD.BlockStartState {
    get stateType() {
        return $jW0J3.ATNStateType.PLUS_BLOCK_START;
    }
}
$42fdd58a54abf462$var$__decorate([
    $4w9vi.Override
], $42fdd58a54abf462$var$PlusBlockStartState.prototype, "stateType", null);
module.exports.PlusBlockStartState = $42fdd58a54abf462$var$PlusBlockStartState; //# sourceMappingURL=PlusBlockStartState.js.map

});

parcelRegister("02msZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $00719d6fc8e1814f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PlusLoopbackState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $frUMD = parcelRequire("frUMD");


var $4w9vi = parcelRequire("4w9vi");

/** Decision state for `A+` and `(A|B)+`.  It has two transitions:
 *  one to the loop back to start of the block and one to exit.
 */ class $00719d6fc8e1814f$var$PlusLoopbackState extends $frUMD.DecisionState {
    get stateType() {
        return $jW0J3.ATNStateType.PLUS_LOOP_BACK;
    }
}
$00719d6fc8e1814f$var$__decorate([
    $4w9vi.Override
], $00719d6fc8e1814f$var$PlusLoopbackState.prototype, "stateType", null);
module.exports.PlusLoopbackState = $00719d6fc8e1814f$var$PlusLoopbackState; //# sourceMappingURL=PlusLoopbackState.js.map

});

parcelRegister("ucBKb", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $05ac951906e3d94e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $05ac951906e3d94e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrecedencePredicateTransition = void 0;

var $4Lzcj = parcelRequire("4Lzcj");


var $4w9vi = parcelRequire("4w9vi");


var $cAJ3R = parcelRequire("cAJ3R");

/**
 *
 * @author Sam Harwell
 */ let $05ac951906e3d94e$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $4Lzcj.AbstractPredicateTransition {
    get serializationType() {
        return 10 /* PRECEDENCE */ ;
    }
    get isEpsilon() {
        return true;
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return false;
    }
    get predicate() {
        return new $cAJ3R.SemanticContext.PrecedencePredicate(this.precedence);
    }
    toString() {
        return this.precedence + " >= _p";
    }
    constructor(target, precedence){
        super(target);
        this.precedence = precedence;
    }
};
$05ac951906e3d94e$var$__decorate([
    $4w9vi.Override
], $05ac951906e3d94e$var$PrecedencePredicateTransition.prototype, "serializationType", null);
$05ac951906e3d94e$var$__decorate([
    $4w9vi.Override
], $05ac951906e3d94e$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
$05ac951906e3d94e$var$__decorate([
    $4w9vi.Override
], $05ac951906e3d94e$var$PrecedencePredicateTransition.prototype, "matches", null);
$05ac951906e3d94e$var$__decorate([
    $4w9vi.Override
], $05ac951906e3d94e$var$PrecedencePredicateTransition.prototype, "toString", null);
$05ac951906e3d94e$var$PrecedencePredicateTransition = $05ac951906e3d94e$var$__decorate([
    $05ac951906e3d94e$var$__param(0, $4w9vi.NotNull)
], $05ac951906e3d94e$var$PrecedencePredicateTransition);
module.exports.PrecedencePredicateTransition = $05ac951906e3d94e$var$PrecedencePredicateTransition; //# sourceMappingURL=PrecedencePredicateTransition.js.map

});

parcelRegister("i8IS6", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d34bc7ebfa26157e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d34bc7ebfa26157e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangeTransition = void 0;

var $g8cb0 = parcelRequire("g8cb0");


var $4w9vi = parcelRequire("4w9vi");


var $151Ma = parcelRequire("151Ma");

let $d34bc7ebfa26157e$var$RangeTransition = class RangeTransition extends $151Ma.Transition {
    get serializationType() {
        return 2 /* RANGE */ ;
    }
    get label() {
        return $g8cb0.IntervalSet.of(this.from, this.to);
    }
    matches(symbol, minVocabSymbol, maxVocabSymbol) {
        return symbol >= this.from && symbol <= this.to;
    }
    toString() {
        return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
    }
    constructor(target, from, to){
        super(target);
        this.from = from;
        this.to = to;
    }
};
$d34bc7ebfa26157e$var$__decorate([
    $4w9vi.Override
], $d34bc7ebfa26157e$var$RangeTransition.prototype, "serializationType", null);
$d34bc7ebfa26157e$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $d34bc7ebfa26157e$var$RangeTransition.prototype, "label", null);
$d34bc7ebfa26157e$var$__decorate([
    $4w9vi.Override
], $d34bc7ebfa26157e$var$RangeTransition.prototype, "matches", null);
$d34bc7ebfa26157e$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $d34bc7ebfa26157e$var$RangeTransition.prototype, "toString", null);
$d34bc7ebfa26157e$var$RangeTransition = $d34bc7ebfa26157e$var$__decorate([
    $d34bc7ebfa26157e$var$__param(0, $4w9vi.NotNull)
], $d34bc7ebfa26157e$var$RangeTransition);
module.exports.RangeTransition = $d34bc7ebfa26157e$var$RangeTransition; //# sourceMappingURL=RangeTransition.js.map

});

parcelRegister("juHvA", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $e312918a22313a8b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleStartState = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $4w9vi = parcelRequire("4w9vi");

class $e312918a22313a8b$var$RuleStartState extends $ltT8J.ATNState {
    get stateType() {
        return $jW0J3.ATNStateType.RULE_START;
    }
    constructor(){
        super(...arguments);
        this.isPrecedenceRule = false;
        this.leftFactored = false;
    }
}
$e312918a22313a8b$var$__decorate([
    $4w9vi.Override
], $e312918a22313a8b$var$RuleStartState.prototype, "stateType", null);
module.exports.RuleStartState = $e312918a22313a8b$var$RuleStartState; //# sourceMappingURL=RuleStartState.js.map

});

parcelRegister("97ZDg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6a54936a8d437c3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarBlockStartState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $lvaZD = parcelRequire("lvaZD");


var $4w9vi = parcelRequire("4w9vi");

/** The block that begins a closure loop. */ class $6a54936a8d437c3c$var$StarBlockStartState extends $lvaZD.BlockStartState {
    get stateType() {
        return $jW0J3.ATNStateType.STAR_BLOCK_START;
    }
}
$6a54936a8d437c3c$var$__decorate([
    $4w9vi.Override
], $6a54936a8d437c3c$var$StarBlockStartState.prototype, "stateType", null);
module.exports.StarBlockStartState = $6a54936a8d437c3c$var$StarBlockStartState; //# sourceMappingURL=StarBlockStartState.js.map

});

parcelRegister("3sdjf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $283e4f9eb93ec0dc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarLoopbackState = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $4w9vi = parcelRequire("4w9vi");

class $283e4f9eb93ec0dc$var$StarLoopbackState extends $ltT8J.ATNState {
    get loopEntryState() {
        return this.transition(0).target;
    }
    get stateType() {
        return $jW0J3.ATNStateType.STAR_LOOP_BACK;
    }
}
$283e4f9eb93ec0dc$var$__decorate([
    $4w9vi.Override
], $283e4f9eb93ec0dc$var$StarLoopbackState.prototype, "stateType", null);
module.exports.StarLoopbackState = $283e4f9eb93ec0dc$var$StarLoopbackState; //# sourceMappingURL=StarLoopbackState.js.map

});

parcelRegister("1dk9Y", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0e26a4b093c5c0c4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokensStartState = void 0;

var $jW0J3 = parcelRequire("jW0J3");


var $frUMD = parcelRequire("frUMD");


var $4w9vi = parcelRequire("4w9vi");

/** The Tokens rule start state linking to each lexer rule start state */ class $0e26a4b093c5c0c4$var$TokensStartState extends $frUMD.DecisionState {
    get stateType() {
        return $jW0J3.ATNStateType.TOKEN_START;
    }
}
$0e26a4b093c5c0c4$var$__decorate([
    $4w9vi.Override
], $0e26a4b093c5c0c4$var$TokensStartState.prototype, "stateType", null);
module.exports.TokensStartState = $0e26a4b093c5c0c4$var$TokensStartState; //# sourceMappingURL=TokensStartState.js.map

});

parcelRegister("8eluj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $5fe04c98f9ecb457$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5fe04c98f9ecb457$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseInfo = void 0;

var $4w9vi = parcelRequire("4w9vi");

/**
 * This class provides access to specific and aggregate statistics gathered
 * during profiling of a parser.
 *
 * @since 4.3
 */ let $5fe04c98f9ecb457$var$ParseInfo = class ParseInfo {
    /**
     * Gets an array of {@link DecisionInfo} instances containing the profiling
     * information gathered for each decision in the ATN.
     *
     * @returns An array of {@link DecisionInfo} instances, indexed by decision
     * number.
     */ getDecisionInfo() {
        return this.atnSimulator.getDecisionInfo();
    }
    /**
     * Gets the decision numbers for decisions that required one or more
     * full-context predictions during parsing. These are decisions for which
     * {@link DecisionInfo#LL_Fallback} is non-zero.
     *
     * @returns A list of decision numbers which required one or more
     * full-context predictions during parsing.
     */ getLLDecisions() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let LL = [];
        for(let i = 0; i < decisions.length; i++){
            let fallBack = decisions[i].LL_Fallback;
            if (fallBack > 0) LL.push(i);
        }
        return LL;
    }
    /**
     * Gets the total time spent during prediction across all decisions made
     * during parsing. This value is the sum of
     * {@link DecisionInfo#timeInPrediction} for all decisions.
     */ getTotalTimeInPrediction() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let t = 0;
        for (let decision of decisions)t += decision.timeInPrediction;
        return t;
    }
    /**
     * Gets the total number of SLL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#SLL_TotalLook} for all decisions.
     */ getTotalSLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of LL lookahead operations across all decisions
     * made during parsing. This value is the sum of
     * {@link DecisionInfo#LL_TotalLook} for all decisions.
     */ getTotalLLLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_TotalLook;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL prediction
     * across all decisions made during parsing.
     */ getTotalSLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.SLL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for LL prediction
     * across all decisions made during parsing.
     */ getTotalLLATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions)k += decision.LL_ATNTransitions;
        return k;
    }
    /**
     * Gets the total number of ATN lookahead operations for SLL and LL
     * prediction across all decisions made during parsing.
     *
     * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
     * {@link #getTotalLLATNLookaheadOps}.
     */ getTotalATNLookaheadOps() {
        let decisions = this.atnSimulator.getDecisionInfo();
        let k = 0;
        for (let decision of decisions){
            k += decision.SLL_ATNTransitions;
            k += decision.LL_ATNTransitions;
        }
        return k;
    }
    getDFASize(decision) {
        if (decision) {
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
            return decisionToDFA.states.size;
        } else {
            let n = 0;
            let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
            for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
            return n;
        }
    }
    constructor(atnSimulator){
        this.atnSimulator = atnSimulator;
    }
};
$5fe04c98f9ecb457$var$__decorate([
    $4w9vi.NotNull
], $5fe04c98f9ecb457$var$ParseInfo.prototype, "getDecisionInfo", null);
$5fe04c98f9ecb457$var$__decorate([
    $4w9vi.NotNull
], $5fe04c98f9ecb457$var$ParseInfo.prototype, "getLLDecisions", null);
$5fe04c98f9ecb457$var$ParseInfo = $5fe04c98f9ecb457$var$__decorate([
    $5fe04c98f9ecb457$var$__param(0, $4w9vi.NotNull)
], $5fe04c98f9ecb457$var$ParseInfo);
module.exports.ParseInfo = $5fe04c98f9ecb457$var$ParseInfo; //# sourceMappingURL=ParseInfo.js.map

});

parcelRegister("lINPT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $fd045d700debc64f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyParserErrorListener = void 0;

var $fPBfc = parcelRequire("fPBfc");


var $4w9vi = parcelRequire("4w9vi");

/**
 * @author Sam Harwell
 */ class $fd045d700debc64f$var$ProxyParserErrorListener extends $fPBfc.ProxyErrorListener {
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
        });
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
        });
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        this.getDelegates().forEach((listener)=>{
            if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
        });
    }
    constructor(delegates){
        super(delegates);
    }
}
$fd045d700debc64f$var$__decorate([
    $4w9vi.Override
], $fd045d700debc64f$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
$fd045d700debc64f$var$__decorate([
    $4w9vi.Override
], $fd045d700debc64f$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
$fd045d700debc64f$var$__decorate([
    $4w9vi.Override
], $fd045d700debc64f$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
module.exports.ProxyParserErrorListener = $fd045d700debc64f$var$ProxyParserErrorListener; //# sourceMappingURL=ProxyParserErrorListener.js.map

});

parcelRegister("bRhh0", function(module, exports) {

let $8a220b0eb87599d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a220b0eb87599d8$var$load("jbOaK").then(()=>parcelRequire('eWlOH'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("gcyqD", function(module, exports) {

let $bcb87922d2b07731$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcb87922d2b07731$var$load("1Qgo1").then(()=>parcelRequire('8eqKx'));

});

parcelRegister("im4Ak", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseCancellationException = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:42.5447085-07:00
/**
 * This exception is thrown to cancel a parsing operation. This exception does
 * not extend {@link RecognitionException}, allowing it to bypass the standard
 * error recovery mechanisms. {@link BailErrorStrategy} throws this exception in
 * response to a parse error.
 *
 * @author Sam Harwell
 */ class $d5cdd69180e8cc9b$var$ParseCancellationException extends Error {
    getCause() {
        return this.cause;
    }
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.stack = cause.stack;
    }
}
module.exports.ParseCancellationException = $d5cdd69180e8cc9b$var$ParseCancellationException; //# sourceMappingURL=ParseCancellationException.js.map

});

parcelRegister("gvaIw", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c037dace78c882c9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $c037dace78c882c9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferedTokenStream = void 0;

var $9ir1r = parcelRequire("9ir1r");


var $dasyL = parcelRequire("dasyL");


var $kCyYI = parcelRequire("kCyYI");


var $hEcm0 = parcelRequire("hEcm0");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

/**
 * This implementation of {@link TokenStream} loads tokens from a
 * {@link TokenSource} on-demand, and places the tokens in a buffer to provide
 * access to any previous token by index.
 *
 * This token stream ignores the value of {@link Token#getChannel}. If your
 * parser requires the token stream filter tokens to only those on a particular
 * channel, such as {@link Token#DEFAULT_CHANNEL} or
 * {@link Token#HIDDEN_CHANNEL}, use a filtering token stream such a
 * {@link CommonTokenStream}.
 */ let $c037dace78c882c9$var$BufferedTokenStream = class BufferedTokenStream {
    get tokenSource() {
        return this._tokenSource;
    }
    /** Reset this token stream by setting its token source. */ set tokenSource(tokenSource) {
        this._tokenSource = tokenSource;
        this.tokens.length = 0;
        this.p = -1;
        this.fetchedEOF = false;
    }
    get index() {
        return this.p;
    }
    mark() {
        return 0;
    }
    release(marker) {
    // no resources to release
    }
    seek(index) {
        this.lazyInit();
        this.p = this.adjustSeekIndex(index);
    }
    get size() {
        return this.tokens.length;
    }
    consume() {
        let skipEofCheck;
        if (this.p >= 0) {
            if (this.fetchedEOF) // the last token in tokens is EOF. skip check if p indexes any
            // fetched token except the last.
            skipEofCheck = this.p < this.tokens.length - 1;
            else // no EOF token in tokens. skip check if p indexes a fetched token.
            skipEofCheck = this.p < this.tokens.length;
        } else // not yet initialized
        skipEofCheck = false;
        if (!skipEofCheck && this.LA(1) === $lxPhv.Token.EOF) throw new Error("cannot consume EOF");
        if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
    }
    /** Make sure index `i` in tokens has a token.
     *
     * @returns `true` if a token is located at index `i`, otherwise
     *    `false`.
     * @see #get(int i)
     */ sync(i) {
        $9ir1r(i >= 0);
        let n = i - this.tokens.length + 1; // how many more elements we need?
        //System.out.println("sync("+i+") needs "+n);
        if (n > 0) {
            let fetched = this.fetch(n);
            return fetched >= n;
        }
        return true;
    }
    /** Add `n` elements to buffer.
     *
     * @returns The actual number of elements added to the buffer.
     */ fetch(n) {
        if (this.fetchedEOF) return 0;
        for(let i = 0; i < n; i++){
            let t = this.tokenSource.nextToken();
            if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
            this.tokens.push(t);
            if (t.type === $lxPhv.Token.EOF) {
                this.fetchedEOF = true;
                return i + 1;
            }
        }
        return n;
    }
    get(i) {
        if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
        return this.tokens[i];
    }
    /** Get all tokens from start..stop inclusively. */ getRange(start, stop) {
        if (start < 0 || stop < 0) return [];
        this.lazyInit();
        let subset = new Array();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $lxPhv.Token.EOF) break;
            subset.push(t);
        }
        return subset;
    }
    LA(i) {
        let token = this.LT(i);
        if (!token) return $lxPhv.Token.INVALID_TYPE;
        return token.type;
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        return this.tokens[this.p - k];
    }
    LT(k) {
        let result = this.tryLT(k);
        if (result === undefined) throw new RangeError("requested lookback index out of range");
        return result;
    }
    tryLT(k) {
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p + k - 1;
        this.sync(i);
        if (i >= this.tokens.length) // return EOF token
        // EOF must be last token
        return this.tokens[this.tokens.length - 1];
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /**
     * Allowed derived classes to modify the behavior of operations which change
     * the current stream position by adjusting the target token index of a seek
     * operation. The default implementation simply returns `i`. If an
     * exception is thrown in this method, the current stream index should not be
     * changed.
     *
     * For example, {@link CommonTokenStream} overrides this method to ensure that
     * the seek target is always an on-channel token.
     *
     * @param i The target token index.
     * @returns The adjusted target token index.
     */ adjustSeekIndex(i) {
        return i;
    }
    lazyInit() {
        if (this.p === -1) this.setup();
    }
    setup() {
        this.sync(0);
        this.p = this.adjustSeekIndex(0);
    }
    /** Given a start and stop index, return a `List` of all tokens in
     *  the token type `BitSet`.  Return an empty array if no tokens were found.  This
     *  method looks at both on and off channel tokens.
     */ getTokens(start, stop, types) {
        this.lazyInit();
        if (start === undefined) {
            $9ir1r(stop === undefined && types === undefined);
            return this.tokens;
        } else if (stop === undefined) stop = this.tokens.length - 1;
        if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
        if (start > stop) return [];
        if (types === undefined) return this.tokens.slice(start, stop + 1);
        else if (typeof types === "number") types = new Set().add(types);
        let typesSet = types;
        // list = tokens[start:stop]:{T t, t.type in types}
        let filteredTokens = this.tokens.slice(start, stop + 1);
        filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
        return filteredTokens;
    }
    /**
     * Given a starting index, return the index of the next token on channel.
     * Return `i` if `tokens[i]` is on channel. Return the index of
     * the EOF token if there are no tokens on channel between `i` and
     * EOF.
     */ nextTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) return this.size - 1;
        let token = this.tokens[i];
        while(token.channel !== channel){
            if (token.type === $lxPhv.Token.EOF) return i;
            i++;
            this.sync(i);
            token = this.tokens[i];
        }
        return i;
    }
    /**
     * Given a starting index, return the index of the previous token on
     * channel. Return `i` if `tokens[i]` is on channel. Return -1
     * if there are no tokens on channel between `i` and 0.
     *
     * If `i` specifies an index at or after the EOF token, the EOF token
     * index is returned. This is due to the fact that the EOF token is treated
     * as though it were on every channel.
     */ previousTokenOnChannel(i, channel) {
        this.sync(i);
        if (i >= this.size) // the EOF token is on every channel
        return this.size - 1;
        while(i >= 0){
            let token = this.tokens[i];
            if (token.type === $lxPhv.Token.EOF || token.channel === channel) return i;
            i--;
        }
        return i;
    }
    /** Collect all tokens on specified channel to the right of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL} or
     *  EOF. If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToRight(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $hEcm0.Lexer.DEFAULT_TOKEN_CHANNEL);
        let to;
        let from = tokenIndex + 1;
        // if none onchannel to right, nextOnChannel=-1 so set to = last token
        if (nextOnChannel === -1) to = this.size - 1;
        else to = nextOnChannel;
        return this.filterForChannel(from, to, channel);
    }
    /** Collect all tokens on specified channel to the left of
     *  the current token up until we see a token on {@link Lexer#DEFAULT_TOKEN_CHANNEL}.
     *  If `channel` is `-1`, find any non default channel token.
     */ getHiddenTokensToLeft(tokenIndex, channel = -1) {
        this.lazyInit();
        if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
        if (tokenIndex === 0) // obviously no tokens can appear before the first token
        return [];
        let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $hEcm0.Lexer.DEFAULT_TOKEN_CHANNEL);
        if (prevOnChannel === tokenIndex - 1) return [];
        // if none onchannel to left, prevOnChannel=-1 then from=0
        let from = prevOnChannel + 1;
        let to = tokenIndex - 1;
        return this.filterForChannel(from, to, channel);
    }
    filterForChannel(from, to, channel) {
        let hidden = new Array();
        for(let i = from; i <= to; i++){
            let t = this.tokens[i];
            if (channel === -1) {
                if (t.channel !== $hEcm0.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
            } else if (t.channel === channel) hidden.push(t);
        }
        return hidden;
    }
    get sourceName() {
        return this.tokenSource.sourceName;
    }
    getText(interval) {
        if (interval === undefined) interval = $kCyYI.Interval.of(0, this.size - 1);
        else if (!(interval instanceof $kCyYI.Interval)) // Note: the more obvious check for 'instanceof RuleContext' results in a circular dependency problem
        interval = interval.sourceInterval;
        let start = interval.a;
        let stop = interval.b;
        if (start < 0 || stop < 0) return "";
        this.fill();
        if (stop >= this.tokens.length) stop = this.tokens.length - 1;
        let buf = "";
        for(let i = start; i <= stop; i++){
            let t = this.tokens[i];
            if (t.type === $lxPhv.Token.EOF) break;
            buf += t.text;
        }
        return buf.toString();
    }
    getTextFromRange(start, stop) {
        if (this.isToken(start) && this.isToken(stop)) return this.getText($kCyYI.Interval.of(start.tokenIndex, stop.tokenIndex));
        return "";
    }
    /** Get all tokens from lexer until EOF. */ fill() {
        this.lazyInit();
        const blockSize = 1000;
        while(true){
            let fetched = this.fetch(blockSize);
            if (fetched < blockSize) return;
        }
    }
    // TODO: Figure out a way to make this more flexible?
    isWritableToken(t) {
        return t instanceof $dasyL.CommonToken;
    }
    // TODO: Figure out a way to make this more flexible?
    isToken(t) {
        return t instanceof $dasyL.CommonToken;
    }
    constructor(tokenSource){
        /**
         * A collection of all tokens fetched from the token source. The list is
         * considered a complete view of the input once {@link #fetchedEOF} is set
         * to `true`.
         */ this.tokens = [];
        /**
         * The index into {@link #tokens} of the current token (next token to
         * {@link #consume}). {@link #tokens}`[`{@link #p}`]` should be
         * {@link #LT LT(1)}.
         *
         * This field is set to -1 when the stream is first constructed or when
         * {@link #setTokenSource} is called, indicating that the first token has
         * not yet been fetched from the token source. For additional information,
         * see the documentation of {@link IntStream} for a description of
         * Initializing Methods.
         */ this.p = -1;
        /**
         * Indicates whether the {@link Token#EOF} token has been fetched from
         * {@link #tokenSource} and added to {@link #tokens}. This field improves
         * performance for the following cases:
         *
         * * {@link #consume}: The lookahead check in {@link #consume} to prevent
         *   consuming the EOF symbol is optimized by checking the values of
         *   {@link #fetchedEOF} and {@link #p} instead of calling {@link #LA}.
         * * {@link #fetch}: The check to prevent adding multiple EOF symbols into
         *   {@link #tokens} is trivial with this field.
         */ this.fetchedEOF = false;
        if (tokenSource == null) throw new Error("tokenSource cannot be null");
        this._tokenSource = tokenSource;
    }
};
$c037dace78c882c9$var$__decorate([
    $4w9vi.NotNull
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "tokenSource", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "index", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "mark", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "release", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "seek", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "size", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "consume", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "get", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "LA", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.NotNull,
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "LT", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "sourceName", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.NotNull,
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "getText", null);
$c037dace78c882c9$var$__decorate([
    $4w9vi.NotNull,
    $4w9vi.Override
], $c037dace78c882c9$var$BufferedTokenStream.prototype, "getTextFromRange", null);
$c037dace78c882c9$var$BufferedTokenStream = $c037dace78c882c9$var$__decorate([
    $c037dace78c882c9$var$__param(0, $4w9vi.NotNull)
], $c037dace78c882c9$var$BufferedTokenStream);
module.exports.BufferedTokenStream = $c037dace78c882c9$var$BufferedTokenStream; //# sourceMappingURL=BufferedTokenStream.js.map

});

parcelRegister("3DQZ5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=CharStream.js.map

});

parcelRegister("892DV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CharStreams = void 0;

var $8O5Sc = parcelRequire("8O5Sc");


var $1mRlg = parcelRequire("1mRlg");


var $eK8do = parcelRequire("eK8do");

// const DEFAULT_BUFFER_SIZE: number = 4096;
/** This class represents the primary interface for creating {@link CharStream}s
 *  from a variety of sources as of 4.7.  The motivation was to support
 *  Unicode code points > U+FFFF.  {@link ANTLRInputStream} and
 *  {@link ANTLRFileStream} are now deprecated in favor of the streams created
 *  by this interface.
 *
 *  DEPRECATED: {@code new ANTLRFileStream("myinputfile")}
 *  NEW:        {@code CharStreams.fromFileName("myinputfile")}
 *
 *  WARNING: If you use both the deprecated and the new streams, you will see
 *  a nontrivial performance degradation. This speed hit is because the
 *  {@link Lexer}'s internal code goes from a monomorphic to megamorphic
 *  dynamic dispatch to get characters from the input stream. Java's
 *  on-the-fly compiler (JIT) is unable to perform the same optimizations
 *  so stick with either the old or the new streams, if performance is
 *  a primary concern. See the extreme debugging and spelunking
 *  needed to identify this issue in our timing rig:
 *
 *      https://github.com/antlr/antlr4/pull/1781
 *
 *  The ANTLR character streams still buffer all the input when you create
 *  the stream, as they have done for ~20 years. If you need unbuffered
 *  access, please note that it becomes challenging to create
 *  parse trees. The parse tree has to point to tokens which will either
 *  point into a stale location in an unbuffered stream or you have to copy
 *  the characters out of the buffer into the token. That defeats the purpose
 *  of unbuffered input. Per the ANTLR book, unbuffered streams are primarily
 *  useful for processing infinite streams *during the parse.*
 *
 *  The new streams also use 8-bit buffers when possible so this new
 *  interface supports character streams that use half as much memory
 *  as the old {@link ANTLRFileStream}, which assumed 16-bit characters.
 *
 *  A big shout out to Ben Hamilton (github bhamiltoncx) for his superhuman
 *  efforts across all targets to get true Unicode 3.1 support for U+10FFFF.
 *
 *  @since 4.7
 */ var $5ee136da3d5fb3e9$var$CharStreams;
(function(CharStreams) {
    // /**
    //  * Creates a {@link CharStream} given a path to a UTF-8
    //  * encoded file on disk.
    //  *
    //  * Reads the entire contents of the file into the result before returning.
    //  */
    // export function fromFile(file: File): CharStream;
    // export function fromFile(file: File, charset: Charset): CharStream;
    // export function fromFile(file: File, charset?: Charset): CharStream {
    // 	if (charset === undefined) {
    // 		charset = Charset.forName("UTF-8");
    // 	}
    function fromString(s, sourceName) {
        if (sourceName === undefined || sourceName.length === 0) sourceName = $eK8do.IntStream.UNKNOWN_SOURCE_NAME;
        // Initial guess assumes no code points > U+FFFF: one code
        // point for each code unit in the string
        let codePointBufferBuilder = $8O5Sc.CodePointBuffer.builder(s.length);
        // TODO: CharBuffer.wrap(String) rightfully returns a read-only buffer
        // which doesn't expose its array, so we make a copy.
        let cb = new Uint16Array(s.length);
        for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
        codePointBufferBuilder.append(cb);
        return $1mRlg.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
    }
    CharStreams.fromString = fromString;
// export function bufferFromChannel(
// 	channel: ReadableByteChannel,
// 	charset: Charset,
// 	bufferSize: number,
// 	decodingErrorAction: CodingErrorAction,
// 	inputSize: number): CodePointBuffer {
// 	try {
// 		let utf8BytesIn: Uint8Array = new Uint8Array(bufferSize);
// 		let utf16CodeUnitsOut: Uint16Array = new Uint16Array(bufferSize);
// 		if (inputSize === -1) {
// 			inputSize = bufferSize;
// 		} else if (inputSize > Integer.MAX_VALUE) {
// 			// ByteBuffer et al don't support long sizes
// 			throw new RangeError(`inputSize ${inputSize} larger than max ${Integer.MAX_VALUE}`);
// 		}
// 		let codePointBufferBuilder: CodePointBuffer.Builder = CodePointBuffer.builder(inputSize);
// 		let decoder: CharsetDecoder = charset
// 				.newDecoder()
// 				.onMalformedInput(decodingErrorAction)
// 				.onUnmappableCharacter(decodingErrorAction);
// 		let endOfInput: boolean = false;
// 		while (!endOfInput) {
// 			let bytesRead: number = channel.read(utf8BytesIn);
// 			endOfInput = (bytesRead === -1);
// 			utf8BytesIn.flip();
// 			let result: CoderResult = decoder.decode(
// 				utf8BytesIn,
// 				utf16CodeUnitsOut,
// 				endOfInput);
// 			if (result.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 				result.throwException();
// 			}
// 			utf16CodeUnitsOut.flip();
// 			codePointBufferBuilder.append(utf16CodeUnitsOut);
// 			utf8BytesIn.compact();
// 			utf16CodeUnitsOut.compact();
// 		}
// 		// Handle any bytes at the end of the file which need to
// 		// be represented as errors or substitution characters.
// 		let flushResult: CoderResult = decoder.flush(utf16CodeUnitsOut);
// 		if (flushResult.isError() && decodingErrorAction === CodingErrorAction.REPORT) {
// 			flushResult.throwException();
// 		}
// 		utf16CodeUnitsOut.flip();
// 		codePointBufferBuilder.append(utf16CodeUnitsOut);
// 		return codePointBufferBuilder.build();
// 	}
// 	finally {
// 		channel.close();
// 	}
// }
})($5ee136da3d5fb3e9$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {})); //# sourceMappingURL=CharStreams.js.map

});

parcelRegister("8O5Sc", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointBuffer = void 0;

var $9ir1r = parcelRequire("9ir1r");


var $k0RKh = parcelRequire("k0RKh");

/**
 * Wrapper for `Uint8Array` / `Uint16Array` / `Int32Array`.
 */ class $66978c8be353ab37$var$CodePointBuffer {
    static withArray(buffer) {
        return new $66978c8be353ab37$var$CodePointBuffer(buffer, buffer.length);
    }
    get position() {
        return this._position;
    }
    set position(newPosition) {
        if (newPosition < 0 || newPosition > this._size) throw new RangeError();
        this._position = newPosition;
    }
    get remaining() {
        return this._size - this.position;
    }
    get(offset) {
        return this.buffer[offset];
    }
    array() {
        return this.buffer.slice(0, this._size);
    }
    static builder(initialBufferSize) {
        return new $66978c8be353ab37$var$CodePointBuffer.Builder(initialBufferSize);
    }
    constructor(buffer, size){
        this.buffer = buffer;
        this._position = 0;
        this._size = size;
    }
}
module.exports.CodePointBuffer = $66978c8be353ab37$var$CodePointBuffer;
(function(CodePointBuffer) {
    let Type;
    (function(Type) {
        Type[Type["BYTE"] = 0] = "BYTE";
        Type[Type["CHAR"] = 1] = "CHAR";
        Type[Type["INT"] = 2] = "INT";
    })(Type || (Type = {}));
    class Builder {
        build() {
            return new CodePointBuffer(this.buffer, this.position);
        }
        static roundUpToNextPowerOfTwo(i) {
            let nextPowerOfTwo = 32 - Math.clz32(i - 1);
            return Math.pow(2, nextPowerOfTwo);
        }
        ensureRemaining(remainingNeeded) {
            switch(this.type){
                case 0 /* BYTE */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint8Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 1 /* CHAR */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Uint16Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
                case 2 /* INT */ :
                    if (this.buffer.length - this.position < remainingNeeded) {
                        let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                        let newBuffer = new Int32Array(newCapacity);
                        newBuffer.set(this.buffer.subarray(0, this.position), 0);
                        this.buffer = newBuffer;
                    }
                    break;
            }
        }
        append(utf16In) {
            this.ensureRemaining(utf16In.length);
            this.appendArray(utf16In);
        }
        appendArray(utf16In) {
            switch(this.type){
                case 0 /* BYTE */ :
                    this.appendArrayByte(utf16In);
                    break;
                case 1 /* CHAR */ :
                    this.appendArrayChar(utf16In);
                    break;
                case 2 /* INT */ :
                    this.appendArrayInt(utf16In);
                    break;
            }
        }
        appendArrayByte(utf16In) {
            $9ir1r(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outByte = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (c <= 0xFF) outByte[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    if (!$k0RKh.isHighSurrogate(c)) {
                        this.byteToCharBuffer(utf16In.length);
                        this.appendArrayChar(utf16In);
                        return;
                    } else {
                        this.byteToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayChar(utf16In) {
            $9ir1r(this.prevHighSurrogate === -1);
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outChar = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                if (!$k0RKh.isHighSurrogate(c)) outChar[outOffset] = c;
                else {
                    utf16In = utf16In.subarray(inOffset, inLimit);
                    this.position = outOffset;
                    this.charToIntBuffer(utf16In.length);
                    this.appendArrayInt(utf16In);
                    return;
                }
                inOffset++;
                outOffset++;
            }
            this.position = outOffset;
        }
        appendArrayInt(utf16In) {
            let input = utf16In;
            let inOffset = 0;
            let inLimit = utf16In.length;
            let outInt = this.buffer;
            let outOffset = this.position;
            while(inOffset < inLimit){
                let c = input[inOffset];
                inOffset++;
                if (this.prevHighSurrogate !== -1) {
                    if ($k0RKh.isLowSurrogate(c)) {
                        outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                        outOffset++;
                        this.prevHighSurrogate = -1;
                    } else {
                        // Dangling high surrogate
                        outInt[outOffset] = this.prevHighSurrogate;
                        outOffset++;
                        if ($k0RKh.isHighSurrogate(c)) this.prevHighSurrogate = c;
                        else {
                            outInt[outOffset] = c;
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        }
                    }
                } else if ($k0RKh.isHighSurrogate(c)) this.prevHighSurrogate = c;
                else {
                    outInt[outOffset] = c;
                    outOffset++;
                }
            }
            if (this.prevHighSurrogate !== -1) {
                // Dangling high surrogate
                outInt[outOffset] = this.prevHighSurrogate;
                outOffset++;
            }
            this.position = outOffset;
        }
        byteToCharBuffer(toAppend) {
            // CharBuffers hold twice as much per unit as ByteBuffers, so start with half the capacity.
            let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 1 /* CHAR */ ;
            this.buffer = newBuffer;
        }
        byteToIntBuffer(toAppend) {
            // IntBuffers hold four times as much per unit as ByteBuffers, so start with one quarter the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        charToIntBuffer(toAppend) {
            // IntBuffers hold two times as much per unit as ByteBuffers, so start with one half the capacity.
            let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
            newBuffer.set(this.buffer.subarray(0, this.position), 0);
            this.type = 2 /* INT */ ;
            this.buffer = newBuffer;
        }
        constructor(initialBufferSize){
            this.type = 0 /* BYTE */ ;
            this.buffer = new Uint8Array(initialBufferSize);
            this.prevHighSurrogate = -1;
            this.position = 0;
        }
    }
    CodePointBuffer.Builder = Builder;
})($66978c8be353ab37$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {})); //# sourceMappingURL=CodePointBuffer.js.map

});

parcelRegister("k0RKh", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
function $e91d7f77772af286$var$isHighSurrogate(ch) {
    return ch >= 0xD800 && ch <= 0xDBFF;
}
module.exports.isHighSurrogate = $e91d7f77772af286$var$isHighSurrogate;
function $e91d7f77772af286$var$isLowSurrogate(ch) {
    return ch >= 0xDC00 && ch <= 0xDFFF;
}
module.exports.isLowSurrogate = $e91d7f77772af286$var$isLowSurrogate;
function $e91d7f77772af286$var$isSupplementaryCodePoint(ch) {
    return ch >= 0x10000;
}
module.exports.isSupplementaryCodePoint = $e91d7f77772af286$var$isSupplementaryCodePoint; //# sourceMappingURL=Character.js.map

});

parcelRegister("1mRlg", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $0ff13919d1230514$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodePointCharStream = void 0;

var $9ir1r = parcelRequire("9ir1r");


var $eK8do = parcelRequire("eK8do");


var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");

/**
 * Alternative to {@link ANTLRInputStream} which treats the input
 * as a series of Unicode code points, instead of a series of UTF-16
 * code units.
 *
 * Use this if you need to parse input which potentially contains
 * Unicode values > U+FFFF.
 */ class $0ff13919d1230514$var$CodePointCharStream {
    get internalStorage() {
        return this._array;
    }
    static fromBuffer(codePointBuffer, name) {
        if (name === undefined || name.length === 0) name = $eK8do.IntStream.UNKNOWN_SOURCE_NAME;
        // Java lacks generics on primitive types.
        //
        // To avoid lots of calls to virtual methods in the
        // very hot codepath of LA() below, we construct one
        // of three concrete subclasses.
        //
        // The concrete subclasses directly access the code
        // points stored in the underlying array (byte[],
        // char[], or int[]), so we can avoid lots of virtual
        // method calls to ByteBuffer.get(offset).
        return new $0ff13919d1230514$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
    }
    consume() {
        if (this._size - this._position === 0) {
            $9ir1r(this.LA(1) === $eK8do.IntStream.EOF);
            throw new RangeError("cannot consume EOF");
        }
        this._position++;
    }
    get index() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    /** mark/release do nothing; we have entire buffer */ mark() {
        return -1;
    }
    release(marker) {
    // No default implementation since this stream buffers the entire input
    }
    seek(index) {
        this._position = index;
    }
    get sourceName() {
        return this._name;
    }
    toString() {
        return this.getText($kCyYI.Interval.of(0, this.size - 1));
    }
    LA(i) {
        let offset;
        switch(Math.sign(i)){
            case -1:
                offset = this.index + i;
                if (offset < 0) return $eK8do.IntStream.EOF;
                return this._array[offset];
            case 0:
                // Undefined
                return 0;
            case 1:
                offset = this.index + i - 1;
                if (offset >= this.size) return $eK8do.IntStream.EOF;
                return this._array[offset];
        }
        throw new RangeError("Not reached");
    }
    /** Return the UTF-16 encoded string for the given interval */ getText(interval) {
        const startIdx = Math.min(interval.a, this.size);
        const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
        if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
    }
    // Use the factory method {@link #fromBuffer(CodePointBuffer)} to
    // construct instances of this type.
    constructor(array, position, remaining, name){
        // TODO
        $9ir1r(position === 0);
        this._array = array;
        this._size = remaining;
        this._name = name;
        this._position = 0;
    }
}
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "consume", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "index", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "size", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "mark", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "release", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "seek", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "sourceName", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "toString", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "LA", null);
$0ff13919d1230514$var$__decorate([
    $4w9vi.Override
], $0ff13919d1230514$var$CodePointCharStream.prototype, "getText", null);
module.exports.CodePointCharStream = $0ff13919d1230514$var$CodePointCharStream; //# sourceMappingURL=CodePointCharStream.js.map

});

parcelRegister("bO1lR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $8985699f95a96297$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $8985699f95a96297$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommonTokenStream = void 0;

var $gvaIw = parcelRequire("gvaIw");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

/**
 * This class extends {@link BufferedTokenStream} with functionality to filter
 * token streams to tokens on a particular channel (tokens where
 * {@link Token#getChannel} returns a particular value).
 *
 * This token stream provides access to all tokens by index or when calling
 * methods like {@link #getText}. The channel filtering is only used for code
 * accessing tokens via the lookahead methods {@link #LA}, {@link #LT}, and
 * {@link #LB}.
 *
 * By default, tokens are placed on the default channel
 * ({@link Token#DEFAULT_CHANNEL}), but may be reassigned by using the
 * `->channel(HIDDEN)` lexer command, or by using an embedded action to
 * call {@link Lexer#setChannel}.
 *
 * Note: lexer rules which use the `->skip` lexer command or call
 * {@link Lexer#skip} do not produce tokens at all, so input text matched by
 * such a rule will not be available as part of the token stream, regardless of
 * channel.
 */ let $8985699f95a96297$var$CommonTokenStream = class CommonTokenStream extends $gvaIw.BufferedTokenStream {
    adjustSeekIndex(i) {
        return this.nextTokenOnChannel(i, this.channel);
    }
    tryLB(k) {
        if (this.p - k < 0) return undefined;
        let i = this.p;
        let n = 1;
        // find k good tokens looking backwards
        while(n <= k && i > 0){
            // skip off-channel tokens
            i = this.previousTokenOnChannel(i - 1, this.channel);
            n++;
        }
        if (i < 0) return undefined;
        return this.tokens[i];
    }
    tryLT(k) {
        //System.out.println("enter LT("+k+")");
        this.lazyInit();
        if (k === 0) throw new RangeError("0 is not a valid lookahead index");
        if (k < 0) return this.tryLB(-k);
        let i = this.p;
        let n = 1; // we know tokens[p] is a good one
        // find k good tokens
        while(n < k){
            // skip off-channel tokens, but make sure to not look past EOF
            if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
            n++;
        }
        //		if ( i>range ) range = i;
        return this.tokens[i];
    }
    /** Count EOF just once. */ getNumberOfOnChannelTokens() {
        let n = 0;
        this.fill();
        for (let t of this.tokens){
            if (t.channel === this.channel) n++;
            if (t.type === $lxPhv.Token.EOF) break;
        }
        return n;
    }
    /**
     * Constructs a new {@link CommonTokenStream} using the specified token
     * source and filtering tokens to the specified channel. Only tokens whose
     * {@link Token#getChannel} matches `channel` or have the
     * `Token.type` equal to {@link Token#EOF} will be returned by the
     * token stream lookahead methods.
     *
     * @param tokenSource The token source.
     * @param channel The channel to use for filtering tokens.
     */ constructor(tokenSource, channel = $lxPhv.Token.DEFAULT_CHANNEL){
        super(tokenSource);
        this.channel = channel;
    }
};
$8985699f95a96297$var$__decorate([
    $4w9vi.Override
], $8985699f95a96297$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
$8985699f95a96297$var$__decorate([
    $4w9vi.Override
], $8985699f95a96297$var$CommonTokenStream.prototype, "tryLB", null);
$8985699f95a96297$var$__decorate([
    $4w9vi.Override
], $8985699f95a96297$var$CommonTokenStream.prototype, "tryLT", null);
$8985699f95a96297$var$CommonTokenStream = $8985699f95a96297$var$__decorate([
    $8985699f95a96297$var$__param(0, $4w9vi.NotNull)
], $8985699f95a96297$var$CommonTokenStream);
module.exports.CommonTokenStream = $8985699f95a96297$var$CommonTokenStream; //# sourceMappingURL=CommonTokenStream.js.map

});

parcelRegister("30Gp3", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dependents = void 0;
// ConvertTo-TS run at 2016-10-04T11:26:51.1349829-07:00
/**
 *
 * @author Sam Harwell
 */ var $23124388fa9e6760$var$Dependents;
(function(Dependents) {
    /**
     * The element is dependent upon the specified rule.
     */ Dependents[Dependents["SELF"] = 0] = "SELF";
    /**
     * The element is dependent upon the set of the specified rule's parents
     * (rules which directly reference it).
     */ Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
    /**
     * The element is dependent upon the set of the specified rule's children
     * (rules which it directly references).
     */ Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
    /**
     * The element is dependent upon the set of the specified rule's ancestors
     * (the transitive closure of `PARENTS` rules).
     */ Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
    /**
     * The element is dependent upon the set of the specified rule's descendants
     * (the transitive closure of `CHILDREN` rules).
     */ Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
    /**
     * The element is dependent upon the set of the specified rule's siblings
     * (the union of `CHILDREN` of its `PARENTS`).
     */ Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear before a reference to the rule).
     */ Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's following
     * siblings (the union of `CHILDREN` of its `PARENTS` which
     * appear after a reference to the rule).
     */ Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
    /**
     * The element is dependent upon the set of the specified rule's preceeding
     * elements (rules which might end before the start of the specified rule
     * while parsing). This is calculated by taking the
     * `PRECEEDING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
    /**
     * The element is dependent upon the set of the specified rule's following
     * elements (rules which might start after the end of the specified rule
     * while parsing). This is calculated by taking the
     * `FOLLOWING_SIBLINGS` of the rule and each of its
     * `ANCESTORS`, along with the `DESCENDANTS` of those
     * elements.
     */ Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
})($23124388fa9e6760$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {})); //# sourceMappingURL=Dependents.js.map

});

parcelRegister("7qAGk", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $56876a56b4d9c16d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $56876a56b4d9c16d$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiagnosticErrorListener = void 0;

var $6YKio = parcelRequire("6YKio");


var $4w9vi = parcelRequire("4w9vi");


var $kCyYI = parcelRequire("kCyYI");

/**
 * This implementation of {@link ANTLRErrorListener} can be used to identify
 * certain potential correctness and performance problems in grammars. "Reports"
 * are made by calling {@link Parser#notifyErrorListeners} with the appropriate
 * message.
 *
 * * **Ambiguities**: These are cases where more than one path through the
 *   grammar can match the input.
 * * **Weak context sensitivity**: These are cases where full-context
 *   prediction resolved an SLL conflict to a unique alternative which equaled the
 *   minimum alternative of the SLL conflict.
 * * **Strong (forced) context sensitivity**: These are cases where the
 *   full-context prediction resolved an SLL conflict to a unique alternative,
 *   *and* the minimum alternative of the SLL conflict was found to not be
 *   a truly viable alternative. Two-stage parsing cannot be used for inputs where
 *   this situation occurs.
 *
 * @author Sam Harwell
 */ class $56876a56b4d9c16d$var$DiagnosticErrorListener {
    syntaxError(/*@NotNull*/ recognizer, offendingSymbol, line, charPositionInLine, /*@NotNull*/ msg, e) {
    // intentionally empty
    }
    reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
        if (this.exactOnly && !exact) return;
        let decision = this.getDecisionDescription(recognizer, dfa);
        let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
        let text = recognizer.inputStream.getText($kCyYI.Interval.of(startIndex, stopIndex));
        let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
        let format = "reportAttemptingFullContext d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($kCyYI.Interval.of(startIndex, stopIndex));
        let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
        let format = "reportContextSensitivity d=%s, input='%s'";
        let decision = this.getDecisionDescription(recognizer, dfa);
        let text = recognizer.inputStream.getText($kCyYI.Interval.of(startIndex, stopIndex));
        let message = `reportContextSensitivity d=${decision}, input='${text}'`;
        recognizer.notifyErrorListeners(message);
    }
    getDecisionDescription(recognizer, dfa) {
        let decision = dfa.decision;
        let ruleIndex = dfa.atnStartState.ruleIndex;
        let ruleNames = recognizer.ruleNames;
        if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
        let ruleName = ruleNames[ruleIndex];
        if (!ruleName) return decision.toString();
        return `${decision} (${ruleName})`;
    }
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `undefined`, otherwise
     * returns the set of alternatives represented in `configs`.
     */ getConflictingAlts(reportedAlts, configs) {
        if (reportedAlts != null) return reportedAlts;
        let result = new $6YKio.BitSet();
        for (let config of configs)result.set(config.alt);
        return result;
    }
    /**
     * Initializes a new instance of {@link DiagnosticErrorListener}, specifying
     * whether all ambiguities or only exact ambiguities are reported.
     *
     * @param exactOnly `true` to report only exact ambiguities, otherwise
     * `false` to report all ambiguities.  Defaults to true.
     */ constructor(exactOnly = true){
        this.exactOnly = exactOnly;
        this.exactOnly = exactOnly;
    }
}
$56876a56b4d9c16d$var$__decorate([
    $4w9vi.Override
], $56876a56b4d9c16d$var$DiagnosticErrorListener.prototype, "syntaxError", null);
$56876a56b4d9c16d$var$__decorate([
    $4w9vi.Override,
    $56876a56b4d9c16d$var$__param(0, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(1, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(6, $4w9vi.NotNull)
], $56876a56b4d9c16d$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
$56876a56b4d9c16d$var$__decorate([
    $4w9vi.Override,
    $56876a56b4d9c16d$var$__param(0, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(1, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(5, $4w9vi.NotNull)
], $56876a56b4d9c16d$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
$56876a56b4d9c16d$var$__decorate([
    $4w9vi.Override,
    $56876a56b4d9c16d$var$__param(0, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(1, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(5, $4w9vi.NotNull)
], $56876a56b4d9c16d$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
$56876a56b4d9c16d$var$__decorate([
    $56876a56b4d9c16d$var$__param(0, $4w9vi.NotNull),
    $56876a56b4d9c16d$var$__param(1, $4w9vi.NotNull)
], $56876a56b4d9c16d$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
$56876a56b4d9c16d$var$__decorate([
    $4w9vi.NotNull,
    $56876a56b4d9c16d$var$__param(1, $4w9vi.NotNull)
], $56876a56b4d9c16d$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
module.exports.DiagnosticErrorListener = $56876a56b4d9c16d$var$DiagnosticErrorListener; //# sourceMappingURL=DiagnosticErrorListener.js.map

});

parcelRegister("9payv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $6d8ea2f2ba79b4a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InterpreterRuleContext = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $7EUlr = parcelRequire("7EUlr");

/**
 * This class extends {@link ParserRuleContext} by allowing the value of
 * {@link #getRuleIndex} to be explicitly set for the context.
 *
 * {@link ParserRuleContext} does not include field storage for the rule index
 * since the context classes created by the code generator override the
 * {@link #getRuleIndex} method to return the correct value for that context.
 * Since the parser interpreter does not use the context classes generated for a
 * parser, this class (with slightly more memory overhead per node) is used to
 * provide equivalent functionality.
 */ class $6d8ea2f2ba79b4a7$var$InterpreterRuleContext extends $7EUlr.ParserRuleContext {
    get ruleIndex() {
        return this._ruleIndex;
    }
    constructor(ruleIndex, parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._ruleIndex = ruleIndex;
    }
}
$6d8ea2f2ba79b4a7$var$__decorate([
    $4w9vi.Override
], $6d8ea2f2ba79b4a7$var$InterpreterRuleContext.prototype, "ruleIndex", null);
module.exports.InterpreterRuleContext = $6d8ea2f2ba79b4a7$var$InterpreterRuleContext; //# sourceMappingURL=InterpreterRuleContext.js.map

});

parcelRegister("e4hZr", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a3df64d88ce2c3d1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a3df64d88ce2c3d1$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerInterpreter = void 0;

var $hEcm0 = parcelRequire("hEcm0");


var $l5Qwf = parcelRequire("l5Qwf");


var $4w9vi = parcelRequire("4w9vi");




let $a3df64d88ce2c3d1$var$LexerInterpreter = class LexerInterpreter extends $hEcm0.Lexer {
    get atn() {
        return this._atn;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get channelNames() {
        return this._channelNames;
    }
    get modeNames() {
        return this._modeNames;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
        super(input);
        if (atn.grammarType !== 0 /* LEXER */ ) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
        this._grammarFileName = grammarFileName;
        this._atn = atn;
        this._ruleNames = ruleNames.slice(0);
        this._channelNames = channelNames.slice(0);
        this._modeNames = modeNames.slice(0);
        this._vocabulary = vocabulary;
        this._interp = new $l5Qwf.LexerATNSimulator(atn, this);
    }
};
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.NotNull
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "_vocabulary", void 0);
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.Override
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "atn", null);
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.Override
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "grammarFileName", null);
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.Override
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "ruleNames", null);
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.Override
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "channelNames", null);
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.Override
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "modeNames", null);
$a3df64d88ce2c3d1$var$__decorate([
    $4w9vi.Override
], $a3df64d88ce2c3d1$var$LexerInterpreter.prototype, "vocabulary", null);
$a3df64d88ce2c3d1$var$LexerInterpreter = $a3df64d88ce2c3d1$var$__decorate([
    $a3df64d88ce2c3d1$var$__param(1, $4w9vi.NotNull)
], $a3df64d88ce2c3d1$var$LexerInterpreter);
module.exports.LexerInterpreter = $a3df64d88ce2c3d1$var$LexerInterpreter; //# sourceMappingURL=LexerInterpreter.js.map

});

parcelRegister("lgiUf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f7a9c1fb8426f695$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f7a9c1fb8426f695$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListTokenSource = void 0;

var $aucRF = parcelRequire("aucRF");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

/**
 * Provides an implementation of {@link TokenSource} as a wrapper around a list
 * of {@link Token} objects.
 *
 * If the final token in the list is an {@link Token#EOF} token, it will be used
 * as the EOF token for every call to {@link #nextToken} after the end of the
 * list is reached. Otherwise, an EOF token will be created.
 */ let $f7a9c1fb8426f695$var$ListTokenSource = class ListTokenSource {
    /**
     * {@inheritDoc}
     */ get charPositionInLine() {
        if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
        else if (this.eofToken != null) return this.eofToken.charPositionInLine;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let tokenText = lastToken.text;
            if (tokenText != null) {
                let lastNewLine = tokenText.lastIndexOf("\n");
                if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
            }
            return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 0;
    }
    /**
     * {@inheritDoc}
     */ nextToken() {
        if (this.i >= this.tokens.length) {
            if (this.eofToken == null) {
                let start = -1;
                if (this.tokens.length > 0) {
                    let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                    if (previousStop !== -1) start = previousStop + 1;
                }
                let stop = Math.max(-1, start - 1);
                this.eofToken = this._factory.create({
                    source: this,
                    stream: this.inputStream
                }, $lxPhv.Token.EOF, "EOF", $lxPhv.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
            }
            return this.eofToken;
        }
        let t = this.tokens[this.i];
        if (this.i === this.tokens.length - 1 && t.type === $lxPhv.Token.EOF) this.eofToken = t;
        this.i++;
        return t;
    }
    /**
     * {@inheritDoc}
     */ get line() {
        if (this.i < this.tokens.length) return this.tokens[this.i].line;
        else if (this.eofToken != null) return this.eofToken.line;
        else if (this.tokens.length > 0) {
            // have to calculate the result from the line/column of the previous
            // token, along with the text of the token.
            let lastToken = this.tokens[this.tokens.length - 1];
            let line = lastToken.line;
            let tokenText = lastToken.text;
            if (tokenText != null) {
                for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
            }
            // if no text is available, assume the token did not contain any newline characters.
            return line;
        }
        // only reach this if tokens is empty, meaning EOF occurs at the first
        // position in the input
        return 1;
    }
    /**
     * {@inheritDoc}
     */ get inputStream() {
        if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
        else if (this.eofToken != null) return this.eofToken.inputStream;
        else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
        // no input stream information is available
        return undefined;
    }
    /**
     * {@inheritDoc}
     */ get sourceName() {
        if (this._sourceName) return this._sourceName;
        let inputStream = this.inputStream;
        if (inputStream != null) return inputStream.sourceName;
        return "List";
    }
    /**
     * {@inheritDoc}
     */ // @Override
    set tokenFactory(factory) {
        this._factory = factory;
    }
    /**
     * {@inheritDoc}
     */ get tokenFactory() {
        return this._factory;
    }
    /**
     * Constructs a new {@link ListTokenSource} instance from the specified
     * collection of {@link Token} objects and source name.
     *
     * @param tokens The collection of {@link Token} objects to provide as a
     * {@link TokenSource}.
     * @param sourceName The name of the {@link TokenSource}. If this value is
     * `undefined`, {@link #getSourceName} will attempt to infer the name from
     * the next {@link Token} (or the previous token if the end of the input has
     * been reached).
     *
     * @exception NullPointerException if `tokens` is `undefined`
     */ constructor(tokens, sourceName){
        /**
         * The index into {@link #tokens} of token to return by the next call to
         * {@link #nextToken}. The end of the input is indicated by this value
         * being greater than or equal to the number of items in {@link #tokens}.
         */ this.i = 0;
        /**
         * This is the backing field for {@link #getTokenFactory} and
         * {@link setTokenFactory}.
         */ this._factory = $aucRF.CommonTokenFactory.DEFAULT;
        if (tokens == null) throw new Error("tokens cannot be null");
        this.tokens = tokens;
        this._sourceName = sourceName;
    }
};
$f7a9c1fb8426f695$var$__decorate([
    $4w9vi.Override
], $f7a9c1fb8426f695$var$ListTokenSource.prototype, "charPositionInLine", null);
$f7a9c1fb8426f695$var$__decorate([
    $4w9vi.Override
], $f7a9c1fb8426f695$var$ListTokenSource.prototype, "nextToken", null);
$f7a9c1fb8426f695$var$__decorate([
    $4w9vi.Override
], $f7a9c1fb8426f695$var$ListTokenSource.prototype, "line", null);
$f7a9c1fb8426f695$var$__decorate([
    $4w9vi.Override
], $f7a9c1fb8426f695$var$ListTokenSource.prototype, "inputStream", null);
$f7a9c1fb8426f695$var$__decorate([
    $4w9vi.Override
], $f7a9c1fb8426f695$var$ListTokenSource.prototype, "sourceName", null);
$f7a9c1fb8426f695$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull,
    $f7a9c1fb8426f695$var$__param(0, $4w9vi.NotNull)
], $f7a9c1fb8426f695$var$ListTokenSource.prototype, "tokenFactory", null);
$f7a9c1fb8426f695$var$ListTokenSource = $f7a9c1fb8426f695$var$__decorate([
    $f7a9c1fb8426f695$var$__param(0, $4w9vi.NotNull)
], $f7a9c1fb8426f695$var$ListTokenSource);
module.exports.ListTokenSource = $f7a9c1fb8426f695$var$ListTokenSource; //# sourceMappingURL=ListTokenSource.js.map

});

parcelRegister("6gTKJ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=ParserErrorListener.js.map

});

parcelRegister("ed0cM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a5827057d99664c8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $a5827057d99664c8$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserInterpreter = void 0;

var $ltT8J = parcelRequire("ltT8J");


var $jW0J3 = parcelRequire("jW0J3");


var $6YKio = parcelRequire("6YKio");


var $2M3s9 = parcelRequire("2M3s9");


var $1GSEa = parcelRequire("1GSEa");


var $9payv = parcelRequire("9payv");


var $i2y55 = parcelRequire("i2y55");


var $4w9vi = parcelRequire("4w9vi");





var $dCLTv = parcelRequire("dCLTv");


var $e2oSX = parcelRequire("e2oSX");


var $jzLQT = parcelRequire("jzLQT");


var $9nX6N = parcelRequire("9nX6N");


var $lxPhv = parcelRequire("lxPhv");

/** A parser simulator that mimics what ANTLR's generated
 *  parser code does. A ParserATNSimulator is used to make
 *  predictions via adaptivePredict but this class moves a pointer through the
 *  ATN to simulate parsing. ParserATNSimulator just
 *  makes us efficient rather than having to backtrack, for example.
 *
 *  This properly creates parse trees even for left recursive rules.
 *
 *  We rely on the left recursive rule invocation and special predicate
 *  transitions to make left recursive rules work.
 *
 *  See TestParserInterpreter for examples.
 */ let $a5827057d99664c8$var$ParserInterpreter = class ParserInterpreter extends $dCLTv.Parser {
    reset(resetInput) {
        if (resetInput === undefined) super.reset();
        else super.reset(resetInput);
        this.overrideDecisionReached = false;
        this._overrideDecisionRoot = undefined;
    }
    get atn() {
        return this._atn;
    }
    get vocabulary() {
        return this._vocabulary;
    }
    get ruleNames() {
        return this._ruleNames;
    }
    get grammarFileName() {
        return this._grammarFileName;
    }
    /** Begin parsing at startRuleIndex */ parse(startRuleIndex) {
        let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
        this._rootContext = this.createInterpreterRuleContext(undefined, $ltT8J.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
        if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
        else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
        while(true){
            let p = this.atnState;
            switch(p.stateType){
                case $jW0J3.ATNStateType.RULE_STOP:
                    // pop; return from rule
                    if (this._ctx.isEmpty) {
                        if (startRuleStartState.isPrecedenceRule) {
                            let result = this._ctx;
                            let parentContext = this._parentContextStack.pop();
                            this.unrollRecursionContexts(parentContext[0]);
                            return result;
                        } else {
                            this.exitRule();
                            return this._rootContext;
                        }
                    }
                    this.visitRuleStopState(p);
                    break;
                default:
                    try {
                        this.visitState(p);
                    } catch (e) {
                        if (e instanceof $jzLQT.RecognitionException) {
                            this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                            this.context.exception = e;
                            this.errorHandler.reportError(this, e);
                            this.recover(e);
                        } else throw e;
                    }
                    break;
            }
        }
    }
    enterRecursionRule(localctx, state, ruleIndex, precedence) {
        this._parentContextStack.push([
            this._ctx,
            localctx.invokingState
        ]);
        super.enterRecursionRule(localctx, state, ruleIndex, precedence);
    }
    get atnState() {
        return this._atn.states[this.state];
    }
    visitState(p) {
        let predictedAlt = 1;
        if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
        let transition = p.transition(predictedAlt - 1);
        switch(transition.serializationType){
            case 1 /* EPSILON */ :
                if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $i2y55.LoopEndState)) {
                    // We are at the start of a left recursive rule's (...)* loop
                    // and we're not taking the exit branch of loop.
                    let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                    let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                    this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                }
                break;
            case 5 /* ATOM */ :
                this.match(transition._label);
                break;
            case 2 /* RANGE */ :
            case 7 /* SET */ :
            case 8 /* NOT_SET */ :
                if (!transition.matches(this._input.LA(1), $lxPhv.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                this.matchWildcard();
                break;
            case 9 /* WILDCARD */ :
                this.matchWildcard();
                break;
            case 3 /* RULE */ :
                let ruleStartState = transition.target;
                let ruleIndex = ruleStartState.ruleIndex;
                let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                break;
            case 4 /* PREDICATE */ :
                let predicateTransition = transition;
                if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $2M3s9.FailedPredicateException(this);
                break;
            case 6 /* ACTION */ :
                let actionTransition = transition;
                this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                break;
            case 10 /* PRECEDENCE */ :
                if (!this.precpred(this._ctx, transition.precedence)) {
                    let precedence = transition.precedence;
                    throw new $2M3s9.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                }
                break;
            default:
                throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
        }
        this.state = transition.target.stateNumber;
    }
    /** Method visitDecisionState() is called when the interpreter reaches
     *  a decision state (instance of DecisionState). It gives an opportunity
     *  for subclasses to track interesting things.
     */ visitDecisionState(p) {
        let predictedAlt;
        this.errorHandler.sync(this);
        let decision = p.decision;
        if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
            predictedAlt = this.overrideDecisionAlt;
            this.overrideDecisionReached = true;
        } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
        return predictedAlt;
    }
    /** Provide simple "factory" for InterpreterRuleContext's.
     *  @since 4.5.1
     */ createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
        return new $9payv.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
    }
    visitRuleStopState(p) {
        let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
        if (ruleStartState.isPrecedenceRule) {
            let parentContext = this._parentContextStack.pop();
            this.unrollRecursionContexts(parentContext[0]);
            this.state = parentContext[1];
        } else this.exitRule();
        let ruleTransition = this._atn.states[this.state].transition(0);
        this.state = ruleTransition.followState.stateNumber;
    }
    /** Override this parser interpreters normal decision-making process
     *  at a particular decision and input token index. Instead of
     *  allowing the adaptive prediction mechanism to choose the
     *  first alternative within a block that leads to a successful parse,
     *  force it to take the alternative, 1..n for n alternatives.
     *
     *  As an implementation limitation right now, you can only specify one
     *  override. This is sufficient to allow construction of different
     *  parse trees for ambiguous input. It means re-parsing the entire input
     *  in general because you're never sure where an ambiguous sequence would
     *  live in the various parse trees. For example, in one interpretation,
     *  an ambiguous input sequence would be matched completely in expression
     *  but in another it could match all the way back to the root.
     *
     *  s : e '!'? ;
     *  e : ID
     *    | ID '!'
     *    ;
     *
     *  Here, x! can be matched as (s (e ID) !) or (s (e ID !)). In the first
     *  case, the ambiguous sequence is fully contained only by the root.
     *  In the second case, the ambiguous sequences fully contained within just
     *  e, as in: (e ID !).
     *
     *  Rather than trying to optimize this and make
     *  some intelligent decisions for optimization purposes, I settled on
     *  just re-parsing the whole input and then using
     *  {link Trees#getRootOfSubtreeEnclosingRegion} to find the minimal
     *  subtree that contains the ambiguous sequence. I originally tried to
     *  record the call stack at the point the parser detected and ambiguity but
     *  left recursive rules create a parse tree stack that does not reflect
     *  the actual call stack. That impedance mismatch was enough to make
     *  it it challenging to restart the parser at a deeply nested rule
     *  invocation.
     *
     *  Only parser interpreters can override decisions so as to avoid inserting
     *  override checking code in the critical ALL(*) prediction execution path.
     *
     *  @since 4.5
     */ addDecisionOverride(decision, tokenIndex, forcedAlt) {
        this.overrideDecision = decision;
        this.overrideDecisionInputIndex = tokenIndex;
        this.overrideDecisionAlt = forcedAlt;
    }
    get overrideDecisionRoot() {
        return this._overrideDecisionRoot;
    }
    /** Rely on the error handler for this parser but, if no tokens are consumed
     *  to recover, add an error node. Otherwise, nothing is seen in the parse
     *  tree.
     */ recover(e) {
        let i = this._input.index;
        this.errorHandler.recover(this, e);
        if (this._input.index === i) {
            // no input consumed, better add an error node
            let tok = e.getOffendingToken();
            if (!tok) throw new Error("Expected exception to have an offending token");
            let source = tok.tokenSource;
            let stream = source !== undefined ? source.inputStream : undefined;
            let sourcePair = {
                source: source,
                stream: stream
            };
            if (e instanceof $1GSEa.InputMismatchException) {
                let expectedTokens = e.expectedTokens;
                if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                let expectedTokenType = $lxPhv.Token.INVALID_TYPE;
                if (!expectedTokens.isNil) // get any element
                expectedTokenType = expectedTokens.minElement;
                let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $lxPhv.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            } else {
                let source = tok.tokenSource;
                let errToken = this.tokenFactory.create(sourcePair, $lxPhv.Token.INVALID_TYPE, tok.text, $lxPhv.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
            }
        }
    }
    recoverInline() {
        return this._errHandler.recoverInline(this);
    }
    /** Return the root of the parse, which can be useful if the parser
     *  bails out. You still can access the top node. Note that,
     *  because of the way left recursive rules add children, it's possible
     *  that the root will not have any children if the start rule immediately
     *  called and left recursive rule that fails.
     *
     * @since 4.5.1
     */ get rootContext() {
        return this._rootContext;
    }
    constructor(grammarFileName, vocabulary, ruleNames, atn, input){
        super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
        /** This stack corresponds to the _parentctx, _parentState pair of locals
         *  that would exist on call stack frames with a recursive descent parser;
         *  in the generated function for a left-recursive rule you'd see:
         *
         *  private EContext e(int _p) {
         *      ParserRuleContext _parentctx = _ctx;    // Pair.a
         *      int _parentState = state;          // Pair.b
         *      ...
         *  }
         *
         *  Those values are used to create new recursive rule invocation contexts
         *  associated with left operand of an alt like "expr '*' expr".
         */ this._parentContextStack = [];
        /** We need a map from (decision,inputIndex)->forced alt for computing ambiguous
         *  parse trees. For now, we allow exactly one override.
         */ this.overrideDecision = -1;
        this.overrideDecisionInputIndex = -1;
        this.overrideDecisionAlt = -1;
        this.overrideDecisionReached = false; // latch and only override once; error might trigger infinite loop
        /** What is the current context when we override a decisions?  This tells
         *  us what the root of the parse tree is when using override
         *  for an ambiguity/lookahead check.
         */ this._overrideDecisionRoot = undefined;
        if (grammarFileName instanceof ParserInterpreter) {
            let old = grammarFileName;
            this._grammarFileName = old._grammarFileName;
            this._atn = old._atn;
            this.pushRecursionContextStates = old.pushRecursionContextStates;
            this._ruleNames = old._ruleNames;
            this._vocabulary = old._vocabulary;
            this.interpreter = new $e2oSX.ParserATNSimulator(this._atn, this);
        } else {
            // The second constructor requires non-null arguments
            vocabulary;
            ruleNames;
            atn;
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._vocabulary = vocabulary;
            // identify the ATN states where pushNewRecursionContext() must be called
            this.pushRecursionContextStates = new $6YKio.BitSet(atn.states.length);
            for (let state of atn.states){
                if (!(state instanceof $9nX6N.StarLoopEntryState)) continue;
                if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
            }
            // get atn simulator that knows how to do predictions
            this.interpreter = new $e2oSX.ParserATNSimulator(atn, this);
        }
    }
};
$a5827057d99664c8$var$__decorate([
    $4w9vi.NotNull
], $a5827057d99664c8$var$ParserInterpreter.prototype, "_vocabulary", void 0);
$a5827057d99664c8$var$__decorate([
    $4w9vi.Override
], $a5827057d99664c8$var$ParserInterpreter.prototype, "reset", null);
$a5827057d99664c8$var$__decorate([
    $4w9vi.Override
], $a5827057d99664c8$var$ParserInterpreter.prototype, "atn", null);
$a5827057d99664c8$var$__decorate([
    $4w9vi.Override
], $a5827057d99664c8$var$ParserInterpreter.prototype, "vocabulary", null);
$a5827057d99664c8$var$__decorate([
    $4w9vi.Override
], $a5827057d99664c8$var$ParserInterpreter.prototype, "ruleNames", null);
$a5827057d99664c8$var$__decorate([
    $4w9vi.Override
], $a5827057d99664c8$var$ParserInterpreter.prototype, "grammarFileName", null);
$a5827057d99664c8$var$__decorate([
    $4w9vi.Override
], $a5827057d99664c8$var$ParserInterpreter.prototype, "enterRecursionRule", null);
$a5827057d99664c8$var$ParserInterpreter = $a5827057d99664c8$var$__decorate([
    $a5827057d99664c8$var$__param(1, $4w9vi.NotNull)
], $a5827057d99664c8$var$ParserInterpreter);
module.exports.ParserInterpreter = $a5827057d99664c8$var$ParserInterpreter; //# sourceMappingURL=ParserInterpreter.js.map

});

parcelRegister("kNx2J", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f24203e9830ebcf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleContextWithAltNum = void 0;

var $EKDdQ = parcelRequire("EKDdQ");


var $4w9vi = parcelRequire("4w9vi");


var $7EUlr = parcelRequire("7EUlr");

/** A handy class for use with
 *
 *  options {contextSuperClass=org.antlr.v4.runtime.RuleContextWithAltNum;}
 *
 *  that provides a backing field / impl for the outer alternative number
 *  matched for an internal parse tree node.
 *
 *  I'm only putting into Java runtime as I'm certain I'm the only one that
 *  will really every use this.
 */ class $f24203e9830ebcf0$var$RuleContextWithAltNum extends $7EUlr.ParserRuleContext {
    get altNumber() {
        return this._altNumber;
    }
    // @Override
    set altNumber(altNum) {
        this._altNumber = altNum;
    }
    constructor(parent, invokingStateNumber){
        if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
        else super();
        this._altNumber = $EKDdQ.ATN.INVALID_ALT_NUMBER;
    }
}
$f24203e9830ebcf0$var$__decorate([
    $4w9vi.Override
], $f24203e9830ebcf0$var$RuleContextWithAltNum.prototype, "altNumber", null);
module.exports.RuleContextWithAltNum = $f24203e9830ebcf0$var$RuleContextWithAltNum; //# sourceMappingURL=RuleContextWithAltNum.js.map

});

parcelRegister("9D4O5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleDependency = void 0;
/**
 * Declares a dependency upon a grammar rule, along with a set of zero or more dependent rules.
 *
 * Version numbers within a grammar should be assigned on a monotonically increasing basis to allow for accurate
 * tracking of dependent rules.
 *
 * @author Sam Harwell
 */ function $702b7c220efffd58$var$RuleDependency(dependency) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleDependency = $702b7c220efffd58$var$RuleDependency; //# sourceMappingURL=RuleDependency.js.map

});

parcelRegister("6biZ5", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RuleVersion = void 0;
/**
 *
 * @author Sam Harwell
 */ function $48027f0766c3979c$var$RuleVersion(version) {
    return (target, propertyKey, propertyDescriptor)=>{
    // intentionally empty
    };
}
module.exports.RuleVersion = $48027f0766c3979c$var$RuleVersion; //# sourceMappingURL=RuleVersion.js.map

});

parcelRegister("lWDte", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=TokenFactory.js.map

});

parcelRegister("4ctYY", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=TokenSource.js.map

});

parcelRegister("edOCj", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=TokenStream.js.map

});

parcelRegister("7C4OZ", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $58afd26fb7b83fd4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;

var $kCyYI = parcelRequire("kCyYI");


var $4w9vi = parcelRequire("4w9vi");


var $lxPhv = parcelRequire("lxPhv");

/**
 * Useful for rewriting out a buffered input token stream after doing some
 * augmentation or other manipulations on it.
 *
 * You can insert stuff, replace, and delete chunks. Note that the operations
 * are done lazily--only if you convert the buffer to a {@link String} with
 * {@link TokenStream#getText()}. This is very efficient because you are not
 * moving data around all the time. As the buffer of tokens is converted to
 * strings, the {@link #getText()} method(s) scan the input token stream and
 * check to see if there is an operation at the current index. If so, the
 * operation is done and then normal {@link String} rendering continues on the
 * buffer. This is like having multiple Turing machine instruction streams
 * (programs) operating on a single input tape. :)
 *
 * This rewriter makes no modifications to the token stream. It does not ask the
 * stream to fill itself up nor does it advance the input cursor. The token
 * stream `TokenStream.index` will return the same value before and
 * after any {@link #getText()} call.
 *
 * The rewriter only works on tokens that you have in the buffer and ignores the
 * current input cursor. If you are buffering tokens on-demand, calling
 * {@link #getText()} halfway through the input will only do rewrites for those
 * tokens in the first half of the file.
 *
 * Since the operations are done lazily at {@link #getText}-time, operations do
 * not screw up the token index values. That is, an insert operation at token
 * index `i` does not change the index values for tokens
 * `i`+1..n-1.
 *
 * Because operations never actually alter the buffer, you may always get the
 * original token stream back without undoing anything. Since the instructions
 * are queued up, you can easily simulate transactions and roll back any changes
 * if there is an error just by removing instructions. For example,
 *
 * ```
 * CharStream input = new ANTLRFileStream("input");
 * TLexer lex = new TLexer(input);
 * CommonTokenStream tokens = new CommonTokenStream(lex);
 * T parser = new T(tokens);
 * TokenStreamRewriter rewriter = new TokenStreamRewriter(tokens);
 * parser.startRule();
 * ```
 *
 * Then in the rules, you can execute (assuming rewriter is visible):
 *
 * ```
 * Token t,u;
 * ...
 * rewriter.insertAfter(t, "text to put after t");}
 * rewriter.insertAfter(u, "text after u");}
 * System.out.println(rewriter.getText());
 * ```
 *
 * You can also have multiple "instruction streams" and get multiple rewrites
 * from a single pass over the input. Just name the instruction streams and use
 * that name again when printing the buffer. This could be useful for generating
 * a C file and also its header file--all from the same buffer:
 *
 * ```
 * rewriter.insertAfter("pass1", t, "text to put after t");}
 * rewriter.insertAfter("pass2", u, "text after u");}
 * System.out.println(rewriter.getText("pass1"));
 * System.out.println(rewriter.getText("pass2"));
 * ```
 *
 * If you don't use named rewrite streams, a "default" stream is used as the
 * first example shows.
 */ class $58afd26fb7b83fd4$var$TokenStreamRewriter {
    getTokenStream() {
        return this.tokens;
    }
    rollback(instructionIndex, programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let is = this.programs.get(programName);
        if (is != null) this.programs.set(programName, is.slice($58afd26fb7b83fd4$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
    }
    deleteProgram(programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        this.rollback($58afd26fb7b83fd4$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
    }
    insertAfter(tokenOrIndex, text, programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        // to insert after, just insert before next index (even if past end)
        let rewrites = this.getProgram(programName);
        let op = new $58afd26fb7b83fd4$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    insertBefore(tokenOrIndex, text, programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let index;
        if (typeof tokenOrIndex === "number") index = tokenOrIndex;
        else index = tokenOrIndex.tokenIndex;
        let rewrites = this.getProgram(programName);
        let op = new $58afd26fb7b83fd4$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
        rewrites.push(op);
    }
    replaceSingle(index, text) {
        if (typeof index === "number") this.replace(index, index, text);
        else this.replace(index, index, text);
    }
    replace(from, to, text, programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (typeof from !== "number") from = from.tokenIndex;
        if (typeof to !== "number") to = to.tokenIndex;
        if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
        let rewrites = this.getProgram(programName);
        let op = new $58afd26fb7b83fd4$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
        rewrites.push(op);
    }
    delete(from, to, programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        if (to === undefined) to = from;
        if (typeof from === "number") this.replace(from, to, "", programName);
        else this.replace(from, to, "", programName);
    }
    getLastRewriteTokenIndex(programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let I = this.lastRewriteTokenIndexes.get(programName);
        if (I == null) return -1;
        return I;
    }
    setLastRewriteTokenIndex(programName, i) {
        this.lastRewriteTokenIndexes.set(programName, i);
    }
    getProgram(name) {
        let is = this.programs.get(name);
        if (is == null) is = this.initializeProgram(name);
        return is;
    }
    initializeProgram(name) {
        let is = [];
        this.programs.set(name, is);
        return is;
    }
    getText(intervalOrProgram, programName = $58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
        let interval;
        if (intervalOrProgram instanceof $kCyYI.Interval) interval = intervalOrProgram;
        else interval = $kCyYI.Interval.of(0, this.tokens.size - 1);
        if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
        let rewrites = this.programs.get(programName);
        let start = interval.a;
        let stop = interval.b;
        // ensure start/end are in range
        if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
        if (start < 0) start = 0;
        if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval); // no instructions to execute
        let buf = [];
        // First, optimize instruction stream
        let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
        // Walk buffer, executing instructions and emitting tokens
        let i = start;
        while(i <= stop && i < this.tokens.size){
            let op = indexToOp.get(i);
            indexToOp.delete(i); // remove so any left have index size-1
            let t = this.tokens.get(i);
            if (op == null) {
                // no operation at that index, just dump token
                if (t.type !== $lxPhv.Token.EOF) buf.push(String(t.text));
                i++; // move to next token
            } else i = op.execute(buf); // execute operation and skip
        }
        // include stuff after end if it's last index in buffer
        // So, if they did an insertAfter(lastValidIndex, "foo"), include
        // foo if end==lastValidIndex.
        if (stop === this.tokens.size - 1) {
            // Scan any remaining operations after last token
            // should be included (they will be inserts).
            for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
        }
        return buf.join("");
    }
    /** We need to combine operations and report invalid operations (like
     *  overlapping replaces that are not completed nested). Inserts to
     *  same index need to be combined etc...  Here are the cases:
     *
     *  I.i.u I.j.v								leave alone, nonoverlapping
     *  I.i.u I.i.v								combine: Iivu
     *
     *  R.i-j.u R.x-y.v	| i-j in x-y			delete first R
     *  R.i-j.u R.i-j.v							delete first R
     *  R.i-j.u R.x-y.v	| x-y in i-j			ERROR
     *  R.i-j.u R.x-y.v	| boundaries overlap	ERROR
     *
     *  Delete special case of replace (text==undefined):
     *  D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
     *
     *  I.i.u R.x-y.v | i in (x+1)-y			delete I (since insert before
     * 											we're not deleting i)
     *  I.i.u R.x-y.v | i not in (x+1)-y		leave alone, nonoverlapping
     *  R.x-y.v I.i.u | i in x-y				ERROR
     *  R.x-y.v I.x.u 							R.x-y.uv (combine, delete I)
     *  R.x-y.v I.i.u | i not in x-y			leave alone, nonoverlapping
     *
     *  I.i.u = insert u before op @ index i
     *  R.x-y.u = replace x-y indexed tokens with u
     *
     *  First we need to examine replaces. For any replace op:
     *
     * 		1. wipe out any insertions before op within that range.
     * 		2. Drop any replace op before that is contained completely within
     * 	 that range.
     * 		3. Throw exception upon boundary overlap with any previous replace.
     *
     *  Then we can deal with inserts:
     *
     * 		1. for any inserts to same index, combine even if not adjacent.
     * 		2. for any prior replace with same left boundary, combine this
     * 	 insert with replace and delete this replace.
     * 		3. throw exception if index in same range as previous replace
     *
     *  Don't actually delete; make op undefined in list. Easier to walk list.
     *  Later we can throw as we add to index &rarr; op map.
     *
     *  Note that I.2 R.2-2 will wipe out I.2 even though, technically, the
     *  inserted stuff would be before the replace range. But, if you
     *  add tokens in front of a method body '{' and then delete the method
     *  body, I think the stuff before the '{' you added should disappear too.
     *
     *  Return a map from token index to operation.
     */ reduceToSingleOperationPerIndex(rewrites) {
        // console.log(`rewrites=[${Utils.join(rewrites, ", ")}]`);
        // WALK REPLACES
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $58afd26fb7b83fd4$var$ReplaceOp)) continue;
            let rop = op;
            // Wipe prior inserts within range
            let inserts = this.getKindOfOps(rewrites, $58afd26fb7b83fd4$var$InsertBeforeOp, i);
            for (let iop of inserts){
                if (iop.index === rop.index) {
                    // E.g., insert before 2, delete 2..2; update replace
                    // text to include insert before, kill insert
                    rewrites[iop.instructionIndex] = undefined;
                    rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                } else if (iop.index > rop.index && iop.index <= rop.lastIndex) // delete insert as it's a no-op.
                rewrites[iop.instructionIndex] = undefined;
            }
            // Drop any prior replaces contained within
            let prevReplaces = this.getKindOfOps(rewrites, $58afd26fb7b83fd4$var$ReplaceOp, i);
            for (let prevRop of prevReplaces){
                if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                    // delete replace as it's a no-op.
                    rewrites[prevRop.instructionIndex] = undefined;
                    continue;
                }
                // throw exception unless disjoint or identical
                let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                // Delete special case of replace (text==null):
                // D.i-j.u D.x-y.v	| boundaries overlap	combine to max(min)..max(right)
                if (prevRop.text == null && rop.text == null && !disjoint) {
                    // console.log(`overlapping deletes: ${prevRop}, ${rop}`);
                    rewrites[prevRop.instructionIndex] = undefined; // kill first delete
                    rop.index = Math.min(prevRop.index, rop.index);
                    rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                // console.log(`new rop ${rop}`);
                } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
            }
        }
        // WALK INSERTS
        for(let i = 0; i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (!(op instanceof $58afd26fb7b83fd4$var$InsertBeforeOp)) continue;
            let iop = op;
            // combine current insert with prior if any at same index
            let prevInserts = this.getKindOfOps(rewrites, $58afd26fb7b83fd4$var$InsertBeforeOp, i);
            for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                if (prevIop instanceof $58afd26fb7b83fd4$var$InsertAfterOp) {
                    iop.text = this.catOpText(prevIop.text, iop.text);
                    rewrites[prevIop.instructionIndex] = undefined;
                } else if (prevIop instanceof $58afd26fb7b83fd4$var$InsertBeforeOp) {
                    // convert to strings...we're in process of toString'ing
                    // whole token buffer so no lazy eval issue with any templates
                    iop.text = this.catOpText(iop.text, prevIop.text);
                    // delete redundant prior insert
                    rewrites[prevIop.instructionIndex] = undefined;
                }
            }
            // look for replaces where iop.index is in range; error
            let prevReplaces = this.getKindOfOps(rewrites, $58afd26fb7b83fd4$var$ReplaceOp, i);
            for (let rop of prevReplaces){
                if (iop.index === rop.index) {
                    rop.text = this.catOpText(iop.text, rop.text);
                    rewrites[i] = undefined; // delete current insert
                    continue;
                }
                if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
            }
        }
        // console.log(`rewrites after=[${Utils.join(rewrites, ", ")}]`);
        let m = new Map();
        for (let op of rewrites){
            if (op == null) continue;
            if (m.get(op.index) != null) throw new Error("should only be one op per index");
            m.set(op.index, op);
        }
        // console.log(`index to op: ${m}`);
        return m;
    }
    catOpText(a, b) {
        let x = "";
        let y = "";
        if (a != null) x = a.toString();
        if (b != null) y = b.toString();
        return x + y;
    }
    /** Get all operations before an index of a particular kind */ getKindOfOps(rewrites, kind, before) {
        let ops = [];
        for(let i = 0; i < before && i < rewrites.length; i++){
            let op = rewrites[i];
            if (op == null) continue;
            if (op instanceof kind) ops.push(op);
        }
        return ops;
    }
    constructor(tokens){
        this.tokens = tokens;
        this.programs = new Map();
        this.programs.set($58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
        this.lastRewriteTokenIndexes = new Map();
    }
}
module.exports.TokenStreamRewriter = $58afd26fb7b83fd4$var$TokenStreamRewriter;
$58afd26fb7b83fd4$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
$58afd26fb7b83fd4$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
$58afd26fb7b83fd4$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
// Define the rewrite operation hierarchy
class $58afd26fb7b83fd4$var$RewriteOperation {
    /** Execute the rewrite operation by possibly adding to the buffer.
     *  Return the index of the next token to operate on.
     */ execute(buf) {
        return this.index;
    }
    toString() {
        let opName = this.constructor.name;
        let $index = opName.indexOf("$");
        opName = opName.substring($index + 1, opName.length);
        return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
    }
    constructor(tokens, index, instructionIndex, text){
        this.tokens = tokens;
        this.instructionIndex = instructionIndex;
        this.index = index;
        this.text = text === undefined ? "" : text;
    }
}
$58afd26fb7b83fd4$var$__decorate([
    $4w9vi.Override
], $58afd26fb7b83fd4$var$RewriteOperation.prototype, "toString", null);
module.exports.RewriteOperation = $58afd26fb7b83fd4$var$RewriteOperation;
class $58afd26fb7b83fd4$var$InsertBeforeOp extends $58afd26fb7b83fd4$var$RewriteOperation {
    execute(buf) {
        buf.push(this.text.toString());
        if (this.tokens.get(this.index).type !== $lxPhv.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
        return this.index + 1;
    }
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index, instructionIndex, text);
    }
}
$58afd26fb7b83fd4$var$__decorate([
    $4w9vi.Override
], $58afd26fb7b83fd4$var$InsertBeforeOp.prototype, "execute", null);
/** Distinguish between insert after/before to do the "insert afters"
 *  first and then the "insert befores" at same index. Implementation
 *  of "insert after" is "insert before index+1".
 */ class $58afd26fb7b83fd4$var$InsertAfterOp extends $58afd26fb7b83fd4$var$InsertBeforeOp {
    constructor(tokens, index, instructionIndex, text){
        super(tokens, index + 1, instructionIndex, text); // insert after is insert before index+1
    }
}
/** I'm going to try replacing range from x..y with (y-x)+1 ReplaceOp
 *  instructions.
 */ class $58afd26fb7b83fd4$var$ReplaceOp extends $58afd26fb7b83fd4$var$RewriteOperation {
    execute(buf) {
        if (this.text != null) buf.push(this.text.toString());
        return this.lastIndex + 1;
    }
    toString() {
        if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
        return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
    }
    constructor(tokens, from, to, instructionIndex, text){
        super(tokens, from, instructionIndex, text);
        this.lastIndex = to;
    }
}
$58afd26fb7b83fd4$var$__decorate([
    $4w9vi.Override
], $58afd26fb7b83fd4$var$ReplaceOp.prototype, "execute", null);
$58afd26fb7b83fd4$var$__decorate([
    $4w9vi.Override
], $58afd26fb7b83fd4$var$ReplaceOp.prototype, "toString", null); //# sourceMappingURL=TokenStreamRewriter.js.map

});

parcelRegister("jcv78", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=Vocabulary.js.map

});

parcelRegister("7pR22", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
}); //# sourceMappingURL=WritableToken.js.map

});

parcelRegister("f9r94", function(module, exports) {

var $fetTS = parcelRequire("fetTS");


var $hEcm0 = parcelRequire("hEcm0");


var $l5Qwf = parcelRequire("l5Qwf");


var $auHu3 = parcelRequire("auHu3");


var $1rLy7 = parcelRequire("1rLy7");

var $4b0e66ad1c4c426d$var$_JQLLexer;
class $4b0e66ad1c4c426d$export$375c79404cc64c7f extends (0, $hEcm0.Lexer) {
    // @Override
    // @NotNull
    get vocabulary() {
        return $4b0e66ad1c4c426d$export$375c79404cc64c7f.VOCABULARY;
    }
    // @Override
    get grammarFileName() {
        return 'JQLLexer.g4';
    }
    // @Override
    get ruleNames() {
        return $4b0e66ad1c4c426d$export$375c79404cc64c7f.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATN;
    }
    // @Override
    get channelNames() {
        return $4b0e66ad1c4c426d$export$375c79404cc64c7f.channelNames;
    }
    // @Override
    get modeNames() {
        return $4b0e66ad1c4c426d$export$375c79404cc64c7f.modeNames;
    }
    static get _ATN() {
        if (!$4b0e66ad1c4c426d$export$375c79404cc64c7f.__ATN) $4b0e66ad1c4c426d$export$375c79404cc64c7f.__ATN = new (0, $fetTS.ATNDeserializer)().deserialize($1rLy7.toCharArray($4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATN));
        return $4b0e66ad1c4c426d$export$375c79404cc64c7f.__ATN;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input){
        super(input);
        this._interp = new (0, $l5Qwf.LexerATNSimulator)($4b0e66ad1c4c426d$export$375c79404cc64c7f._ATN, this);
    }
}
$4b0e66ad1c4c426d$var$_JQLLexer = $4b0e66ad1c4c426d$export$375c79404cc64c7f;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.LPAREN = 1;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.RPAREN = 2;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.COMMA = 3;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.LBRACKET = 4;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.RBRACKET = 5;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.BANG = 6;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.LT = 7;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.GT = 8;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.GTEQ = 9;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.LTEQ = 10;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.EQUALS = 11;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.NOT_EQUALS = 12;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.LIKE = 13;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.NOT_LIKE = 14;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.IN = 15;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.IS = 16;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.AND = 17;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.OR = 18;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.NOT = 19;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.EMPTY = 20;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.WAS = 21;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.CHANGED = 22;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.BEFORE = 23;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.AFTER = 24;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.FROM = 25;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.TO = 26;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.ON = 27;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.DURING = 28;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.ORDER = 29;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.BY = 30;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.ASC = 31;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.DESC = 32;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.POSNUMBER = 33;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.NEGNUMBER = 34;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.CUSTOMFIELD = 35;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.RESERVED_WORD = 36;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.STRING = 37;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.MATCHWS = 38;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.ERROR_RESERVED = 39;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.ERRORCHAR = 40;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.QUOTE_STRING = 41;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.UNCLOSED_QUOTE_STRING = 42;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.INVALID_QUOTE_STRING = 43;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.SQUOTE_STRING = 44;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.UNCLOSED_SQUOTE_STRING = 45;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.INVALID_SQUOTE_STRING = 46;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.QUOTED_STR = 1;
$4b0e66ad1c4c426d$export$375c79404cc64c7f.SQUOTED_STR = 2;
// tslint:disable:no-trailing-whitespace
$4b0e66ad1c4c426d$export$375c79404cc64c7f.channelNames = [
    'DEFAULT_TOKEN_CHANNEL',
    'HIDDEN'
];
// tslint:disable:no-trailing-whitespace
$4b0e66ad1c4c426d$export$375c79404cc64c7f.modeNames = [
    'DEFAULT_MODE',
    'QUOTED_STR',
    'SQUOTED_STR'
];
$4b0e66ad1c4c426d$export$375c79404cc64c7f.ruleNames = [
    'LPAREN',
    'RPAREN',
    'COMMA',
    'LBRACKET',
    'RBRACKET',
    'LQUOTE',
    'LSQUOTE',
    'BANG',
    'LT',
    'GT',
    'GTEQ',
    'LTEQ',
    'EQUALS',
    'NOT_EQUALS',
    'LIKE',
    'NOT_LIKE',
    'IN',
    'IS',
    'AND',
    'OR',
    'NOT',
    'EMPTY',
    'WAS',
    'CHANGED',
    'BEFORE',
    'AFTER',
    'FROM',
    'TO',
    'ON',
    'DURING',
    'ORDER',
    'BY',
    'ASC',
    'DESC',
    'POSNUMBER',
    'NEGNUMBER',
    'CUSTOMFIELD',
    'RESERVED_WORD',
    'STRING',
    'MATCHWS',
    'ERROR_RESERVED',
    'ERRORCHAR',
    'QUOTE_STRING',
    'QUOTED_CONTENT',
    'UNCLOSED_QUOTE_STRING',
    'INVALID_QUOTE_STRING',
    'SQUOTE_STRING',
    'SQUOTED_CONTENT',
    'UNCLOSED_SQUOTE_STRING',
    'INVALID_SQUOTE_STRING',
    'VALID_UNQUOTED_CHARS',
    'VALID_QUOTED_CHARS',
    'VALID_SQUOTED_CHARS',
    'RESERVED_CHARS',
    'QUOTE',
    'SQUOTE',
    'BSLASH',
    'NL',
    'CR',
    'SPACE',
    'AMPER',
    'AMPER_AMPER',
    'PIPE',
    'PIPE_PIPE',
    'ESCAPE',
    'NEWLINE',
    'HEXDIGIT',
    'WS',
    'MINUS',
    'DIGIT',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
$4b0e66ad1c4c426d$export$375c79404cc64c7f._LITERAL_NAMES = [
    undefined,
    "'('",
    "')'",
    "','",
    "'['",
    "']'",
    "'!'",
    "'<'",
    "'>'",
    "'>='",
    "'<='",
    "'='",
    "'!='",
    "'~'",
    "'!~'"
];
$4b0e66ad1c4c426d$export$375c79404cc64c7f._SYMBOLIC_NAMES = [
    undefined,
    'LPAREN',
    'RPAREN',
    'COMMA',
    'LBRACKET',
    'RBRACKET',
    'BANG',
    'LT',
    'GT',
    'GTEQ',
    'LTEQ',
    'EQUALS',
    'NOT_EQUALS',
    'LIKE',
    'NOT_LIKE',
    'IN',
    'IS',
    'AND',
    'OR',
    'NOT',
    'EMPTY',
    'WAS',
    'CHANGED',
    'BEFORE',
    'AFTER',
    'FROM',
    'TO',
    'ON',
    'DURING',
    'ORDER',
    'BY',
    'ASC',
    'DESC',
    'POSNUMBER',
    'NEGNUMBER',
    'CUSTOMFIELD',
    'RESERVED_WORD',
    'STRING',
    'MATCHWS',
    'ERROR_RESERVED',
    'ERRORCHAR',
    'QUOTE_STRING',
    'UNCLOSED_QUOTE_STRING',
    'INVALID_QUOTE_STRING',
    'SQUOTE_STRING',
    'UNCLOSED_SQUOTE_STRING',
    'INVALID_SQUOTE_STRING'
];
$4b0e66ad1c4c426d$export$375c79404cc64c7f.VOCABULARY = new (0, $auHu3.VocabularyImpl)($4b0e66ad1c4c426d$var$_JQLLexer._LITERAL_NAMES, $4b0e66ad1c4c426d$var$_JQLLexer._SYMBOLIC_NAMES, []);
$4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATNSegments = 3;
$4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
$4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
$4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
$4b0e66ad1c4c426d$export$375c79404cc64c7f._serializedATN = $1rLy7.join([
    $4b0e66ad1c4c426d$var$_JQLLexer._serializedATNSegment0,
    $4b0e66ad1c4c426d$var$_JQLLexer._serializedATNSegment1,
    $4b0e66ad1c4c426d$var$_JQLLexer._serializedATNSegment2
], '');
$4b0e66ad1c4c426d$export$375c79404cc64c7f.__ATN = void 0;
module.exports["JQLLexer"] = $4b0e66ad1c4c426d$export$375c79404cc64c7f;

});

parcelRegister("jHyNg", function(module, exports) {

var $fetTS = parcelRequire("fetTS");


var $dF72r = parcelRequire("dF72r");


var $dCLTv = parcelRequire("dCLTv");


var $7EUlr = parcelRequire("7EUlr");


var $e2oSX = parcelRequire("e2oSX");


var $jzLQT = parcelRequire("jzLQT");


var $lxPhv = parcelRequire("lxPhv");


var $auHu3 = parcelRequire("auHu3");


var $1rLy7 = parcelRequire("1rLy7");

var $f948258ac6616e58$var$_JQLParser;
class $f948258ac6616e58$export$9c4772e191bdb810 extends (0, $dCLTv.Parser) {
    // @Override
    // @NotNull
    get vocabulary() {
        return $f948258ac6616e58$export$9c4772e191bdb810.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'JQLParser.g4';
    }
    // @Override
    get ruleNames() {
        return $f948258ac6616e58$export$9c4772e191bdb810.ruleNames;
    }
    // @Override
    get serializedATN() {
        return $f948258ac6616e58$export$9c4772e191bdb810._serializedATN;
    }
    // @RuleVersion(0)
    jqlQuery() {
        let _localctx = new $f948258ac6616e58$export$ff413535b9575c8(this._ctx, this.state);
        this.enterRule(_localctx, 0, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlQuery);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 83;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la & -32) === 0 && (1 << _la & (1 << $f948258ac6616e58$export$9c4772e191bdb810.LPAREN | 1 << $f948258ac6616e58$export$9c4772e191bdb810.BANG | 1 << $f948258ac6616e58$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.STRING - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 82;
                this.jqlWhere();
            }
            this.state = 86;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $f948258ac6616e58$export$9c4772e191bdb810.ORDER) {
                this.state = 85;
                this.jqlOrderBy();
            }
            this.state = 88;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.EOF);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWhere() {
        let _localctx = new $f948258ac6616e58$export$4148a879cab28017(this._ctx, this.state);
        this.enterRule(_localctx, 2, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWhere);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 90;
            this.jqlOrClause();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrClause() {
        let _localctx = new $f948258ac6616e58$export$d69831d387793480(this._ctx, this.state);
        this.enterRule(_localctx, 4, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOrClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 92;
            this.jqlAndClause();
            this.state = 97;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $f948258ac6616e58$export$9c4772e191bdb810.OR){
                this.state = 93;
                this.match($f948258ac6616e58$export$9c4772e191bdb810.OR);
                this.state = 94;
                this.jqlAndClause();
                this.state = 99;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlAndClause() {
        let _localctx = new $f948258ac6616e58$export$f16819001158b9e(this._ctx, this.state);
        this.enterRule(_localctx, 6, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlAndClause);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 100;
            this.jqlNotClause();
            this.state = 105;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $f948258ac6616e58$export$9c4772e191bdb810.AND){
                this.state = 101;
                this.match($f948258ac6616e58$export$9c4772e191bdb810.AND);
                this.state = 102;
                this.jqlNotClause();
                this.state = 107;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNotClause() {
        let _localctx = new $f948258ac6616e58$export$5e9146f8d5cf1330(this._ctx, this.state);
        this.enterRule(_localctx, 8, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlNotClause);
        let _la;
        try {
            this.state = 112;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.BANG:
                case $f948258ac6616e58$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 108;
                    _la = this._input.LA(1);
                    if (!(_la === $f948258ac6616e58$export$9c4772e191bdb810.BANG || _la === $f948258ac6616e58$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 109;
                    this.jqlNotClause();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.LPAREN:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 110;
                    this.jqlSubClause();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                case $f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD:
                case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 111;
                    this.jqlTerminalClause();
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSubClause() {
        let _localctx = new $f948258ac6616e58$export$a136a0e9655bfb04(this._ctx, this.state);
        this.enterRule(_localctx, 10, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlSubClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 114;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.LPAREN);
            this.state = 115;
            this.jqlOrClause();
            this.state = 116;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClause() {
        let _localctx = new $f948258ac6616e58$export$23486a2f2ddd5bcd(this._ctx, this.state);
        this.enterRule(_localctx, 12, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlTerminalClause);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 118;
            this.jqlField();
            this.state = 119;
            this.jqlTerminalClauseRhs();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlTerminalClauseRhs() {
        let _localctx = new $f948258ac6616e58$export$93924a205c12d32c(this._ctx, this.state);
        this.enterRule(_localctx, 14, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
        let _la;
        try {
            this.state = 176;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                case 1:
                    _localctx = new $f948258ac6616e58$export$c428f709a58396e5(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 121;
                    this.jqlEqualsOperator();
                    this.state = 125;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                        case 1:
                            this.state = 122;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 123;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 124;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 2:
                    _localctx = new $f948258ac6616e58$export$1b131204ef9fa33d(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 127;
                    this.jqlLikeOperator();
                    this.state = 131;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                        case 1:
                            this.state = 128;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 129;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 130;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 3:
                    _localctx = new $f948258ac6616e58$export$d83706ee80a9852a(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 133;
                    this.jqlComparisonOperator();
                    this.state = 136;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                        case 1:
                            this.state = 134;
                            this.jqlValue();
                            break;
                        case 2:
                            this.state = 135;
                            this.jqlFunction();
                            break;
                    }
                    break;
                case 4:
                    _localctx = new $f948258ac6616e58$export$2934b8ff22fddd2d(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 138;
                    this.jqlInOperator();
                    this.state = 141;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $f948258ac6616e58$export$9c4772e191bdb810.LPAREN:
                            this.state = 139;
                            this.jqlList();
                            break;
                        case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                        case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                        case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                        case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                        case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 140;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $dF72r.NoViableAltException)(this);
                    }
                    break;
                case 5:
                    _localctx = new $f948258ac6616e58$export$8b84310182afcf93(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    this.state = 143;
                    this.jqlIsOperator();
                    this.state = 144;
                    this.jqlEmpty();
                    break;
                case 6:
                    _localctx = new $f948258ac6616e58$export$5df295dc7a2cac7c(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    this.state = 146;
                    this.jqlWasOperator();
                    this.state = 150;
                    this._errHandler.sync(this);
                    switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                        case 1:
                            this.state = 147;
                            this.jqlEmpty();
                            break;
                        case 2:
                            this.state = 148;
                            this.jqlValue();
                            break;
                        case 3:
                            this.state = 149;
                            this.jqlFunction();
                            break;
                    }
                    this.state = 155;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $f948258ac6616e58$export$9c4772e191bdb810.BEFORE | 1 << $f948258ac6616e58$export$9c4772e191bdb810.AFTER | 1 << $f948258ac6616e58$export$9c4772e191bdb810.ON | 1 << $f948258ac6616e58$export$9c4772e191bdb810.DURING | 1 << $f948258ac6616e58$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 152;
                        this.jqlWasPredicate();
                        this.state = 157;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 7:
                    _localctx = new $f948258ac6616e58$export$9ac3367aee261b32(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    this.state = 158;
                    this.jqlWasInOperator();
                    this.state = 161;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $f948258ac6616e58$export$9c4772e191bdb810.LPAREN:
                            this.state = 159;
                            this.jqlList();
                            break;
                        case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                        case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                        case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                        case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                        case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 160;
                            this.jqlFunction();
                            break;
                        default:
                            throw new (0, $dF72r.NoViableAltException)(this);
                    }
                    this.state = 166;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $f948258ac6616e58$export$9c4772e191bdb810.BEFORE | 1 << $f948258ac6616e58$export$9c4772e191bdb810.AFTER | 1 << $f948258ac6616e58$export$9c4772e191bdb810.ON | 1 << $f948258ac6616e58$export$9c4772e191bdb810.DURING | 1 << $f948258ac6616e58$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 163;
                        this.jqlWasPredicate();
                        this.state = 168;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                case 8:
                    _localctx = new $f948258ac6616e58$export$7a7defca8628a13c(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    this.state = 169;
                    this.jqlChangedOperator();
                    this.state = 173;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while((_la & -32) === 0 && (1 << _la & (1 << $f948258ac6616e58$export$9c4772e191bdb810.BEFORE | 1 << $f948258ac6616e58$export$9c4772e191bdb810.AFTER | 1 << $f948258ac6616e58$export$9c4772e191bdb810.FROM | 1 << $f948258ac6616e58$export$9c4772e191bdb810.TO | 1 << $f948258ac6616e58$export$9c4772e191bdb810.ON | 1 << $f948258ac6616e58$export$9c4772e191bdb810.DURING | 1 << $f948258ac6616e58$export$9c4772e191bdb810.BY)) !== 0){
                        this.state = 170;
                        this.jqlChangedPredicate();
                        this.state = 175;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEqualsOperator() {
        let _localctx = new $f948258ac6616e58$export$41e475fc1988e413(this._ctx, this.state);
        this.enterRule(_localctx, 16, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 178;
            _la = this._input.LA(1);
            if (!(_la === $f948258ac6616e58$export$9c4772e191bdb810.EQUALS || _la === $f948258ac6616e58$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlLikeOperator() {
        let _localctx = new $f948258ac6616e58$export$b76fe5387fdd7efd(this._ctx, this.state);
        this.enterRule(_localctx, 18, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlLikeOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 180;
            _la = this._input.LA(1);
            if (!(_la === $f948258ac6616e58$export$9c4772e191bdb810.LIKE || _la === $f948258ac6616e58$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlComparisonOperator() {
        let _localctx = new $f948258ac6616e58$export$d821da0716b3ec95(this._ctx, this.state);
        this.enterRule(_localctx, 20, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 182;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $f948258ac6616e58$export$9c4772e191bdb810.LT | 1 << $f948258ac6616e58$export$9c4772e191bdb810.GT | 1 << $f948258ac6616e58$export$9c4772e191bdb810.GTEQ | 1 << $f948258ac6616e58$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlInOperator() {
        let _localctx = new $f948258ac6616e58$export$178478bfa8292f72(this._ctx, this.state);
        this.enterRule(_localctx, 22, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlInOperator);
        try {
            this.state = 187;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.IN:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 184;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.IN);
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.NOT:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 185;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.NOT);
                    this.state = 186;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.IN);
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlIsOperator() {
        let _localctx = new $f948258ac6616e58$export$e64c31d2830b66e4(this._ctx, this.state);
        this.enterRule(_localctx, 24, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlIsOperator);
        try {
            this.state = 192;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 189;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.IS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 190;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.IS);
                    this.state = 191;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasOperator() {
        let _localctx = new $f948258ac6616e58$export$7e283636700e4a6c(this._ctx, this.state);
        this.enterRule(_localctx, 26, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasOperator);
        try {
            this.state = 197;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 194;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.WAS);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 195;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.WAS);
                    this.state = 196;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.NOT);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasInOperator() {
        let _localctx = new $f948258ac6616e58$export$b9118b1ed9a78d66(this._ctx, this.state);
        this.enterRule(_localctx, 28, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasInOperator);
        try {
            this.state = 204;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 199;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.WAS);
                    this.state = 200;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.IN);
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 201;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.WAS);
                    this.state = 202;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.NOT);
                    this.state = 203;
                    this.match($f948258ac6616e58$export$9c4772e191bdb810.IN);
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedOperator() {
        let _localctx = new $f948258ac6616e58$export$493d626ed78ca66(this._ctx, this.state);
        this.enterRule(_localctx, 30, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlChangedOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 206;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.CHANGED);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlField() {
        let _localctx = new $f948258ac6616e58$export$b33300c3d916229a(this._ctx, this.state);
        this.enterRule(_localctx, 32, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlField);
        let _la;
        try {
            this.state = 219;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                    _localctx = new $f948258ac6616e58$export$11fec15307d2e17b(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 208;
                    this.jqlNumber();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD:
                case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                    _localctx = new $f948258ac6616e58$export$b8b24f99f985ebb3(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 211;
                    this._errHandler.sync(this);
                    switch(this._input.LA(1)){
                        case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                        case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                        case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                            this.state = 209;
                            this.jqlString();
                            break;
                        case $f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD:
                            this.state = 210;
                            this.jqlCustomField();
                            break;
                        default:
                            throw new (0, $dF72r.NoViableAltException)(this);
                    }
                    this.state = 216;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                    while(_la === $f948258ac6616e58$export$9c4772e191bdb810.LBRACKET){
                        this.state = 213;
                        this.jqlFieldProperty();
                        this.state = 218;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                    }
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFieldProperty() {
        let _localctx = new $f948258ac6616e58$export$b02d0b6637ce0593(this._ctx, this.state);
        this.enterRule(_localctx, 34, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFieldProperty);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 221;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.LBRACKET);
            this.state = 222;
            this.jqlArgument();
            this.state = 223;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.RBRACKET);
            this.state = 228;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.STRING - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                this.state = 225;
                this.jqlPropertyArgument();
                this.state = 230;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlCustomField() {
        let _localctx = new $f948258ac6616e58$export$401a038855cc5b15(this._ctx, this.state);
        this.enterRule(_localctx, 36, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlCustomField);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 231;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD);
            this.state = 232;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.LBRACKET);
            this.state = 233;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER);
            this.state = 234;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.RBRACKET);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlString() {
        let _localctx = new $f948258ac6616e58$export$bde73d8ad7c8b71e(this._ctx, this.state);
        this.enterRule(_localctx, 38, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlString);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 236;
            _la = this._input.LA(1);
            if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $f948258ac6616e58$export$9c4772e191bdb810.STRING - 37 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlNumber() {
        let _localctx = new $f948258ac6616e58$export$8737d94a1880e8b3(this._ctx, this.state);
        this.enterRule(_localctx, 40, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlNumber);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 238;
            _localctx._jqlNum = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER || _la === $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOperand() {
        let _localctx = new $f948258ac6616e58$export$2eaac5a9828bf647(this._ctx, this.state);
        this.enterRule(_localctx, 42, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOperand);
        try {
            this.state = 244;
            this._errHandler.sync(this);
            switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                case 1:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 240;
                    this.jqlEmpty();
                    break;
                case 2:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 241;
                    this.jqlValue();
                    break;
                case 3:
                    this.enterOuterAlt(_localctx, 3);
                    this.state = 242;
                    this.jqlFunction();
                    break;
                case 4:
                    this.enterOuterAlt(_localctx, 4);
                    this.state = 243;
                    this.jqlList();
                    break;
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlEmpty() {
        let _localctx = new $f948258ac6616e58$export$d85a062f90025e5c(this._ctx, this.state);
        this.enterRule(_localctx, 44, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlEmpty);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 246;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.EMPTY);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValue() {
        let _localctx = new $f948258ac6616e58$export$2e17d457b0933bec(this._ctx, this.state);
        this.enterRule(_localctx, 46, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlValue);
        try {
            this.state = 250;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 248;
                    this.jqlString();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 249;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunction() {
        let _localctx = new $f948258ac6616e58$export$ebf0cc785e9ee41a(this._ctx, this.state);
        this.enterRule(_localctx, 48, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFunction);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 252;
            this.jqlFunctionName();
            this.state = 253;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.LPAREN);
            this.state = 255;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.STRING - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                this.state = 254;
                this.jqlArgumentList();
            }
            this.state = 257;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlFunctionName() {
        let _localctx = new $f948258ac6616e58$export$1f5f7ac816788f44(this._ctx, this.state);
        this.enterRule(_localctx, 50, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFunctionName);
        try {
            this.state = 261;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 259;
                    this.jqlString();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 260;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgumentList() {
        let _localctx = new $f948258ac6616e58$export$83d7c13849b931c3(this._ctx, this.state);
        this.enterRule(_localctx, 52, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlArgumentList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 263;
            this.jqlArgument();
            this.state = 268;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $f948258ac6616e58$export$9c4772e191bdb810.COMMA){
                this.state = 264;
                this.match($f948258ac6616e58$export$9c4772e191bdb810.COMMA);
                this.state = 265;
                this.jqlArgument();
                this.state = 270;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlList() {
        let _localctx = new $f948258ac6616e58$export$9cb97a63f2be4864(this._ctx, this.state);
        this.enterRule(_localctx, 54, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlList);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 271;
            this.jqlListStart();
            this.state = 272;
            this.jqlOperand();
            this.state = 277;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $f948258ac6616e58$export$9c4772e191bdb810.COMMA){
                this.state = 273;
                this.match($f948258ac6616e58$export$9c4772e191bdb810.COMMA);
                this.state = 274;
                this.jqlOperand();
                this.state = 279;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 280;
            this.jqlListEnd();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListStart() {
        let _localctx = new $f948258ac6616e58$export$c419f717bfc46a5d(this._ctx, this.state);
        this.enterRule(_localctx, 56, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlListStart);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 282;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.LPAREN);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlListEnd() {
        let _localctx = new $f948258ac6616e58$export$f6cd3e372f5ab120(this._ctx, this.state);
        this.enterRule(_localctx, 58, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlListEnd);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 284;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.RPAREN);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPropertyArgument() {
        let _localctx = new $f948258ac6616e58$export$e20ce4a2ed16372c(this._ctx, this.state);
        this.enterRule(_localctx, 60, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 286;
            this.jqlArgument();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlArgument() {
        let _localctx = new $f948258ac6616e58$export$a95583953c237f88(this._ctx, this.state);
        this.enterRule(_localctx, 62, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlArgument);
        try {
            this.state = 290;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING:
                case $f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING:
                    this.enterOuterAlt(_localctx, 1);
                    this.state = 288;
                    this.jqlString();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER:
                case $f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER:
                    this.enterOuterAlt(_localctx, 2);
                    this.state = 289;
                    this.jqlNumber();
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlWasPredicate() {
        let _localctx = new $f948258ac6616e58$export$9fa1e4d63f31b911(this._ctx, this.state);
        this.enterRule(_localctx, 64, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 295;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.BEFORE:
                case $f948258ac6616e58$export$9c4772e191bdb810.AFTER:
                case $f948258ac6616e58$export$9c4772e191bdb810.ON:
                    this.state = 292;
                    this.jqlDatePredicateOperator();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.DURING:
                    this.state = 293;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.BY:
                    this.state = 294;
                    this.jqlUserPredicateOperator();
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
            this.state = 297;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlChangedPredicate() {
        let _localctx = new $f948258ac6616e58$export$e77e479a48133015(this._ctx, this.state);
        this.enterRule(_localctx, 66, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 303;
            this._errHandler.sync(this);
            switch(this._input.LA(1)){
                case $f948258ac6616e58$export$9c4772e191bdb810.BEFORE:
                case $f948258ac6616e58$export$9c4772e191bdb810.AFTER:
                case $f948258ac6616e58$export$9c4772e191bdb810.ON:
                    this.state = 299;
                    this.jqlDatePredicateOperator();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.DURING:
                    this.state = 300;
                    this.jqlDateRangePredicateOperator();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.BY:
                    this.state = 301;
                    this.jqlUserPredicateOperator();
                    break;
                case $f948258ac6616e58$export$9c4772e191bdb810.FROM:
                case $f948258ac6616e58$export$9c4772e191bdb810.TO:
                    this.state = 302;
                    this.jqlValuePredicateOperator();
                    break;
                default:
                    throw new (0, $dF72r.NoViableAltException)(this);
            }
            this.state = 305;
            this.jqlPredicateOperand();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDatePredicateOperator() {
        let _localctx = new $f948258ac6616e58$export$dc01290aee731418(this._ctx, this.state);
        this.enterRule(_localctx, 68, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 307;
            _la = this._input.LA(1);
            if (!((_la & -32) === 0 && (1 << _la & (1 << $f948258ac6616e58$export$9c4772e191bdb810.BEFORE | 1 << $f948258ac6616e58$export$9c4772e191bdb810.AFTER | 1 << $f948258ac6616e58$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlDateRangePredicateOperator() {
        let _localctx = new $f948258ac6616e58$export$75412b8b6a6442e1(this._ctx, this.state);
        this.enterRule(_localctx, 70, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 309;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.DURING);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlUserPredicateOperator() {
        let _localctx = new $f948258ac6616e58$export$ad402332075c8656(this._ctx, this.state);
        this.enterRule(_localctx, 72, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 311;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.BY);
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlValuePredicateOperator() {
        let _localctx = new $f948258ac6616e58$export$4239d7c0fbafd3f1(this._ctx, this.state);
        this.enterRule(_localctx, 74, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 313;
            _la = this._input.LA(1);
            if (!(_la === $f948258ac6616e58$export$9c4772e191bdb810.FROM || _la === $f948258ac6616e58$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
            else {
                if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlPredicateOperand() {
        let _localctx = new $f948258ac6616e58$export$6b796c5a4b8c18e(this._ctx, this.state);
        this.enterRule(_localctx, 76, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 315;
            this.jqlOperand();
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlOrderBy() {
        let _localctx = new $f948258ac6616e58$export$534469b9c8f44139(this._ctx, this.state);
        this.enterRule(_localctx, 78, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOrderBy);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 317;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.ORDER);
            this.state = 318;
            this.match($f948258ac6616e58$export$9c4772e191bdb810.BY);
            this.state = 319;
            this.jqlSearchSort();
            this.state = 324;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la === $f948258ac6616e58$export$9c4772e191bdb810.COMMA){
                this.state = 320;
                this.match($f948258ac6616e58$export$9c4772e191bdb810.COMMA);
                this.state = 321;
                this.jqlSearchSort();
                this.state = 326;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    jqlSearchSort() {
        let _localctx = new $f948258ac6616e58$export$c7d8f03f36952a46(this._ctx, this.state);
        this.enterRule(_localctx, 80, $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlSearchSort);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            this.state = 327;
            this.jqlField();
            this.state = 329;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if (_la === $f948258ac6616e58$export$9c4772e191bdb810.ASC || _la === $f948258ac6616e58$export$9c4772e191bdb810.DESC) {
                this.state = 328;
                _la = this._input.LA(1);
                if (!(_la === $f948258ac6616e58$export$9c4772e191bdb810.ASC || _la === $f948258ac6616e58$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $lxPhv.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            }
        } catch (re) {
            if (re instanceof (0, $jzLQT.RecognitionException)) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            } else throw re;
        } finally{
            this.exitRule();
        }
        return _localctx;
    }
    static get _ATN() {
        if (!$f948258ac6616e58$export$9c4772e191bdb810.__ATN) $f948258ac6616e58$export$9c4772e191bdb810.__ATN = new (0, $fetTS.ATNDeserializer)().deserialize($1rLy7.toCharArray($f948258ac6616e58$export$9c4772e191bdb810._serializedATN));
        return $f948258ac6616e58$export$9c4772e191bdb810.__ATN;
    }
    constructor(input){
        super(input);
        this._interp = new (0, $e2oSX.ParserATNSimulator)($f948258ac6616e58$export$9c4772e191bdb810._ATN, this);
    }
}
$f948258ac6616e58$var$_JQLParser = $f948258ac6616e58$export$9c4772e191bdb810;
$f948258ac6616e58$export$9c4772e191bdb810.LPAREN = 1;
$f948258ac6616e58$export$9c4772e191bdb810.RPAREN = 2;
$f948258ac6616e58$export$9c4772e191bdb810.COMMA = 3;
$f948258ac6616e58$export$9c4772e191bdb810.LBRACKET = 4;
$f948258ac6616e58$export$9c4772e191bdb810.RBRACKET = 5;
$f948258ac6616e58$export$9c4772e191bdb810.BANG = 6;
$f948258ac6616e58$export$9c4772e191bdb810.LT = 7;
$f948258ac6616e58$export$9c4772e191bdb810.GT = 8;
$f948258ac6616e58$export$9c4772e191bdb810.GTEQ = 9;
$f948258ac6616e58$export$9c4772e191bdb810.LTEQ = 10;
$f948258ac6616e58$export$9c4772e191bdb810.EQUALS = 11;
$f948258ac6616e58$export$9c4772e191bdb810.NOT_EQUALS = 12;
$f948258ac6616e58$export$9c4772e191bdb810.LIKE = 13;
$f948258ac6616e58$export$9c4772e191bdb810.NOT_LIKE = 14;
$f948258ac6616e58$export$9c4772e191bdb810.IN = 15;
$f948258ac6616e58$export$9c4772e191bdb810.IS = 16;
$f948258ac6616e58$export$9c4772e191bdb810.AND = 17;
$f948258ac6616e58$export$9c4772e191bdb810.OR = 18;
$f948258ac6616e58$export$9c4772e191bdb810.NOT = 19;
$f948258ac6616e58$export$9c4772e191bdb810.EMPTY = 20;
$f948258ac6616e58$export$9c4772e191bdb810.WAS = 21;
$f948258ac6616e58$export$9c4772e191bdb810.CHANGED = 22;
$f948258ac6616e58$export$9c4772e191bdb810.BEFORE = 23;
$f948258ac6616e58$export$9c4772e191bdb810.AFTER = 24;
$f948258ac6616e58$export$9c4772e191bdb810.FROM = 25;
$f948258ac6616e58$export$9c4772e191bdb810.TO = 26;
$f948258ac6616e58$export$9c4772e191bdb810.ON = 27;
$f948258ac6616e58$export$9c4772e191bdb810.DURING = 28;
$f948258ac6616e58$export$9c4772e191bdb810.ORDER = 29;
$f948258ac6616e58$export$9c4772e191bdb810.BY = 30;
$f948258ac6616e58$export$9c4772e191bdb810.ASC = 31;
$f948258ac6616e58$export$9c4772e191bdb810.DESC = 32;
$f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER = 33;
$f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER = 34;
$f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD = 35;
$f948258ac6616e58$export$9c4772e191bdb810.RESERVED_WORD = 36;
$f948258ac6616e58$export$9c4772e191bdb810.STRING = 37;
$f948258ac6616e58$export$9c4772e191bdb810.MATCHWS = 38;
$f948258ac6616e58$export$9c4772e191bdb810.ERROR_RESERVED = 39;
$f948258ac6616e58$export$9c4772e191bdb810.ERRORCHAR = 40;
$f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING = 41;
$f948258ac6616e58$export$9c4772e191bdb810.UNCLOSED_QUOTE_STRING = 42;
$f948258ac6616e58$export$9c4772e191bdb810.INVALID_QUOTE_STRING = 43;
$f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING = 44;
$f948258ac6616e58$export$9c4772e191bdb810.UNCLOSED_SQUOTE_STRING = 45;
$f948258ac6616e58$export$9c4772e191bdb810.INVALID_SQUOTE_STRING = 46;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlQuery = 0;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWhere = 1;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOrClause = 2;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlAndClause = 3;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlNotClause = 4;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlSubClause = 5;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlTerminalClause = 6;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs = 7;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlEqualsOperator = 8;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlLikeOperator = 9;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlComparisonOperator = 10;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlInOperator = 11;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlIsOperator = 12;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasOperator = 13;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasInOperator = 14;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlChangedOperator = 15;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlField = 16;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFieldProperty = 17;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlCustomField = 18;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlString = 19;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlNumber = 20;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOperand = 21;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlEmpty = 22;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlValue = 23;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFunction = 24;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFunctionName = 25;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlArgumentList = 26;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlList = 27;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlListStart = 28;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlListEnd = 29;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlPropertyArgument = 30;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlArgument = 31;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasPredicate = 32;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlChangedPredicate = 33;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator = 34;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator = 35;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator = 36;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator = 37;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlPredicateOperand = 38;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOrderBy = 39;
$f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlSearchSort = 40;
// tslint:disable:no-trailing-whitespace
$f948258ac6616e58$export$9c4772e191bdb810.ruleNames = [
    'jqlQuery',
    'jqlWhere',
    'jqlOrClause',
    'jqlAndClause',
    'jqlNotClause',
    'jqlSubClause',
    'jqlTerminalClause',
    'jqlTerminalClauseRhs',
    'jqlEqualsOperator',
    'jqlLikeOperator',
    'jqlComparisonOperator',
    'jqlInOperator',
    'jqlIsOperator',
    'jqlWasOperator',
    'jqlWasInOperator',
    'jqlChangedOperator',
    'jqlField',
    'jqlFieldProperty',
    'jqlCustomField',
    'jqlString',
    'jqlNumber',
    'jqlOperand',
    'jqlEmpty',
    'jqlValue',
    'jqlFunction',
    'jqlFunctionName',
    'jqlArgumentList',
    'jqlList',
    'jqlListStart',
    'jqlListEnd',
    'jqlPropertyArgument',
    'jqlArgument',
    'jqlWasPredicate',
    'jqlChangedPredicate',
    'jqlDatePredicateOperator',
    'jqlDateRangePredicateOperator',
    'jqlUserPredicateOperator',
    'jqlValuePredicateOperator',
    'jqlPredicateOperand',
    'jqlOrderBy',
    'jqlSearchSort'
];
$f948258ac6616e58$export$9c4772e191bdb810._LITERAL_NAMES = [
    undefined,
    "'('",
    "')'",
    "','",
    "'['",
    "']'",
    "'!'",
    "'<'",
    "'>'",
    "'>='",
    "'<='",
    "'='",
    "'!='",
    "'~'",
    "'!~'"
];
$f948258ac6616e58$export$9c4772e191bdb810._SYMBOLIC_NAMES = [
    undefined,
    'LPAREN',
    'RPAREN',
    'COMMA',
    'LBRACKET',
    'RBRACKET',
    'BANG',
    'LT',
    'GT',
    'GTEQ',
    'LTEQ',
    'EQUALS',
    'NOT_EQUALS',
    'LIKE',
    'NOT_LIKE',
    'IN',
    'IS',
    'AND',
    'OR',
    'NOT',
    'EMPTY',
    'WAS',
    'CHANGED',
    'BEFORE',
    'AFTER',
    'FROM',
    'TO',
    'ON',
    'DURING',
    'ORDER',
    'BY',
    'ASC',
    'DESC',
    'POSNUMBER',
    'NEGNUMBER',
    'CUSTOMFIELD',
    'RESERVED_WORD',
    'STRING',
    'MATCHWS',
    'ERROR_RESERVED',
    'ERRORCHAR',
    'QUOTE_STRING',
    'UNCLOSED_QUOTE_STRING',
    'INVALID_QUOTE_STRING',
    'SQUOTE_STRING',
    'UNCLOSED_SQUOTE_STRING',
    'INVALID_SQUOTE_STRING'
];
$f948258ac6616e58$export$9c4772e191bdb810.VOCABULARY = new (0, $auHu3.VocabularyImpl)($f948258ac6616e58$var$_JQLParser._LITERAL_NAMES, $f948258ac6616e58$var$_JQLParser._SYMBOLIC_NAMES, []);
$f948258ac6616e58$export$9c4772e191bdb810._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
$f948258ac6616e58$export$9c4772e191bdb810.__ATN = void 0;
class $f948258ac6616e58$export$ff413535b9575c8 extends (0, $7EUlr.ParserRuleContext) {
    EOF() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.EOF, 0);
    }
    jqlWhere() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$4148a879cab28017);
    }
    jqlOrderBy() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$534469b9c8f44139);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlQuery;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlQuery) listener.enterJqlQuery(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlQuery) listener.exitJqlQuery(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$4148a879cab28017 extends (0, $7EUlr.ParserRuleContext) {
    jqlOrClause() {
        return this.getRuleContext(0, $f948258ac6616e58$export$d69831d387793480);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWhere;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWhere) listener.enterJqlWhere(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWhere) listener.exitJqlWhere(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$d69831d387793480 extends (0, $7EUlr.ParserRuleContext) {
    jqlAndClause(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$f16819001158b9e);
        else return this.getRuleContext(i, $f948258ac6616e58$export$f16819001158b9e);
    }
    OR(i) {
        if (i === undefined) return this.getTokens($f948258ac6616e58$export$9c4772e191bdb810.OR);
        else return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.OR, i);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOrClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$f16819001158b9e extends (0, $7EUlr.ParserRuleContext) {
    jqlNotClause(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$5e9146f8d5cf1330);
        else return this.getRuleContext(i, $f948258ac6616e58$export$5e9146f8d5cf1330);
    }
    AND(i) {
        if (i === undefined) return this.getTokens($f948258ac6616e58$export$9c4772e191bdb810.AND);
        else return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.AND, i);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlAndClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$5e9146f8d5cf1330 extends (0, $7EUlr.ParserRuleContext) {
    jqlNotClause() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$5e9146f8d5cf1330);
    }
    NOT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT, 0);
    }
    BANG() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.BANG, 0);
    }
    jqlSubClause() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$a136a0e9655bfb04);
    }
    jqlTerminalClause() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$23486a2f2ddd5bcd);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlNotClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$a136a0e9655bfb04 extends (0, $7EUlr.ParserRuleContext) {
    LPAREN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.LPAREN, 0);
    }
    jqlOrClause() {
        return this.getRuleContext(0, $f948258ac6616e58$export$d69831d387793480);
    }
    RPAREN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.RPAREN, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlSubClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$23486a2f2ddd5bcd extends (0, $7EUlr.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $f948258ac6616e58$export$b33300c3d916229a);
    }
    jqlTerminalClauseRhs() {
        return this.getRuleContext(0, $f948258ac6616e58$export$93924a205c12d32c);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlTerminalClause;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$93924a205c12d32c extends (0, $7EUlr.ParserRuleContext) {
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$c428f709a58396e5 extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlEqualsOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$41e475fc1988e413);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$1b131204ef9fa33d extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlLikeOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$b76fe5387fdd7efd);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$d83706ee80a9852a extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlComparisonOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$d821da0716b3ec95);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$2934b8ff22fddd2d extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlInOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$178478bfa8292f72);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInClause) listener.enterJqlInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInClause) listener.exitJqlInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$8b84310182afcf93 extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlIsOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$e64c31d2830b66e4);
    }
    jqlEmpty() {
        return this.getRuleContext(0, $f948258ac6616e58$export$d85a062f90025e5c);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$5df295dc7a2cac7c extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlWasOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$7e283636700e4a6c);
    }
    jqlEmpty() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $f948258ac6616e58$export$9fa1e4d63f31b911);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$9ac3367aee261b32 extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlWasInOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$b9118b1ed9a78d66);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$9cb97a63f2be4864);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    jqlWasPredicate(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$9fa1e4d63f31b911);
        else return this.getRuleContext(i, $f948258ac6616e58$export$9fa1e4d63f31b911);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$7a7defca8628a13c extends $f948258ac6616e58$export$93924a205c12d32c {
    jqlChangedOperator() {
        return this.getRuleContext(0, $f948258ac6616e58$export$493d626ed78ca66);
    }
    jqlChangedPredicate(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$e77e479a48133015);
        else return this.getRuleContext(i, $f948258ac6616e58$export$e77e479a48133015);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$41e475fc1988e413 extends (0, $7EUlr.ParserRuleContext) {
    EQUALS() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.EQUALS, 0);
    }
    NOT_EQUALS() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT_EQUALS, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$b76fe5387fdd7efd extends (0, $7EUlr.ParserRuleContext) {
    LIKE() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.LIKE, 0);
    }
    NOT_LIKE() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT_LIKE, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlLikeOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$d821da0716b3ec95 extends (0, $7EUlr.ParserRuleContext) {
    LT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.LT, 0);
    }
    GT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.GT, 0);
    }
    LTEQ() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.LTEQ, 0);
    }
    GTEQ() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.GTEQ, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$178478bfa8292f72 extends (0, $7EUlr.ParserRuleContext) {
    IN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$e64c31d2830b66e4 extends (0, $7EUlr.ParserRuleContext) {
    IS() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.IS, 0);
    }
    NOT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlIsOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$7e283636700e4a6c extends (0, $7EUlr.ParserRuleContext) {
    WAS() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.WAS, 0);
    }
    NOT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$b9118b1ed9a78d66 extends (0, $7EUlr.ParserRuleContext) {
    WAS() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.WAS, 0);
    }
    IN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.IN, 0);
    }
    NOT() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NOT, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasInOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$493d626ed78ca66 extends (0, $7EUlr.ParserRuleContext) {
    CHANGED() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.CHANGED, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlChangedOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$b33300c3d916229a extends (0, $7EUlr.ParserRuleContext) {
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlField;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$11fec15307d2e17b extends $f948258ac6616e58$export$b33300c3d916229a {
    jqlNumber() {
        return this.getRuleContext(0, $f948258ac6616e58$export$8737d94a1880e8b3);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$b8b24f99f985ebb3 extends $f948258ac6616e58$export$b33300c3d916229a {
    jqlString() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$bde73d8ad7c8b71e);
    }
    jqlCustomField() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$401a038855cc5b15);
    }
    jqlFieldProperty(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$b02d0b6637ce0593);
        else return this.getRuleContext(i, $f948258ac6616e58$export$b02d0b6637ce0593);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
        else return visitor.visitChildren(this);
    }
    constructor(ctx){
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
}
class $f948258ac6616e58$export$b02d0b6637ce0593 extends (0, $7EUlr.ParserRuleContext) {
    LBRACKET() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.LBRACKET, 0);
    }
    RBRACKET() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.RBRACKET, 0);
    }
    jqlPropertyArgument(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$e20ce4a2ed16372c);
        else return this.getRuleContext(i, $f948258ac6616e58$export$e20ce4a2ed16372c);
    }
    jqlArgument() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$a95583953c237f88);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFieldProperty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$401a038855cc5b15 extends (0, $7EUlr.ParserRuleContext) {
    CUSTOMFIELD() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.CUSTOMFIELD, 0);
    }
    LBRACKET() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.LBRACKET, 0);
    }
    POSNUMBER() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    RBRACKET() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.RBRACKET, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlCustomField;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$bde73d8ad7c8b71e extends (0, $7EUlr.ParserRuleContext) {
    STRING() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.STRING, 0);
    }
    QUOTE_STRING() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.QUOTE_STRING, 0);
    }
    SQUOTE_STRING() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.SQUOTE_STRING, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlString;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlString) listener.enterJqlString(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlString) listener.exitJqlString(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlString) return visitor.visitJqlString(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$8737d94a1880e8b3 extends (0, $7EUlr.ParserRuleContext) {
    POSNUMBER() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.POSNUMBER, 0);
    }
    NEGNUMBER() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.NEGNUMBER, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlNumber;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlNumber) listener.enterJqlNumber(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlNumber) listener.exitJqlNumber(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
        this._jqlNum = void 0;
    }
}
class $f948258ac6616e58$export$2eaac5a9828bf647 extends (0, $7EUlr.ParserRuleContext) {
    jqlEmpty() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$d85a062f90025e5c);
    }
    jqlValue() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$2e17d457b0933bec);
    }
    jqlFunction() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ebf0cc785e9ee41a);
    }
    jqlList() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$9cb97a63f2be4864);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOperand) listener.enterJqlOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOperand) listener.exitJqlOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$d85a062f90025e5c extends (0, $7EUlr.ParserRuleContext) {
    EMPTY() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.EMPTY, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlEmpty;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$2e17d457b0933bec extends (0, $7EUlr.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$8737d94a1880e8b3);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlValue;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValue) listener.enterJqlValue(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValue) listener.exitJqlValue(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$ebf0cc785e9ee41a extends (0, $7EUlr.ParserRuleContext) {
    jqlFunctionName() {
        return this.getRuleContext(0, $f948258ac6616e58$export$1f5f7ac816788f44);
    }
    LPAREN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.LPAREN, 0);
    }
    RPAREN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.RPAREN, 0);
    }
    jqlArgumentList() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$83d7c13849b931c3);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFunction;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunction) listener.enterJqlFunction(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunction) listener.exitJqlFunction(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$1f5f7ac816788f44 extends (0, $7EUlr.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$8737d94a1880e8b3);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlFunctionName;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$83d7c13849b931c3 extends (0, $7EUlr.ParserRuleContext) {
    jqlArgument(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$a95583953c237f88);
        else return this.getRuleContext(i, $f948258ac6616e58$export$a95583953c237f88);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($f948258ac6616e58$export$9c4772e191bdb810.COMMA);
        else return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.COMMA, i);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlArgumentList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$9cb97a63f2be4864 extends (0, $7EUlr.ParserRuleContext) {
    jqlListStart() {
        return this.getRuleContext(0, $f948258ac6616e58$export$c419f717bfc46a5d);
    }
    jqlOperand(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$2eaac5a9828bf647);
        else return this.getRuleContext(i, $f948258ac6616e58$export$2eaac5a9828bf647);
    }
    jqlListEnd() {
        return this.getRuleContext(0, $f948258ac6616e58$export$f6cd3e372f5ab120);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($f948258ac6616e58$export$9c4772e191bdb810.COMMA);
        else return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.COMMA, i);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlList;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlList) listener.enterJqlList(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlList) listener.exitJqlList(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlList) return visitor.visitJqlList(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$c419f717bfc46a5d extends (0, $7EUlr.ParserRuleContext) {
    LPAREN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.LPAREN, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlListStart;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListStart) listener.enterJqlListStart(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListStart) listener.exitJqlListStart(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$f6cd3e372f5ab120 extends (0, $7EUlr.ParserRuleContext) {
    RPAREN() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.RPAREN, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlListEnd;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$e20ce4a2ed16372c extends (0, $7EUlr.ParserRuleContext) {
    jqlArgument() {
        return this.getRuleContext(0, $f948258ac6616e58$export$a95583953c237f88);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$a95583953c237f88 extends (0, $7EUlr.ParserRuleContext) {
    jqlString() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$bde73d8ad7c8b71e);
    }
    jqlNumber() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$8737d94a1880e8b3);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlArgument;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlArgument) listener.enterJqlArgument(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlArgument) listener.exitJqlArgument(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$9fa1e4d63f31b911 extends (0, $7EUlr.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $f948258ac6616e58$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ad402332075c8656);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlWasPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$e77e479a48133015 extends (0, $7EUlr.ParserRuleContext) {
    jqlPredicateOperand() {
        return this.getRuleContext(0, $f948258ac6616e58$export$6b796c5a4b8c18e);
    }
    jqlDatePredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$dc01290aee731418);
    }
    jqlDateRangePredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$75412b8b6a6442e1);
    }
    jqlUserPredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$ad402332075c8656);
    }
    jqlValuePredicateOperator() {
        return this.tryGetRuleContext(0, $f948258ac6616e58$export$4239d7c0fbafd3f1);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$dc01290aee731418 extends (0, $7EUlr.ParserRuleContext) {
    AFTER() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.AFTER, 0);
    }
    BEFORE() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.BEFORE, 0);
    }
    ON() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.ON, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$75412b8b6a6442e1 extends (0, $7EUlr.ParserRuleContext) {
    DURING() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.DURING, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$ad402332075c8656 extends (0, $7EUlr.ParserRuleContext) {
    BY() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.BY, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$4239d7c0fbafd3f1 extends (0, $7EUlr.ParserRuleContext) {
    FROM() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.FROM, 0);
    }
    TO() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.TO, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$6b796c5a4b8c18e extends (0, $7EUlr.ParserRuleContext) {
    jqlOperand() {
        return this.getRuleContext(0, $f948258ac6616e58$export$2eaac5a9828bf647);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$534469b9c8f44139 extends (0, $7EUlr.ParserRuleContext) {
    ORDER() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.ORDER, 0);
    }
    BY() {
        return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.BY, 0);
    }
    jqlSearchSort(i) {
        if (i === undefined) return this.getRuleContexts($f948258ac6616e58$export$c7d8f03f36952a46);
        else return this.getRuleContext(i, $f948258ac6616e58$export$c7d8f03f36952a46);
    }
    COMMA(i) {
        if (i === undefined) return this.getTokens($f948258ac6616e58$export$9c4772e191bdb810.COMMA);
        else return this.getToken($f948258ac6616e58$export$9c4772e191bdb810.COMMA, i);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlOrderBy;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
class $f948258ac6616e58$export$c7d8f03f36952a46 extends (0, $7EUlr.ParserRuleContext) {
    jqlField() {
        return this.getRuleContext(0, $f948258ac6616e58$export$b33300c3d916229a);
    }
    DESC() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.DESC, 0);
    }
    ASC() {
        return this.tryGetToken($f948258ac6616e58$export$9c4772e191bdb810.ASC, 0);
    }
    // @Override
    get ruleIndex() {
        return $f948258ac6616e58$export$9c4772e191bdb810.RULE_jqlSearchSort;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
    }
    // @Override
    exitRule(listener) {
        if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
    }
    // @Override
    accept(visitor) {
        if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
        else return visitor.visitChildren(this);
    }
    constructor(parent, invokingState){
        super(parent, invokingState);
    }
}
module.exports["JQLParser"] = $f948258ac6616e58$export$9c4772e191bdb810;

});

parcelRegister("9foTl", function(module, exports) {

var $3lfxh = parcelRequire("3lfxh");

var $g9Jfe = parcelRequire("g9Jfe");


var $eUiqt = parcelRequire("eUiqt");

const $6fb2c74696c90120$export$c11f53c00e0a0ad4 = new RegExp(`[\\s${(0, (/*@__PURE__*/$parcel$interopDefault($eUiqt)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
const $6fb2c74696c90120$export$1fa3c1f0578bafad = new Set([
    'a',
    'an',
    'abort',
    'access',
    'add',
    'after',
    'alias',
    'all',
    'alter',
    'and',
    'any',
    'are',
    'as',
    'asc',
    'at',
    'audit',
    'avg',
    'be',
    'before',
    'begin',
    'between',
    'boolean',
    'break',
    'but',
    'by',
    'byte',
    'catch',
    'cf',
    'char',
    'character',
    'check',
    'checkpoint',
    'collate',
    'collation',
    'column',
    'commit',
    'connect',
    'continue',
    'count',
    'create',
    'current',
    'date',
    'decimal',
    'declare',
    'decrement',
    'default',
    'defaults',
    'define',
    'delete',
    'delimiter',
    'desc',
    'difference',
    'distinct',
    'divide',
    'do',
    'double',
    'drop',
    'else',
    'empty',
    'encoding',
    'end',
    'equals',
    'escape',
    'exclusive',
    'exec',
    'execute',
    'exists',
    'explain',
    'false',
    'fetch',
    'file',
    'field',
    'first',
    'float',
    'for',
    'from',
    'function',
    'go',
    'goto',
    'grant',
    'greater',
    'group',
    'having',
    'identified',
    'if',
    'immediate',
    'in',
    'increment',
    'index',
    'initial',
    'inner',
    'inout',
    'input',
    'insert',
    'int',
    'integer',
    'intersect',
    'intersection',
    'into',
    'is',
    'isempty',
    'isnull',
    'it',
    'join',
    'last',
    'left',
    'less',
    'like',
    'limit',
    'lock',
    'long',
    'max',
    'min',
    'minus',
    'mode',
    'modify',
    'modulo',
    'more',
    'multiply',
    'next',
    'no',
    'noaudit',
    'not',
    'notin',
    'nowait',
    'null',
    'number',
    'object',
    'of',
    'on',
    'option',
    'or',
    'order',
    'outer',
    'output',
    'power',
    'previous',
    'prior',
    'privileges',
    'public',
    'raise',
    'raw',
    'remainder',
    'rename',
    'resource',
    'return',
    'returns',
    'revoke',
    'right',
    'row',
    'rowid',
    'rownum',
    'rows',
    'select',
    'session',
    'set',
    'share',
    'size',
    'sqrt',
    'start',
    'strict',
    'string',
    'subtract',
    'such',
    'sum',
    'synonym',
    'table',
    'that',
    'the',
    'their',
    'then',
    'there',
    'these',
    'they',
    'this',
    'to',
    'trans',
    'transaction',
    'trigger',
    'true',
    'uid',
    'union',
    'unique',
    'update',
    'user',
    'validate',
    'values',
    'view',
    'was',
    'when',
    'whenever',
    'where',
    'while',
    'will',
    'with'
]);


const $7a35b8da3f4c495c$export$3eb9033c48208278 = (jqlString)=>{
    // If the string contains special characters, perform a proper escape
    if ((0, $6fb2c74696c90120$export$c11f53c00e0a0ad4).test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
    // If the string matches a reserved word, wrap it in quotes since any
    // special characters would have been caught above already
    if ((0, $6fb2c74696c90120$export$1fa3c1f0578bafad).has(jqlString.toLowerCase()) && (0, $g9Jfe.fg)('queue-setting-page-jql-bug')) return `"${jqlString}"`;
    return jqlString;
};



var $jyVZk = parcelRequire("jyVZk");

function $3707c2eebe42f103$var$acceptArgument(visitor) {
    return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
}
function $3707c2eebe42f103$var$enterNode(listener) {
    listener.enterArgument && listener.enterArgument(this);
}
function $3707c2eebe42f103$var$exitNode(listener) {
    listener.exitArgument && listener.exitArgument(this);
}
const $3707c2eebe42f103$export$6ea29ee575e3f5ff = (value)=>$3707c2eebe42f103$export$5b341d50fa5bcdd5(value, (0, $7a35b8da3f4c495c$export$3eb9033c48208278)(value));
const $3707c2eebe42f103$export$84c43d23f51170cb = (text)=>$3707c2eebe42f103$export$5b341d50fa5bcdd5((0, $3lfxh.normaliseJqlString)(text), text);
const $3707c2eebe42f103$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $3707c2eebe42f103$var$acceptArgument,
        enterNode: $3707c2eebe42f103$var$enterNode,
        exitNode: $3707c2eebe42f103$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });



var $9cND1 = parcelRequire("9cND1");

var $3RZEH = parcelRequire("3RZEH");


var $acn5g = parcelRequire("acn5g");




function $058aed3e10c967aa$var$acceptCompoundClause(visitor) {
    return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
}
function $058aed3e10c967aa$var$enterNode(listener) {
    listener.enterCompoundClause && listener.enterCompoundClause(this);
}
function $058aed3e10c967aa$var$exitNode(listener) {
    listener.exitCompoundClause && listener.exitCompoundClause(this);
}
function $058aed3e10c967aa$var$getChildren() {
    return [
        this.operator,
        ...this.clauses
    ];
}
const $058aed3e10c967aa$export$ab714e56a32c25f2 = (operator, clauses)=>{
    return $058aed3e10c967aa$export$cd65eed8c10b0911(operator, clauses);
};
const $058aed3e10c967aa$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_CLAUSE),
        clauseType: (0, $9cND1.CLAUSE_TYPE_COMPOUND),
        operator: operator,
        clauses: clauses,
        position: position,
        accept: $058aed3e10c967aa$var$acceptCompoundClause,
        enterNode: $058aed3e10c967aa$var$enterNode,
        exitNode: $058aed3e10c967aa$var$exitNode,
        getChildren: $058aed3e10c967aa$var$getChildren,
        parent: null,
        appendClause: $acn5g.appendClause,
        remove: $acn5g.remove,
        removeClause: $acn5g.removeClause,
        replace: $acn5g.replace,
        replaceClause: $acn5g.replaceClause
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};





function $8f3a3575464793a8$var$acceptCompoundOperator(visitor) {
    return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
}
function $8f3a3575464793a8$var$enterNode(listener) {
    listener.enterCompoundOperator && listener.enterCompoundOperator(this);
}
function $8f3a3575464793a8$var$exitNode(listener) {
    listener.exitCompoundOperator && listener.exitCompoundOperator(this);
}
const $8f3a3575464793a8$export$84bb3ebbba491aee = (value)=>$8f3a3575464793a8$export$63c33bc3fe74fee6(value, []);
const $8f3a3575464793a8$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
        value: value,
        positions: operatorPositions,
        position: null,
        accept: $8f3a3575464793a8$var$acceptCompoundOperator,
        enterNode: $8f3a3575464793a8$var$enterNode,
        exitNode: $8f3a3575464793a8$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });






function $75c35059a87e7599$var$acceptField(visitor) {
    return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
}
function $75c35059a87e7599$var$enterNode(listener) {
    listener.enterField && listener.enterField(this);
}
function $75c35059a87e7599$var$exitNode(listener) {
    listener.exitField && listener.exitField(this);
}
function $75c35059a87e7599$var$getChildren() {
    return this.properties ? [
        ...this.properties
    ] : [];
}
const $75c35059a87e7599$export$e0f35d825088c098 = (value, properties)=>{
    return $75c35059a87e7599$export$2193f8c541622b6(value, (0, $7a35b8da3f4c495c$export$3eb9033c48208278)(value), properties);
};
const $75c35059a87e7599$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
    const node = {
        text: text,
        value: value,
        properties: properties,
        position: position,
        accept: $75c35059a87e7599$var$acceptField,
        enterNode: $75c35059a87e7599$var$enterNode,
        exitNode: $75c35059a87e7599$var$exitNode,
        getChildren: $75c35059a87e7599$var$getChildren,
        parent: null
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};





var $bztru = parcelRequire("bztru");




function $162ac1785b095a1b$var$acceptFunctionOperand(visitor) {
    return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function $162ac1785b095a1b$var$enterNode(listener) {
    listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function $162ac1785b095a1b$var$exitNode(listener) {
    listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function $162ac1785b095a1b$var$getChildren() {
    return [
        this.function,
        ...this.arguments
    ];
}
const $162ac1785b095a1b$export$4f981b0e83488ce = (functionString, args = [])=>$162ac1785b095a1b$export$c1f2ce91dc05872a(functionString, args);
const $162ac1785b095a1b$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_OPERAND),
        operandType: (0, $bztru.OPERAND_TYPE_FUNCTION),
        function: functionString,
        arguments: args,
        position: position,
        accept: $162ac1785b095a1b$var$acceptFunctionOperand,
        enterNode: $162ac1785b095a1b$var$enterNode,
        exitNode: $162ac1785b095a1b$var$exitNode,
        getChildren: $162ac1785b095a1b$var$getChildren,
        parent: null
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};






function $b188e1f392909211$var$acceptFunctionString(visitor) {
    return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
}
function $b188e1f392909211$var$enterNode(listener) {
    listener.enterFunction && listener.enterFunction(this);
}
function $b188e1f392909211$var$exitNode(listener) {
    listener.exitFunction && listener.exitFunction(this);
}
const $b188e1f392909211$export$4e1bb9a7ff8d0ef9 = (value)=>$b188e1f392909211$export$7aa9944588b7a69f(value, (0, $7a35b8da3f4c495c$export$3eb9033c48208278)(value));
const $b188e1f392909211$export$7aa9944588b7a69f = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $b188e1f392909211$var$acceptFunctionString,
        enterNode: $b188e1f392909211$var$enterNode,
        exitNode: $b188e1f392909211$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });


const $9753706674a213e3$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
        query: query,
        represents: represents,
        errors: errors
    });










function $eb530f62673d010e$var$acceptKeywordOperand(visitor) {
    return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
}
function $eb530f62673d010e$var$enterNode(listener) {
    listener.enterKeywordOperand && listener.enterKeywordOperand(this);
}
function $eb530f62673d010e$var$exitNode(listener) {
    listener.exitKeywordOperand && listener.exitKeywordOperand(this);
}
const $eb530f62673d010e$export$2edd4971ed69f2ce = ()=>$eb530f62673d010e$export$7cc55480b054047b((0, $bztru.OPERAND_EMPTY));
const $eb530f62673d010e$export$7cc55480b054047b = (value, position = null)=>({
        type: (0, $3RZEH.NODE_TYPE_OPERAND),
        operandType: (0, $bztru.OPERAND_TYPE_KEYWORD),
        value: value,
        position: position,
        accept: $eb530f62673d010e$var$acceptKeywordOperand,
        enterNode: $eb530f62673d010e$var$enterNode,
        exitNode: $eb530f62673d010e$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });













function $a38e24e16f53e288$export$d94c54f1aee177c4(operand) {
    this.values.push(...operand.operandType === (0, $bztru.OPERAND_TYPE_LIST) ? operand.values : [
        operand
    ]);
    (0, $jyVZk.assignParent)(this);
}





function $0a2d4bd9260ee5fc$var$acceptListOperand(visitor) {
    return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
}
function $0a2d4bd9260ee5fc$var$enterNode(listener) {
    listener.enterListOperand && listener.enterListOperand(this);
}
function $0a2d4bd9260ee5fc$var$exitNode(listener) {
    listener.exitListOperand && listener.exitListOperand(this);
}
function $0a2d4bd9260ee5fc$var$getChildren() {
    return [
        ...this.values
    ];
}
const $0a2d4bd9260ee5fc$export$769866c3e9d41d50 = (values)=>$0a2d4bd9260ee5fc$export$663c7831528c984b(values);
const $0a2d4bd9260ee5fc$export$663c7831528c984b = (values, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_OPERAND),
        operandType: (0, $bztru.OPERAND_TYPE_LIST),
        values: values,
        position: position,
        accept: $0a2d4bd9260ee5fc$var$acceptListOperand,
        enterNode: $0a2d4bd9260ee5fc$var$enterNode,
        exitNode: $0a2d4bd9260ee5fc$var$exitNode,
        getChildren: $0a2d4bd9260ee5fc$var$getChildren,
        parent: null,
        appendOperand: $a38e24e16f53e288$export$d94c54f1aee177c4
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};








var $e6yWf = parcelRequire("e6yWf");





var $elkRg = parcelRequire("elkRg");




function $76ee54213efa5624$var$acceptNotClauseOperator(visitor) {
    return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
}
function $76ee54213efa5624$var$enterNode(listener) {
    listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
}
function $76ee54213efa5624$var$exitNode(listener) {
    listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
}
const $76ee54213efa5624$export$d2cd8239f99c13d3 = ()=>$76ee54213efa5624$export$1b15a32bb57b9020();
const $76ee54213efa5624$export$1b15a32bb57b9020 = (position = null)=>({
        value: (0, $elkRg.CLAUSE_OPERATOR_NOT),
        position: position,
        accept: $76ee54213efa5624$var$acceptNotClauseOperator,
        enterNode: $76ee54213efa5624$var$enterNode,
        exitNode: $76ee54213efa5624$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });


function $5119bd0e2047d1b0$var$acceptNotClause(visitor) {
    return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
}
function $5119bd0e2047d1b0$var$enterNode(listener) {
    listener.enterNotClause && listener.enterNotClause(this);
}
function $5119bd0e2047d1b0$var$exitNode(listener) {
    listener.exitNotClause && listener.exitNotClause(this);
}
function $5119bd0e2047d1b0$var$getChildren() {
    return [
        this.operator,
        this.clause
    ];
}
const $5119bd0e2047d1b0$export$b4734a9fedb4d44e = (clause)=>{
    return $5119bd0e2047d1b0$export$b25621824fea4548(clause, (0, $76ee54213efa5624$export$d2cd8239f99c13d3)());
};
const $5119bd0e2047d1b0$export$b25621824fea4548 = (clause, operator, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_CLAUSE),
        clauseType: (0, $9cND1.CLAUSE_TYPE_NOT),
        clause: clause,
        operator: operator,
        position: position,
        accept: $5119bd0e2047d1b0$var$acceptNotClause,
        enterNode: $5119bd0e2047d1b0$var$enterNode,
        exitNode: $5119bd0e2047d1b0$var$exitNode,
        getChildren: $5119bd0e2047d1b0$var$getChildren,
        parent: null,
        remove: $e6yWf.remove,
        removeClause: $e6yWf.removeClause,
        replace: $e6yWf.replace,
        replaceClause: $e6yWf.replaceClause
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};






function $11296619dc629112$var$acceptOperator(visitor) {
    return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
}
function $11296619dc629112$var$enterNode(listener) {
    listener.enterOperator && listener.enterOperator(this);
}
function $11296619dc629112$var$exitNode(listener) {
    listener.exitOperator && listener.exitOperator(this);
}
const $11296619dc629112$export$dbd72860f701d4f3 = (value)=>$11296619dc629112$export$649025bc60ab9c3b(value, value);
const $11296619dc629112$export$649025bc60ab9c3b = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $11296619dc629112$var$acceptOperator,
        enterNode: $11296619dc629112$var$enterNode,
        exitNode: $11296619dc629112$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });






var $cR6D0 = parcelRequire("cR6D0");





var $awcA2 = parcelRequire("awcA2");




function $e435256c061675ad$var$acceptOrderByOperator(visitor) {
    return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
}
function $e435256c061675ad$var$enterNode(listener) {
    listener.enterOrderByOperator && listener.enterOrderByOperator(this);
}
function $e435256c061675ad$var$exitNode(listener) {
    listener.exitOrderByOperator && listener.exitOrderByOperator(this);
}
const $e435256c061675ad$export$c7307b67924c61ea = ()=>$e435256c061675ad$export$739e30af23a08da0();
const $e435256c061675ad$export$739e30af23a08da0 = (position = null)=>({
        value: (0, $awcA2.ORDER_BY_OPERATOR_ORDER_BY),
        position: position,
        accept: $e435256c061675ad$var$acceptOrderByOperator,
        enterNode: $e435256c061675ad$var$enterNode,
        exitNode: $e435256c061675ad$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });


function $66891c92f01b8d08$var$acceptOrderBy(visitor) {
    return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
}
function $66891c92f01b8d08$var$enterNode(listener) {
    listener.enterOrderBy && listener.enterOrderBy(this);
}
function $66891c92f01b8d08$var$exitNode(listener) {
    listener.exitOrderBy && listener.exitOrderBy(this);
}
function $66891c92f01b8d08$var$getChildren() {
    return [
        this.operator,
        ...this.fields
    ];
}
const $66891c92f01b8d08$export$f18af21d6f4dafd8 = (fields)=>{
    return $66891c92f01b8d08$export$e4eb1fa6bc8465c1(fields, (0, $e435256c061675ad$export$c7307b67924c61ea)());
};
const $66891c92f01b8d08$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_ORDER_BY),
        operator: operator,
        fields: fields,
        position: position,
        accept: $66891c92f01b8d08$var$acceptOrderBy,
        enterNode: $66891c92f01b8d08$var$enterNode,
        exitNode: $66891c92f01b8d08$var$exitNode,
        getChildren: $66891c92f01b8d08$var$getChildren,
        parent: null,
        prependOrderField: $cR6D0.prependOrderField,
        setOrderDirection: $cR6D0.setOrderDirection,
        replace: $cR6D0.replace,
        replaceOrderField: $cR6D0.replaceOrderField,
        remove: $cR6D0.remove,
        removeOrderField: $cR6D0.removeOrderField
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};





function $0126e76da375900a$var$acceptOrderByDirection(visitor) {
    return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
}
function $0126e76da375900a$var$enterNode(listener) {
    listener.enterOrderByDirection && listener.enterOrderByDirection(this);
}
function $0126e76da375900a$var$exitNode(listener) {
    listener.exitOrderByDirection && listener.exitOrderByDirection(this);
}
const $0126e76da375900a$export$864d934efed3ccaa = (value)=>$0126e76da375900a$export$8c65cac1a7852d1f(value);
const $0126e76da375900a$export$8c65cac1a7852d1f = (value, position = null)=>({
        value: value,
        position: position,
        accept: $0126e76da375900a$var$acceptOrderByDirection,
        enterNode: $0126e76da375900a$var$enterNode,
        exitNode: $0126e76da375900a$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });





function $9a1eba57b016a782$export$b596730931a09703(orderDirection) {
    this.direction = orderDirection;
    (0, $jyVZk.assignParent)(this);
}
function $9a1eba57b016a782$export$77ad94ebf1c2b9ed(orderByField) {
    if (this.parent) this.parent.replaceOrderField(this, orderByField);
}
function $9a1eba57b016a782$export$cd7f480d6b8286c3() {
    if (this.parent) this.parent.removeOrderField(this);
}





function $701c3a5cac8991d3$var$acceptOrderByField(visitor) {
    return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function $701c3a5cac8991d3$var$enterNode(listener) {
    listener.enterOrderByField && listener.enterOrderByField(this);
}
function $701c3a5cac8991d3$var$exitNode(listener) {
    listener.exitOrderByField && listener.exitOrderByField(this);
}
function $701c3a5cac8991d3$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.direction) children.push(this.direction);
    return children;
}
const $701c3a5cac8991d3$export$942df63e5e3d3899 = (field, direction)=>$701c3a5cac8991d3$export$661a7786e3d15926(field, direction);
const $701c3a5cac8991d3$export$661a7786e3d15926 = (field, direction, position = null)=>{
    const node = {
        field: field,
        direction: direction,
        position: position,
        accept: $701c3a5cac8991d3$var$acceptOrderByField,
        enterNode: $701c3a5cac8991d3$var$enterNode,
        exitNode: $701c3a5cac8991d3$var$exitNode,
        getChildren: $701c3a5cac8991d3$var$getChildren,
        parent: null,
        setOrderDirection: $9a1eba57b016a782$export$b596730931a09703,
        replace: $9a1eba57b016a782$export$77ad94ebf1c2b9ed,
        remove: $9a1eba57b016a782$export$cd7f480d6b8286c3
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};






function $a2eedfb02e3f55da$var$acceptPredicate(visitor) {
    return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
}
function $a2eedfb02e3f55da$var$enterNode(listener) {
    listener.enterPredicate && listener.enterPredicate(this);
}
function $a2eedfb02e3f55da$var$exitNode(listener) {
    listener.exitPredicate && listener.exitPredicate(this);
}
function $a2eedfb02e3f55da$var$getChildren() {
    const children = [
        this.operator
    ];
    if (this.operand) children.push(this.operand);
    return children;
}
const $a2eedfb02e3f55da$export$5fc51e445ce24faf = (operator, operand)=>$a2eedfb02e3f55da$export$a767a27ad05a38a2(operator, operand);
const $a2eedfb02e3f55da$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
    const node = {
        operator: operator,
        operand: operand,
        position: position,
        accept: $a2eedfb02e3f55da$var$acceptPredicate,
        enterNode: $a2eedfb02e3f55da$var$enterNode,
        exitNode: $a2eedfb02e3f55da$var$exitNode,
        getChildren: $a2eedfb02e3f55da$var$getChildren,
        parent: null
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};





function $7764553532efe393$var$acceptPredicateOperator(visitor) {
    return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
}
function $7764553532efe393$var$enterNode(listener) {
    listener.enterPredicateOperator && listener.enterPredicateOperator(this);
}
function $7764553532efe393$var$exitNode(listener) {
    listener.exitPredicateOperator && listener.exitPredicateOperator(this);
}
const $7764553532efe393$export$5419b7f16910ea62 = (value)=>$7764553532efe393$export$c69d893689716768(value, value);
const $7764553532efe393$export$c69d893689716768 = (value, text, position = null)=>({
        text: text,
        value: value,
        position: position,
        accept: $7764553532efe393$var$acceptPredicateOperator,
        enterNode: $7764553532efe393$var$enterNode,
        exitNode: $7764553532efe393$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });





function $e051a9e65af4d3fb$var$acceptProperty(visitor) {
    return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
}
function $e051a9e65af4d3fb$var$enterNode(listener) {
    listener.enterProperty && listener.enterProperty(this);
}
function $e051a9e65af4d3fb$var$exitNode(listener) {
    listener.exitProperty && listener.exitProperty(this);
}
function $e051a9e65af4d3fb$var$getChildren() {
    const children = [];
    if (this.key) children.push(this.key);
    if (this.path) return children.concat(this.path);
    return children;
}
const $e051a9e65af4d3fb$export$d541bacb2bda4494 = (key, path = [])=>$e051a9e65af4d3fb$export$1cbd90994fef1fad(key, path);
const $e051a9e65af4d3fb$export$1cbd90994fef1fad = (key, path, position = null)=>{
    const node = {
        key: key,
        path: path,
        position: position,
        accept: $e051a9e65af4d3fb$var$acceptProperty,
        enterNode: $e051a9e65af4d3fb$var$enterNode,
        exitNode: $e051a9e65af4d3fb$var$exitNode,
        getChildren: $e051a9e65af4d3fb$var$getChildren,
        parent: null
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};






var $k00Ux = parcelRequire("k00Ux");




/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */ function $fbd5aa72507547f2$var$acceptQuery(visitor) {
    return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function $fbd5aa72507547f2$var$enterNode(listener) {
    listener.enterQuery && listener.enterQuery(this);
}
function $fbd5aa72507547f2$var$exitNode(listener) {
    listener.exitQuery && listener.exitQuery(this);
}
function $fbd5aa72507547f2$var$getChildren() {
    const children = [];
    if (this.where) children.push(this.where);
    if (this.orderBy) children.push(this.orderBy);
    return children;
}
const $fbd5aa72507547f2$export$2fa187e846a241c4 = (where, orderBy)=>$fbd5aa72507547f2$export$bc2d6e2e1fd9014(where, orderBy);
const $fbd5aa72507547f2$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_QUERY),
        where: where,
        orderBy: orderBy,
        position: position,
        accept: $fbd5aa72507547f2$var$acceptQuery,
        enterNode: $fbd5aa72507547f2$var$enterNode,
        exitNode: $fbd5aa72507547f2$var$exitNode,
        getChildren: $fbd5aa72507547f2$var$getChildren,
        parent: null,
        appendClause: $k00Ux.appendClause,
        prependOrderField: $k00Ux.prependOrderField,
        setOrderDirection: $k00Ux.setOrderDirection,
        removeClause: $k00Ux.removeClause,
        replaceClause: $k00Ux.replaceClause,
        replaceOrderBy: $k00Ux.replaceOrderBy,
        removeOrderBy: $k00Ux.removeOrderBy
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};








var $cT0U6 = parcelRequire("cT0U6");




function $9f071d020511b093$var$acceptTerminalClause(visitor) {
    return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
}
function $9f071d020511b093$var$enterNode(listener) {
    listener.enterTerminalClause && listener.enterTerminalClause(this);
}
function $9f071d020511b093$var$exitNode(listener) {
    listener.exitTerminalClause && listener.exitTerminalClause(this);
}
function $9f071d020511b093$var$getChildren() {
    const children = [
        this.field
    ];
    if (this.operator) children.push(this.operator);
    if (this.operand) children.push(this.operand);
    return children.concat(this.predicates);
}
const $9f071d020511b093$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
    return $9f071d020511b093$export$cc08e43598d091fc(field, operator, operand, predicates);
};
const $9f071d020511b093$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
    const node = {
        type: (0, $3RZEH.NODE_TYPE_CLAUSE),
        clauseType: (0, $9cND1.CLAUSE_TYPE_TERMINAL),
        field: field,
        operator: operator,
        operand: operand,
        predicates: predicates,
        position: position,
        accept: $9f071d020511b093$var$acceptTerminalClause,
        enterNode: $9f071d020511b093$var$enterNode,
        exitNode: $9f071d020511b093$var$exitNode,
        getChildren: $9f071d020511b093$var$getChildren,
        parent: null,
        setOperator: $cT0U6.setOperator,
        setOperand: $cT0U6.setOperand,
        appendOperand: $cT0U6.appendOperand,
        remove: $cT0U6.remove,
        replace: $cT0U6.replace
    };
    (0, $jyVZk.assignParent)(node);
    return node;
};













function $32c1523227c332a4$var$acceptValueOperand(visitor) {
    return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
}
function $32c1523227c332a4$var$enterNode(listener) {
    listener.enterValueOperand && listener.enterValueOperand(this);
}
function $32c1523227c332a4$var$exitNode(listener) {
    listener.exitValueOperand && listener.exitValueOperand(this);
}
const $32c1523227c332a4$export$2b6e4d2ed8d53bf3 = (value)=>$32c1523227c332a4$export$79c37d97caac8627(value, (0, $7a35b8da3f4c495c$export$3eb9033c48208278)(value));
const $32c1523227c332a4$export$3ac9155bde56a45f = (text)=>$32c1523227c332a4$export$79c37d97caac8627((0, $3lfxh.normaliseJqlString)(text), text);
const $32c1523227c332a4$export$79c37d97caac8627 = (value, text, position = null)=>({
        type: (0, $3RZEH.NODE_TYPE_OPERAND),
        operandType: (0, $bztru.OPERAND_TYPE_VALUE),
        text: text,
        value: value,
        position: position,
        accept: $32c1523227c332a4$var$acceptValueOperand,
        enterNode: $32c1523227c332a4$var$enterNode,
        exitNode: $32c1523227c332a4$var$exitNode,
        getChildren: (0, $jyVZk.noChildren),
        parent: null
    });


const $fee572fc94a27ca8$export$64d991963cfb5532 = {
    query: (0, $fbd5aa72507547f2$export$bc2d6e2e1fd9014),
    compoundClause: (0, $058aed3e10c967aa$export$cd65eed8c10b0911),
    compoundOperator: (0, $8f3a3575464793a8$export$63c33bc3fe74fee6),
    terminalClause: (0, $9f071d020511b093$export$cc08e43598d091fc),
    notClause: (0, $5119bd0e2047d1b0$export$b25621824fea4548),
    notClauseOperator: (0, $76ee54213efa5624$export$1b15a32bb57b9020),
    predicate: (0, $a2eedfb02e3f55da$export$a767a27ad05a38a2),
    predicateOperator: (0, $7764553532efe393$export$c69d893689716768),
    field: (0, $75c35059a87e7599$export$2193f8c541622b6),
    property: (0, $e051a9e65af4d3fb$export$1cbd90994fef1fad),
    operator: (0, $11296619dc629112$export$649025bc60ab9c3b),
    valueOperand: (0, $32c1523227c332a4$export$79c37d97caac8627),
    keywordOperand: (0, $eb530f62673d010e$export$7cc55480b054047b),
    functionOperand: (0, $162ac1785b095a1b$export$c1f2ce91dc05872a),
    functionString: (0, $b188e1f392909211$export$7aa9944588b7a69f),
    argument: (0, $3707c2eebe42f103$export$5b341d50fa5bcdd5),
    listOperand: (0, $0a2d4bd9260ee5fc$export$663c7831528c984b),
    orderBy: (0, $66891c92f01b8d08$export$e4eb1fa6bc8465c1),
    orderByOperator: (0, $e435256c061675ad$export$739e30af23a08da0),
    orderByField: (0, $701c3a5cac8991d3$export$661a7786e3d15926),
    orderByDirection: (0, $0126e76da375900a$export$8c65cac1a7852d1f)
};
const $fee572fc94a27ca8$var$_default_1 = {
    jast: $9753706674a213e3$export$b9e70a00f479ff43,
    query: $fbd5aa72507547f2$export$2fa187e846a241c4,
    compoundClause: $058aed3e10c967aa$export$ab714e56a32c25f2,
    compoundOperator: $8f3a3575464793a8$export$84bb3ebbba491aee,
    terminalClause: $9f071d020511b093$export$2627cbe08dd86b00,
    notClause: $5119bd0e2047d1b0$export$b4734a9fedb4d44e,
    notClauseOperator: $76ee54213efa5624$export$d2cd8239f99c13d3,
    predicate: $a2eedfb02e3f55da$export$5fc51e445ce24faf,
    predicateOperator: $7764553532efe393$export$5419b7f16910ea62,
    field: $75c35059a87e7599$export$e0f35d825088c098,
    property: $e051a9e65af4d3fb$export$d541bacb2bda4494,
    operator: $11296619dc629112$export$dbd72860f701d4f3,
    valueOperand: $32c1523227c332a4$export$2b6e4d2ed8d53bf3,
    keywordOperand: $eb530f62673d010e$export$2edd4971ed69f2ce,
    functionOperand: $162ac1785b095a1b$export$4f981b0e83488ce,
    functionString: $b188e1f392909211$export$4e1bb9a7ff8d0ef9,
    argument: $3707c2eebe42f103$export$6ea29ee575e3f5ff,
    listOperand: $0a2d4bd9260ee5fc$export$769866c3e9d41d50,
    orderBy: $66891c92f01b8d08$export$f18af21d6f4dafd8,
    orderByOperator: $e435256c061675ad$export$c7307b67924c61ea,
    orderByField: $701c3a5cac8991d3$export$942df63e5e3d3899,
    orderByDirection: $0126e76da375900a$export$864d934efed3ccaa,
    byText: {
        argument: (0, $3707c2eebe42f103$export$84c43d23f51170cb),
        valueOperand: (0, $32c1523227c332a4$export$3ac9155bde56a45f)
    }
};
var $fee572fc94a27ca8$export$2e2bcd8739ae039 = $fee572fc94a27ca8$var$_default_1;
module.exports["internalCreators"] = $fee572fc94a27ca8$export$64d991963cfb5532;
module.exports["default"] = $fee572fc94a27ca8$export$2e2bcd8739ae039;

});

parcelRegister("3lfxh", function(module, exports) {
const $4cbc5883dd7e9991$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $4cbc5883dd7e9991$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $4cbc5883dd7e9991$export$b86601123607fee5 = (maybeQuotedString)=>$4cbc5883dd7e9991$export$7a0b99b892e0dda8(maybeQuotedString) || $4cbc5883dd7e9991$export$d5efd6512db694fd(maybeQuotedString);
const $4cbc5883dd7e9991$export$cecf78a779acc0ff = (maybeQuotedString)=>{
    if ($4cbc5883dd7e9991$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};
module.exports["normaliseJqlString"] = $4cbc5883dd7e9991$export$cecf78a779acc0ff;

});

parcelRegister("9cND1", function(module, exports) {
const $cb68a86a0d97fab5$export$7a58b23488ea076b = 'compound';
const $cb68a86a0d97fab5$export$ae56b4ef248a2b6a = 'terminal';
const $cb68a86a0d97fab5$export$e356b89f8c8d2fcb = 'not';
module.exports["CLAUSE_TYPE_COMPOUND"] = $cb68a86a0d97fab5$export$7a58b23488ea076b;
module.exports["CLAUSE_TYPE_TERMINAL"] = $cb68a86a0d97fab5$export$ae56b4ef248a2b6a;
module.exports["CLAUSE_TYPE_NOT"] = $cb68a86a0d97fab5$export$e356b89f8c8d2fcb;

});

parcelRegister("3RZEH", function(module, exports) {
const $90366511434d196c$export$98dda21ec825792 = 'query';
const $90366511434d196c$export$2d205682cc545947 = 'clause';
const $90366511434d196c$export$d2f212d8ddbc8d1d = 'operand';
const $90366511434d196c$export$da0f73edded4a63d = 'order_by';
module.exports["NODE_TYPE_QUERY"] = $90366511434d196c$export$98dda21ec825792;
module.exports["NODE_TYPE_CLAUSE"] = $90366511434d196c$export$2d205682cc545947;
module.exports["NODE_TYPE_OPERAND"] = $90366511434d196c$export$d2f212d8ddbc8d1d;
module.exports["NODE_TYPE_ORDER_BY"] = $90366511434d196c$export$da0f73edded4a63d;

});

parcelRegister("acn5g", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $9cND1 = parcelRequire("9cND1");


var $jyVZk = parcelRequire("jyVZk");

function appendClause(clause) {
    let clausesToAppend = [
        clause
    ];
    // If the clause to append is compound with a matching operator then we flatten it into the current clause
    if (clause.clauseType === (0, $9cND1.CLAUSE_TYPE_COMPOUND) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
    this.clauses.push(...clausesToAppend);
    (0, $jyVZk.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    this.clauses = this.clauses.filter((val)=>val !== clause);
    if (this.clauses.length === 1) this.replace(this.clauses[0]);
    else if (this.clauses.length === 0) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    this.clauses = this.clauses.map((child)=>{
        return child === clause ? nextClause : child;
    });
    (0, $jyVZk.assignParent)(this);
}

});

parcelRegister("bztru", function(module, exports) {
const $8b7bb40d9fd59fc4$export$38accfc5a5d1c113 = 'value';
const $8b7bb40d9fd59fc4$export$f6049126fd97001f = 'keyword';
const $8b7bb40d9fd59fc4$export$19c7c729db381f9d = 'function';
const $8b7bb40d9fd59fc4$export$fabec4aebba3f4df = 'list';
const $8b7bb40d9fd59fc4$export$1c46dca02aac24dd = 'empty';
module.exports["OPERAND_TYPE_VALUE"] = $8b7bb40d9fd59fc4$export$38accfc5a5d1c113;
module.exports["OPERAND_TYPE_KEYWORD"] = $8b7bb40d9fd59fc4$export$f6049126fd97001f;
module.exports["OPERAND_TYPE_FUNCTION"] = $8b7bb40d9fd59fc4$export$19c7c729db381f9d;
module.exports["OPERAND_TYPE_LIST"] = $8b7bb40d9fd59fc4$export$fabec4aebba3f4df;
module.exports["OPERAND_EMPTY"] = $8b7bb40d9fd59fc4$export$1c46dca02aac24dd;

});

parcelRegister("e6yWf", function(module, exports) {
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceClause", () => replaceClause);

var $jyVZk = parcelRequire("jyVZk");

function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function removeClause(clause) {
    if (this.clause === clause) this.remove();
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}
function replaceClause(clause, nextClause) {
    if (this.clause === clause) {
        this.clause = nextClause;
        (0, $jyVZk.assignParent)(this);
    }
}

});

parcelRegister("elkRg", function(module, exports) {
const $786f4f1082fec7bf$export$c6c71ceedb15cda9 = 'not';
const $786f4f1082fec7bf$export$466517a888d00195 = '=';
const $786f4f1082fec7bf$export$6d0d8810623974a5 = '!=';
const $786f4f1082fec7bf$export$bcbb090ab3c498b3 = '>';
const $786f4f1082fec7bf$export$4bf1a4aa659c6ea4 = '<';
const $786f4f1082fec7bf$export$83ce674214a54b2a = '>=';
const $786f4f1082fec7bf$export$9629fd1727ef62ee = '<=';
const $786f4f1082fec7bf$export$c4e3fb55e320e979 = 'in';
const $786f4f1082fec7bf$export$f9857532eaa24ddc = 'not in';
const $786f4f1082fec7bf$export$221595834b8766ab = '~';
const $786f4f1082fec7bf$export$fcefabf94a9bffbf = '!~';
const $786f4f1082fec7bf$export$4feeb3f4ff56bcef = 'is';
const $786f4f1082fec7bf$export$d08d969a0da27188 = 'is not';
const $786f4f1082fec7bf$export$8f907e179985256d = 'was';
const $786f4f1082fec7bf$export$cc7b9d0b3ee23193 = 'was in';
const $786f4f1082fec7bf$export$585d3c004af078bb = 'was not in';
const $786f4f1082fec7bf$export$123eaa9ccc2d9445 = 'was not';
const $786f4f1082fec7bf$export$15f5b446ba8c941e = 'changed';
const $786f4f1082fec7bf$export$643c6101f3fc8547 = [
    $786f4f1082fec7bf$export$466517a888d00195,
    $786f4f1082fec7bf$export$6d0d8810623974a5
];
const $786f4f1082fec7bf$export$329664c9cf18cca6 = [
    $786f4f1082fec7bf$export$221595834b8766ab,
    $786f4f1082fec7bf$export$fcefabf94a9bffbf
];
const $786f4f1082fec7bf$export$1b167a3705885a8b = [
    $786f4f1082fec7bf$export$4bf1a4aa659c6ea4,
    $786f4f1082fec7bf$export$bcbb090ab3c498b3,
    $786f4f1082fec7bf$export$9629fd1727ef62ee,
    $786f4f1082fec7bf$export$83ce674214a54b2a
];
const $786f4f1082fec7bf$export$f25cf16c2270312f = [
    $786f4f1082fec7bf$export$c4e3fb55e320e979,
    $786f4f1082fec7bf$export$f9857532eaa24ddc
];
const $786f4f1082fec7bf$export$eb58cfffe4a6b805 = [
    $786f4f1082fec7bf$export$4feeb3f4ff56bcef,
    $786f4f1082fec7bf$export$d08d969a0da27188
];
const $786f4f1082fec7bf$export$c22a981f581de218 = [
    $786f4f1082fec7bf$export$8f907e179985256d,
    $786f4f1082fec7bf$export$123eaa9ccc2d9445
];
const $786f4f1082fec7bf$export$6d08c4699bb75284 = [
    $786f4f1082fec7bf$export$cc7b9d0b3ee23193,
    $786f4f1082fec7bf$export$585d3c004af078bb
];
const $786f4f1082fec7bf$export$b7dc214eef214c1c = [
    $786f4f1082fec7bf$export$15f5b446ba8c941e
];
const $786f4f1082fec7bf$export$184799fc79ccac89 = [
    ...$786f4f1082fec7bf$export$643c6101f3fc8547,
    ...$786f4f1082fec7bf$export$329664c9cf18cca6,
    ...$786f4f1082fec7bf$export$1b167a3705885a8b,
    ...$786f4f1082fec7bf$export$f25cf16c2270312f,
    ...$786f4f1082fec7bf$export$eb58cfffe4a6b805,
    ...$786f4f1082fec7bf$export$c22a981f581de218,
    ...$786f4f1082fec7bf$export$6d08c4699bb75284,
    ...$786f4f1082fec7bf$export$b7dc214eef214c1c
];
const $786f4f1082fec7bf$export$77c793736847e030 = [
    $786f4f1082fec7bf$export$c4e3fb55e320e979,
    $786f4f1082fec7bf$export$f9857532eaa24ddc,
    $786f4f1082fec7bf$export$cc7b9d0b3ee23193,
    $786f4f1082fec7bf$export$585d3c004af078bb
];
module.exports["CLAUSE_OPERATOR_NOT"] = $786f4f1082fec7bf$export$c6c71ceedb15cda9;
module.exports["OPERATOR_EQUALS"] = $786f4f1082fec7bf$export$466517a888d00195;
module.exports["OPERATOR_NOT_EQUALS"] = $786f4f1082fec7bf$export$6d0d8810623974a5;
module.exports["OPERATOR_GT"] = $786f4f1082fec7bf$export$bcbb090ab3c498b3;
module.exports["OPERATOR_LT"] = $786f4f1082fec7bf$export$4bf1a4aa659c6ea4;
module.exports["OPERATOR_GT_EQUALS"] = $786f4f1082fec7bf$export$83ce674214a54b2a;
module.exports["OPERATOR_LT_EQUALS"] = $786f4f1082fec7bf$export$9629fd1727ef62ee;
module.exports["OPERATOR_IN"] = $786f4f1082fec7bf$export$c4e3fb55e320e979;
module.exports["OPERATOR_NOT_IN"] = $786f4f1082fec7bf$export$f9857532eaa24ddc;
module.exports["OPERATOR_LIKE"] = $786f4f1082fec7bf$export$221595834b8766ab;
module.exports["OPERATOR_NOT_LIKE"] = $786f4f1082fec7bf$export$fcefabf94a9bffbf;
module.exports["OPERATOR_IS"] = $786f4f1082fec7bf$export$4feeb3f4ff56bcef;
module.exports["OPERATOR_IS_NOT"] = $786f4f1082fec7bf$export$d08d969a0da27188;
module.exports["OPERATOR_WAS"] = $786f4f1082fec7bf$export$8f907e179985256d;
module.exports["OPERATOR_WAS_IN"] = $786f4f1082fec7bf$export$cc7b9d0b3ee23193;
module.exports["OPERATOR_WAS_NOT_IN"] = $786f4f1082fec7bf$export$585d3c004af078bb;
module.exports["OPERATOR_WAS_NOT"] = $786f4f1082fec7bf$export$123eaa9ccc2d9445;
module.exports["OPERATOR_CHANGED"] = $786f4f1082fec7bf$export$15f5b446ba8c941e;
module.exports["EQUALS_OPERATORS"] = $786f4f1082fec7bf$export$643c6101f3fc8547;
module.exports["LIKE_OPERATORS"] = $786f4f1082fec7bf$export$329664c9cf18cca6;
module.exports["COMPARISON_OPERATORS"] = $786f4f1082fec7bf$export$1b167a3705885a8b;
module.exports["IN_OPERATORS"] = $786f4f1082fec7bf$export$f25cf16c2270312f;
module.exports["IS_OPERATORS"] = $786f4f1082fec7bf$export$eb58cfffe4a6b805;
module.exports["WAS_OPERATORS"] = $786f4f1082fec7bf$export$c22a981f581de218;
module.exports["WAS_IN_OPERATORS"] = $786f4f1082fec7bf$export$6d08c4699bb75284;
module.exports["CHANGED_OPERATORS"] = $786f4f1082fec7bf$export$b7dc214eef214c1c;
module.exports["OPERATORS"] = $786f4f1082fec7bf$export$184799fc79ccac89;
module.exports["LIST_OPERATORS"] = $786f4f1082fec7bf$export$77c793736847e030;

});

parcelRegister("cR6D0", function(module, exports) {
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "replace", () => replace);
$parcel$export(module.exports, "replaceOrderField", () => replaceOrderField);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "removeOrderField", () => removeOrderField);

var $jyVZk = parcelRequire("jyVZk");

function prependOrderField(orderField) {
    this.fields.unshift(orderField);
    (0, $jyVZk.assignParent)(this);
}
function setOrderDirection(orderDirection) {
    if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
}
function replace(nextOrderBy) {
    if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
}
function replaceOrderField(orderByField, nextOrderByField) {
    this.fields = this.fields.map((child)=>{
        return child === orderByField ? nextOrderByField : child;
    });
    (0, $jyVZk.assignParent)(this);
}
function remove() {
    if (this.parent) this.parent.removeOrderBy();
}
function removeOrderField(orderByField) {
    this.fields = this.fields.filter((field)=>field !== orderByField);
    if (this.fields.length === 0) this.remove();
}

});

parcelRegister("awcA2", function(module, exports) {
const $b77304377b4f6ff8$export$ca51f5fd60a74517 = 'ORDER BY';
const $b77304377b4f6ff8$export$6d60017b9e092e73 = 'ASC';
const $b77304377b4f6ff8$export$2ea27ea5f2121899 = 'DESC';
module.exports["ORDER_BY_OPERATOR_ORDER_BY"] = $b77304377b4f6ff8$export$ca51f5fd60a74517;
module.exports["ORDER_BY_DIRECTION_ASC"] = $b77304377b4f6ff8$export$6d60017b9e092e73;
module.exports["ORDER_BY_DIRECTION_DESC"] = $b77304377b4f6ff8$export$2ea27ea5f2121899;

});

parcelRegister("k00Ux", function(module, exports) {
$parcel$export(module.exports, "appendClause", () => appendClause);
$parcel$export(module.exports, "prependOrderField", () => prependOrderField);
$parcel$export(module.exports, "setOrderDirection", () => setOrderDirection);
$parcel$export(module.exports, "removeClause", () => removeClause);
$parcel$export(module.exports, "replaceOrderBy", () => replaceOrderBy);
$parcel$export(module.exports, "replaceClause", () => replaceClause);
$parcel$export(module.exports, "removeOrderBy", () => removeOrderBy);

var $9foTl = parcelRequire("9foTl");


var $jyVZk = parcelRequire("jyVZk");

function appendClause(clause, compoundOperatorValue) {
    if (!this.where) this.where = clause;
    else {
        const nextCompoundOperator = (0, $9foTl.default).compoundOperator(compoundOperatorValue);
        const nextClause = (0, $9foTl.default).compoundClause(nextCompoundOperator, []);
        // Append previous and new clause which will flatten compound clauses with matching operators.
        nextClause.appendClause(this.where);
        nextClause.appendClause(clause);
        this.where = nextClause;
    }
    (0, $jyVZk.assignParent)(this);
}
function prependOrderField(orderField) {
    if (!this.orderBy) {
        this.orderBy = (0, $9foTl.default).orderBy([
            orderField
        ]);
        (0, $jyVZk.assignParent)(this);
    } else this.orderBy.prependOrderField(orderField);
}
function setOrderDirection(orderDirection) {
    if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
}
function removeClause(clause) {
    if (this.where === clause) this.where = undefined;
}
function replaceOrderBy(orderBy) {
    if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
    else {
        this.orderBy = orderBy;
        (0, $jyVZk.assignParent)(this);
    }
}
function replaceClause(clause, nextClause) {
    if (this.where === clause) {
        this.where = nextClause;
        (0, $jyVZk.assignParent)(this);
    }
}
function removeOrderBy() {
    this.orderBy = undefined;
}

});

parcelRegister("cT0U6", function(module, exports) {
$parcel$export(module.exports, "setOperator", () => setOperator);
$parcel$export(module.exports, "setOperand", () => setOperand);
$parcel$export(module.exports, "appendOperand", () => appendOperand);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replace", () => replace);

var $bztru = parcelRequire("bztru");


var $9foTl = parcelRequire("9foTl");


var $jyVZk = parcelRequire("jyVZk");

function setOperator(operator) {
    this.operator = operator;
    (0, $jyVZk.assignParent)(this);
}
function setOperand(operand) {
    this.operand = operand;
    (0, $jyVZk.assignParent)(this);
}
function appendOperand(operand) {
    if (this.operand) {
        if (this.operand.operandType === (0, $bztru.OPERAND_TYPE_LIST)) this.operand.appendOperand(operand);
        else this.setOperand((0, $9foTl.default).listOperand([
            this.operand,
            ...operand.operandType === (0, $bztru.OPERAND_TYPE_LIST) ? operand.values : [
                operand
            ]
        ]));
    } else this.setOperand(operand);
}
function remove() {
    if (this.parent) this.parent.removeClause(this);
}
function replace(nextClause) {
    if (this.parent) this.parent.replaceClause(this, nextClause);
}

});

parcelRegister("9bonr", function(module, exports) {

var $3St4x = parcelRequire("3St4x");

class $18aba1875c38c705$export$3276184116160c41 extends (0, $3St4x.JQLParseError) {
    constructor(message, start, stop, line, charPositionInLine){
        super(message);
        /**
     * The starting character position (zero-indexed) of the offending token.
     */ this.start = void 0;
        /**
     * The last character position (zero-indexed) of the offending token.
     */ this.stop = void 0;
        /**
     * The line number (starting from 1) in the input where the error occurred.
     */ this.line = void 0;
        /**
     * The character position (zero-indexed) within that line where the error occurred.
     */ this.charPositionInLine = void 0;
        this.name = 'JQLSyntaxError';
        this.start = start;
        this.stop = stop;
        this.line = line;
        this.charPositionInLine = charPositionInLine;
    }
}
module.exports["JQLSyntaxError"] = $18aba1875c38c705$export$3276184116160c41;

});

parcelRegister("chZN7", function(module, exports) {
const $633881e8601e94c5$export$6d6d48d210d3ca97 = 'and';
const $633881e8601e94c5$export$7b8f0a728d79a753 = 'or';
module.exports["COMPOUND_OPERATOR_AND"] = $633881e8601e94c5$export$6d6d48d210d3ca97;
module.exports["COMPOUND_OPERATOR_OR"] = $633881e8601e94c5$export$7b8f0a728d79a753;

});

parcelRegister("jNj2z", function(module, exports) {

var $elkRg = parcelRequire("elkRg");

const $e8e11a23197b825b$export$4e40859592ee7ac2 = (operator)=>(0, $elkRg.OPERATORS).includes(operator);
const $e8e11a23197b825b$export$6d0fc196fa8a1673 = (operator)=>(0, $elkRg.EQUALS_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$ad91b6d6a89cb64e = (operator)=>(0, $elkRg.LIKE_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$4477c442bd5c2a6d = (operator)=>(0, $elkRg.COMPARISON_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$c5e1cdef30e30bff = (operator)=>(0, $elkRg.IN_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$ccc3334744e395c7 = (operator)=>(0, $elkRg.IS_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$2b1c5d7e7856f91d = (operator)=>(0, $elkRg.WAS_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$55d8c9b20d99509f = (operator)=>(0, $elkRg.WAS_IN_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$b65d23d23ade534b = (operator)=>(0, $elkRg.CHANGED_OPERATORS).includes(operator);
const $e8e11a23197b825b$export$b09522e4061bbdd6 = (operator)=>(0, $elkRg.LIST_OPERATORS).includes(operator);
module.exports["isOperator"] = $e8e11a23197b825b$export$4e40859592ee7ac2;
module.exports["isEqualsOperator"] = $e8e11a23197b825b$export$6d0fc196fa8a1673;
module.exports["isLikeOperator"] = $e8e11a23197b825b$export$ad91b6d6a89cb64e;
module.exports["isComparisonOperator"] = $e8e11a23197b825b$export$4477c442bd5c2a6d;
module.exports["isInOperator"] = $e8e11a23197b825b$export$c5e1cdef30e30bff;
module.exports["isIsOperator"] = $e8e11a23197b825b$export$ccc3334744e395c7;
module.exports["isWasOperator"] = $e8e11a23197b825b$export$2b1c5d7e7856f91d;
module.exports["isWasInOperator"] = $e8e11a23197b825b$export$55d8c9b20d99509f;
module.exports["isChangedOperator"] = $e8e11a23197b825b$export$b65d23d23ade534b;
module.exports["isListOperator"] = $e8e11a23197b825b$export$b09522e4061bbdd6;

});

parcelRegister("AOFDx", function(module, exports) {
const $3d29485bab9ba7b9$export$a8de6ce748deffac = (listener, jast)=>{
    jast.query && $3d29485bab9ba7b9$var$walkNode(listener, jast.query);
};
const $3d29485bab9ba7b9$var$walkNode = (listener, node)=>{
    listener.enterEveryNode && listener.enterEveryNode(node);
    node.enterNode(listener);
    node.getChildren().forEach((child)=>$3d29485bab9ba7b9$var$walkNode(listener, child));
    node.exitNode(listener);
    listener.exitEveryNode && listener.exitEveryNode(node);
};
module.exports["walkAST"] = $3d29485bab9ba7b9$export$a8de6ce748deffac;

});

parcelRegister("eEYRR", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $aac4042c732c0f73$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $aac4042c732c0f73$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashSet = void 0;

var $9ir1r = parcelRequire("9ir1r");


var $9SvmM = parcelRequire("9SvmM");


var $4w9vi = parcelRequire("4w9vi");


var $g3jfX = parcelRequire("g3jfX");

/** {@link Set} implementation with closed hashing (open addressing). */ // NOTE:  JavaScript's Set interface has on significant different diffrence from Java's:
// 		  e.g. the return type of add() differs!
//        For this reason I've commented tweaked the implements clause
const $aac4042c732c0f73$var$INITAL_CAPACITY = 16; // must be power of 2
const $aac4042c732c0f73$var$LOAD_FACTOR = 0.75;
class $aac4042c732c0f73$var$Array2DHashSet {
    /**
     * Add `o` to set if not there; return existing value if already
     * there. This method performs the same operation as {@link #add} aside from
     * the return value.
     */ getOrAdd(o) {
        if (this.n > this.threshold) this.expand();
        return this.getOrAddImpl(o);
    }
    getOrAddImpl(o) {
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        // NEW BUCKET
        if (!bucket) {
            bucket = [
                o
            ];
            this.buckets[b] = bucket;
            this.n++;
            return o;
        }
        // LOOK FOR IT IN BUCKET
        for (let existing of bucket){
            if (this.comparator.equals(existing, o)) return existing; // found existing, quit
        }
        // FULL BUCKET, expand and add to end
        bucket.push(o);
        this.n++;
        return o;
    }
    get(o) {
        if (o == null) return o;
        let b = this.getBucket(o);
        let bucket = this.buckets[b];
        if (!bucket) // no bucket
        return undefined;
        for (let e of bucket){
            if (this.comparator.equals(e, o)) return e;
        }
        return undefined;
    }
    getBucket(o) {
        let hash = this.comparator.hashCode(o);
        let b = hash & this.buckets.length - 1; // assumes len is power of 2
        return b;
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize();
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                hash = $g3jfX.MurmurHash.update(hash, this.comparator.hashCode(o));
            }
        }
        hash = $g3jfX.MurmurHash.finish(hash, this.size);
        return hash;
    }
    equals(o) {
        if (o === this) return true;
        if (!(o instanceof $aac4042c732c0f73$var$Array2DHashSet)) return false;
        if (o.size !== this.size) return false;
        let same = this.containsAll(o);
        return same;
    }
    expand() {
        let old = this.buckets;
        let newCapacity = this.buckets.length * 2;
        let newTable = this.createBuckets(newCapacity);
        this.buckets = newTable;
        this.threshold = Math.floor(newCapacity * $aac4042c732c0f73$var$LOAD_FACTOR);
        //		System.out.println("new size="+newCapacity+", thres="+threshold);
        // rehash all existing entries
        let oldSize = this.size;
        for (let bucket of old){
            if (!bucket) continue;
            for (let o of bucket){
                let b = this.getBucket(o);
                let newBucket = this.buckets[b];
                if (!newBucket) {
                    newBucket = [];
                    this.buckets[b] = newBucket;
                }
                newBucket.push(o);
            }
        }
        $9ir1r(this.n === oldSize);
    }
    add(t) {
        let existing = this.getOrAdd(t);
        return existing === t;
    }
    get size() {
        return this.n;
    }
    get isEmpty() {
        return this.n === 0;
    }
    contains(o) {
        return this.containsFast(this.asElementType(o));
    }
    containsFast(obj) {
        if (obj == null) return false;
        return this.get(obj) != null;
    }
    *[Symbol.iterator]() {
        yield* this.toArray();
    }
    toArray() {
        const a = new Array(this.size);
        // Copy elements from the nested arrays into the destination array
        let i = 0; // Position within destination array
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                a[i++] = o;
            }
        }
        return a;
    }
    containsAll(collection) {
        if (collection instanceof $aac4042c732c0f73$var$Array2DHashSet) {
            let s = collection;
            for (let bucket of s.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (!this.containsFast(this.asElementType(o))) return false;
                }
            }
        } else for (let o of collection){
            if (!this.containsFast(this.asElementType(o))) return false;
        }
        return true;
    }
    addAll(c) {
        let changed = false;
        for (let o of c){
            let existing = this.getOrAdd(o);
            if (existing !== o) changed = true;
        }
        return changed;
    }
    clear() {
        this.buckets = this.createBuckets($aac4042c732c0f73$var$INITAL_CAPACITY);
        this.n = 0;
        this.threshold = Math.floor($aac4042c732c0f73$var$INITAL_CAPACITY * $aac4042c732c0f73$var$LOAD_FACTOR);
    }
    toString() {
        if (this.size === 0) return "{}";
        let buf = "{";
        let first = true;
        for (let bucket of this.buckets){
            if (bucket == null) continue;
            for (let o of bucket){
                if (o == null) break;
                if (first) first = false;
                else buf += ", ";
                buf += o.toString();
            }
        }
        buf += "}";
        return buf;
    }
    toTableString() {
        let buf = "";
        for (let bucket of this.buckets){
            if (bucket == null) {
                buf += "null\n";
                continue;
            }
            buf += "[";
            let first = true;
            for (let o of bucket){
                if (first) first = false;
                else buf += " ";
                if (o == null) buf += "_";
                else buf += o.toString();
            }
            buf += "]\n";
        }
        return buf;
    }
    /**
     * Return `o` as an instance of the element type `T`. If
     * `o` is non-undefined but known to not be an instance of `T`, this
     * method returns `undefined`. The base implementation does not perform any
     * type checks; override this method to provide strong type checks for the
     * {@link #contains} and {@link #remove} methods to ensure the arguments to
     * the {@link EqualityComparator} for the set always have the expected
     * types.
     *
     * @param o the object to try and cast to the element type of the set
     * @returns `o` if it could be an instance of `T`, otherwise
     * `undefined`.
     */ asElementType(o) {
        return o;
    }
    /**
     * Return an array of `T[]` with length `capacity`.
     *
     * @param capacity the length of the array to return
     * @returns the newly constructed array
     */ createBuckets(capacity) {
        return new Array(capacity);
    }
    constructor(comparatorOrSet, initialCapacity = $aac4042c732c0f73$var$INITAL_CAPACITY){
        /** How many elements in set */ this.n = 0;
        this.threshold = Math.floor($aac4042c732c0f73$var$INITAL_CAPACITY * $aac4042c732c0f73$var$LOAD_FACTOR); // when to expand
        if (comparatorOrSet instanceof $aac4042c732c0f73$var$Array2DHashSet) {
            this.comparator = comparatorOrSet.comparator;
            this.buckets = comparatorOrSet.buckets.slice(0);
            for(let i = 0; i < this.buckets.length; i++){
                let bucket = this.buckets[i];
                if (bucket) this.buckets[i] = bucket.slice(0);
            }
            this.n = comparatorOrSet.n;
            this.threshold = comparatorOrSet.threshold;
        } else {
            this.comparator = comparatorOrSet || $9SvmM.DefaultEqualityComparator.INSTANCE;
            this.buckets = this.createBuckets(initialCapacity);
        }
    }
}
$aac4042c732c0f73$var$__decorate([
    $4w9vi.NotNull
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "comparator", void 0);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "hashCode", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "equals", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "add", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "size", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "isEmpty", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "contains", null);
$aac4042c732c0f73$var$__decorate([
    $aac4042c732c0f73$var$__param(0, $4w9vi.Nullable)
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "containsFast", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, Symbol.iterator, null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "toArray", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "containsAll", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "addAll", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "clear", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.Override
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "toString", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.SuppressWarnings("unchecked")
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "asElementType", null);
$aac4042c732c0f73$var$__decorate([
    $4w9vi.SuppressWarnings("unchecked")
], $aac4042c732c0f73$var$Array2DHashSet.prototype, "createBuckets", null);
module.exports.Array2DHashSet = $aac4042c732c0f73$var$Array2DHashSet; //# sourceMappingURL=Array2DHashSet.js.map

});

parcelRegister("io9eO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $d631a2556e4a5eaf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrayEqualityComparator = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $g3jfX = parcelRequire("g3jfX");


var $gxIPs = parcelRequire("gxIPs");

/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $d631a2556e4a5eaf$var$ArrayEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return $g3jfX.MurmurHash.hashCode(obj, 0);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined`, this method returns `true`. Otherwise if only
     * `a` is `undefined`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (b == null) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$gxIPs.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
        }
        return true;
    }
}
$d631a2556e4a5eaf$var$ArrayEqualityComparator.INSTANCE = new $d631a2556e4a5eaf$var$ArrayEqualityComparator();
$d631a2556e4a5eaf$var$__decorate([
    $4w9vi.Override
], $d631a2556e4a5eaf$var$ArrayEqualityComparator.prototype, "hashCode", null);
$d631a2556e4a5eaf$var$__decorate([
    $4w9vi.Override
], $d631a2556e4a5eaf$var$ArrayEqualityComparator.prototype, "equals", null);
module.exports.ArrayEqualityComparator = $d631a2556e4a5eaf$var$ArrayEqualityComparator; //# sourceMappingURL=ArrayEqualityComparator.js.map

});

parcelRegister("g3jfX", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MurmurHash = void 0;
/**
 *
 * @author Sam Harwell
 */ var $bafbdd1446e8a487$var$MurmurHash;
(function(MurmurHash) {
    const DEFAULT_SEED = 0;
    /**
     * Initialize the hash using the specified `seed`.
     *
     * @param seed the seed (optional)
     * @returns the intermediate hash value
     */ function initialize(seed = DEFAULT_SEED) {
        return seed;
    }
    MurmurHash.initialize = initialize;
    /**
     * Update the intermediate hash value for the next input `value`.
     *
     * @param hash the intermediate hash value
     * @param value the value to add to the current hash
     * @returns the updated intermediate hash value
     */ function update(hash, value) {
        const c1 = 0xCC9E2D51;
        const c2 = 0x1B873593;
        const r1 = 15;
        const r2 = 13;
        const m = 5;
        const n = 0xE6546B64;
        if (value == null) value = 0;
        else if (typeof value === "string") value = hashString(value);
        else if (typeof value === "object") value = value.hashCode();
        let k = value;
        k = Math.imul(k, c1);
        k = k << r1 | k >>> 32 - r1;
        k = Math.imul(k, c2);
        hash = hash ^ k;
        hash = hash << r2 | hash >>> 32 - r2;
        hash = Math.imul(hash, m) + n;
        return hash & 0xFFFFFFFF;
    }
    MurmurHash.update = update;
    /**
     * Apply the final computation steps to the intermediate value `hash`
     * to form the final result of the MurmurHash 3 hash function.
     *
     * @param hash the intermediate hash value
     * @param numberOfWords the number of integer values added to the hash
     * @returns the final hash result
     */ function finish(hash, numberOfWords) {
        hash = hash ^ numberOfWords * 4;
        hash = hash ^ hash >>> 16;
        hash = Math.imul(hash, 0x85EBCA6B);
        hash = hash ^ hash >>> 13;
        hash = Math.imul(hash, 0xC2B2AE35);
        hash = hash ^ hash >>> 16;
        return hash;
    }
    MurmurHash.finish = finish;
    /**
     * Utility function to compute the hash code of an array using the
     * MurmurHash algorithm.
     *
     * @param <T> the array element type
     * @param data the array data
     * @param seed the seed for the MurmurHash algorithm
     * @returns the hash code of the data
     */ function hashCode(data, seed = DEFAULT_SEED) {
        let hash = initialize(seed);
        let length = 0;
        for (let value of data){
            hash = update(hash, value);
            length++;
        }
        hash = finish(hash, length);
        return hash;
    }
    MurmurHash.hashCode = hashCode;
    /**
     * Function to hash a string. Based on the implementation found here:
     * http://stackoverflow.com/a/7616484
     */ function hashString(str) {
        let len = str.length;
        if (len === 0) return 0;
        let hash = 0;
        for(let i = 0; i < len; i++){
            let c = str.charCodeAt(i);
            hash = (hash << 5 >>> 0) - hash + c;
            hash |= 0;
        }
        return hash;
    }
})($bafbdd1446e8a487$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {})); //# sourceMappingURL=MurmurHash.js.map

});

parcelRegister("gxIPs", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $c0b2807bd2e54cc7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ObjectEqualityComparator = void 0;

var $4w9vi = parcelRequire("4w9vi");

/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $c0b2807bd2e54cc7$var$ObjectEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        return obj.hashCode();
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        return a.equals(b);
    }
}
$c0b2807bd2e54cc7$var$ObjectEqualityComparator.INSTANCE = new $c0b2807bd2e54cc7$var$ObjectEqualityComparator();
$c0b2807bd2e54cc7$var$__decorate([
    $4w9vi.Override
], $c0b2807bd2e54cc7$var$ObjectEqualityComparator.prototype, "hashCode", null);
$c0b2807bd2e54cc7$var$__decorate([
    $4w9vi.Override
], $c0b2807bd2e54cc7$var$ObjectEqualityComparator.prototype, "equals", null);
module.exports.ObjectEqualityComparator = $c0b2807bd2e54cc7$var$ObjectEqualityComparator; //# sourceMappingURL=ObjectEqualityComparator.js.map

});

parcelRegister("kTbzO", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $f351ec8ecbce5e18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerList = void 0;

var $l7ijV = parcelRequire("l7ijV");


var $4w9vi = parcelRequire("4w9vi");

const $f351ec8ecbce5e18$var$EMPTY_DATA = new Int32Array(0);
const $f351ec8ecbce5e18$var$INITIAL_SIZE = 4;
const $f351ec8ecbce5e18$var$MAX_ARRAY_SIZE = 2147483639;
/**
 *
 * @author Sam Harwell
 */ class $f351ec8ecbce5e18$var$IntegerList {
    add(value) {
        if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
        this._data[this._size] = value;
        this._size++;
    }
    addAll(list) {
        if (Array.isArray(list)) {
            this.ensureCapacity(this._size + list.length);
            this._data.subarray(this._size, this._size + list.length).set(list);
            this._size += list.length;
        } else if (list instanceof $f351ec8ecbce5e18$var$IntegerList) {
            this.ensureCapacity(this._size + list._size);
            this._data.subarray(this._size, this._size + list.size).set(list._data);
            this._size += list._size;
        } else {
            // list is JavaCollection<number>
            this.ensureCapacity(this._size + list.size);
            let current = 0;
            for (let xi of list){
                this._data[this._size + current] = xi;
                current++;
            }
            this._size += list.size;
        }
    }
    get(index) {
        if (index < 0 || index >= this._size) throw RangeError();
        return this._data[index];
    }
    contains(value) {
        for(let i = 0; i < this._size; i++){
            if (this._data[i] === value) return true;
        }
        return false;
    }
    set(index, value) {
        if (index < 0 || index >= this._size) throw RangeError();
        let previous = this._data[index];
        this._data[index] = value;
        return previous;
    }
    removeAt(index) {
        let value = this.get(index);
        this._data.copyWithin(index, index + 1, this._size);
        this._data[this._size - 1] = 0;
        this._size--;
        return value;
    }
    removeRange(fromIndex, toIndex) {
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
        if (fromIndex > toIndex) throw RangeError();
        this._data.copyWithin(toIndex, fromIndex, this._size);
        this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
        this._size -= toIndex - fromIndex;
    }
    get isEmpty() {
        return this._size === 0;
    }
    get size() {
        return this._size;
    }
    trimToSize() {
        if (this._data.length === this._size) return;
        this._data = this._data.slice(0, this._size);
    }
    clear() {
        this._data.fill(0, 0, this._size);
        this._size = 0;
    }
    toArray() {
        if (this._size === 0) return [];
        return Array.from(this._data.subarray(0, this._size));
    }
    sort() {
        this._data.subarray(0, this._size).sort();
    }
    /**
     * Compares the specified object with this list for equality.  Returns
     * `true` if and only if the specified object is also an {@link IntegerList},
     * both lists have the same size, and all corresponding pairs of elements in
     * the two lists are equal.  In other words, two lists are defined to be
     * equal if they contain the same elements in the same order.
     *
     * This implementation first checks if the specified object is this
     * list. If so, it returns `true`; if not, it checks if the
     * specified object is an {@link IntegerList}. If not, it returns `false`;
     * if so, it checks the size of both lists. If the lists are not the same size,
     * it returns `false`; otherwise it iterates over both lists, comparing
     * corresponding pairs of elements.  If any comparison returns `false`,
     * this method returns `false`.
     *
     * @param o the object to be compared for equality with this list
     * @returns `true` if the specified object is equal to this list
     */ equals(o) {
        if (o === this) return true;
        if (!(o instanceof $f351ec8ecbce5e18$var$IntegerList)) return false;
        if (this._size !== o._size) return false;
        for(let i = 0; i < this._size; i++){
            if (this._data[i] !== o._data[i]) return false;
        }
        return true;
    }
    /**
     * Returns the hash code value for this list.
     *
     * This implementation uses exactly the code that is used to define the
     * list hash function in the documentation for the {@link List#hashCode}
     * method.
     *
     * @returns the hash code value for this list
     */ hashCode() {
        let hashCode = 1;
        for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
        return hashCode;
    }
    /**
     * Returns a string representation of this list.
     */ toString() {
        return this._data.toString();
    }
    binarySearch(key, fromIndex, toIndex) {
        if (fromIndex === undefined) fromIndex = 0;
        if (toIndex === undefined) toIndex = this._size;
        if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
        if (fromIndex > toIndex) throw new RangeError();
        return $l7ijV.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
    }
    ensureCapacity(capacity) {
        if (capacity < 0 || capacity > $f351ec8ecbce5e18$var$MAX_ARRAY_SIZE) throw new RangeError();
        let newLength;
        if (this._data.length === 0) newLength = $f351ec8ecbce5e18$var$INITIAL_SIZE;
        else newLength = this._data.length;
        while(newLength < capacity){
            newLength = newLength * 2;
            if (newLength < 0 || newLength > $f351ec8ecbce5e18$var$MAX_ARRAY_SIZE) newLength = $f351ec8ecbce5e18$var$MAX_ARRAY_SIZE;
        }
        let tmp = new Int32Array(newLength);
        tmp.set(this._data);
        this._data = tmp;
    }
    /** Convert the list to a UTF-16 encoded char array. If all values are less
     *  than the 0xFFFF 16-bit code point limit then this is just a char array
     *  of 16-bit char as usual. For values in the supplementary range, encode
     * them as two UTF-16 code units.
     */ toCharArray() {
        // Optimize for the common case (all data values are < 0xFFFF) to avoid an extra scan
        let resultArray = new Uint16Array(this._size);
        let resultIdx = 0;
        let calculatedPreciseResultSize = false;
        for(let i = 0; i < this._size; i++){
            let codePoint = this._data[i];
            if (codePoint >= 0 && codePoint < 0x10000) {
                resultArray[resultIdx] = codePoint;
                resultIdx++;
                continue;
            }
            // Calculate the precise result size if we encounter a code point > 0xFFFF
            if (!calculatedPreciseResultSize) {
                let newResultArray = new Uint16Array(this.charArraySize());
                newResultArray.set(resultArray, 0);
                resultArray = newResultArray;
                calculatedPreciseResultSize = true;
            }
            // This will throw RangeError if the code point is not a valid Unicode code point
            let pair = String.fromCodePoint(codePoint);
            resultArray[resultIdx] = pair.charCodeAt(0);
            resultArray[resultIdx + 1] = pair.charCodeAt(1);
            resultIdx += 2;
        }
        return resultArray;
    }
    charArraySize() {
        let result = 0;
        for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
        return result;
    }
    constructor(arg){
        if (!arg) {
            this._data = $f351ec8ecbce5e18$var$EMPTY_DATA;
            this._size = 0;
        } else if (arg instanceof $f351ec8ecbce5e18$var$IntegerList) {
            this._data = arg._data.slice(0);
            this._size = arg._size;
        } else if (typeof arg === "number") {
            if (arg === 0) {
                this._data = $f351ec8ecbce5e18$var$EMPTY_DATA;
                this._size = 0;
            } else {
                this._data = new Int32Array(arg);
                this._size = 0;
            }
        } else {
            // arg is Iterable<number>
            this._data = $f351ec8ecbce5e18$var$EMPTY_DATA;
            this._size = 0;
            for (let value of arg)this.add(value);
        }
    }
}
$f351ec8ecbce5e18$var$__decorate([
    $4w9vi.NotNull
], $f351ec8ecbce5e18$var$IntegerList.prototype, "_data", void 0);
$f351ec8ecbce5e18$var$__decorate([
    $4w9vi.Override
], $f351ec8ecbce5e18$var$IntegerList.prototype, "equals", null);
$f351ec8ecbce5e18$var$__decorate([
    $4w9vi.Override
], $f351ec8ecbce5e18$var$IntegerList.prototype, "hashCode", null);
$f351ec8ecbce5e18$var$__decorate([
    $4w9vi.Override
], $f351ec8ecbce5e18$var$IntegerList.prototype, "toString", null);
module.exports.IntegerList = $f351ec8ecbce5e18$var$IntegerList; //# sourceMappingURL=IntegerList.js.map

});

parcelRegister("9ETsS", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntegerStack = void 0;

var $kTbzO = parcelRequire("kTbzO");

/**
 *
 * @author Sam Harwell
 */ class $7082df9b011e2757$var$IntegerStack extends $kTbzO.IntegerList {
    push(value) {
        this.add(value);
    }
    pop() {
        return this.removeAt(this.size - 1);
    }
    peek() {
        return this.get(this.size - 1);
    }
    constructor(arg){
        super(arg);
    }
}
module.exports.IntegerStack = $7082df9b011e2757$var$IntegerStack; //# sourceMappingURL=IntegerStack.js.map

});

parcelRegister("7oXsf", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AcceptStateInfo = void 0;
/**
 * Stores information about a {@link DFAState} which is an accept state under
 * some condition. Certain settings, such as
 * {@link ParserATNSimulator#getPredictionMode()}, may be used in addition to
 * this information to determine whether or not a particular state is an accept
 * state.
 *
 * @author Sam Harwell
 */ class $5638e4c41d568327$var$AcceptStateInfo {
    /**
     * Gets the prediction made by this accept state. Note that this value
     * assumes the predicates, if any, in the {@link DFAState} evaluate to
     * `true`. If predicate evaluation is enabled, the final prediction of
     * the accept state will be determined by the result of predicate
     * evaluation.
     */ get prediction() {
        return this._prediction;
    }
    /**
     * Gets the {@link LexerActionExecutor} which can be used to execute actions
     * and/or commands after the lexer matches a token.
     */ get lexerActionExecutor() {
        return this._lexerActionExecutor;
    }
    constructor(prediction, lexerActionExecutor){
        this._prediction = prediction;
        this._lexerActionExecutor = lexerActionExecutor;
    }
}
module.exports.AcceptStateInfo = $5638e4c41d568327$var$AcceptStateInfo; //# sourceMappingURL=AcceptStateInfo.js.map

});

parcelRegister("iIwZu", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $da05ed568f935d0f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $da05ed568f935d0f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFAState = void 0;

var $EKDdQ = parcelRequire("EKDdQ");


var $6YKio = parcelRequire("6YKio");


var $g3jfX = parcelRequire("g3jfX");


var $4w9vi = parcelRequire("4w9vi");


var $ca31u = parcelRequire("ca31u");


var $9ir1r = parcelRequire("9ir1r");

/** A DFA state represents a set of possible ATN configurations.
 *  As Aho, Sethi, Ullman p. 117 says "The DFA uses its state
 *  to keep track of all possible states the ATN can be in after
 *  reading each input symbol.  That is to say, after reading
 *  input a1a2..an, the DFA is in a state that represents the
 *  subset T of the states of the ATN that are reachable from the
 *  ATN's start state along some path labeled a1a2..an."
 *  In conventional NFA&rarr;DFA conversion, therefore, the subset T
 *  would be a bitset representing the set of states the
 *  ATN could be in.  We need to track the alt predicted by each
 *  state as well, however.  More importantly, we need to maintain
 *  a stack of states, tracking the closure operations as they
 *  jump from rule to rule, emulating rule invocations (method calls).
 *  I have to add a stack to simulate the proper lookahead sequences for
 *  the underlying LL grammar from which the ATN was derived.
 *
 *  I use a set of ATNConfig objects not simple states.  An ATNConfig
 *  is both a state (ala normal conversion) and a RuleContext describing
 *  the chain of rules (if any) followed to arrive at that state.
 *
 *  A DFA state may have multiple references to a particular state,
 *  but with different ATN contexts (with same or different alts)
 *  meaning that state was reached via a different set of rule invocations.
 */ class $da05ed568f935d0f$var$DFAState {
    get isContextSensitive() {
        return !!this.contextSymbols;
    }
    isContextSymbol(symbol) {
        if (!this.isContextSensitive) return false;
        return this.contextSymbols.get(symbol);
    }
    setContextSymbol(symbol) {
        $9ir1r(this.isContextSensitive);
        this.contextSymbols.set(symbol);
    }
    setContextSensitive(atn) {
        $9ir1r(!this.configs.isOutermostConfigSet);
        if (this.isContextSensitive) return;
        if (!this.contextSymbols) this.contextSymbols = new $6YKio.BitSet();
    }
    get acceptStateInfo() {
        return this._acceptStateInfo;
    }
    set acceptStateInfo(acceptStateInfo) {
        this._acceptStateInfo = acceptStateInfo;
    }
    get isAcceptState() {
        return !!this._acceptStateInfo;
    }
    get prediction() {
        if (!this._acceptStateInfo) return $EKDdQ.ATN.INVALID_ALT_NUMBER;
        return this._acceptStateInfo.prediction;
    }
    get lexerActionExecutor() {
        if (!this._acceptStateInfo) return undefined;
        return this._acceptStateInfo.lexerActionExecutor;
    }
    getTarget(symbol) {
        return this.edges.get(symbol);
    }
    setTarget(symbol, target) {
        this.edges.set(symbol, target);
    }
    getEdgeMap() {
        return this.edges;
    }
    getContextTarget(invokingState) {
        if (invokingState === $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        return this.contextEdges.get(invokingState);
    }
    setContextTarget(invokingState, target) {
        if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
        if (invokingState === $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
        this.contextEdges.set(invokingState, target);
    }
    getContextEdgeMap() {
        let map = new Map(this.contextEdges);
        let existing = map.get(-1);
        if (existing !== undefined) {
            if (map.size === 1) {
                let result = new Map();
                result.set($ca31u.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                return result;
            } else {
                map.delete(-1);
                map.set($ca31u.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
            }
        }
        return map;
    }
    hashCode() {
        let hash = $g3jfX.MurmurHash.initialize(7);
        hash = $g3jfX.MurmurHash.update(hash, this.configs.hashCode());
        hash = $g3jfX.MurmurHash.finish(hash, 1);
        return hash;
    }
    /**
     * Two {@link DFAState} instances are equal if their ATN configuration sets
     * are the same. This method is used to see if a state already exists.
     *
     * Because the number of alternatives and number of ATN configurations are
     * finite, there is a finite number of DFA states that can be processed.
     * This is necessary to show that the algorithm terminates.
     *
     * Cannot test the DFA state numbers here because in
     * {@link ParserATNSimulator#addDFAState} we need to know if any other state
     * exists that has this exact set of ATN configurations. The
     * {@link #stateNumber} is irrelevant.
     */ equals(o) {
        // compare set of ATN configurations in this set with other
        if (this === o) return true;
        if (!(o instanceof $da05ed568f935d0f$var$DFAState)) return false;
        let other = o;
        let sameSet = this.configs.equals(other.configs);
        //		System.out.println("DFAState.equals: "+configs+(sameSet?"==":"!=")+other.configs);
        return sameSet;
    }
    toString() {
        let buf = "";
        buf += this.stateNumber + ":" + this.configs;
        if (this.isAcceptState) {
            buf += "=>";
            if (this.predicates) buf += this.predicates;
            else buf += this.prediction;
        }
        return buf.toString();
    }
    /**
     * Constructs a new `DFAState`.
     *
     * @param configs The set of ATN configurations defining this state.
     */ constructor(configs){
        this.stateNumber = -1;
        this.configs = configs;
        this.edges = new Map();
        this.contextEdges = new Map();
    }
}
$da05ed568f935d0f$var$__decorate([
    $4w9vi.NotNull
], $da05ed568f935d0f$var$DFAState.prototype, "configs", void 0);
$da05ed568f935d0f$var$__decorate([
    $4w9vi.NotNull
], $da05ed568f935d0f$var$DFAState.prototype, "edges", void 0);
$da05ed568f935d0f$var$__decorate([
    $4w9vi.NotNull
], $da05ed568f935d0f$var$DFAState.prototype, "contextEdges", void 0);
$da05ed568f935d0f$var$__decorate([
    $4w9vi.Override
], $da05ed568f935d0f$var$DFAState.prototype, "hashCode", null);
$da05ed568f935d0f$var$__decorate([
    $4w9vi.Override
], $da05ed568f935d0f$var$DFAState.prototype, "equals", null);
$da05ed568f935d0f$var$__decorate([
    $4w9vi.Override
], $da05ed568f935d0f$var$DFAState.prototype, "toString", null);
module.exports.DFAState = $da05ed568f935d0f$var$DFAState;
(function(DFAState) {
    /** Map a predicate to a predicted alternative. */ let PredPrediction = class PredPrediction {
        toString() {
            return "(" + this.pred + ", " + this.alt + ")";
        }
        constructor(pred, alt){
            this.alt = alt;
            this.pred = pred;
        }
    };
    $da05ed568f935d0f$var$__decorate([
        $4w9vi.NotNull
    ], PredPrediction.prototype, "pred", void 0);
    $da05ed568f935d0f$var$__decorate([
        $4w9vi.Override
    ], PredPrediction.prototype, "toString", null);
    PredPrediction = $da05ed568f935d0f$var$__decorate([
        $da05ed568f935d0f$var$__param(0, $4w9vi.NotNull)
    ], PredPrediction);
    DFAState.PredPrediction = PredPrediction;
})($da05ed568f935d0f$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {})); //# sourceMappingURL=DFAState.js.map

});

parcelRegister("ei6xC", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Array2DHashMap = void 0;

var $eEYRR = parcelRequire("eEYRR");

class $a677d21084aba151$var$MapKeyEqualityComparator {
    hashCode(obj) {
        return this.keyComparator.hashCode(obj.key);
    }
    equals(a, b) {
        return this.keyComparator.equals(a.key, b.key);
    }
    constructor(keyComparator){
        this.keyComparator = keyComparator;
    }
}
class $a677d21084aba151$var$Array2DHashMap {
    clear() {
        this.backingStore.clear();
    }
    containsKey(key) {
        return this.backingStore.contains({
            key: key
        });
    }
    get(key) {
        let bucket = this.backingStore.get({
            key: key
        });
        if (!bucket) return undefined;
        return bucket.value;
    }
    get isEmpty() {
        return this.backingStore.isEmpty;
    }
    put(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else {
            result = element.value;
            element.value = value;
        }
        return result;
    }
    putIfAbsent(key, value) {
        let element = this.backingStore.get({
            key: key,
            value: value
        });
        let result;
        if (!element) this.backingStore.add({
            key: key,
            value: value
        });
        else result = element.value;
        return result;
    }
    get size() {
        return this.backingStore.size;
    }
    hashCode() {
        return this.backingStore.hashCode();
    }
    equals(o) {
        if (!(o instanceof $a677d21084aba151$var$Array2DHashMap)) return false;
        return this.backingStore.equals(o.backingStore);
    }
    constructor(keyComparer){
        if (keyComparer instanceof $a677d21084aba151$var$Array2DHashMap) this.backingStore = new $eEYRR.Array2DHashSet(keyComparer.backingStore);
        else this.backingStore = new $eEYRR.Array2DHashSet(new $a677d21084aba151$var$MapKeyEqualityComparator(keyComparer));
    }
}
module.exports.Array2DHashMap = $a677d21084aba151$var$Array2DHashMap; //# sourceMappingURL=Array2DHashMap.js.map

});

parcelRegister("lgmvT", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $03fea774db18e286$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $03fea774db18e286$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFA = void 0;

var $eEYRR = parcelRequire("eEYRR");


var $51XoR = parcelRequire("51XoR");


var $ctL7v = parcelRequire("ctL7v");


var $iIwZu = parcelRequire("iIwZu");


var $aE1Uv = parcelRequire("aE1Uv");


var $4w9vi = parcelRequire("4w9vi");


var $gxIPs = parcelRequire("gxIPs");


var $9nX6N = parcelRequire("9nX6N");


var $auHu3 = parcelRequire("auHu3");

let $03fea774db18e286$var$DFA = class DFA {
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise,
     * `false`.
     * @see Parser.precedence
     */ get isPrecedenceDfa() {
        return this.precedenceDfa;
    }
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @returns The start state corresponding to the specified precedence, or
     * `undefined` if no start state exists for the specified precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ getPrecedenceStartState(precedence, fullContext) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        // s0 and s0full are never null for a precedence DFA
        if (fullContext) return this.s0full.getTarget(precedence);
        else return this.s0.getTarget(precedence);
    }
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified
     * precedence.
     *
     * @ if this is not a precedence DFA.
     * @see `isPrecedenceDfa`
     */ setPrecedenceStartState(precedence, fullContext, startState) {
        if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
        if (precedence < 0) return;
        if (fullContext) // s0full is never null for a precedence DFA
        this.s0full.setTarget(precedence, startState);
        else // s0 is never null for a precedence DFA
        this.s0.setTarget(precedence, startState);
    }
    get isEmpty() {
        if (this.isPrecedenceDfa) // s0 and s0full are never null for a precedence DFA
        return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
        return this.s0 == null && this.s0full == null;
    }
    get isContextSensitive() {
        if (this.isPrecedenceDfa) // s0full is never null for a precedence DFA
        return this.s0full.getEdgeMap().size > 0;
        return this.s0full != null;
    }
    addState(state) {
        state.stateNumber = this.nextStateNumber++;
        return this.states.getOrAdd(state);
    }
    toString(vocabulary, ruleNames) {
        if (!vocabulary) vocabulary = $auHu3.VocabularyImpl.EMPTY_VOCABULARY;
        if (!this.s0) return "";
        let serializer;
        if (ruleNames) serializer = new $ctL7v.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
        else serializer = new $ctL7v.DFASerializer(this, vocabulary);
        return serializer.toString();
    }
    toLexerString() {
        if (!this.s0) return "";
        let serializer = new $aE1Uv.LexerDFASerializer(this);
        return serializer.toString();
    }
    constructor(atnStartState, decision = 0){
        /**
         * A set of all states in the `DFA`.
         *
         * Note that this collection of states holds the DFA states for both SLL and LL prediction. Only the start state
         * needs to be differentiated for these cases, which is tracked by the `s0` and `s0full` fields.
         */ this.states = new $eEYRR.Array2DHashSet($gxIPs.ObjectEqualityComparator.INSTANCE);
        this.nextStateNumber = 0;
        if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
        this.atnStartState = atnStartState;
        this.atn = atnStartState.atn;
        this.decision = decision;
        // Precedence DFAs are associated with the special precedence decision created for left-recursive rules which
        // evaluate their alternatives using a precedence hierarchy. When such a decision is encountered, we mark this
        // DFA instance as a precedence DFA and initialize the initial states s0 and s0full to special DFAState
        // instances which use outgoing edges to link to the actual start state used for each precedence level.
        let isPrecedenceDfa = false;
        if (atnStartState instanceof $9nX6N.StarLoopEntryState) {
            if (atnStartState.precedenceRuleDecision) {
                isPrecedenceDfa = true;
                this.s0 = new $iIwZu.DFAState(new $51XoR.ATNConfigSet());
                this.s0full = new $iIwZu.DFAState(new $51XoR.ATNConfigSet());
            }
        }
        this.precedenceDfa = isPrecedenceDfa;
    }
};
$03fea774db18e286$var$__decorate([
    $4w9vi.NotNull
], $03fea774db18e286$var$DFA.prototype, "states", void 0);
$03fea774db18e286$var$__decorate([
    $4w9vi.NotNull
], $03fea774db18e286$var$DFA.prototype, "atnStartState", void 0);
$03fea774db18e286$var$__decorate([
    $4w9vi.NotNull
], $03fea774db18e286$var$DFA.prototype, "atn", void 0);
$03fea774db18e286$var$DFA = $03fea774db18e286$var$__decorate([
    $03fea774db18e286$var$__param(0, $4w9vi.NotNull)
], $03fea774db18e286$var$DFA);
module.exports.DFA = $03fea774db18e286$var$DFA; //# sourceMappingURL=DFA.js.map

});

parcelRegister("6YKio", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BitSet = void 0;

var $b0OmS = parcelRequire("b0OmS");


var $g3jfX = parcelRequire("g3jfX");

/**
 * Private empty array used to construct empty BitSets
 */ const $514c420c743230c9$var$EMPTY_DATA = new Uint16Array(0);
/**
 * Gets the word index of the `UInt16` element in `BitSet.data` containing the bit with the specified index.
 */ function $514c420c743230c9$var$getIndex(bitNumber) {
    return bitNumber >>> 4;
}
/**
 * Convert a word index into the bit index of the LSB of that word
 */ function $514c420c743230c9$var$unIndex(n) {
    return n * 16;
}
/**
 * Get's the bit number of the least signficant bit set LSB which is set in a word non-zero word;
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $514c420c743230c9$var$findLSBSet(word) {
    let bit = 1;
    for(let i = 0; i < 16; i++){
        if ((word & bit) !== 0) return i;
        bit = bit << 1 >>> 0;
    }
    throw new RangeError("No specified bit found");
}
function $514c420c743230c9$var$findMSBSet(word) {
    let bit = 32768;
    for(let i = 15; i >= 0; i--){
        if ((word & bit) !== 0) return i;
        bit = bit >>> 1;
    }
    throw new RangeError("No specified bit found");
}
/**
 * Gets a 16-bit mask with bit numbers fromBit to toBit (inclusive) set.
 * Bit numbers run from LSB to MSB starting with 0.
 */ function $514c420c743230c9$var$bitsFor(fromBit, toBit) {
    fromBit &= 0xF;
    toBit &= 0xF;
    if (fromBit === toBit) return 1 << fromBit >>> 0;
    return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
}
/**
 * A lookup table for number of set bits in a 16-bit integer.   This is used to quickly count the cardinality (number of unique elements) of a BitSet.
 */ const $514c420c743230c9$var$POP_CNT = new Uint8Array(65536);
for(let i = 0; i < 16; i++){
    const stride = 1 << i >>> 0;
    let index = 0;
    while(index < $514c420c743230c9$var$POP_CNT.length){
        // skip the numbers where the bit isn't set
        index += stride;
        // increment the ones where the bit is set
        for(let j = 0; j < stride; j++){
            $514c420c743230c9$var$POP_CNT[index]++;
            index++;
        }
    }
}
class $514c420c743230c9$var$BitSet {
    /**
     * Performs a logical **AND** of this target bit set with the argument bit set. This bit set is modified so that
     * each bit in it has the value `true` if and only if it both initially had the value `true` and the corresponding
     * bit in the bit set argument also had the value `true`.
     */ and(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $514c420c743230c9$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Clears all of the bits in this `BitSet` whose corresponding bit is set in the specified `BitSet`.
     */ andNot(set) {
        const data = this.data;
        const other = set.data;
        const words = Math.min(data.length, other.length);
        let lastWord = -1; // Keep track of index of last non-zero word
        for(let i = 0; i < words; i++){
            let value = data[i] &= other[i] ^ 0xFFFF;
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $514c420c743230c9$var$EMPTY_DATA;
        if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
    }
    /**
     * Returns the number of bits set to `true` in this `BitSet`.
     */ cardinality() {
        if (this.isEmpty) return 0;
        const data = this.data;
        const length = data.length;
        let result = 0;
        for(let i = 0; i < length; i++)result += $514c420c743230c9$var$POP_CNT[data[i]];
        return result;
    }
    clear(fromIndex, toIndex) {
        if (fromIndex == null) this.data.fill(0);
        else if (toIndex == null) this.set(fromIndex, false);
        else this.set(fromIndex, toIndex, false);
    }
    flip(fromIndex, toIndex) {
        if (toIndex == null) toIndex = fromIndex;
        if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
        let word = $514c420c743230c9$var$getIndex(fromIndex);
        const lastWord = $514c420c743230c9$var$getIndex(toIndex);
        if (word === lastWord) this.data[word] ^= $514c420c743230c9$var$bitsFor(fromIndex, toIndex);
        else {
            this.data[word++] ^= $514c420c743230c9$var$bitsFor(fromIndex, 15);
            while(word < lastWord)this.data[word++] ^= 0xFFFF;
            this.data[word++] ^= $514c420c743230c9$var$bitsFor(0, toIndex);
        }
    }
    get(fromIndex, toIndex) {
        if (toIndex === undefined) return !!(this.data[$514c420c743230c9$var$getIndex(fromIndex)] & $514c420c743230c9$var$bitsFor(fromIndex, fromIndex));
        else {
            // return a BitSet
            let result = new $514c420c743230c9$var$BitSet(toIndex + 1);
            for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
            return result;
        }
    }
    /**
     * Returns true if the specified `BitSet` has any bits set to `true` that are also set to `true` in this `BitSet`.
     *
     * @param set `BitSet` to intersect with
     */ intersects(set) {
        let smallerLength = Math.min(this.length(), set.length());
        if (smallerLength === 0) return false;
        let bound = $514c420c743230c9$var$getIndex(smallerLength - 1);
        for(let i = 0; i <= bound; i++){
            if ((this.data[i] & set.data[i]) !== 0) return true;
        }
        return false;
    }
    /**
     * Returns true if this `BitSet` contains no bits that are set to `true`.
     */ get isEmpty() {
        return this.length() === 0;
    }
    /**
     * Returns the "logical size" of this `BitSet`: the index of the highest set bit in the `BitSet` plus one. Returns
     * zero if the `BitSet` contains no set bits.
     */ length() {
        if (!this.data.length) return 0;
        return this.previousSetBit($514c420c743230c9$var$unIndex(this.data.length) - 1) + 1;
    }
    /**
     * Returns the index of the first bit that is set to `false` that occurs on or after the specified starting index,
     * If no such bit exists then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $514c420c743230c9$var$getIndex(fromIndex);
        if (word > length) return -1;
        let ignore = 0xFFFF ^ $514c420c743230c9$var$bitsFor(fromIndex, 15);
        if ((data[word] | ignore) === 0xFFFF) {
            word++;
            ignore = 0;
            for(; word < length; word++){
                if (data[word] !== 0xFFFF) break;
            }
            if (word === length) // Hit the end
            return -1;
        }
        return $514c420c743230c9$var$unIndex(word) + $514c420c743230c9$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
     * If no such bit exists then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.nextSetBit(0); i >= 0; i = bs.nextSetBit(i + 1)) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is negative
     */ nextSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $514c420c743230c9$var$getIndex(fromIndex);
        if (word > length) return -1;
        let mask = $514c420c743230c9$var$bitsFor(fromIndex, 15);
        if ((data[word] & mask) === 0) {
            word++;
            mask = 0xFFFF;
            for(; word < length; word++){
                if (data[word] !== 0) break;
            }
            if (word >= length) return -1;
        }
        return $514c420c743230c9$var$unIndex(word) + $514c420c743230c9$var$findLSBSet(data[word] & mask);
    }
    /**
     * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
     * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
     * set argument has the value `true`.
     */ or(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Or those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] | other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $514c420c743230c9$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord);
    }
    /**
     * Returns the index of the nearest bit that is set to `false` that occurs on or before the specified starting
     * index. If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousClearBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $514c420c743230c9$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let ignore = 0xFFFF ^ $514c420c743230c9$var$bitsFor(0, fromIndex);
        if ((data[word] | ignore) === 0xFFFF) {
            ignore = 0;
            word--;
            for(; word >= 0; word--){
                if (data[word] !== 0xFFFF) break;
            }
            if (word < 0) // Hit the end
            return -1;
        }
        return $514c420c743230c9$var$unIndex(word) + $514c420c743230c9$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
    }
    /**
     * Returns the index of the nearest bit that is set to `true` that occurs on or before the specified starting index.
     * If no such bit exists, or if `-1` is given as the starting index, then `-1` is returned.
     *
     * To iterate over the `true` bits in a `BitSet`, use the following loop:
     *
     * ```
     * for (let i = bs.length(); (i = bs.previousSetBit(i-1)) >= 0; ) {
     *   // operate on index i here
     * }
     * ```
     *
     * @param fromIndex the index to start checking from (inclusive)
     *
     * @throws RangeError if the specified index is less than `-1`
     */ previousSetBit(fromIndex) {
        if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
        const data = this.data;
        const length = data.length;
        let word = $514c420c743230c9$var$getIndex(fromIndex);
        if (word >= length) word = length - 1;
        let mask = $514c420c743230c9$var$bitsFor(0, fromIndex);
        if ((data[word] & mask) === 0) {
            word--;
            mask = 0xFFFF;
            for(; word >= 0; word--){
                if (data[word] !== 0) break;
            }
            if (word < 0) return -1;
        }
        return $514c420c743230c9$var$unIndex(word) + $514c420c743230c9$var$findMSBSet(data[word] & mask);
    }
    set(fromIndex, toIndex, value) {
        if (toIndex === undefined) {
            toIndex = fromIndex;
            value = true;
        } else if (typeof toIndex === "boolean") {
            value = toIndex;
            toIndex = fromIndex;
        }
        if (value === undefined) value = true;
        if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
        let word = $514c420c743230c9$var$getIndex(fromIndex);
        let lastWord = $514c420c743230c9$var$getIndex(toIndex);
        if (value && lastWord >= this.data.length) {
            // Grow array "just enough" for bits we need to set
            let temp = new Uint16Array(lastWord + 1);
            this.data.forEach((value, index)=>temp[index] = value);
            this.data = temp;
        } else if (!value) {
            // But there is no need to grow array to clear bits.
            if (word >= this.data.length) // Early exit
            return;
            if (lastWord >= this.data.length) {
                // Adjust work to fit array
                lastWord = this.data.length - 1;
                toIndex = this.data.length * 16 - 1;
            }
        }
        if (word === lastWord) this._setBits(word, value, $514c420c743230c9$var$bitsFor(fromIndex, toIndex));
        else {
            this._setBits(word++, value, $514c420c743230c9$var$bitsFor(fromIndex, 15));
            while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
            this._setBits(word, value, $514c420c743230c9$var$bitsFor(0, toIndex));
        }
    }
    _setBits(word, value, mask) {
        if (value) this.data[word] |= mask;
        else this.data[word] &= 0xFFFF ^ mask;
    }
    /**
     * Returns the number of bits of space actually in use by this `BitSet` to represent bit values. The maximum element
     * in the set is the size - 1st element.
     */ get size() {
        return this.data.byteLength * 8;
    }
    /**
     * Returns a new byte array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let bytes = s.toByteArray();`
     * then `bytes.length === (s.length()+7)/8` and `s.get(n) === ((bytes[n/8] & (1<<(n%8))) != 0)` for all
     * `n < 8 * bytes.length`.
     */ // toByteArray(): Int8Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Returns a new integer array containing all the bits in this bit set.
     *
     * More precisely, if
     * `let integers = s.toIntegerArray();`
     * then `integers.length === (s.length()+31)/32` and `s.get(n) === ((integers[n/32] & (1<<(n%32))) != 0)` for all
     * `n < 32 * integers.length`.
     */ // toIntegerArray(): Int32Array {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    hashCode() {
        return $g3jfX.MurmurHash.hashCode(this.data, 22);
    }
    /**
     * Compares this object against the specified object. The result is `true` if and only if the argument is not
     * `undefined` and is a `Bitset` object that has exactly the same set of bits set to `true` as this bit set. That
     * is, for every nonnegative index `k`,
     *
     * ```
     * ((BitSet)obj).get(k) == this.get(k)
     * ```
     *
     * must be true. The current sizes of the two bit sets are not compared.
     */ equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $514c420c743230c9$var$BitSet)) return false;
        const len = this.length();
        if (len !== obj.length()) return false;
        if (len === 0) return true;
        let bound = $514c420c743230c9$var$getIndex(len - 1);
        for(let i = 0; i <= bound; i++){
            if (this.data[i] !== obj.data[i]) return false;
        }
        return true;
    }
    /**
     * Returns a string representation of this bit set. For every index for which this `BitSet` contains a bit in the
     * set state, the decimal representation of that index is included in the result. Such indices are listed in order
     * from lowest to highest, separated by ", " (a comma and a space) and surrounded by braces, resulting in the usual
     * mathematical notation for a set of integers.
     *
     * Example:
     *
     *     BitSet drPepper = new BitSet();
     *
     * Now `drPepper.toString()` returns `"{}"`.
     *
     *     drPepper.set(2);
     *
     * Now `drPepper.toString()` returns `"{2}"`.
     *
     *     drPepper.set(4);
     *     drPepper.set(10);
     *
     * Now `drPepper.toString()` returns `"{2, 4, 10}"`.
     */ toString() {
        let result = "{";
        let first = true;
        for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
            if (first) first = false;
            else result += ", ";
            result += i;
        }
        result += "}";
        return result;
    }
    // static valueOf(bytes: Int8Array): BitSet;
    // static valueOf(buffer: ArrayBuffer): BitSet;
    // static valueOf(integers: Int32Array): BitSet;
    // static valueOf(data: Int8Array | Int32Array | ArrayBuffer): BitSet {
    // 	throw new Error("NOT IMPLEMENTED");
    // }
    /**
     * Performs a logical **XOR** of this bit set with the bit set argument. This bit set is modified so that a bit in
     * it has the value `true` if and only if one of the following statements holds:
     *
     * * The bit initially has the value `true`, and the corresponding bit in the argument has the value `false`.
     * * The bit initially has the value `false`, and the corresponding bit in the argument has the value `true`.
     */ xor(set) {
        const data = this.data;
        const other = set.data;
        const minWords = Math.min(data.length, other.length);
        const words = Math.max(data.length, other.length);
        const dest = data.length === words ? data : new Uint16Array(words);
        let lastWord = -1;
        // Xor those words both sets have in common
        for(let i = 0; i < minWords; i++){
            let value = dest[i] = data[i] ^ other[i];
            if (value !== 0) lastWord = i;
        }
        // Copy words from larger set (if there is one)
        const longer = data.length > other.length ? data : other;
        for(let i = minWords; i < words; i++){
            let value = dest[i] = longer[i];
            if (value !== 0) lastWord = i;
        }
        if (lastWord === -1) this.data = $514c420c743230c9$var$EMPTY_DATA;
        else if (dest.length === lastWord + 1) this.data = dest;
        else this.data = dest.slice(0, lastWord + 1);
    }
    clone() {
        return new $514c420c743230c9$var$BitSet(this);
    }
    [Symbol.iterator]() {
        return new $514c420c743230c9$var$BitSetIterator(this.data);
    }
    // Overrides formatting for nodejs assert etc.
    [$b0OmS.inspect.custom]() {
        return "BitSet " + this.toString();
    }
    /*
    ** constructor implementation
    */ constructor(arg){
        if (!arg) // covering the case of unspecified and nbits===0
        this.data = $514c420c743230c9$var$EMPTY_DATA;
        else if (typeof arg === "number") {
            if (arg < 0) throw new RangeError("nbits cannot be negative");
            else this.data = new Uint16Array($514c420c743230c9$var$getIndex(arg - 1) + 1);
        } else if (arg instanceof $514c420c743230c9$var$BitSet) this.data = arg.data.slice(0); // Clone the data
        else {
            let max = -1;
            for (let v of arg)if (max < v) max = v;
            this.data = new Uint16Array($514c420c743230c9$var$getIndex(max - 1) + 1);
            for (let v of arg)this.set(v);
        }
    }
}
module.exports.BitSet = $514c420c743230c9$var$BitSet;
class $514c420c743230c9$var$BitSetIterator {
    next() {
        while(this.index < this.data.length){
            const bits = this.data[this.index] & this.mask;
            if (bits !== 0) {
                const bitNumber = $514c420c743230c9$var$unIndex(this.index) + $514c420c743230c9$var$findLSBSet(bits);
                this.mask = $514c420c743230c9$var$bitsFor(bitNumber + 1, 15);
                return {
                    done: false,
                    value: bitNumber
                };
            }
            this.index++;
            this.mask = 0xFFFF;
        }
        return {
            done: true,
            value: -1
        };
    }
    [Symbol.iterator]() {
        return this;
    }
    constructor(data){
        this.data = data;
        this.index = 0;
        this.mask = 0xFFFF;
    }
} //# sourceMappingURL=BitSet.js.map

});

parcelRegister("l7ijV", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arrays = void 0;
var $f5f8767bac331c62$var$Arrays;
(function(Arrays) {
    /**
     * Searches the specified array of numbers for the specified value using the binary search algorithm. The array must
     * be sorted prior to making this call. If it is not sorted, the results are unspecified. If the array contains
     * multiple elements with the specified value, there is no guarantee which one will be found.
     *
     * @returns index of the search key, if it is contained in the array; otherwise, (-(insertion point) - 1). The
     * insertion point is defined as the point at which the key would be inserted into the array: the index of the first
     * element greater than the key, or array.length if all elements in the array are less than the specified key. Note
     * that this guarantees that the return value will be >= 0 if and only if the key is found.
     */ function binarySearch(array, key, fromIndex, toIndex) {
        return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
    }
    Arrays.binarySearch = binarySearch;
    function binarySearch0(array, fromIndex, toIndex, key) {
        let low = fromIndex;
        let high = toIndex - 1;
        while(low <= high){
            let mid = low + high >>> 1;
            let midVal = array[mid];
            if (midVal < key) low = mid + 1;
            else if (midVal > key) high = mid - 1;
            else // key found
            return mid;
        }
        // key not found.
        return -(low + 1);
    }
    function toString(array) {
        let result = "[";
        let first = true;
        for (let element of array){
            if (first) first = false;
            else result += ", ";
            if (element === null) result += "null";
            else if (element === undefined) result += "undefined";
            else result += element;
        }
        result += "]";
        return result;
    }
    Arrays.toString = toString;
})($f5f8767bac331c62$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {})); //# sourceMappingURL=Arrays.js.map

});

parcelRegister("e3JhD", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $a3c478d6be35214f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorNode = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $kNZsc = parcelRequire("kNZsc");

/** Represents a token that was consumed during resynchronization
 *  rather than during a valid match operation. For example,
 *  we will create this kind of a node during single token insertion
 *  and deletion as well as during "consume until error recovery set"
 *  upon no viable alternative exceptions.
 */ class $a3c478d6be35214f$var$ErrorNode extends $kNZsc.TerminalNode {
    accept(visitor) {
        return visitor.visitErrorNode(this);
    }
    constructor(token){
        super(token);
    }
}
$a3c478d6be35214f$var$__decorate([
    $4w9vi.Override
], $a3c478d6be35214f$var$ErrorNode.prototype, "accept", null);
module.exports.ErrorNode = $a3c478d6be35214f$var$ErrorNode; //# sourceMappingURL=ErrorNode.js.map

});

parcelRegister("eKmKF", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UUID = void 0;

var $g3jfX = parcelRequire("g3jfX");

class $abc702959438a51f$var$UUID {
    static fromString(data) {
        if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
        let segments = data.split("-");
        let mostSigBits = parseInt(segments[0], 16);
        let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
        let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
        let leastSigBits = parseInt(segments[4].substr(-8), 16);
        return new $abc702959438a51f$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
    }
    hashCode() {
        return $g3jfX.MurmurHash.hashCode([
            this.data[0],
            this.data[1],
            this.data[2],
            this.data[3]
        ]);
    }
    equals(obj) {
        if (obj === this) return true;
        else if (!(obj instanceof $abc702959438a51f$var$UUID)) return false;
        return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
    }
    toString() {
        return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
    }
    constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
        this.data = new Uint32Array(4);
        this.data[0] = mostSigBits;
        this.data[1] = moreSigBits;
        this.data[2] = lessSigBits;
        this.data[3] = leastSigBits;
    }
}
module.exports.UUID = $abc702959438a51f$var$UUID; //# sourceMappingURL=UUID.js.map

});

parcelRegister("jyVZk", function(module, exports) {
const $e93077c46d99b42d$export$470bef71e654b804 = ()=>[];
const $e93077c46d99b42d$export$a4685923af2913a = (node)=>{
    node.getChildren().forEach((child)=>{
        child.parent = node;
    });
};
module.exports["noChildren"] = $e93077c46d99b42d$export$470bef71e654b804;
module.exports["assignParent"] = $e93077c46d99b42d$export$a4685923af2913a;

});

parcelRegister("3St4x", function(module, exports) {
/**
 * Represents a error occurring when trying to parse JQL into a Jast.
 */ class $2a229932350845e9$export$e8cfe2b2c93fbd4b extends Error {
    constructor(message, cause){
        super(message);
        /**
     * The original JS error that was thrown trying to parse JQL.
     */ this.cause = void 0;
        /**
     * The error message. We use a separate property here so consumers can perform shallow comparison of error objects.
     */ this.description = void 0;
        this.name = 'JQLParseError';
        this.cause = cause;
        this.description = message;
    }
}
module.exports["JQLParseError"] = $2a229932350845e9$export$e8cfe2b2c93fbd4b;

});

parcelRegister("9SvmM", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $73117ce70b7341fe$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultEqualityComparator = void 0;

var $4w9vi = parcelRequire("4w9vi");


var $g3jfX = parcelRequire("g3jfX");


var $gxIPs = parcelRequire("gxIPs");

/**
 * This default implementation of {@link EqualityComparator} uses object equality
 * for comparisons by calling {@link Object#hashCode} and {@link Object#equals}.
 *
 * @author Sam Harwell
 */ class $73117ce70b7341fe$var$DefaultEqualityComparator {
    /**
     * {@inheritDoc}
     *
     * This implementation returns
     * `obj.`{@link Object#hashCode hashCode()}.
     */ hashCode(obj) {
        if (obj == null) return 0;
        else if (typeof obj === "string" || typeof obj === "number") return $g3jfX.MurmurHash.hashCode([
            obj
        ]);
        else return $gxIPs.ObjectEqualityComparator.INSTANCE.hashCode(obj);
    }
    /**
     * {@inheritDoc}
     *
     * This implementation relies on object equality. If both objects are
     * `undefined` or `null`, this method returns `true`. Otherwise if only
     * `a` is `undefined` or `null`, this method returns `false`. Otherwise,
     * this method returns the result of
     * `a.`{@link Object#equals equals}`(b)`.
     */ equals(a, b) {
        if (a == null) return b == null;
        else if (typeof a === "string" || typeof a === "number") return a === b;
        else return $gxIPs.ObjectEqualityComparator.INSTANCE.equals(a, b);
    }
}
$73117ce70b7341fe$var$DefaultEqualityComparator.INSTANCE = new $73117ce70b7341fe$var$DefaultEqualityComparator();
$73117ce70b7341fe$var$__decorate([
    $4w9vi.Override
], $73117ce70b7341fe$var$DefaultEqualityComparator.prototype, "hashCode", null);
$73117ce70b7341fe$var$__decorate([
    $4w9vi.Override
], $73117ce70b7341fe$var$DefaultEqualityComparator.prototype, "equals", null);
module.exports.DefaultEqualityComparator = $73117ce70b7341fe$var$DefaultEqualityComparator; //# sourceMappingURL=DefaultEqualityComparator.js.map

});

parcelRegister("ctL7v", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $915cbe82999adc65$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DFASerializer = void 0;

var $gZszX = parcelRequire("gZszX");


var $4w9vi = parcelRequire("4w9vi");


var $ca31u = parcelRequire("ca31u");


var $lEpws = parcelRequire("lEpws");


var $auHu3 = parcelRequire("auHu3");

/** A DFA walker that knows how to dump them to serialized strings. */ class $915cbe82999adc65$var$DFASerializer {
    toString() {
        if (!this.dfa.s0) return "";
        let buf = "";
        if (this.dfa.states) {
            let states = new Array(...this.dfa.states.toArray());
            states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
            for (let s of states){
                let edges = s.getEdgeMap();
                let edgeKeys = [
                    ...edges.keys()
                ].sort((a, b)=>a - b);
                let contextEdges = s.getContextEdgeMap();
                let contextEdgeKeys = [
                    ...contextEdges.keys()
                ].sort((a, b)=>a - b);
                for (let entry of edgeKeys){
                    let value = edges.get(entry);
                    if ((value == null || value === $gZszX.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                    let contextSymbol = false;
                    buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                    if (s.isContextSymbol(entry)) {
                        buf += "!";
                        contextSymbol = true;
                    }
                    let t = value;
                    if (t && t.stateNumber !== $gZszX.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                    else if (contextSymbol) buf += "ctx\n";
                }
                if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
            }
        }
        let output = buf;
        if (output.length === 0) return "";
        //return Utils.sortLinesInString(output);
        return output;
    }
    getContextLabel(i) {
        if (i === $ca31u.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
        else if (i === $ca31u.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
        if (this.atn && i > 0 && i <= this.atn.states.length) {
            let state = this.atn.states[i];
            let ruleIndex = state.ruleIndex;
            if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
        return "ctx:" + String(i);
    }
    getEdgeLabel(i) {
        return this.vocabulary.getDisplayName(i);
    }
    getStateString(s) {
        if (s === $gZszX.ATNSimulator.ERROR) return "ERROR";
        let n = s.stateNumber;
        let stateStr = "s" + n;
        if (s.isAcceptState) {
            if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
            else stateStr = ":s" + n + "=>" + s.prediction;
        }
        if (s.isContextSensitive) {
            stateStr += "*";
            for (let config of s.configs)if (config.reachesIntoOuterContext) {
                stateStr += "*";
                break;
            }
        }
        return stateStr;
    }
    constructor(dfa, vocabulary, ruleNames, atn){
        if (vocabulary instanceof $lEpws.Recognizer) {
            ruleNames = vocabulary.ruleNames;
            atn = vocabulary.atn;
            vocabulary = vocabulary.vocabulary;
        } else if (!vocabulary) vocabulary = $auHu3.VocabularyImpl.EMPTY_VOCABULARY;
        this.dfa = dfa;
        this.vocabulary = vocabulary;
        this.ruleNames = ruleNames;
        this.atn = atn;
    }
}
$915cbe82999adc65$var$__decorate([
    $4w9vi.NotNull
], $915cbe82999adc65$var$DFASerializer.prototype, "dfa", void 0);
$915cbe82999adc65$var$__decorate([
    $4w9vi.NotNull
], $915cbe82999adc65$var$DFASerializer.prototype, "vocabulary", void 0);
$915cbe82999adc65$var$__decorate([
    $4w9vi.Override
], $915cbe82999adc65$var$DFASerializer.prototype, "toString", null);
module.exports.DFASerializer = $915cbe82999adc65$var$DFASerializer; //# sourceMappingURL=DFASerializer.js.map

});

parcelRegister("aE1Uv", function(module, exports) {
"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */ var $7bff1f2a494bc483$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7bff1f2a494bc483$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LexerDFASerializer = void 0;

var $ctL7v = parcelRequire("ctL7v");


var $4w9vi = parcelRequire("4w9vi");


var $auHu3 = parcelRequire("auHu3");

let $7bff1f2a494bc483$var$LexerDFASerializer = class LexerDFASerializer extends $ctL7v.DFASerializer {
    getEdgeLabel(i) {
        return "'" + String.fromCodePoint(i) + "'";
    }
    constructor(dfa){
        super(dfa, $auHu3.VocabularyImpl.EMPTY_VOCABULARY);
    }
};
$7bff1f2a494bc483$var$__decorate([
    $4w9vi.Override,
    $4w9vi.NotNull
], $7bff1f2a494bc483$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
$7bff1f2a494bc483$var$LexerDFASerializer = $7bff1f2a494bc483$var$__decorate([
    $7bff1f2a494bc483$var$__param(0, $4w9vi.NotNull)
], $7bff1f2a494bc483$var$LexerDFASerializer);
module.exports.LexerDFASerializer = $7bff1f2a494bc483$var$LexerDFASerializer; //# sourceMappingURL=LexerDFASerializer.js.map

});


//# sourceMappingURL=modal.80cf06fe.js.map
